import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type ActiveTemplateResult = {
  __typename?: 'ActiveTemplateResult';
  templateId?: Maybe<Scalars['String']['output']>;
  templateVersionId?: Maybe<Scalars['String']['output']>;
};

export enum AddressTypeCode {
  BusinessAddress = 'BUSINESS_ADDRESS',
  DeliveryToAddress = 'DELIVERY_TO_ADDRESS',
  FiscalAddress = 'FISCAL_ADDRESS',
  MailToAddress = 'MAIL_TO_ADDRESS',
  PhysicalAddress = 'PHYSICAL_ADDRESS',
  PostalAddress = 'POSTAL_ADDRESS',
  PostboxAddress = 'POSTBOX_ADDRESS',
  ResidentialAddress = 'RESIDENTIAL_ADDRESS'
}

export type Agency = {
  __typename?: 'Agency';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<AgencyType>;
};

export type AgencyInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<AgencyType>;
};

export enum AgencyType {
  Certifying = 'CERTIFYING',
  Halal = 'HALAL',
  Iva = 'IVA',
  Oca = 'OCA',
  Other = 'OTHER',
  Ra = 'RA',
  Verifying = 'VERIFYING'
}

export type AggregatedProcessHistory = {
  __typename?: 'AggregatedProcessHistory';
  concatenated: Scalars['Boolean']['output'];
  countryCode: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  currentEndDate?: Maybe<Scalars['AWSDate']['output']>;
  currentStartDate?: Maybe<Scalars['AWSDate']['output']>;
  dateOverride?: Maybe<Scalars['Boolean']['output']>;
  earliestStartDate?: Maybe<Scalars['AWSDate']['output']>;
  id: Scalars['ID']['output'];
  lastProcessEndDate?: Maybe<Scalars['AWSDate']['output']>;
  lastProcessStartDate?: Maybe<Scalars['AWSDate']['output']>;
  latestEndDate?: Maybe<Scalars['AWSDate']['output']>;
  latestSubmissionDate?: Maybe<Scalars['AWSDateTime']['output']>;
  nameOverride?: Maybe<Scalars['Boolean']['output']>;
  overriddenEndDate?: Maybe<Scalars['AWSDate']['output']>;
  overriddenStartDate?: Maybe<Scalars['AWSDate']['output']>;
  owned: Scalars['Boolean']['output'];
  premisesIdentifier: Scalars['String']['output'];
  premisesName?: Maybe<Scalars['String']['output']>;
  premisesRegistrationId?: Maybe<Scalars['String']['output']>;
  processCategory: Scalars['String']['output'];
  processCode: Scalars['String']['output'];
  processName?: Maybe<Scalars['String']['output']>;
  processSequenceNumber?: Maybe<Scalars['Int']['output']>;
  processUnCode?: Maybe<Scalars['String']['output']>;
  productItemId: Scalars['ID']['output'];
  registrationTypeCode?: Maybe<Scalars['String']['output']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  publishDate: Scalars['AWSDateTime']['output'];
  status: AnnouncementStatus;
  title: Scalars['String']['output'];
};

export type AnnouncementList = {
  __typename?: 'AnnouncementList';
  items: Array<Announcement>;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementListInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum AnnouncementStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Ended = 'ENDED',
  Scheduled = 'SCHEDULED'
}

export type ApprovalToReplaceExportCertificateRequestInput = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveCertificateRequestInput = {
  certifier: SpsAuthenticationInput;
  reason_for_status_change?: InputMaybe<Scalars['String']['input']>;
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['String']['input'];
  status: ExportCertificateStatus;
};

export type ApprovedProductRequest = {
  __typename?: 'ApprovedProductRequest';
  products: Array<TransferProductDetails>;
};

export type ApprovedProductRequestInput = {
  productIds: Array<Scalars['String']['input']>;
};

export enum AuthenticationType {
  AzureAd = 'AZURE_AD',
  AzureB2C = 'AZURE_B2C',
  Legacy = 'LEGACY'
}

export type AvailableTemplateFields = {
  __typename?: 'AvailableTemplateFields';
  code: Scalars['String']['output'];
  commodity?: Maybe<Scalars['String']['output']>;
  destinationMarket: DestinationMarket;
  displayedDescription?: Maybe<Scalars['String']['output']>;
  exportCertificateType?: Maybe<CertificateType>;
  id: Scalars['ID']['output'];
  majorVersion: Scalars['Int']['output'];
  minorVersion: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AwsS3Fields = {
  __typename?: 'AwsS3Fields';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type B2GAddress = {
  __typename?: 'B2GAddress';
  city?: Maybe<Scalars['String']['output']>;
  cityId?: Maybe<Scalars['ID']['output']>;
  countryId?: Maybe<Scalars['ID']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countrySubdivisionId?: Maybe<Scalars['ID']['output']>;
  countrySubdivisionName?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcodeCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<AddressTypeCode>;
};

export type B2GAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  countrySubdivisionId?: InputMaybe<Scalars['ID']['input']>;
  countrySubdivisionName?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcodeCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  typeCode?: InputMaybe<AddressTypeCode>;
};

export type B2GAuthentication = {
  __typename?: 'B2GAuthentication';
  actual?: Maybe<Scalars['AWSDateTime']['output']>;
  includedClauses: Array<B2GClause>;
  issueLocation?: Maybe<B2GLocation>;
  locationProviderParty?: Maybe<B2GParty>;
  providerParty?: Maybe<B2GParty>;
  typeCode?: Maybe<NamedCode>;
};

export type B2GAuthenticationInput = {
  actual?: InputMaybe<Scalars['AWSDateTime']['input']>;
  includedClauses?: InputMaybe<Array<B2GClauseInput>>;
  issueLocation?: InputMaybe<B2GLocationInput>;
  locationProviderParty?: InputMaybe<B2GPartyInput>;
  providerParty?: InputMaybe<B2GPartyInput>;
  typeCode?: InputMaybe<NamedCodeInput>;
};

export type B2GBanWineBatchInput = {
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  market: DestinationMarket;
  productId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type B2GCertificateDelivery = {
  __typename?: 'B2GCertificateDelivery';
  certificateDeliveryMethod?: Maybe<B2GCertificateDeliveryMethod>;
  certificateSigningOffice?: Maybe<Scalars['ID']['output']>;
  collectionMethod?: Maybe<B2GCollectionMethod>;
  copies?: Maybe<Scalars['Int']['output']>;
  digitalScanRequired?: Maybe<Scalars['Boolean']['output']>;
  dueDate?: Maybe<Scalars['AWSDateTime']['output']>;
  recipientAddress?: Maybe<B2GAddress>;
  recipientContactName?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
};

export type B2GCertificateDeliveryInput = {
  certificateDeliveryMethod?: InputMaybe<B2GCertificateDeliveryMethod>;
  certificateSigningOffice?: InputMaybe<Scalars['ID']['input']>;
  collectionMethod?: InputMaybe<B2GCollectionMethod>;
  copies?: InputMaybe<Scalars['Int']['input']>;
  digitalScanRequired?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  recipientAddress?: InputMaybe<B2GAddressInput>;
  recipientContactName?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

export enum B2GCertificateDeliveryMethod {
  OvernightCourierAuckland = 'OVERNIGHT_COURIER_AUCKLAND',
  OvernightCourierChristchurch = 'OVERNIGHT_COURIER_CHRISTCHURCH',
  UrgentCourier = 'URGENT_COURIER'
}

export type B2GClassification = {
  __typename?: 'B2GClassification';
  classCode?: Maybe<Scalars['String']['output']>;
  className: Scalars['String']['output'];
  systemId?: Maybe<Scalars['String']['output']>;
  systemName: Scalars['String']['output'];
};

export type B2GClassificationInput = {
  classCode?: InputMaybe<Scalars['String']['input']>;
  className: Scalars['String']['input'];
  systemId?: InputMaybe<Scalars['String']['input']>;
  systemName: Scalars['String']['input'];
};

export type B2GClause = {
  __typename?: 'B2GClause';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type B2GClauseInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum B2GCollectionMethod {
  Delivery = 'Delivery',
  Pickup = 'Pickup'
}

export type B2GConsignment = {
  __typename?: 'B2GConsignment';
  EORINumber?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<B2GParty>;
  consignee?: Maybe<B2GParty>;
  consignor?: Maybe<B2GParty>;
  consignorReference?: Maybe<Scalars['ID']['output']>;
  containers: Array<B2GContainer>;
  delivery?: Maybe<B2GParty>;
  expectedArrivalDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  exportExitDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  grossWeight?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<B2GTradeLineItem>;
  loadingBasePort?: Maybe<B2GLocation>;
  mainCarriageTransportMovements: Array<B2GTransportMovement>;
  unloadingBasePort?: Maybe<B2GLocation>;
  verifier?: Maybe<B2GParty>;
  wineConsignment?: Maybe<B2GWineConsignment>;
  /** @deprecated Use wineConsignment.shippingFormat */
  wineShippingFormat?: Maybe<WinePackaging>;
};

export type B2GConsignmentInput = {
  EORINumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<B2GPartyInput>;
  consignee?: InputMaybe<B2GPartyInput>;
  consignor?: InputMaybe<B2GPartyInput>;
  consignorReference?: InputMaybe<Scalars['ID']['input']>;
  containers?: InputMaybe<Array<B2GContainerInput>>;
  delivery?: InputMaybe<B2GPartyInput>;
  expectedArrivalDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exportExitDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  grossWeight?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<B2GTradeLineItemInput>>;
  loadingBasePort?: InputMaybe<B2GLocationInput>;
  mainCarriageTransportMovements?: InputMaybe<Array<B2GTransportMovementInput>>;
  unloadingBasePort?: InputMaybe<B2GLocationInput>;
  verifier?: InputMaybe<B2GPartyInput>;
  wineConsignment?: InputMaybe<B2GWineConsignmentInput>;
  /** @deprecated Use wineConsignment.shippingFormat */
  wineShippingFormat?: InputMaybe<WinePackaging>;
};

export type B2GContact = {
  __typename?: 'B2GContact';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type B2GContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type B2GContainer = {
  __typename?: 'B2GContainer';
  affixedSeals: Array<B2GSeal>;
  containerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  temperatureSettings: Array<B2GTemperature>;
};

export type B2GContainerInput = {
  affixedSeals?: InputMaybe<Array<B2GSealInput>>;
  containerId: Scalars['String']['input'];
  temperatureSettings?: InputMaybe<Array<B2GTemperatureInput>>;
};

export type B2GCountry = {
  __typename?: 'B2GCountry';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<B2GCountrySubDivision>;
};

export type B2GCountryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<B2GCountrySubDivisionInput>;
};

export type B2GCountrySubDivision = {
  __typename?: 'B2GCountrySubDivision';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type B2GCountrySubDivisionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type B2GDeclaration = {
  __typename?: 'B2GDeclaration';
  eligibilityCriteria: Scalars['ID']['output'];
  market?: Maybe<DestinationMarket>;
  text?: Maybe<Scalars['String']['output']>;
};

export type B2GDeclarationInput = {
  eligibilityCriteria: Scalars['ID']['input'];
  market?: InputMaybe<DestinationMarket>;
  text: Scalars['String']['input'];
};

export type B2GEligibilityCriteriaMet = {
  __typename?: 'B2GEligibilityCriteriaMet';
  effectiveDate?: Maybe<Scalars['AWSDateTime']['output']>;
  eligibilityCriteria: Scalars['ID']['output'];
  expiryDate?: Maybe<Scalars['AWSDateTime']['output']>;
  processId: Scalars['ID']['output'];
};

export type B2GEligibilityCriteriaMetInput = {
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eligibilityCriteria: Scalars['ID']['input'];
  expiryDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  processId: Scalars['ID']['input'];
};

export type B2GEligibilityStatus = {
  __typename?: 'B2GEligibilityStatus';
  expiryDate?: Maybe<Scalars['AWSDateTime']['output']>;
  market: DestinationMarket;
  status: B2GEligibilityStatusType;
};

export enum B2GEligibilityStatusType {
  Eligible = 'ELIGIBLE',
  Expired = 'EXPIRED',
  Incomplete = 'INCOMPLETE',
  NotEligible = 'NOT_ELIGIBLE',
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED'
}

export enum B2GError {
  InvalidValue = 'INVALID_VALUE',
  Required = 'REQUIRED'
}

export type B2GExportCertificateRequest = {
  __typename?: 'B2GExportCertificateRequest';
  certificateDelivery?: Maybe<B2GCertificateDelivery>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  certificateType?: Maybe<CertificateType>;
  commodity?: Maybe<Scalars['String']['output']>;
  consignment?: Maybe<B2GConsignment>;
  customsPermitNumber?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<B2GCountry>;
  exporterDeclaration?: Maybe<B2GExporterDeclaration>;
  id: Scalars['ID']['output'];
  lastStatusChange?: Maybe<Scalars['AWSDateTime']['output']>;
  market: DestinationMarket;
  referencedDocuments: Array<B2GReferencedDocument>;
  replacedBy?: Maybe<B2GExportCertificateRequest>;
  replacing?: Maybe<B2GExportCertificateRequest>;
  requestName?: Maybe<Scalars['String']['output']>;
  requestedOnBehalfOfConsignor?: Maybe<Scalars['Boolean']['output']>;
  status: ExportCertificateStatus;
  statusLabel: Scalars['String']['output'];
  statusNotes?: Maybe<Scalars['String']['output']>;
};

export type B2GExportCertificateRequestInput = {
  certificateDelivery?: InputMaybe<B2GCertificateDeliveryInput>;
  certificateType?: InputMaybe<CertificateType>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  consignment?: InputMaybe<B2GConsignmentInput>;
  copyFromId?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<B2GCountryInput>;
  exporterDeclaration?: InputMaybe<B2GExporterDeclarationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use consigment.consignor.id */
  partyId?: InputMaybe<Scalars['ID']['input']>;
  referencedDocuments?: InputMaybe<Array<B2GReferencedDocumentInput>>;
  requestName?: InputMaybe<Scalars['String']['input']>;
  requestedOnBehalfOfConsignor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type B2GExportCertificatesDownloadUrl = {
  __typename?: 'B2GExportCertificatesDownloadUrl';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type B2GExporterDeclaration = {
  __typename?: 'B2GExporterDeclaration';
  date: Scalars['AWSDateTime']['output'];
  name: Scalars['String']['output'];
};

export type B2GExporterDeclarationInput = {
  date: Scalars['AWSDateTime']['input'];
  name: Scalars['String']['input'];
};

export type B2GLocation = {
  __typename?: 'B2GLocation';
  country?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type B2GLocationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type B2GNote = {
  __typename?: 'B2GNote';
  content: Scalars['String']['output'];
  contentCode?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectCode?: Maybe<Scalars['String']['output']>;
};

export type B2GNoteInput = {
  content: Scalars['String']['input'];
  contentCode?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjectCode?: InputMaybe<Scalars['String']['input']>;
};

export type B2GPackage = {
  __typename?: 'B2GPackage';
  levelCode?: Maybe<Scalars['String']['output']>;
  nominalGrossVolume?: Maybe<Scalars['String']['output']>;
  nominalGrossWeight?: Maybe<Scalars['String']['output']>;
  packaging?: Maybe<B2GPackage>;
  physicalShippingMarks: Array<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<NamedCode>;
};

export type B2GPackageInput = {
  levelCode?: InputMaybe<Scalars['String']['input']>;
  nominalGrossVolume?: InputMaybe<Scalars['String']['input']>;
  nominalGrossWeight?: InputMaybe<Scalars['String']['input']>;
  packaging?: InputMaybe<B2GPackageInput>;
  physicalShippingMarks?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  typeCode?: InputMaybe<NamedCodeInput>;
};

export type B2GParty = {
  __typename?: 'B2GParty';
  definedContacts: Array<B2GContact>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use registration.number */
  partyId?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<B2GRegistrationDetails>;
  specifiedAddress?: Maybe<B2GAddress>;
  specifiedPerson?: Maybe<B2GPerson>;
};

export type B2GPartyInput = {
  definedContacts?: InputMaybe<Array<B2GContactInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use registrationNumber */
  partyId?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<B2GRegistrationDetailsInput>;
  specifiedAddress?: InputMaybe<B2GAddressInput>;
  specifiedPerson?: InputMaybe<B2GPersonInput>;
};

export type B2GPeriod = {
  __typename?: 'B2GPeriod';
  duration?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['AWSDateTime']['output']>;
  start?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type B2GPeriodInput = {
  duration?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['AWSDateTime']['input']>;
  start?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type B2GPerson = {
  __typename?: 'B2GPerson';
  attainedQualifications: Array<B2GQualification>;
  name?: Maybe<Scalars['String']['output']>;
};

export type B2GPersonInput = {
  attainedQualifications?: InputMaybe<Array<B2GQualificationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type B2GPremise = {
  __typename?: 'B2GPremise';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type B2GPremiseInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type B2GProcess = {
  __typename?: 'B2GProcess';
  applicableProcessCharacteristics: Array<B2GProcessCharacteristic>;
  completionPeriod?: Maybe<B2GPeriod>;
  operationCountry?: Maybe<B2GCountry>;
  operatorParty?: Maybe<B2GParty>;
  typeCode?: Maybe<NamedCode>;
};

export type B2GProcessCharacteristic = {
  __typename?: 'B2GProcessCharacteristic';
  description?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<NamedCode>;
  value?: Maybe<Scalars['String']['output']>;
};

export type B2GProcessCharacteristicInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  typeCode?: InputMaybe<NamedCodeInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type B2GProcessInput = {
  applicableProcessCharacteristics?: InputMaybe<Array<B2GProcessCharacteristicInput>>;
  completionPeriod?: InputMaybe<B2GPeriodInput>;
  operationCountry?: InputMaybe<B2GCountryInput>;
  operatorParty?: InputMaybe<B2GPartyInput>;
  typeCode?: InputMaybe<NamedCodeInput>;
};

export type B2GProduct = {
  __typename?: 'B2GProduct';
  additionalInformation: Array<B2GNote>;
  appliedProcesses: Array<B2GProcess>;
  assertedAuthentications: Array<B2GAuthentication>;
  classifications: Array<B2GClassification>;
  cnCode?: Maybe<Scalars['String']['output']>;
  commodity: Scalars['String']['output'];
  commonName?: Maybe<Scalars['String']['output']>;
  created: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  declarations?: Maybe<Array<B2GDeclaration>>;
  description: Scalars['String']['output'];
  eligibilityCriteriaFailed?: Maybe<Array<B2GEligibilityCriteriaMet>>;
  eligibilityCriteriaMet?: Maybe<Array<B2GEligibilityCriteriaMet>>;
  eligibilityStatus?: Maybe<Array<B2GEligibilityStatus>>;
  events: Array<B2GProductEvent>;
  expiry?: Maybe<Scalars['AWSDateTime']['output']>;
  exporterReference?: Maybe<Scalars['ID']['output']>;
  finalProcessor?: Maybe<B2GParty>;
  grossVolume?: Maybe<Scalars['String']['output']>;
  grossWeight?: Maybe<Scalars['String']['output']>;
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intendedUse: Array<Scalars['String']['output']>;
  migrationId?: Maybe<Scalars['ID']['output']>;
  modifiable: Scalars['Boolean']['output'];
  netVolume?: Maybe<Scalars['String']['output']>;
  netWeight?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  physicalPackage?: Maybe<B2GPackage>;
  premise: B2GPremise;
  productNumber?: Maybe<Scalars['String']['output']>;
  productionBatchIds: Array<Scalars['String']['output']>;
  referencedDocuments: Array<B2GReferencedDocument>;
  scientificName?: Maybe<Scalars['String']['output']>;
  verifier?: Maybe<B2GParty>;
  wine?: Maybe<B2GWineFields>;
};

export type B2GProductEligibility = {
  __typename?: 'B2GProductEligibility';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  criteriaId: Scalars['ID']['output'];
  effectiveDate?: Maybe<Scalars['AWSDateTime']['output']>;
  executionArn?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  market: DestinationMarket;
  status: B2GEligibilityStatusType;
};

export type B2GProductEligibilityCriteriaV2 = {
  __typename?: 'B2GProductEligibilityCriteriaV2';
  active?: Maybe<Scalars['Boolean']['output']>;
  criteria: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['AWSDateTime']['output']>;
  expiryDate?: Maybe<Scalars['AWSDateTime']['output']>;
  failed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  market?: Maybe<DestinationMarket>;
  met: Scalars['Boolean']['output'];
  processId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  wsmpId?: Maybe<Scalars['String']['output']>;
};

export type B2GProductEligibilityInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  criteriaId: Scalars['ID']['input'];
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  executionArn?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  market: DestinationMarket;
  status: B2GEligibilityStatusType;
};

export type B2GProductEvent = {
  __typename?: 'B2GProductEvent';
  from: B2GProduct;
  id: Scalars['ID']['output'];
  other?: Maybe<Scalars['String']['output']>;
  to: B2GProduct;
  what: B2GProductEventType;
  when: Scalars['AWSDateTime']['output'];
  where: B2GPremise;
};

export enum B2GProductEventType {
  AddedToExportCertificateRequest = 'ADDED_TO_EXPORT_CERTIFICATE_REQUEST',
  Amended = 'AMENDED',
  Other = 'OTHER',
  Processsed = 'PROCESSSED',
  Saved = 'SAVED',
  Transferred = 'TRANSFERRED'
}

export type B2GProductInput = {
  additionalInformation?: InputMaybe<Array<B2GNoteInput>>;
  appliedProcesses?: InputMaybe<Array<B2GProcessInput>>;
  assertedAuthentications?: InputMaybe<Array<B2GAuthenticationInput>>;
  classifications?: InputMaybe<Array<B2GClassificationInput>>;
  cnCode?: InputMaybe<Scalars['String']['input']>;
  commodity: Scalars['String']['input'];
  commonName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['AWSDateTime']['input']>;
  declarations?: InputMaybe<Array<B2GDeclarationInput>>;
  description: Scalars['String']['input'];
  eligibilityCriteriaFailed?: InputMaybe<Array<B2GEligibilityCriteriaMetInput>>;
  eligibilityCriteriaMet?: InputMaybe<Array<B2GEligibilityCriteriaMetInput>>;
  expiry?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exporterReference?: InputMaybe<Scalars['ID']['input']>;
  finalProcessor?: InputMaybe<B2GPartyInput>;
  grossVolume?: InputMaybe<Scalars['String']['input']>;
  grossWeight?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intendedUse?: InputMaybe<Array<Scalars['String']['input']>>;
  netVolume?: InputMaybe<Scalars['String']['input']>;
  netWeight?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  physicalPackage?: InputMaybe<B2GPackageInput>;
  premise: B2GPremiseInput;
  productionBatchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  referencedDocuments?: InputMaybe<Array<B2GReferencedDocumentInput>>;
  scientificName?: InputMaybe<Scalars['String']['input']>;
  verifier?: InputMaybe<B2GPartyInput>;
  wine?: InputMaybe<B2GWineFieldsInput>;
};

export type B2GProductsDownloadUrl = {
  __typename?: 'B2GProductsDownloadUrl';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type B2GQualification = {
  __typename?: 'B2GQualification';
  abbreviatedName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type B2GQualificationInput = {
  abbreviatedName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type B2GReferencedDocument = {
  __typename?: 'B2GReferencedDocument';
  attachment?: Maybe<ReferencedDocument>;
  documentType?: Maybe<Scalars['String']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  issued?: Maybe<Scalars['AWSDateTime']['output']>;
  relationshipTypeCode: Scalars['String']['output'];
  requestorId?: Maybe<Scalars['ID']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
};

export type B2GReferencedDocumentInput = {
  attachment: Scalars['ID']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  issued?: InputMaybe<Scalars['AWSDateTime']['input']>;
  relationshipTypeCode: Scalars['String']['input'];
  requestorId?: InputMaybe<Scalars['ID']['input']>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
};

export type B2GRegistrationDetails = {
  __typename?: 'B2GRegistrationDetails';
  identifier?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type B2GRegistrationDetailsInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type B2GSeal = {
  __typename?: 'B2GSeal';
  issuingParty?: Maybe<B2GParty>;
  sealId: Scalars['String']['output'];
};

export type B2GSealInput = {
  issuingParty?: InputMaybe<B2GPartyInput>;
  sealId: Scalars['String']['input'];
};

export type B2GTemperature = {
  __typename?: 'B2GTemperature';
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type B2GTemperatureInput = {
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type B2GTradeLineItem = {
  __typename?: 'B2GTradeLineItem';
  associatedTransportEquipment: Array<B2GContainer>;
  id: Scalars['String']['output'];
  physicalPackage?: Maybe<B2GPackage>;
  product?: Maybe<B2GProduct>;
  verified: Scalars['Boolean']['output'];
};

export type B2GTradeLineItemContainer = {
  __typename?: 'B2GTradeLineItemContainer';
  containerId: Scalars['String']['output'];
  grossVolume?: Maybe<Scalars['String']['output']>;
  grossWeight?: Maybe<Scalars['String']['output']>;
  netVolume?: Maybe<Scalars['String']['output']>;
  netWeight?: Maybe<Scalars['String']['output']>;
};

export type B2GTradeLineItemContainerInput = {
  containerId: Scalars['String']['input'];
  grossVolume?: InputMaybe<Scalars['String']['input']>;
  grossWeight?: InputMaybe<Scalars['String']['input']>;
  netVolume?: InputMaybe<Scalars['String']['input']>;
  netWeight?: InputMaybe<Scalars['String']['input']>;
};

export type B2GTradeLineItemInput = {
  associatedTransportEquipment?: InputMaybe<Array<B2GContainerInput>>;
  physicalPackage?: InputMaybe<B2GPackageInput>;
  product?: InputMaybe<B2GProductInput>;
};

export type B2GTransportMovement = {
  __typename?: 'B2GTransportMovement';
  /** @deprecated Use reference */
  ITDNNumber?: Maybe<Scalars['String']['output']>;
  mode: TransportModeCode;
  reference?: Maybe<Scalars['String']['output']>;
  registeredCountry?: Maybe<B2GCountry>;
  usedTransportMeans?: Maybe<Scalars['String']['output']>;
};

export type B2GTransportMovementInput = {
  /** @deprecated Use reference */
  ITDNNumber?: InputMaybe<Scalars['String']['input']>;
  mode: TransportModeCode;
  reference?: InputMaybe<Scalars['String']['input']>;
  registeredCountry?: InputMaybe<B2GCountryInput>;
  usedTransportMeans?: InputMaybe<Scalars['String']['input']>;
};

export type B2GValidationErrors = {
  __typename?: 'B2GValidationErrors';
  error?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<B2GError>;
};

export type B2GWineChemistry = {
  __typename?: 'B2GWineChemistry';
  actual_alcohol_content?: Maybe<Scalars['String']['output']>;
  citric_acidity?: Maybe<Scalars['String']['output']>;
  laboratory?: Maybe<B2GParty>;
  laboratoryReference?: Maybe<Scalars['String']['output']>;
  methyl_alcohol?: Maybe<Scalars['String']['output']>;
  reduced_dry_extract?: Maybe<Scalars['String']['output']>;
  sugar_content?: Maybe<Scalars['String']['output']>;
  sugar_content_qualifier?: Maybe<Scalars['String']['output']>;
  total_acidity_7_0?: Maybe<Scalars['String']['output']>;
  total_acidity_8_2_meql?: Maybe<Scalars['String']['output']>;
  total_alcoholic_strength?: Maybe<Scalars['String']['output']>;
  total_dry_extract?: Maybe<Scalars['String']['output']>;
  total_sulphates?: Maybe<Scalars['String']['output']>;
  total_sulphur_dioxide?: Maybe<Scalars['String']['output']>;
  volatile_acidity?: Maybe<Scalars['String']['output']>;
  volatile_acidity_meql?: Maybe<Scalars['String']['output']>;
};

export type B2GWineConsignment = {
  __typename?: 'B2GWineConsignment';
  packaging?: Maybe<B2GPackage>;
  shippingFormat?: Maybe<WinePackaging>;
};

export type B2GWineConsignmentInput = {
  packaging?: InputMaybe<B2GPackageInput>;
  shippingFormat?: InputMaybe<WinePackaging>;
};

export type B2GWineFields = {
  __typename?: 'B2GWineFields';
  BRClassification?: Maybe<BrClassification>;
  EUCategory?: Maybe<Scalars['String']['output']>;
  EUIngredients?: Maybe<Array<EuIngredient>>;
  alternateWineNames?: Maybe<Array<Scalars['String']['output']>>;
  availableLitres?: Maybe<Scalars['Float']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  bottlerReference?: Maybe<Scalars['String']['output']>;
  chemistry?: Maybe<B2GWineChemistry>;
  colour?: Maybe<Scalars['String']['output']>;
  exportedLitres?: Maybe<Scalars['Float']['output']>;
  geographicIndication?: Maybe<Scalars['ID']['output']>;
  grapeVariety?: Maybe<Scalars['String']['output']>;
  isEUEligible?: Maybe<Scalars['Boolean']['output']>;
  mainNamePrefix?: Maybe<Scalars['String']['output']>;
  mainNameSuffix?: Maybe<Scalars['String']['output']>;
  package?: Maybe<B2GWinePackage>;
  shippingFormat?: Maybe<WinePackaging>;
  specialProcess?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  totalPackagedLitres?: Maybe<Scalars['Float']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
  volumeAdjustment?: Maybe<Array<ManualVolumeAdjustment>>;
};

export type B2GWineFieldsInput = {
  BRClassification?: InputMaybe<BrClassificationInput>;
  EUCategory?: InputMaybe<Scalars['String']['input']>;
  EUIngredients?: InputMaybe<Array<EuIngredientInput>>;
  alternateWineNames?: InputMaybe<Array<Scalars['String']['input']>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  geographicIndication?: InputMaybe<Scalars['ID']['input']>;
  grapeVariety?: InputMaybe<Scalars['String']['input']>;
  mainNamePrefix?: InputMaybe<Scalars['String']['input']>;
  mainNameSuffix?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<B2GWinePackageInput>;
  shippingFormat?: InputMaybe<WinePackaging>;
  specialProcess?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['String']['input']>;
};

export type B2GWinePackage = {
  __typename?: 'B2GWinePackage';
  bottleSize?: Maybe<Scalars['String']['output']>;
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  cases?: Maybe<Scalars['Int']['output']>;
  extraBottles?: Maybe<Scalars['Int']['output']>;
  nameForDocuments?: Maybe<Scalars['String']['output']>;
  totalBottles?: Maybe<Scalars['Int']['output']>;
};

export type B2GWinePackageInput = {
  bottleSize?: InputMaybe<Scalars['String']['input']>;
  bottlesPerCase?: InputMaybe<Scalars['Int']['input']>;
  cases?: InputMaybe<Scalars['Int']['input']>;
  extraBottles?: InputMaybe<Scalars['Int']['input']>;
  nameForDocuments?: InputMaybe<Scalars['String']['input']>;
};

export type BrClassification = {
  __typename?: 'BRClassification';
  className?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sugarContent?: Maybe<Scalars['String']['output']>;
};

export type BrClassificationInput = {
  className?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sugarContent?: InputMaybe<Scalars['String']['input']>;
};

export type BrClassificationTemplate = {
  __typename?: 'BRClassificationTemplate';
  class_name?: Maybe<Scalars['String']['output']>;
  sugar_content?: Maybe<Scalars['String']['output']>;
};

export type Block = {
  __typename?: 'Block';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Row>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BottlingRunData = {
  __typename?: 'BottlingRunData';
  bottleVolume: Scalars['ID']['output'];
  bottlesPerCase: Scalars['Int']['output'];
  cases: Scalars['Int']['output'];
  date: Scalars['AWSDateTime']['output'];
  extraBottles?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  litres: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
};

export type BottlingRunDataInput = {
  bottleVolume: Scalars['ID']['input'];
  bottlesPerCase: Scalars['Int']['input'];
  cases: Scalars['Int']['input'];
  date: Scalars['AWSDateTime']['input'];
  extraBottles?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  reference: Scalars['String']['input'];
};

export type BottlingRunInput = {
  processId: Scalars['ID']['input'];
  runs: Array<BottlingRunDataInput>;
};

export type BottlingRunResponse = {
  __typename?: 'BottlingRunResponse';
  processId: Scalars['ID']['output'];
  runs: Array<BottlingRunData>;
};

export enum BusinessArea {
  Dairy = 'DAIRY',
  Honey = 'HONEY',
  LiveAnimals = 'LIVE_ANIMALS',
  Meat = 'MEAT',
  Organics = 'ORGANICS',
  Other = 'OTHER',
  Plants = 'PLANTS',
  Seafood = 'SEAFOOD',
  Seed = 'SEED',
  Wine = 'WINE'
}

export type BusinessRule = {
  __typename?: 'BusinessRule';
  path?: Maybe<Scalars['String']['output']>;
};

export type BusinessRuleConfigInput = {
  businessRules?: InputMaybe<Array<InputMaybe<BusinessRuleInput>>>;
  fields?: InputMaybe<Array<InputMaybe<BusinessRuleFieldInput>>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type BusinessRuleField = IConfigField & {
  __typename?: 'BusinessRuleField';
  BusinessRules?: Maybe<Array<Maybe<BusinessRule>>>;
  fuid?: Maybe<Scalars['ID']['output']>;
};

export type BusinessRuleFieldInput = {
  businessRules?: InputMaybe<Array<InputMaybe<BusinessRuleInput>>>;
  fuid?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessRuleInput = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessRulesConfig = IConfig & IConfigBase & {
  __typename?: 'BusinessRulesConfig';
  businessRules?: Maybe<Array<Maybe<BusinessRule>>>;
  fields?: Maybe<Array<Maybe<BusinessRuleField>>>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateRevisionId?: Maybe<Scalars['ID']['output']>;
};

export type CtAssayTestDataInput = {
  analyticalTechnique?: InputMaybe<Scalars['String']['input']>;
  assayTestName?: InputMaybe<Scalars['String']['input']>;
  assayTestNumber?: InputMaybe<Scalars['String']['input']>;
  isQualitative?: InputMaybe<Scalars['Boolean']['input']>;
  repetitions?: InputMaybe<Array<InputMaybe<CtRepetitionDataInput>>>;
  reportingUnit?: InputMaybe<Scalars['String']['input']>;
};

export type CtCancellationDataInput = {
  sampleId: Scalars['String']['input'];
};

export type CtCancelledDataInput = {
  sampleId: Scalars['String']['input'];
};

export type CtCompoundDataInput = {
  compoundName?: InputMaybe<Scalars['String']['input']>;
  detectionLimit?: InputMaybe<Scalars['String']['input']>;
  quantitativeResult?: InputMaybe<Scalars['String']['input']>;
  resultQualifier?: InputMaybe<Scalars['String']['input']>;
  resultState?: InputMaybe<Scalars['String']['input']>;
};

export type CtErrorDataInput = {
  processId: Scalars['String']['input'];
};

export type CtFailStatusDataInput = {
  destinationMarkets?: InputMaybe<Array<InputMaybe<DestinationMarket>>>;
  sampleId: Scalars['String']['input'];
  testResults?: InputMaybe<Array<InputMaybe<CtAssayTestDataInput>>>;
};

export type CtFirstReportedDateDataInput = {
  firstReportedDate: Scalars['AWSDateTime']['input'];
  sampleId: Scalars['String']['input'];
};

export type CtInProgressStatusDataInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  dateTimeReceived?: InputMaybe<Scalars['String']['input']>;
  isReceipted?: InputMaybe<Scalars['Boolean']['input']>;
  laboratoryReference?: InputMaybe<Scalars['String']['input']>;
  officiallySealed?: InputMaybe<Scalars['Boolean']['input']>;
  reasonUnsuitable?: InputMaybe<Scalars['String']['input']>;
  receiptChangedOn?: InputMaybe<Scalars['String']['input']>;
  sampleId: Scalars['String']['input'];
  sampleTemperature?: InputMaybe<Scalars['String']['input']>;
  suitable?: InputMaybe<Scalars['Boolean']['input']>;
  timeStamp?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CtnCancellationErrorDataInput = {
  sampleId: Scalars['String']['input'];
};

export type CtNoOrgErrorDataInput = {
  processId: Scalars['String']['input'];
};

export type CtPassStatusDataInput = {
  destinationMarkets?: InputMaybe<Array<InputMaybe<DestinationMarket>>>;
  sampleId: Scalars['String']['input'];
  testResults?: InputMaybe<Array<InputMaybe<CtAssayTestDataInput>>>;
};

export type CtRepetitionDataInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  compounds?: InputMaybe<Array<InputMaybe<CtCompoundDataInput>>>;
  repetitionId?: InputMaybe<Scalars['Int']['input']>;
  reportedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  resultsEntered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtRequestedStatusDataInput = {
  processId: Scalars['String']['input'];
  sampleId: Scalars['String']['input'];
  sampleNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum CtStatusEventType {
  CancellationError = 'CANCELLATION_ERROR',
  CancellationRequested = 'CANCELLATION_REQUESTED',
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Fail = 'FAIL',
  FirstResultReported = 'FIRST_RESULT_REPORTED',
  InProgress = 'IN_PROGRESS',
  NoOrgFoundError = 'NO_ORG_FOUND_ERROR',
  Pass = 'PASS',
  Request = 'REQUEST',
  Requested = 'REQUESTED',
  Unsuitable = 'UNSUITABLE'
}

export type CtUnsuitableStatusDataInput = {
  laboratoryReference?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  receiptDate?: InputMaybe<Scalars['String']['input']>;
  sampleId: Scalars['String']['input'];
  suitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelExportCertificateRequestInput = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelSupportingDocumentInput = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelledProcessInput = {
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
  processId: Scalars['ID']['input'];
};

export type CancelledProcessResponse = {
  __typename?: 'CancelledProcessResponse';
  cancelledReason?: Maybe<Scalars['String']['output']>;
  firstResultReportedDate?: Maybe<Scalars['String']['output']>;
  receipt: ChemistryTestReceipt;
  request: ChemistryTestRequest;
  status?: Maybe<Scalars['String']['output']>;
};

export enum CargoTypeClassificationCode {
  CtBallastOnly = 'CT_BALLAST_ONLY',
  CtBreakbulk = 'CT_BREAKBULK',
  CtContainerized = 'CT_CONTAINERIZED',
  CtDeepFrozenCargo = 'CT_DEEP_FROZEN_CARGO',
  CtDiplomatic = 'CT_DIPLOMATIC',
  CtDocuments = 'CT_DOCUMENTS',
  CtEnvironmentalPollutantCargo = 'CT_ENVIRONMENTAL_POLLUTANT_CARGO',
  CtFrozenCargo = 'CT_FROZEN_CARGO',
  CtGeneralCargo = 'CT_GENERAL_CARGO',
  CtHazardousCargo = 'CT_HAZARDOUS_CARGO',
  CtHighValueConsignments = 'CT_HIGH_VALUE_CONSIGNMENTS',
  CtHouseholdGoodsAndPersonalEffects = 'CT_HOUSEHOLD_GOODS_AND_PERSONAL_EFFECTS',
  CtIncompatibleCargo = 'CT_INCOMPATIBLE_CARGO',
  CtLiquidCargo = 'CT_LIQUID_CARGO',
  CtLowValueDutiableConsignments = 'CT_LOW_VALUE_DUTIABLE_CONSIGNMENTS',
  CtLowValueNonDutiableConsignments = 'CT_LOW_VALUE_NON_DUTIABLE_CONSIGNMENTS',
  CtMilitary = 'CT_MILITARY',
  CtNotHazardousCargo = 'CT_NOT_HAZARDOUS_CARGO',
  CtObnoxious = 'CT_OBNOXIOUS',
  CtOtherNonContainerized = 'CT_OTHER_NON_CONTAINERIZED',
  CtOutOfGauge = 'CT_OUT_OF_GAUGE',
  CtPalletized = 'CT_PALLETIZED',
  CtRollOnRollOff = 'CT_ROLL_ON_ROLL_OFF',
  CtTemperatureControlledCargo = 'CT_TEMPERATURE_CONTROLLED_CARGO',
  CtVehicles = 'CT_VEHICLES'
}

export type CertificateCollectionInput = {
  action: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
  reasonInformation?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  systemUserName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type CertificateCollectionOutput = {
  __typename?: 'CertificateCollectionOutput';
  certificateNumber?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum CertificateType {
  Catch = 'CATCH',
  ExportEligibilityStatement = 'EXPORT_ELIGIBILITY_STATEMENT',
  FreeSale = 'FREE_SALE',
  FreeSaleStatement = 'FREE_SALE_STATEMENT',
  Halal = 'HALAL',
  LiveAnimals = 'LIVE_ANIMALS',
  Nonconsignment = 'NONCONSIGNMENT',
  OecdSeedVarietal = 'OECD_SEED_VARIETAL',
  Organics = 'ORGANICS',
  OtherDocument = 'OTHER_DOCUMENT',
  Phytosanitary = 'PHYTOSANITARY',
  ProductEstablishmentRegistrationDocument = 'PRODUCT_ESTABLISHMENT_REGISTRATION_DOCUMENT',
  ReexportPhytosanitary = 'REEXPORT_PHYTOSANITARY',
  Sanitary = 'SANITARY',
  Supplementary = 'SUPPLEMENTARY'
}

export enum ChangeExportRequestAction {
  Amend = 'AMEND',
  CertificateCollected = 'CERTIFICATE_COLLECTED',
  ExhaustionUpdated = 'EXHAUSTION_UPDATED',
  FullyExhausted = 'FULLY_EXHAUSTED',
  FullyUnExhausted = 'FULLY_UN_EXHAUSTED',
  PreValidationCheck = 'PRE_VALIDATION_CHECK',
  Raise = 'RAISE',
  Replaced = 'REPLACED',
  ResponseReceived = 'RESPONSE_RECEIVED',
  StatusChange = 'STATUS_CHANGE',
  Transferred = 'TRANSFERRED'
}

export enum ChangeExportRequestStatus {
  Accepted = 'ACCEPTED',
  Acknowledged = 'ACKNOWLEDGED',
  Amended = 'AMENDED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  PendingReplacement = 'PENDING_REPLACEMENT',
  Raised = 'RAISED',
  Replaced = 'REPLACED',
  ReplacementAuthorised = 'REPLACEMENT_AUTHORISED',
  RequestReplacement = 'REQUEST_REPLACEMENT',
  Resubmit = 'RESUBMIT',
  Revoked = 'REVOKED'
}

export type ChangeExportRequestStatusInput = {
  action?: InputMaybe<ChangeExportRequestAction>;
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  exportRequestId: Scalars['ID']['input'];
  overseasAuthorityInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  reasonCategories?: InputMaybe<Array<EditReasonCategory>>;
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  requestOrigin?: InputMaybe<RequestOrigin>;
  status: ChangeExportRequestStatus;
  submissionLayout?: InputMaybe<SubmissionLayoutType>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ChangeExportRequestStatusResponse = {
  __typename?: 'ChangeExportRequestStatusResponse';
  exportRequestId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type ChangeTransferRequestAmendmentStatusInput = {
  b2gProfileName: Scalars['String']['input'];
  b2gSystemName: Scalars['String']['input'];
  certificateId: Scalars['ID']['input'];
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  status: ChangeTransferRequestStatus;
};

export type ChangeTransferRequestAmendmentStatusResponse = {
  __typename?: 'ChangeTransferRequestAmendmentStatusResponse';
  certificateId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ChangeTransferRequestStatus {
  Amended = 'AMENDED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Raised = 'RAISED',
  RequestAmendment = 'REQUEST_AMENDMENT',
  Resubmit = 'RESUBMIT',
  Revoked = 'REVOKED',
  ToBeAmended = 'TO_BE_AMENDED'
}

export type ChangeTransferRequestStatusInput = {
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  requestOrigin?: InputMaybe<RequestOrigin>;
  status: ChangeTransferRequestStatus;
  transferRequestId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ChangeTransferRequestStatusResponse = {
  __typename?: 'ChangeTransferRequestStatusResponse';
  status: Scalars['String']['output'];
  transferRequestId: Scalars['ID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type CheckUserAccessInput = {
  registrationId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CheckUserAccessResponse = {
  __typename?: 'CheckUserAccessResponse';
  allowed: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ChemistryTest = {
  chemistryTest: Scalars['String']['input'];
  result: Scalars['Float']['input'];
};

export type ChemistryTestEventDataInput = {
  cancellationData?: InputMaybe<CtCancellationDataInput>;
  cancellationErrorData?: InputMaybe<CtnCancellationErrorDataInput>;
  cancelledData?: InputMaybe<CtCancelledDataInput>;
  errorData?: InputMaybe<CtErrorDataInput>;
  event: CtStatusEventType;
  failData?: InputMaybe<CtFailStatusDataInput>;
  firstReportedDateData?: InputMaybe<CtFirstReportedDateDataInput>;
  inProgressData?: InputMaybe<CtInProgressStatusDataInput>;
  noOrgErrorData?: InputMaybe<CtNoOrgErrorDataInput>;
  passData?: InputMaybe<CtPassStatusDataInput>;
  requestData?: InputMaybe<ChemistryTestInput>;
  requestedData?: InputMaybe<CtRequestedStatusDataInput>;
  unsuitableData?: InputMaybe<CtUnsuitableStatusDataInput>;
};

export type ChemistryTestInput = {
  attributes: ChemistryTestRequestInput;
  productId: Scalars['ID']['input'];
};

export type ChemistryTestReceipt = {
  __typename?: 'ChemistryTestReceipt';
  laboratoryReference?: Maybe<Scalars['String']['output']>;
  receiptDate?: Maybe<Scalars['AWSDateTime']['output']>;
  sampleSuitable?: Maybe<Scalars['Boolean']['output']>;
  unsuitableReason?: Maybe<Scalars['String']['output']>;
};

export type ChemistryTestRequest = {
  __typename?: 'ChemistryTestRequest';
  expectedAlcoholContent?: Maybe<Scalars['Float']['output']>;
  laboratory: Scalars['ID']['output'];
  packagingDate?: Maybe<Scalars['AWSDateTime']['output']>;
  packagingReference?: Maybe<Scalars['String']['output']>;
  sampleCollectionDate: Scalars['AWSDateTime']['output'];
  sampleReference: Scalars['String']['output'];
  testRequired: Scalars['ID']['output'];
  wineTestReference: Scalars['String']['output'];
};

export type ChemistryTestRequestInput = {
  expectedAlcoholContent?: InputMaybe<Scalars['Float']['input']>;
  laboratory: Scalars['String']['input'];
  packagingDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  packagingReference?: InputMaybe<Scalars['String']['input']>;
  sampleCollectionDate: Scalars['AWSDateTime']['input'];
  testRequired: Scalars['ID']['input'];
};

export type ChemistryTestResponse = {
  __typename?: 'ChemistryTestResponse';
  cancelledReason?: Maybe<Scalars['String']['output']>;
  firstResultReportedDate?: Maybe<Scalars['String']['output']>;
  passedDestinationMarkets?: Maybe<Array<DestinationMarket>>;
  receipt: ChemistryTestReceipt;
  request: ChemistryTestRequest;
  requestedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  results?: Maybe<Array<ChemistryTestResult>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ChemistryTestResult = {
  __typename?: 'ChemistryTestResult';
  assayTestName?: Maybe<Scalars['String']['output']>;
  assayTestNumber: Scalars['String']['output'];
  entered?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  qualifier?: Maybe<Scalars['String']['output']>;
  reportedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  resultState?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ChemistryTestStatus {
  CancellationRequested = 'CANCELLATION_REQUESTED',
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  Pass = 'PASS',
  Requested = 'REQUESTED',
  Unsuitable = 'UNSUITABLE'
}

export enum ColumnsToDisplay {
  Code = 'CODE',
  CodeAndText = 'CODE_AND_TEXT',
  Text = 'TEXT'
}

export type CombinedPartyTemplate = {
  __typename?: 'CombinedPartyTemplate';
  authenticator?: Maybe<SpsPartyTemplate>;
  processor?: Maybe<SpsPartyTemplate>;
};

export enum CompetentAuthorityType {
  Custom = 'CUSTOM',
  MinistryForPrimaryIndustries = 'MINISTRY_FOR_PRIMARY_INDUSTRIES',
  NewZealandFoodSafetyAuthority = 'NEW_ZEALAND_FOOD_SAFETY_AUTHORITY',
  None = 'NONE'
}

export type ConfirmPackagingInput = {
  confirmed: Scalars['Boolean']['input'];
  disputeReason?: InputMaybe<Scalars['String']['input']>;
  disputeResolution?: InputMaybe<Scalars['String']['input']>;
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export type ConfirmPackagingResponse = {
  __typename?: 'ConfirmPackagingResponse';
  confirmed: Scalars['Boolean']['output'];
  disputeReason?: Maybe<Scalars['String']['output']>;
  disputeResolution?: Maybe<Scalars['String']['output']>;
  processId: Scalars['ID']['output'];
};

export type ConfirmWinemakingInput = {
  confirmations: Array<WinemakingConfirmationInput>;
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export enum ConnectionType {
  Direct = 'Direct',
  Hub = 'Hub'
}

export type ConsignorDetails = {
  __typename?: 'ConsignorDetails';
  identifiers: Array<ConsignorIdentifier>;
  name: Scalars['String']['output'];
  physicalAddress?: Maybe<Scalars['String']['output']>;
};

export type ConsignorIdentifier = {
  __typename?: 'ConsignorIdentifier';
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CoreAddress = {
  __typename?: 'CoreAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type CoreB2GFile = {
  __typename?: 'CoreB2GFile';
  attachment?: Maybe<Scalars['String']['output']>;
  extensionType?: Maybe<PhytoSupportingDocumentType>;
  fileContentType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CoreB2GFileInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  extensionType?: InputMaybe<PhytoSupportingDocumentType>;
  fileContentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CoreCommodity = {
  __typename?: 'CoreCommodity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CoreContainer = {
  __typename?: 'CoreContainer';
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  seals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CoreContainerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  seals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CoreCountry = {
  __typename?: 'CoreCountry';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CoreDateRange = {
  __typename?: 'CoreDateRange';
  from?: Maybe<Scalars['AWSDate']['output']>;
  to?: Maybe<Scalars['AWSDate']['output']>;
};

export type CoreDateRangeInput = {
  from?: InputMaybe<Scalars['AWSDate']['input']>;
  to?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type CoreDeclarationInputValueOutput = {
  __typename?: 'CoreDeclarationInputValueOutput';
  id?: Maybe<Scalars['ID']['output']>;
  inputValue?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
};

export type CoreDeclarationOutput = {
  __typename?: 'CoreDeclarationOutput';
  id?: Maybe<Scalars['ID']['output']>;
  inputs?: Maybe<Array<CoreDeclarationInputValueOutput>>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  statementCode?: Maybe<Scalars['Int']['output']>;
  substitutedText?: Maybe<Scalars['String']['output']>;
  substitutedTranslatedText?: Maybe<Array<Maybe<CoreDeclarationTranslatedText>>>;
};

export type CoreDeclarationTranslatedText = {
  __typename?: 'CoreDeclarationTranslatedText';
  languageCode?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum CoreExportCertificateType {
  Catch = 'CATCH',
  ExportEligibilityStatement = 'EXPORT_ELIGIBILITY_STATEMENT',
  FreeSale = 'FREE_SALE',
  FreeSaleStatement = 'FREE_SALE_STATEMENT',
  Halal = 'HALAL',
  LiveAnimals = 'LIVE_ANIMALS',
  Nonconsignment = 'NONCONSIGNMENT',
  OecdSeedVarietal = 'OECD_SEED_VARIETAL',
  Organics = 'ORGANICS',
  OtherDocument = 'OTHER_DOCUMENT',
  Phytosanitary = 'PHYTOSANITARY',
  ProductEstablishmentRegistrationDocument = 'PRODUCT_ESTABLISHMENT_REGISTRATION_DOCUMENT',
  ReexportPhytosanitary = 'REEXPORT_PHYTOSANITARY',
  Sanitary = 'SANITARY',
  Supplementary = 'SUPPLEMENTARY'
}

export type CoreExportContainer = {
  __typename?: 'CoreExportContainer';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  productGroupId?: Maybe<Scalars['ID']['output']>;
  productItemId?: Maybe<Scalars['ID']['output']>;
  seals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CoreExportDetails = {
  __typename?: 'CoreExportDetails';
  action?: Maybe<CoreHistoryExportActions>;
  additionalDeclaration?: Maybe<Scalars['String']['output']>;
  additionalDeclarationCaption?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedCertificateEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  approverQualification?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<CoreExportRequestAttributes>;
  calculatedTotalGrossWeight?: Maybe<Measurment>;
  certificateNumber: Scalars['String']['output'];
  certificateNumberReplacedById?: Maybe<Scalars['String']['output']>;
  certificateNumberReplacesId?: Maybe<Scalars['String']['output']>;
  certificate_type?: Maybe<CoreExportCertificateType>;
  certifyingAgencyId?: Maybe<CoreLookup>;
  commodity: CoreCommodity;
  consignee?: Maybe<CoreRegistration>;
  consigneeRegId?: Maybe<Scalars['String']['output']>;
  consignor?: Maybe<CoreRegistration>;
  consignorRegId?: Maybe<Scalars['String']['output']>;
  copiedFromId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customsTransitAgent?: Maybe<CoreExportRequestPartyType>;
  declarations?: Maybe<Array<Maybe<CoreDeclarationOutput>>>;
  deliveryDetails?: Maybe<CoreLookup>;
  deliveryDispatchDetails?: Maybe<CoreLookup>;
  destinationCountry: CoreCountry;
  destinationParty?: Maybe<CoreExportRequestPartyType>;
  externalConsignor?: Maybe<CoreExportRequestPartyType>;
  id: Scalars['ID']['output'];
  importer?: Maybe<CoreExportRequestImporterType>;
  officialStatement?: Maybe<Scalars['String']['output']>;
  officialStatementCaption?: Maybe<Scalars['String']['output']>;
  outputTranslationLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overseasAuthorityInvolved?: Maybe<Scalars['Boolean']['output']>;
  printDetails?: Maybe<CorePrintDetails>;
  productGroupId?: Maybe<Scalars['ID']['output']>;
  productItemGroupDetails?: Maybe<CoreProductItemGroup>;
  reasonCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reasonForStatusChange?: Maybe<Scalars['String']['output']>;
  replacedById?: Maybe<Scalars['String']['output']>;
  replacesApprovedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  replacesId?: Maybe<Scalars['String']['output']>;
  requestName?: Maybe<Scalars['String']['output']>;
  requiresAttention?: Maybe<Scalars['Boolean']['output']>;
  signingOffice?: Maybe<CoreLookup>;
  sourceTransfer?: Maybe<Array<SourceTransfer>>;
  status?: Maybe<ExportStatus>;
  submittedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  substatus?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<Maybe<CoreSupportingDocument>>>;
  template?: Maybe<CoreTemplate>;
  templateCode?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateVersion?: Maybe<Scalars['Int']['output']>;
  thirdParty?: Maybe<Array<Maybe<CoreLookup>>>;
  thirdPartyConsignor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  transitCountries?: Maybe<Array<Maybe<CoreLookup>>>;
  transport?: Maybe<CoreExportTransport>;
  uniqueConsignmentReference?: Maybe<Scalars['String']['output']>;
  unofficialInformation?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<CoreLookup>;
  verifyingAgencyId?: Maybe<Scalars['String']['output']>;
  verifyingAgencyIdentifier?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CoreExportRequest = CoreRequest & {
  __typename?: 'CoreExportRequest';
  certificateNumber: Scalars['String']['output'];
  commodity: CoreCommodity;
  consignee?: Maybe<CoreRegistration>;
  consignor?: Maybe<CoreRegistration>;
  containers?: Maybe<Array<Maybe<CoreContainer>>>;
  declarations?: Maybe<Array<Maybe<DeclarationOutput>>>;
  destinationCountry: CoreCountry;
  externalConsignor?: Maybe<CoreExportRequestPartyType>;
  id: Scalars['ID']['output'];
  importer?: Maybe<CoreExportRequestImporterType>;
  products?: Maybe<Array<Maybe<SavedProductOutput>>>;
  sequenceNumber?: Maybe<Scalars['String']['output']>;
  status: CoreRequestStatus;
  substatus?: Maybe<CoreRequestSubstatus>;
  supportingDocuments?: Maybe<Array<Maybe<CoreSupportingDocument>>>;
  template?: Maybe<CoreTemplate>;
  transport?: Maybe<CoreTransport>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CoreExportRequestAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CoreLookupInput>;
  lines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CoreExportRequestAddressType = {
  __typename?: 'CoreExportRequestAddressType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CoreLookup>;
  countryCode?: Maybe<CoreLookup>;
  lines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type CoreExportRequestAttributes = {
  __typename?: 'CoreExportRequestAttributes';
  address?: Maybe<CoreLookup>;
  administrativeTerritorialUnit?: Maybe<CoreLookup>;
  brandName?: Maybe<CoreLookup>;
  categoryOfGoods?: Maybe<CoreLookup>;
  cnInspection?: Maybe<CoreLookup>;
  contractNo?: Maybe<CoreLookup>;
  edReference?: Maybe<CoreLookup>;
  euCommodityCode?: Maybe<CoreLookup>;
  euTransit?: Maybe<CoreLookup>;
  expRef?: Maybe<CoreLookup>;
  exporterRef?: Maybe<CoreLookup>;
  exporterSignature?: Maybe<CoreLookup>;
  exportingCountryId?: Maybe<CoreLookup>;
  forImportorAdmission?: Maybe<CoreLookup>;
  halalAuditor?: Maybe<CoreLookup>;
  halalCertificateNumber?: Maybe<CoreLookup>;
  importPermitNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  importPermitNumbersCaption?: Maybe<Scalars['String']['output']>;
  inspectionDate?: Maybe<Scalars['AWSDate']['output']>;
  inspectionDateCaption?: Maybe<Scalars['String']['output']>;
  issuingAuthority?: Maybe<CoreLookup>;
  issuingAuthority1?: Maybe<CoreLookup>;
  letterOfCreditRefCode?: Maybe<CoreLookup>;
  lot?: Maybe<CoreLookup>;
  manifacturingpremisesname?: Maybe<CoreLookup>;
  manufacturerRegistration?: Maybe<CoreLookup>;
  markingofsealontransportcontai?: Maybe<CoreLookup>;
  nameRegistrationandAddressofse?: Maybe<CoreLookup>;
  netWeightInWords?: Maybe<CoreLookup>;
  numberOfDoses?: Maybe<CoreLookup>;
  numberOfEmbryos?: Maybe<CoreLookup>;
  numberOfPackagesContainers?: Maybe<CoreLookup>;
  orgCertRefCode?: Maybe<Scalars['String']['output']>;
  phytoCertSubType?: Maybe<CoreLookup>;
  phytoCertificateNumber?: Maybe<Scalars['String']['output']>;
  phytoLotRefNumber?: Maybe<Scalars['String']['output']>;
  phytoPackhouse?: Maybe<Scalars['String']['output']>;
  phytoSchemeControl?: Maybe<CoreLookup>;
  phytoStatementOfRelabelling?: Maybe<Scalars['String']['output']>;
  placeandDateofQuarantine?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<CoreLookup>;
  purposeBR?: Maybe<CoreLookup>;
  sanitoryCertificateNumber?: Maybe<CoreLookup>;
  scope?: Maybe<CoreLookup>;
  shipStores?: Maybe<Scalars['Boolean']['output']>;
  summaryofRecordsfor?: Maybe<CoreLookup>;
  totalGrossWeight?: Maybe<CoreLookup>;
  totalQuantity?: Maybe<CoreLookup>;
  transport?: Maybe<CoreLookup>;
};

export type CoreExportRequestAttributesInput = {
  address?: InputMaybe<CoreLookupInput>;
  administrativeTerritorialUnit?: InputMaybe<CoreLookupInput>;
  brandName?: InputMaybe<CoreLookupInput>;
  categoryOfGoods?: InputMaybe<CoreLookupInput>;
  cnInspection?: InputMaybe<CoreLookupInput>;
  contractNo?: InputMaybe<CoreLookupInput>;
  edReference?: InputMaybe<CoreLookupInput>;
  euCommodityCode?: InputMaybe<CoreLookupInput>;
  euTransit?: InputMaybe<CoreLookupInput>;
  expRef?: InputMaybe<CoreLookupInput>;
  exporterRef?: InputMaybe<CoreLookupInput>;
  exporterSignature?: InputMaybe<CoreLookupInput>;
  exportingCountryId?: InputMaybe<CoreLookupInput>;
  forImportorAdmission?: InputMaybe<CoreLookupInput>;
  halalAuditor?: InputMaybe<CoreLookupInput>;
  halalCertificateNumber?: InputMaybe<CoreLookupInput>;
  importPermitNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inspectionDate?: InputMaybe<Scalars['AWSDate']['input']>;
  issuingAuthority?: InputMaybe<CoreLookupInput>;
  issuingAuthority1?: InputMaybe<CoreLookupInput>;
  letterOfCreditRefCode?: InputMaybe<CoreLookupInput>;
  lot?: InputMaybe<CoreLookupInput>;
  manifacturingpremisesname?: InputMaybe<CoreLookupInput>;
  manufacturerRegistration?: InputMaybe<CoreLookupInput>;
  markingofsealontransportcontai?: InputMaybe<CoreLookupInput>;
  nameRegistrationandAddressofse?: InputMaybe<CoreLookupInput>;
  netWeightInWords?: InputMaybe<CoreLookupInput>;
  numberOfDoses?: InputMaybe<CoreLookupInput>;
  numberOfEmbryos?: InputMaybe<CoreLookupInput>;
  numberOfPackagesContainers?: InputMaybe<CoreLookupInput>;
  orgCertRefCode?: InputMaybe<Scalars['String']['input']>;
  phytoCertSubType?: InputMaybe<CoreLookupInput>;
  phytoCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  phytoLotRefNumber?: InputMaybe<Scalars['String']['input']>;
  phytoPackhouse?: InputMaybe<Scalars['String']['input']>;
  phytoSchemeControl?: InputMaybe<CoreLookupInput>;
  phytoStatementOfRelabelling?: InputMaybe<Scalars['String']['input']>;
  placeandDateofQuarantine?: InputMaybe<Scalars['String']['input']>;
  productDescription?: InputMaybe<CoreLookupInput>;
  purposeBR?: InputMaybe<CoreLookupInput>;
  sanitoryCertificateNumber?: InputMaybe<CoreLookupInput>;
  scope?: InputMaybe<CoreLookupInput>;
  shipStores?: InputMaybe<Scalars['Boolean']['input']>;
  summaryofRecordsfor?: InputMaybe<CoreLookupInput>;
  totalGrossWeight?: InputMaybe<CoreLookupInput>;
  totalQuantity?: InputMaybe<CoreLookupInput>;
  transport?: InputMaybe<CoreLookupInput>;
};

export type CoreExportRequestImporter = {
  address?: InputMaybe<CoreExportRequestAddress>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  representative?: InputMaybe<Scalars['String']['input']>;
};

export type CoreExportRequestImporterType = {
  __typename?: 'CoreExportRequestImporterType';
  address?: Maybe<CoreExportRequestAddressType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  representative?: Maybe<Scalars['String']['output']>;
};

export type CoreExportRequestInput = {
  additionalDeclaration?: InputMaybe<Scalars['String']['input']>;
  approvedCertificateEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<CoreExportRequestAttributesInput>;
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  certificateType?: InputMaybe<Scalars['String']['input']>;
  certifyingAgencyId?: InputMaybe<Scalars['String']['input']>;
  commodity?: InputMaybe<Scalars['ID']['input']>;
  consignee?: InputMaybe<CoreLookupInput>;
  consignor?: InputMaybe<CoreLookupInput>;
  containers?: InputMaybe<CoreContainerInput>;
  copiedFromId?: InputMaybe<Scalars['ID']['input']>;
  customsTransitAgent?: InputMaybe<CoreExportRequestParty>;
  declarations?: InputMaybe<Array<InputMaybe<DeclarationInput>>>;
  deliveryDetails?: InputMaybe<CoreLookupInput>;
  deliveryDispatchDetails?: InputMaybe<CoreLookupInput>;
  destinationCountry?: InputMaybe<CoreLookupInput>;
  destinationParty?: InputMaybe<CoreExportRequestParty>;
  externalConsignor?: InputMaybe<CoreExportRequestParty>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importer?: InputMaybe<CoreExportRequestImporter>;
  isExportInput: Scalars['Boolean']['input'];
  isProductInput: Scalars['Boolean']['input'];
  isReplacementRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isSupportingDocumentInput?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  officialStatement?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<CoreProductItemInput>>;
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  removeContainers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeProcesses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeSources?: InputMaybe<Array<InputMaybe<RemoveSources>>>;
  removeSupportingDocuments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  replacesId?: InputMaybe<Scalars['ID']['input']>;
  requestName?: InputMaybe<Scalars['String']['input']>;
  requestOrigin?: InputMaybe<RequestOrigin>;
  sequenceNumber?: InputMaybe<Scalars['String']['input']>;
  signingOffice?: InputMaybe<CoreLookupInput>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionLayout?: InputMaybe<SubmissionLayoutType>;
  substatus?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<InputMaybe<CoreSupportingDocumentInput>>>;
  template?: InputMaybe<Scalars['ID']['input']>;
  templateCode?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Int']['input']>;
  thirdParty?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  thirdPartyConsignor?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transitCountries?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  transport?: InputMaybe<CoreTransportInput>;
  uniqueConsignmentReference?: InputMaybe<Scalars['String']['input']>;
  unofficialInformation?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<CoreLookupInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
  verifyingAgencyId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CoreExportRequestParty = {
  address?: InputMaybe<CoreExportRequestAddress>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CoreExportRequestPartyType = {
  __typename?: 'CoreExportRequestPartyType';
  address?: Maybe<CoreExportRequestAddressType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CoreExportSupportingDocuments = {
  __typename?: 'CoreExportSupportingDocuments';
  description?: Maybe<Scalars['String']['output']>;
  documentType: PhytoSupportingDocumentType;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type CoreExportSupportingDocumentsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: PhytoSupportingDocumentType;
  filename?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type CoreExportTransport = {
  __typename?: 'CoreExportTransport';
  _transportMode?: Maybe<CoreLookup>;
  carrierName?: Maybe<Scalars['String']['output']>;
  conveyanceReference?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['AWSDate']['output']>;
  dischargePort?: Maybe<CoreLookup>;
  expectedArrivalDate?: Maybe<Scalars['AWSDate']['output']>;
  finalDestination?: Maybe<CoreLookup>;
  inspectionPort?: Maybe<CoreLookup>;
  loadingPort?: Maybe<CoreLookup>;
  localCarrier?: Maybe<Scalars['String']['output']>;
  localCarrierReference?: Maybe<Scalars['String']['output']>;
  transportMode?: Maybe<CoreLookup>;
};

export type CoreGroup = {
  __typename?: 'CoreGroup';
  addressFormat?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum CoreHistoryExportActions {
  Amend = 'AMEND',
  PreValidationCheck = 'PRE_VALIDATION_CHECK',
  Raise = 'RAISE',
  Replaced = 'REPLACED',
  Restore = 'RESTORE',
  StatusChange = 'STATUS_CHANGE'
}

export enum CoreHistoryTransferActions {
  Amend = 'AMEND',
  ExhaustionUpdated = 'EXHAUSTION_UPDATED',
  FullyExhausted = 'FULLY_EXHAUSTED',
  FullyUnexhausted = 'FULLY_UNEXHAUSTED',
  Raise = 'RAISE',
  Restore = 'RESTORE',
  StatusChange = 'STATUS_CHANGE',
  TransportDetailsUpdated = 'TRANSPORT_DETAILS_UPDATED'
}

export type CoreLocation = {
  __typename?: 'CoreLocation';
  country?: Maybe<Scalars['String']['output']>;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CoreLookup = {
  __typename?: 'CoreLookup';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
};

export type CoreLookupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registrationId?: InputMaybe<Scalars['String']['input']>;
};

export type CorePackaging = {
  __typename?: 'CorePackaging';
  itemMarksOuter?: Maybe<Scalars['String']['output']>;
  itemMarksOuterCaption?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  nominalGrossVolume?: Maybe<Measurment>;
  nominalGrossWeight?: Maybe<Measurment>;
  outermostNumberOfPacakges?: Maybe<Scalars['Int']['output']>;
  packageType?: Maybe<CoreLookup>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type CorePrintDetails = {
  __typename?: 'CorePrintDetails';
  officialPrinted: Scalars['Boolean']['output'];
  reasonForReprinting?: Maybe<Scalars['String']['output']>;
};

export type CoreProcessAttributes = {
  __typename?: 'CoreProcessAttributes';
  additionalTreatment?: Maybe<Scalars['String']['output']>;
  chemicalDetail?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Measurment>;
  temperature?: Maybe<Measurment>;
};

export type CoreProcessAttributesInput = {
  additionalTreatment?: InputMaybe<Scalars['String']['input']>;
  chemicalDetail?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<MeasurmentInput>;
  temperature?: InputMaybe<MeasurmentInput>;
};

export type CoreProcessHistory = {
  __typename?: 'CoreProcessHistory';
  country?: Maybe<CoreCountry>;
  earliestStartDate?: Maybe<Scalars['AWSDateTime']['output']>;
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  endDatePDF?: Maybe<Scalars['AWSDateTime']['output']>;
  group?: Maybe<CoreGroup>;
  id?: Maybe<Scalars['ID']['output']>;
  latestEndDate?: Maybe<Scalars['AWSDateTime']['output']>;
  premise?: Maybe<CoreRegistration>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
  startDatePDF?: Maybe<Scalars['AWSDateTime']['output']>;
  unTypeCode?: Maybe<Scalars['String']['output']>;
};

export type CoreProcessTypeLookup = {
  __typename?: 'CoreProcessTypeLookup';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unCode?: Maybe<Scalars['String']['output']>;
};

export type CoreProduct = {
  __typename?: 'CoreProduct';
  id: Scalars['ID']['output'];
};

export type CoreProductAttributes = {
  __typename?: 'CoreProductAttributes';
  NZHSCode?: Maybe<CoreLookup>;
  commonName?: Maybe<CoreLookup>;
  expiryDateFrom?: Maybe<Scalars['AWSDate']['output']>;
  expiryDateTo?: Maybe<Scalars['AWSDate']['output']>;
  grossVolume?: Maybe<Measurment>;
  grossWeight?: Maybe<Measurment>;
  inspectionType?: Maybe<CoreLookup>;
  intendedUse?: Maybe<Array<Maybe<CoreLookup>>>;
  netUnits?: Maybe<Measurment>;
  netVolume?: Maybe<Measurment>;
  netWeight?: Maybe<Measurment>;
  origin?: Maybe<CoreLookup>;
  originCountries?: Maybe<Array<Maybe<CoreLookup>>>;
  otherQuantity?: Maybe<Measurment>;
  overseasCertIDs?: Maybe<Array<Scalars['String']['output']>>;
  phytoApprovedSeedCategory?: Maybe<CoreLookup>;
  phytoBotanicalName?: Maybe<CoreLookup>;
  phytoClass?: Maybe<CoreLookup>;
  phytoClassCaption?: Maybe<Scalars['String']['output']>;
  phytoCommonName?: Maybe<CoreLookup>;
  phytoEndPointInspectionRef?: Maybe<Scalars['String']['output']>;
  phytoGrowers?: Maybe<Scalars['String']['output']>;
  phytoInspectionLocation?: Maybe<Scalars['String']['output']>;
  phytoIsInspectionOnOriginal?: Maybe<Scalars['String']['output']>;
  phytoIsOriginalCert?: Maybe<Scalars['String']['output']>;
  phytoIsOriginalContainer?: Maybe<Scalars['String']['output']>;
  phytoIsRepacked?: Maybe<Scalars['String']['output']>;
  phytoLableDescription?: Maybe<CoreLookup>;
  phytoMixtureName?: Maybe<Scalars['String']['output']>;
  phytoObservation?: Maybe<Scalars['String']['output']>;
  phytoPackhouse?: Maybe<Scalars['String']['output']>;
  phytoPercentageByWeight?: Maybe<Scalars['Float']['output']>;
  phytoQuantityMeasure?: Maybe<Measurment>;
  phytoQuantityType?: Maybe<CoreLookup>;
  phytoSeedLotApproval?: Maybe<Scalars['String']['output']>;
  phytoSeedLotReference?: Maybe<Scalars['String']['output']>;
  phytoSubClass?: Maybe<CoreLookup>;
  phytoSubClassCaption?: Maybe<Scalars['String']['output']>;
  phytoSupplier?: Maybe<Scalars['String']['output']>;
  phytoVariety?: Maybe<Scalars['String']['output']>;
  productBatchIds?: Maybe<Array<Scalars['String']['output']>>;
  productReference?: Maybe<Scalars['String']['output']>;
  productStatement?: Maybe<Scalars['String']['output']>;
  productionBatchIds?: Maybe<Array<Scalars['String']['output']>>;
  scientificName?: Maybe<Array<Maybe<CoreLookup>>>;
  speciesCommonName?: Maybe<Array<Maybe<CoreLookup>>>;
  temperature?: Maybe<CoreLookup>;
};

export type CoreProductAttributesInput = {
  NZHSCode?: InputMaybe<CoreLookupInput>;
  commonName?: InputMaybe<CoreLookupInput>;
  expiryDateFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  expiryDateTo?: InputMaybe<Scalars['AWSDate']['input']>;
  grossVolume?: InputMaybe<MeasurmentInput>;
  grossWeight?: InputMaybe<MeasurmentInput>;
  inspectionType?: InputMaybe<CoreLookupInput>;
  intendedUse?: InputMaybe<Array<CoreLookupInput>>;
  netUnits?: InputMaybe<MeasurmentInput>;
  netVolume?: InputMaybe<MeasurmentInput>;
  netWeight?: InputMaybe<MeasurmentInput>;
  origin?: InputMaybe<CoreLookupInput>;
  originCountries?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  otherQuantity?: InputMaybe<MeasurmentInput>;
  overseasCertIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  phytoApprovedSeedCategory?: InputMaybe<CoreLookupInput>;
  phytoBotanicalName?: InputMaybe<CoreLookupInput>;
  phytoClass?: InputMaybe<CoreLookupInput>;
  phytoCommonName?: InputMaybe<CoreLookupInput>;
  phytoEndPointInspectionRef?: InputMaybe<Scalars['String']['input']>;
  phytoGrowers?: InputMaybe<Scalars['String']['input']>;
  phytoInspectionLocation?: InputMaybe<Scalars['String']['input']>;
  phytoIsInspectionOnOriginal?: InputMaybe<Scalars['String']['input']>;
  phytoIsOriginalCert?: InputMaybe<Scalars['String']['input']>;
  phytoIsOriginalContainer?: InputMaybe<Scalars['String']['input']>;
  phytoIsRepacked?: InputMaybe<Scalars['String']['input']>;
  phytoLableDescription?: InputMaybe<CoreLookupInput>;
  phytoMixtureName?: InputMaybe<Scalars['String']['input']>;
  phytoObservation?: InputMaybe<Scalars['String']['input']>;
  phytoPackhouse?: InputMaybe<Scalars['String']['input']>;
  phytoPercentageByWeight?: InputMaybe<Scalars['Float']['input']>;
  phytoQuantityMeasure?: InputMaybe<MeasurmentInput>;
  phytoQuantityType?: InputMaybe<CoreLookupInput>;
  phytoSeedLotApproval?: InputMaybe<Scalars['String']['input']>;
  phytoSeedLotReference?: InputMaybe<Scalars['String']['input']>;
  phytoSubClass?: InputMaybe<CoreLookupInput>;
  phytoSupplier?: InputMaybe<Scalars['String']['input']>;
  phytoVariety?: InputMaybe<Scalars['String']['input']>;
  productBatchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productReference?: InputMaybe<Scalars['String']['input']>;
  productStatement?: InputMaybe<Scalars['String']['input']>;
  productionBatchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scientificName?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  speciesCommonName?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  temperature?: InputMaybe<CoreLookupInput>;
};

export type CoreProductClassificationInput = {
  classificationCode?: InputMaybe<Scalars['String']['input']>;
  fieldUniqueId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CoreProductClassificationResponse = {
  __typename?: 'CoreProductClassificationResponse';
  classificationCode?: Maybe<Scalars['String']['output']>;
  classificationName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  fieldUniqueId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoreProductItemGroup = {
  __typename?: 'CoreProductItemGroup';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  groupType?: Maybe<CoreRequestType>;
  id?: Maybe<Scalars['ID']['output']>;
  products?: Maybe<Array<Maybe<TransferProductDetails>>>;
};

export type CoreProductItemInput = {
  attributes?: InputMaybe<CoreProductAttributesInput>;
  classification?: InputMaybe<Array<CoreProductClassificationInput>>;
  container?: InputMaybe<Array<InputMaybe<CoreContainerInput>>>;
  eligibilityCountries?: InputMaybe<Array<CoreLookupInput>>;
  exhausted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  itemDescription?: InputMaybe<CoreLookupInput>;
  packaging?: InputMaybe<Array<InputMaybe<PackagingInput>>>;
  process?: InputMaybe<Array<CoreProductProcessInput>>;
  productDeclaration?: InputMaybe<Scalars['String']['input']>;
  productReference?: InputMaybe<Scalars['String']['input']>;
  productStatement?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceProducts?: InputMaybe<Array<InputMaybe<CoreProductRefrence>>>;
  supportingDocuments?: InputMaybe<Array<CoreProductSupportingDocumentInput>>;
  tradeLineGroupNumber?: InputMaybe<Scalars['Int']['input']>;
  tradeLineGroupSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CoreProductItemRelation = {
  __typename?: 'CoreProductItemRelation';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  fromId?: Maybe<Scalars['ID']['output']>;
  toId?: Maybe<Scalars['ID']['output']>;
};

export type CoreProductProcess = {
  __typename?: 'CoreProductProcess';
  _processType?: Maybe<CoreLookup>;
  attributes?: Maybe<CoreProcessAttributes>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['AWSDate']['output']>;
  foreignPremises?: Maybe<Scalars['String']['output']>;
  foreignPremisesCountryID?: Maybe<CoreLookup>;
  foreignPremisesIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSourceProcess?: Maybe<Scalars['Boolean']['output']>;
  nameOverride?: Maybe<Scalars['Boolean']['output']>;
  overrideProcessDate?: Maybe<Scalars['Boolean']['output']>;
  premises?: Maybe<CoreRegistration>;
  processGroup?: Maybe<Scalars['String']['output']>;
  processType?: Maybe<CoreProcessTypeLookup>;
  productItemId?: Maybe<Scalars['ID']['output']>;
  sequenceNumber?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['AWSDate']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CoreProductProcessInput = {
  attributes?: InputMaybe<CoreProcessAttributesInput>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  foreignPremises?: InputMaybe<Scalars['String']['input']>;
  foreignPremisesCountryID?: InputMaybe<CoreLookupInput>;
  foreignPremisesID?: InputMaybe<Scalars['String']['input']>;
  foreignPremisesNameOverride?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSourceProcess?: InputMaybe<Scalars['Boolean']['input']>;
  overrideProcessDate?: InputMaybe<Scalars['Boolean']['input']>;
  premises?: InputMaybe<CoreLookupInput>;
  processType?: InputMaybe<CoreLookupInput>;
  sequenceNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type CoreProductRefrence = {
  requestNumber?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CoreProductSupportingDocumentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  isInherited?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocumentId?: InputMaybe<Scalars['ID']['input']>;
  supportingDocumentNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CoreReferencedDocument = {
  __typename?: 'CoreReferencedDocument';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  uploadInProgress: Scalars['Boolean']['output'];
};

export type CoreReferencedDocumentUrl = {
  __typename?: 'CoreReferencedDocumentUrl';
  documentName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CoreRegistration = {
  __typename?: 'CoreRegistration';
  addresses?: Maybe<CoreAddress>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  registrationTypeCode?: Maybe<Scalars['String']['output']>;
};

export type CoreRequest = {
  certificateNumber: Scalars['String']['output'];
  commodity: CoreCommodity;
  destinationCountry: CoreCountry;
  id: Scalars['ID']['output'];
  status: CoreRequestStatus;
  substatus?: Maybe<CoreRequestSubstatus>;
  template?: Maybe<CoreTemplate>;
};

export type CoreRequestStatus = {
  __typename?: 'CoreRequestStatus';
  code?: Maybe<CoreStatus>;
  label: Scalars['String']['output'];
};

export type CoreRequestSubstatus = {
  __typename?: 'CoreRequestSubstatus';
  code?: Maybe<CoreSubstatus>;
  label: Scalars['String']['output'];
};

export enum CoreRequestType {
  Export = 'EXPORT',
  Transfer = 'TRANSFER'
}

export enum CoreStatus {
  Accepted = 'ACCEPTED',
  Acknowledged = 'ACKNOWLEDGED',
  Amended = 'AMENDED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Detained = 'DETAINED',
  Draft = 'DRAFT',
  Partial = 'PARTIAL',
  PendingReplacement = 'PENDING_REPLACEMENT',
  Raised = 'RAISED',
  Rejected = 'REJECTED',
  Replaced = 'REPLACED',
  RequestAmendment = 'REQUEST_AMENDMENT',
  RequestReplacement = 'REQUEST_REPLACEMENT',
  Resubmit = 'RESUBMIT',
  Revoked = 'REVOKED',
  ToBeAmended = 'TO_BE_AMENDED'
}

export enum CoreSubstatus {
  PendingCertification = 'PENDING_CERTIFICATION',
  PendingSfCall = 'PENDING_SF_CALL',
  PendingVerification = 'PENDING_VERIFICATION'
}

export type CoreSupportingDocument = {
  __typename?: 'CoreSupportingDocument';
  b2gFile?: Maybe<CoreB2GFile>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentReference?: Maybe<Scalars['String']['output']>;
  documentReferenceNumber?: Maybe<Scalars['String']['output']>;
  documentSequence?: Maybe<Scalars['Int']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  fileContentType?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  foreignManufacturePremises?: Maybe<Scalars['String']['output']>;
  foreignPremisesId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identificationMarks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  intendedOperators?: Maybe<Array<Maybe<CoreLookup>>>;
  isLinked?: Maybe<Scalars['Boolean']['output']>;
  lastAction?: Maybe<Scalars['String']['output']>;
  nzManufacturePremises?: Maybe<Scalars['String']['output']>;
  originCountry?: Maybe<CoreLookup>;
  primaryOperator?: Maybe<CoreLookup>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productionDates?: Maybe<Array<Maybe<CoreDateRange>>>;
  reason?: Maybe<Scalars['String']['output']>;
  replacedByDocumentNumber?: Maybe<Scalars['String']['output']>;
  replacedById?: Maybe<Scalars['String']['output']>;
  replacesDocumentNumber?: Maybe<Scalars['String']['output']>;
  replacesId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CoreSupportingDocumentInput = {
  b2gFile?: InputMaybe<CoreB2GFileInput>;
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  foreignManufacturePremises?: InputMaybe<Scalars['String']['input']>;
  foreignPremisesId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identificationMarks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intendedOperators?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  nzManufacturePremises?: InputMaybe<Scalars['String']['input']>;
  originCountry?: InputMaybe<CoreLookupInput>;
  primaryOperator?: InputMaybe<CoreLookupInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productionDates?: InputMaybe<Array<InputMaybe<CoreDateRangeInput>>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  replacesId?: InputMaybe<Scalars['ID']['input']>;
  requestOrigin?: InputMaybe<RequestOrigin>;
};

export type CoreTemplate = {
  __typename?: 'CoreTemplate';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  majorVersion?: Maybe<Scalars['Int']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  requestType?: Maybe<CoreRequestType>;
  templateVersionId?: Maybe<Scalars['String']['output']>;
};

export type CoreTransferProductSupportingDocument = {
  __typename?: 'CoreTransferProductSupportingDocument';
  b2gFile?: Maybe<CoreB2GFile>;
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentReferenceNumber?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  foreignManufacturePremises?: Maybe<Scalars['String']['output']>;
  foreignPremisesId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identificationMarks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  intendedOperators?: Maybe<Array<Maybe<CoreLookup>>>;
  isInherited?: Maybe<Scalars['Boolean']['output']>;
  isLinked?: Maybe<Scalars['Boolean']['output']>;
  nzManufacturePremises?: Maybe<CoreLookup>;
  originCountry?: Maybe<CoreLookup>;
  primaryOperator?: Maybe<CoreLookup>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productionDates?: Maybe<Array<Maybe<CoreDateRange>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CoreTransferRequest = CoreRequest & {
  __typename?: 'CoreTransferRequest';
  certificateNumber: Scalars['String']['output'];
  commodity: CoreCommodity;
  consignee?: Maybe<CoreRegistration>;
  consignor?: Maybe<CoreRegistration>;
  containers?: Maybe<Array<Maybe<CoreContainer>>>;
  destinationCountry: CoreCountry;
  id: Scalars['ID']['output'];
  products?: Maybe<Array<Maybe<SavedProductOutput>>>;
  reasonForStatusChange?: Maybe<Scalars['String']['output']>;
  status: CoreRequestStatus;
  substatus?: Maybe<CoreRequestSubstatus>;
  template?: Maybe<CoreTemplate>;
  transport?: Maybe<CoreTransport>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CoreTransferRequestInput = {
  attributes?: InputMaybe<CoreExportRequestAttributesInput>;
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  commodity?: InputMaybe<Scalars['ID']['input']>;
  consignee?: InputMaybe<CoreLookupInput>;
  consignor?: InputMaybe<CoreLookupInput>;
  containers?: InputMaybe<CoreContainerInput>;
  copiedFromTransferId?: InputMaybe<Scalars['ID']['input']>;
  destinationCountry?: InputMaybe<CoreLookupInput>;
  eligibility_declaration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isProductInput: Scalars['Boolean']['input'];
  isTransferInput: Scalars['Boolean']['input'];
  lastModifiedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  products?: InputMaybe<Array<CoreProductItemInput>>;
  reasonForStateChangeCategories?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  removeProcesses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeSources?: InputMaybe<Array<InputMaybe<RemoveSources>>>;
  removeSupportingDocuments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestOrigin?: InputMaybe<RequestOrigin>;
  sequenceNumber?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['ID']['input']>;
  templateCode?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyConsignor?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  transport?: InputMaybe<CoreTransportInput>;
  uniqueConsignmentReference?: InputMaybe<Scalars['String']['input']>;
  unofficialInformation?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<CoreLookupInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CoreTransport = {
  __typename?: 'CoreTransport';
  carrierName?: Maybe<Scalars['String']['output']>;
  conveyanceReference?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['AWSDate']['output']>;
  dischargePort?: Maybe<CoreLocation>;
  expectedArrivalDate?: Maybe<Scalars['AWSDate']['output']>;
  finalDestination?: Maybe<CoreLookup>;
  inspectionPort?: Maybe<CoreLocation>;
  loadingPort?: Maybe<CoreLocation>;
  localCarrier?: Maybe<Scalars['String']['output']>;
  localCarrierReference?: Maybe<Scalars['String']['output']>;
  transportMode?: Maybe<CoreLookup>;
};

export type CoreTransportInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  conveyanceReference?: InputMaybe<Scalars['String']['input']>;
  departureDate?: InputMaybe<Scalars['AWSDate']['input']>;
  dischargePort?: InputMaybe<CoreLookupInput>;
  expectedArrivalDate?: InputMaybe<Scalars['AWSDate']['input']>;
  finalDestination?: InputMaybe<CoreLookupInput>;
  inspectionPort?: InputMaybe<CoreLookupInput>;
  loadingPort?: InputMaybe<CoreLookupInput>;
  localCarrier?: InputMaybe<Scalars['String']['input']>;
  localCarrierReference?: InputMaybe<Scalars['String']['input']>;
  transportMode?: InputMaybe<CoreLookupInput>;
};

export enum Country {
  At = 'AT',
  Au = 'AU',
  Be = 'BE',
  Bg = 'BG',
  Br = 'BR',
  Ca = 'CA',
  Cn = 'CN',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Ee = 'EE',
  El = 'EL',
  Es = 'ES',
  Eu = 'EU',
  Fi = 'FI',
  Fr = 'FR',
  Gb = 'GB',
  Gr = 'GR',
  Hr = 'HR',
  Hu = 'HU',
  Ie = 'IE',
  It = 'IT',
  Jp = 'JP',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mt = 'MT',
  Nl = 'NL',
  NotApplicable = 'NOT_APPLICABLE',
  Nz = 'NZ',
  Pl = 'PL',
  Pt = 'PT',
  Re = 'RE',
  Ro = 'RO',
  Se = 'SE',
  Sg = 'SG',
  Si = 'SI',
  Sk = 'SK',
  Tw = 'TW',
  Ua = 'UA',
  Us = 'US'
}

export type CreateAnnouncementInput = {
  endDate: Scalars['AWSDateTime']['input'];
  message: Scalars['String']['input'];
  publishDate: Scalars['AWSDateTime']['input'];
  title: Scalars['String']['input'];
};

export type CreateDfeConfigRequest = {
  __typename?: 'CreateDfeConfigRequest';
  templateVersionId: Scalars['ID']['output'];
};

export type CreateDfeConfigResponse = {
  __typename?: 'CreateDfeConfigResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  s3location?: Maybe<Scalars['String']['output']>;
};

export type CreateTemplateGeneralInput = {
  agencies?: InputMaybe<Array<InputMaybe<AgencyInput>>>;
  allowForeignPremises?: InputMaybe<Scalars['Boolean']['input']>;
  allowPackageLevels?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  businessArea?: InputMaybe<BusinessArea>;
  code: Scalars['String']['input'];
  commodities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  commodity: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  destinationCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  displayedDescription: Scalars['String']['input'];
  effective?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expire?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exportCertificateType?: InputMaybe<CertificateType>;
  exportingCountry?: InputMaybe<Scalars['String']['input']>;
  importCertificateType?: InputMaybe<ImportCertificateType>;
  industryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  majorVersion: Scalars['Int']['input'];
  minorVersion: Scalars['Int']['input'];
  ocaAccess?: InputMaybe<Scalars['Boolean']['input']>;
  officialVersion?: InputMaybe<Scalars['Int']['input']>;
  outputSubtitle?: InputMaybe<Scalars['String']['input']>;
  outputSubtitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  outputTitle?: InputMaybe<Scalars['String']['input']>;
  outputTitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  reasonForUpdate?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['AWSDateTime']['input']>;
  signatory?: InputMaybe<Scalars['String']['input']>;
  sourceTemplateVersionId?: InputMaybe<Scalars['ID']['input']>;
  status: TemplateVersionStatus;
  submissionLayout: SubmissionLayoutType;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};

export type CreateTemplateInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  businessArea?: InputMaybe<BusinessArea>;
  code: Scalars['String']['input'];
  commodities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationMarket: DestinationMarket;
  displayedDescription?: InputMaybe<Scalars['String']['input']>;
  effective?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expire?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exportCertificateType?: InputMaybe<CertificateType>;
  importCertificateType?: InputMaybe<ImportCertificateType>;
  majorVersion: Scalars['Int']['input'];
  minorVersion: Scalars['Int']['input'];
  newFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  reasonForUpdate?: InputMaybe<Scalars['String']['input']>;
  status: TemplateVersionStatus;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};

export type CreateTestRegistrationInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  nzbn?: InputMaybe<Scalars['String']['input']>;
  operatorDisplayName?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId: Scalars['Int']['input'];
  source?: InputMaybe<RegistrationSource>;
};

export type CreateTestUserInput = {
  authenticationType?: InputMaybe<AuthenticationType>;
  email: Scalars['String']['input'];
  g2gUser?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<UserPermissionInput>;
  profileName?: InputMaybe<Scalars['String']['input']>;
  sfUserId?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  systemUser?: InputMaybe<Scalars['Boolean']['input']>;
  systemUsername?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  authenticationType?: InputMaybe<AuthenticationType>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CustomLookupType {
  EuOperatorSearch = 'EU_OPERATOR_SEARCH',
  None = 'NONE'
}

export type CustomsPermitNumberUsage = {
  __typename?: 'CustomsPermitNumberUsage';
  allocatedInPastThirtyDays: Scalars['Int']['output'];
  unallocated: Scalars['Int']['output'];
};

export type DfeForm = {
  __typename?: 'DFEForm';
  config?: Maybe<Scalars['AWSJSON']['output']>;
};

export type DfePermission = {
  __typename?: 'DFEPermission';
  permissions: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export enum DateFormat {
  DMY = 'D_M_Y',
  MY = 'M_Y'
}

export enum DateRange {
  All = 'ALL',
  LastInEachProduct = 'LAST_IN_EACH_PRODUCT'
}

export type DateTemplate = {
  __typename?: 'DateTemplate';
  day: IntTemplate;
  month: MonthTemplate;
  year: IntTemplate;
};

export type DateTimeTemplate = {
  __typename?: 'DateTimeTemplate';
  date: DateTemplate;
  time: TimeTemplate;
};

export type DecimalTemplate = {
  __typename?: 'DecimalTemplate';
  in_English: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DecisionTable = {
  __typename?: 'DecisionTable';
  approvedRevision?: Maybe<DecisionTableRevision>;
  id: Scalars['ID']['output'];
  inputColumns: Array<DecisionTableColumn>;
  lastRevision?: Maybe<DecisionTableRevision>;
  responseColumns: Array<DecisionTableColumn>;
  revisions: Array<DecisionTableRevision>;
};

export type DecisionTableBaseInput = {
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DecisionTableColumn = {
  __typename?: 'DecisionTableColumn';
  collection?: Maybe<Scalars['String']['output']>;
  dataType: DecisionTableDataType;
  enumeration?: Maybe<Array<Scalars['String']['output']>>;
  enumerationInfo?: Maybe<Array<EnumerationInfo>>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
};

export enum DecisionTableDataType {
  Boolean = 'BOOLEAN',
  Enumeration = 'ENUMERATION',
  Number = 'NUMBER',
  Search = 'SEARCH',
  String = 'STRING',
  Text = 'TEXT'
}

export type DecisionTableExpectation = {
  __typename?: 'DecisionTableExpectation';
  description: Scalars['String']['output'];
  input: RulesInput;
  response: RulesResponse;
};

export type DecisionTableField = {
  __typename?: 'DecisionTableField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
};

export type DecisionTableFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionTableRevision = {
  __typename?: 'DecisionTableRevision';
  createdAt: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  expectations: Array<DecisionTableExpectation>;
  id: Scalars['ID']['output'];
  revisionNumber: Scalars['Int']['output'];
  rows: Array<DecisionTableRow>;
  status: DecisionTableRevisionStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type DecisionTableRevisionInput = {
  decisionTableId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  expectations: Array<DecisionTableRowInput>;
  rows: Array<DecisionTableRowInput>;
  title: Scalars['String']['input'];
};

export enum DecisionTableRevisionStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT'
}

export type DecisionTableRow = {
  __typename?: 'DecisionTableRow';
  description: Scalars['String']['output'];
  input: RulesInput;
  response: RulesResponse;
};

export type DecisionTableRowInput = {
  declarationsInput?: InputMaybe<DeclarationsInput>;
  declarationsResponse?: InputMaybe<DeclarationsResponseInput>;
  description: Scalars['String']['input'];
  eligibilityInput?: InputMaybe<EligibilityInput>;
  eligibilityResponse?: InputMaybe<EligibilityResponseInput>;
  exportCertificateWorkflowInput?: InputMaybe<ExportCertificateWorkflowInput>;
  exportCertificateWorkflowResponse?: InputMaybe<ExportCertificateWorkflowResponseInput>;
  importConnectionsInput?: InputMaybe<ImportConnectionsInput>;
  importConnectionsResponse?: InputMaybe<ImportConnectionsResponseInput>;
  phytoOcaEmailNotificationsInput?: InputMaybe<PhytoOcaEmailNotificationsInput>;
  phytoOcaEmailNotificationsResponse?: InputMaybe<PhytoOcaEmailNotificationsResponseInput>;
  productFieldInput?: InputMaybe<ProductFieldInput>;
  productFieldResponse?: InputMaybe<ProductFieldResponseInput>;
  validFrom?: InputMaybe<Scalars['AWSDateTime']['input']>;
  validUntil?: InputMaybe<Scalars['AWSDateTime']['input']>;
  wineAnalytesTolerancesInput?: InputMaybe<WineAnalytesTolerancesInput>;
  wineAnalytesTolerancesResponse?: InputMaybe<WineAnalytesTolerancesResponseRowInput>;
  wineProductFieldInput?: InputMaybe<WineProductFieldInput>;
};

export type DecisionTableTestResult = {
  __typename?: 'DecisionTableTestResult';
  error_message: Scalars['String']['output'];
  succes: Scalars['Boolean']['output'];
};

export type DeclarationFormletFields = {
  __typename?: 'DeclarationFormletFields';
  eligibilityCriteria: FormletField;
  market: FormletField;
  text: FormletField;
};

export type DeclarationFormletSection = {
  __typename?: 'DeclarationFormletSection';
  fields: DeclarationFormletFields;
  id: Scalars['String']['output'];
  type: FormletFieldType;
};

export enum DeclarationGroupNumbering {
  Bullet = 'BULLET',
  Custom = 'CUSTOM',
  LowerAlpha = 'LOWER_ALPHA',
  LowerRoman = 'LOWER_ROMAN',
  None = 'NONE',
  Number = 'NUMBER',
  UpperAlpha = 'UPPER_ALPHA',
  UpperRoman = 'UPPER_ROMAN'
}

export enum DeclarationGroupType {
  Footnote = 'FOOTNOTE',
  Mandatory = 'MANDATORY',
  MandatoryExactlyOne = 'MANDATORY_EXACTLY_ONE',
  MandatoryOneOrMore = 'MANDATORY_ONE_OR_MORE',
  OptionalZeroOrMore = 'OPTIONAL_ZERO_OR_MORE',
  OptionalZeroOrOne = 'OPTIONAL_ZERO_OR_ONE',
  Phrase = 'PHRASE'
}

export enum DeclarationHeadingType {
  Custom = 'CUSTOM',
  HealthAttestation = 'HEALTH_ATTESTATION',
  None = 'NONE'
}

export type DeclarationInput = {
  declarationStatementCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inputs?: InputMaybe<Array<DeclarationInputValueInput>>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  statementCode?: InputMaybe<Scalars['Int']['input']>;
};

export type DeclarationInputValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inputValue?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type DeclarationInputValueOutput = {
  __typename?: 'DeclarationInputValueOutput';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeclarationOutput = {
  __typename?: 'DeclarationOutput';
  id?: Maybe<Scalars['ID']['output']>;
  inputs?: Maybe<Array<DeclarationInputValueOutput>>;
  statementCode?: Maybe<Scalars['Int']['output']>;
};

export type DeclarationStatement = {
  __typename?: 'DeclarationStatement';
  code: Scalars['Int']['output'];
  customNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputs?: Maybe<Array<DeclarationStatementInput>>;
  sequenceNumber: Scalars['Int']['output'];
  statementDisplayCode?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  traces?: Maybe<Array<DeclarationStatementTrace>>;
  translations?: Maybe<Scalars['AWSJSON']['output']>;
};

export type DeclarationStatementInput = {
  __typename?: 'DeclarationStatementInput';
  id: Scalars['ID']['output'];
  inputSequenceNumber: Scalars['Int']['output'];
  inputType: DeclarationStatementInputType;
  maxLength?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tracesId?: Maybe<Scalars['String']['output']>;
};

export enum DeclarationStatementInputType {
  CompanyAddress = 'companyAddress',
  CompanyName = 'companyName',
  DefaultTracesStatement = 'defaultTracesStatement',
  ManufacturerName = 'manufacturerName',
  OverseasMarket = 'overseasMarket',
  SourceEd = 'sourceED',
  SourceEddoi = 'sourceEDDOI',
  User = 'user'
}

export type DeclarationStatementTrace = {
  __typename?: 'DeclarationStatementTrace';
  id: Scalars['ID']['output'];
  tracesContent?: Maybe<Scalars['String']['output']>;
  tracesId?: Maybe<Scalars['String']['output']>;
};

export type DeclarationsInput = {
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket?: InputMaybe<DestinationMarket>;
  processType?: InputMaybe<Scalars['String']['input']>;
};

export type DeclarationsResponse = {
  __typename?: 'DeclarationsResponse';
  commodity?: Maybe<Scalars['String']['output']>;
  declaration?: Maybe<Scalars['String']['output']>;
  destinationMarket?: Maybe<DestinationMarket>;
  eligibilityCriteria?: Maybe<Scalars['String']['output']>;
};

export type DeclarationsResponseInput = {
  declaration?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
};

export type DeclarationsType = DecisionTableBaseInput & {
  __typename?: 'DeclarationsType';
  commodity?: Maybe<Scalars['String']['output']>;
  destinationMarket?: Maybe<DestinationMarket>;
  processType?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum DefaultAction {
  Blank = 'BLANK',
  EntryRequired = 'ENTRY_REQUIRED',
  NotApplicable = 'NOT_APPLICABLE',
  NotShown = 'NOT_SHOWN',
  Xxxxxx = 'XXXXXX'
}

export type DeleteReplacementExportRequestInput = {
  id: Scalars['ID']['input'];
};

export type DeleteReplacementExportRequestResponse = {
  __typename?: 'DeleteReplacementExportRequestResponse';
  parentId?: Maybe<Scalars['ID']['output']>;
};

export enum DestinationMarket {
  Australia = 'AUSTRALIA',
  Brazil = 'BRAZIL',
  China = 'CHINA',
  Eu = 'EU',
  GreatBritain = 'GREAT_BRITAIN',
  Japan = 'JAPAN',
  NotApplicable = 'NOT_APPLICABLE',
  Singapore = 'SINGAPORE',
  Taiwan = 'TAIWAN',
  Ukraine = 'UKRAINE'
}

export type DestinationProductTracking = {
  __typename?: 'DestinationProductTracking';
  id: Scalars['ID']['output'];
  isExhausted: Scalars['Boolean']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productItem: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['ID']['output'];
  requestNumber: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  sourceNumber: Scalars['String']['output'];
  sourceStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  templateVersion?: Maybe<Scalars['String']['output']>;
};

export enum DestinationSystem {
  EuTracesCatch = 'EU_TRACES_CATCH',
  EuTracesImport = 'EU_TRACES_IMPORT',
  EuTracesProcessingStatement = 'EU_TRACES_PROCESSING_STATEMENT',
  None = 'NONE'
}

export type DfeCondition = {
  __typename?: 'DfeCondition';
  fieldRef?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<DfeOperatorType>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DfeConditionInput = {
  fieldRef?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<DfeOperatorType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DfeConfig = IConfig & IConfigBase & {
  __typename?: 'DfeConfig';
  declarationGroups: Array<DfeDeclarationGroup>;
  fields: Array<DfeField>;
  meta: DfeMeta;
  products: Layout;
  requests: Layout;
  templateId: Scalars['ID']['output'];
  templateRevisionId: Scalars['ID']['output'];
};

export type DfeConfigInput = {
  fields?: InputMaybe<Array<InputMaybe<DfeFieldInput>>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type DfeCrossExclusion = {
  __typename?: 'DfeCrossExclusion';
  fieldA: Scalars['String']['output'];
  fieldB: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DfeCrossFieldValidation = {
  __typename?: 'DfeCrossFieldValidation';
  crossExclusions?: Maybe<Array<DfeCrossExclusion>>;
  exclusiveGroups?: Maybe<Array<DfeExclusiveGroup>>;
  fieldDisableGroups?: Maybe<Array<DfeFieldDisableGroup>>;
  valueUnitPairs?: Maybe<Array<DfeValueUnitPair>>;
};

export type DfeCustomRule = {
  __typename?: 'DfeCustomRule';
  if?: Maybe<DfeCondition>;
  then?: Maybe<DfeCondition>;
};

export type DfeCustomRuleInput = {
  allOf?: InputMaybe<Array<InputMaybe<DfeCustomRuleInput>>>;
  anyOf?: InputMaybe<Array<InputMaybe<DfeCustomRuleInput>>>;
  if?: InputMaybe<DfeConditionInput>;
  then?: InputMaybe<DfeConditionInput>;
};

export enum DfeDeclarationBlockType {
  Declaration = 'declaration',
  DefaultDeclaration = 'defaultDeclaration'
}

export type DfeDeclarationGroup = {
  __typename?: 'DfeDeclarationGroup';
  blockType: DfeDeclarationBlockType;
  declarationGroupType: DeclarationGroupType;
  statements: Array<DfeDeclarationStatement>;
};

export type DfeDeclarationStatement = {
  __typename?: 'DfeDeclarationStatement';
  inputs?: Maybe<Array<DfeDeclarationStatementInput>>;
  statementCode: Scalars['Int']['output'];
  statementDisplayCode: Scalars['String']['output'];
  statementNumber: Scalars['String']['output'];
  statementText: Scalars['String']['output'];
};

export type DfeDeclarationStatementInput = {
  __typename?: 'DfeDeclarationStatementInput';
  dataType: DeclarationStatementInputType;
  fieldRef: Scalars['String']['output'];
  inputSequenceNumber: Scalars['Int']['output'];
  inputType: DfeDeclarationStatementInputType;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export enum DfeDeclarationStatementInputType {
  Text = 'text'
}

export type DfeExclusiveGroup = {
  __typename?: 'DfeExclusiveGroup';
  fieldAUnit: Scalars['String']['output'];
  fieldAValue: Scalars['String']['output'];
  fieldBUnit: Scalars['String']['output'];
  fieldBValue: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DfeField = IConfigField & {
  __typename?: 'DfeField';
  dataType: DfeFieldType;
  defaultValue?: Maybe<Scalars['String']['output']>;
  fuid: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  validation: DfeValidation;
};

export type DfeFieldDisableGroup = {
  __typename?: 'DfeFieldDisableGroup';
  disable: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  whenActive: Array<Scalars['String']['output']>;
};

export type DfeFieldInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fuid?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DfeFieldType>;
  validation?: InputMaybe<DfeValidationInput>;
};

export enum DfeFieldType {
  Boolean = 'boolean',
  Date = 'date',
  DateTime = 'dateTime',
  EntityArray = 'entityArray',
  Number = 'number',
  String = 'string',
  Text = 'text',
  TextArray = 'textArray'
}

export type DfeMeta = {
  __typename?: 'DfeMeta';
  catalogue?: Maybe<Array<Maybe<DfeMetaCatalogueType>>>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effective?: Maybe<Scalars['AWSDateTime']['output']>;
  expire?: Maybe<Scalars['AWSDateTime']['output']>;
  majorVersion?: Maybe<Scalars['Int']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum DfeMetaCatalogueType {
  DeclarationGroups = 'declarationGroups',
  Fields = 'fields',
  Products = 'products',
  Requests = 'requests',
  Review = 'review'
}

export enum DfeOperatorType {
  Contains = 'contains',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  Matches = 'matches',
  NotContains = 'notContains',
  NotEquals = 'notEquals',
  NotMatches = 'notMatches',
  StartsWith = 'startsWith'
}

export type DfeRequestInput = {
  requestId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type DfeTemplateInfo = IConfigBase & {
  __typename?: 'DfeTemplateInfo';
  templateId?: Maybe<Scalars['ID']['output']>;
  templateRevisionId?: Maybe<Scalars['ID']['output']>;
};

export type DfeValidation = {
  __typename?: 'DfeValidation';
  messages?: Maybe<DfeValidationMessages>;
  rules?: Maybe<DfeValidationRules>;
};

export type DfeValidationInput = {
  messages?: InputMaybe<DfeValidationMessagesInput>;
  rules?: InputMaybe<DfeValidationRulesInput>;
};

export type DfeValidationMessages = {
  __typename?: 'DfeValidationMessages';
  custom?: Maybe<Scalars['String']['output']>;
  greaterThan?: Maybe<Scalars['String']['output']>;
  lessThan?: Maybe<Scalars['String']['output']>;
  maxLength?: Maybe<Scalars['String']['output']>;
  minLength?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['String']['output']>;
};

export type DfeValidationMessagesInput = {
  custom?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  minLength?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['String']['input']>;
};

export type DfeValidationRules = {
  __typename?: 'DfeValidationRules';
  crossFieldValidation?: Maybe<DfeCrossFieldValidation>;
  custom?: Maybe<DfeCustomRule>;
  greaterThan?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lessThan?: Maybe<Scalars['Float']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type DfeValidationRulesInput = {
  custom?: InputMaybe<DfeCustomRuleInput>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DfeValueUnitPair = {
  __typename?: 'DfeValueUnitPair';
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum DisplayType {
  FreeText = 'FREE_TEXT',
  RestrictedList = 'RESTRICTED_LIST',
  UnrestrictedList = 'UNRESTRICTED_LIST'
}

export type DisplayTypeSettings = {
  __typename?: 'DisplayTypeSettings';
  columnsToDisplay?: Maybe<ColumnsToDisplay>;
  maxFieldLength?: Maybe<Scalars['Int']['output']>;
  referenceDataList?: Maybe<ReferenceDataList>;
  sortOrder?: Maybe<SortOrder>;
};

export type DisplayTypeSettingsInput = {
  columnsToDisplay?: InputMaybe<ColumnsToDisplay>;
  maxFieldLength?: InputMaybe<Scalars['Int']['input']>;
  referenceDataList?: InputMaybe<Scalars['ID']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum DisplayedBoxWidth {
  Full = 'FULL',
  Half = 'HALF',
  Quarter = 'QUARTER',
  Third = 'THIRD'
}

export type DownloadExportRequestsCsvInput = {
  exportRequestType: ExportRequestType;
  filter?: InputMaybe<Scalars['String']['input']>;
  highlightFullFields?: InputMaybe<Scalars['String']['input']>;
  infix?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryBy?: InputMaybe<Scalars['String']['input']>;
  queryByWeights?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadSupportingDocumentsCsvInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  infix?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryBy?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadTransferProcessHistoryXmlInput = {
  certificateId: Scalars['ID']['input'];
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadTransferRequestsCsvInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  infix?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryBy?: InputMaybe<Scalars['String']['input']>;
};

export enum DraftCertificateExecutionStatus {
  Aborted = 'ABORTED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
  TimedOut = 'TIMED_OUT'
}

export type DraftCertificateGenerationStatusResponse = {
  __typename?: 'DraftCertificateGenerationStatusResponse';
  error?: Maybe<Scalars['String']['output']>;
  exportRequestOutputId?: Maybe<Scalars['String']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  pdfCertificateUrl?: Maybe<Scalars['String']['output']>;
  status: DraftCertificateExecutionStatus;
};

export type DraftExportCertificate = {
  __typename?: 'DraftExportCertificate';
  executionArn: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EStarOrganisation = {
  __typename?: 'EStarOrganisation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EStarOrganisationFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type EuIngredient = {
  __typename?: 'EUIngredient';
  allergen: Scalars['Boolean']['output'];
  eNumber?: Maybe<Scalars['String']['output']>;
  functionalCategory?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ingredient: Scalars['String']['output'];
  useENumber?: Maybe<Scalars['Boolean']['output']>;
};

export type EuIngredientInput = {
  allergen: Scalars['Boolean']['input'];
  eNumber?: InputMaybe<Scalars['String']['input']>;
  functionalCategory?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ingredient: Scalars['String']['input'];
  useENumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EuIngredientsTemplate = {
  __typename?: 'EUIngredientsTemplate';
  as_formatted_paragraph?: Maybe<Scalars['String']['output']>;
};

export enum EditReasonCategory {
  ChangeOfContainerSeal = 'CHANGE_OF_CONTAINER_SEAL',
  ChangeOfFlight = 'CHANGE_OF_FLIGHT',
  ConsigneeDetails = 'CONSIGNEE_DETAILS',
  ConsignmentDoesNotMeetImportingMarketRequirements = 'CONSIGNMENT_DOES_NOT_MEET_IMPORTING_MARKET_REQUIREMENTS',
  ContainerSeal = 'CONTAINER_SEAL',
  DateOfInspection = 'DATE_OF_INSPECTION',
  Declarations = 'DECLARATIONS',
  DestinationDetails = 'DESTINATION_DETAILS',
  ExporterDetails = 'EXPORTER_DETAILS',
  ImportPermitNumber = 'IMPORT_PERMIT_NUMBER',
  LoadingPort = 'LOADING_PORT',
  NoLongerRequired = 'NO_LONGER_REQUIRED',
  OfficialInformationStatement = 'OFFICIAL_INFORMATION_STATEMENT',
  Other = 'OTHER',
  PackagingDetails = 'PACKAGING_DETAILS',
  PaperCertificateLost = 'PAPER_CERTIFICATE_LOST',
  ProcessingDates = 'PROCESSING_DATES',
  ProcessingTreatmentDetails = 'PROCESSING_TREATMENT_DETAILS',
  ProductDescription = 'PRODUCT_DESCRIPTION',
  Quantity = 'QUANTITY',
  UnofficialUnverifiedCommercialInformation = 'UNOFFICIAL_UNVERIFIED_COMMERCIAL_INFORMATION',
  VesselVoyage = 'VESSEL_VOYAGE'
}

export type EgRequestInput = {
  businessRuleConfig?: InputMaybe<BusinessRuleConfigInput>;
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  dfeConfig?: InputMaybe<DfeConfigInput>;
};

export type EligibilityInput = {
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket?: InputMaybe<DestinationMarket>;
};

export type EligibilityResponse = {
  __typename?: 'EligibilityResponse';
  destinationMarket?: Maybe<DestinationMarket>;
  eligibilityCriteria: Scalars['String']['output'];
};

export type EligibilityResponseInput = {
  eligibilityCriteria: Scalars['String']['input'];
};

export type EligibilityType = DecisionTableBaseInput & {
  __typename?: 'EligibilityType';
  commodity?: Maybe<Scalars['String']['output']>;
  destinationMarket?: Maybe<DestinationMarket>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type EnumerationInfo = {
  __typename?: 'EnumerationInfo';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EstarCancelRequest = {
  __typename?: 'EstarCancelRequest';
  executionArn: Scalars['ID']['output'];
};

export type ExhaustTransferProductsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['ID']['input']>;
  transferRequestId: Scalars['ID']['input'];
};

export type ExhaustTransferProductsResponse = {
  __typename?: 'ExhaustTransferProductsResponse';
  isFullyExhausted: Scalars['Boolean']['output'];
  products: Array<TransferProductDetails>;
};

export type ExhaustTransferRequestInput = {
  certificateNumber: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type ExhaustTransferRequestResponse = {
  __typename?: 'ExhaustTransferRequestResponse';
  certificateNumber: Scalars['String']['output'];
  isFullyExhausted: Scalars['Boolean']['output'];
  transferRequestId: Scalars['ID']['output'];
};

export type ExhaustionResponse = {
  __typename?: 'ExhaustionResponse';
  exhaust?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Array<Maybe<ProductExhaustionResponse>>>;
  transferId?: Maybe<Scalars['String']['output']>;
};

export type ExportCertificateCollectionInput = {
  action: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
  reasonInformation?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  systemUserName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type ExportCertificateCollectionResponse = {
  __typename?: 'ExportCertificateCollectionResponse';
  certificateNumber?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExportCertificateRequest = {
  __typename?: 'ExportCertificateRequest';
  certificate_id?: Maybe<Scalars['String']['output']>;
  certificate_type: CertificateType;
  certifier?: Maybe<SpsAuthentication>;
  commodity?: Maybe<Scalars['String']['output']>;
  consignment: SpsConsignment;
  destination_market: DestinationMarket;
  id: Scalars['ID']['output'];
  reason_for_status_change?: Maybe<Scalars['String']['output']>;
  requestor?: Maybe<Scalars['String']['output']>;
  requestor_id?: Maybe<Scalars['String']['output']>;
  state_machine_execution_arn?: Maybe<Scalars['String']['output']>;
  status: ExportCertificateStatus;
  verifiers: Array<SpsAuthentication>;
};

export type ExportCertificateRequestInput = {
  certificate_id?: InputMaybe<Scalars['String']['input']>;
  certificate_type: CertificateType;
  certifier?: InputMaybe<SpsAuthenticationInput>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  consignment: SpsConsignmentInput;
  destination_market: DestinationMarket;
  reason_for_status_change?: InputMaybe<Scalars['String']['input']>;
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id?: InputMaybe<Scalars['String']['input']>;
  status: ExportCertificateStatus;
  verifiers?: InputMaybe<Array<SpsAuthenticationInput>>;
};

export enum ExportCertificateStatus {
  Accepted = 'ACCEPTED',
  Acknowledged = 'ACKNOWLEDGED',
  Amended = 'AMENDED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  PendingReplacement = 'PENDING_REPLACEMENT',
  ProvisionallyApproved = 'PROVISIONALLY_APPROVED',
  Raised = 'RAISED',
  Replaced = 'REPLACED',
  ReplacementAuthorised = 'REPLACEMENT_AUTHORISED',
  RequestedToReplace = 'REQUESTED_TO_REPLACE',
  RequestedToResubmit = 'REQUESTED_TO_RESUBMIT',
  RequestedToRevoke = 'REQUESTED_TO_REVOKE',
  Revoked = 'REVOKED',
  Verified = 'VERIFIED'
}

export type ExportCertificateSupportingDocumentsInput = {
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['ID']['input'];
};

export type ExportCertificateWorkflowInput = {
  certificateType?: InputMaybe<CertificateType>;
};

export type ExportCertificateWorkflowResponse = {
  __typename?: 'ExportCertificateWorkflowResponse';
  validatonNeeded: Scalars['Boolean']['output'];
};

export type ExportCertificateWorkflowResponseInput = {
  validatonNeeded: Scalars['Boolean']['input'];
};

export type ExportCertificateWorkflowType = DecisionTableBaseInput & {
  __typename?: 'ExportCertificateWorkflowType';
  certificateType?: Maybe<CertificateType>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ExportCsvResponse = {
  __typename?: 'ExportCsvResponse';
  filename: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type ExportDetailsInput = {
  id: Scalars['ID']['input'];
};

export enum ExportReasonCategory {
  Compliance = 'COMPLIANCE'
}

export type ExportRequestHistoryInput = {
  exportRequestId: Scalars['ID']['input'];
};

export type ExportRequestHistoryRecord = {
  __typename?: 'ExportRequestHistoryRecord';
  action?: Maybe<Scalars['String']['output']>;
  exportRequestId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  nzxmlURI?: Maybe<Scalars['String']['output']>;
  overseasAuthorityInvolved?: Maybe<Scalars['Boolean']['output']>;
  reasonCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reasonForReprinting?: Maybe<Scalars['String']['output']>;
  reasonForStatusChange?: Maybe<Scalars['String']['output']>;
  replacesId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  substatus?: Maybe<Scalars['String']['output']>;
  templateVersionId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  updatedByProfileFullName?: Maybe<Scalars['String']['output']>;
  updatedByProfileName?: Maybe<Scalars['String']['output']>;
  updatedBySystem?: Maybe<Scalars['String']['output']>;
};

export enum ExportRequestOutputAssuranceType {
  Copy = 'COPY',
  Draft = 'DRAFT',
  Extract = 'EXTRACT',
  Official = 'OFFICIAL'
}

export enum ExportRequestOutputFileType {
  Pdf = 'PDF',
  Xml = 'XML'
}

export enum ExportRequestOutputStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export enum ExportRequestType {
  AnimalProducts = 'ANIMAL_PRODUCTS',
  OcaBorder = 'OCA_BORDER',
  PlantsProducts = 'PLANTS_PRODUCTS',
  Wine = 'WINE'
}

export type ExportSpsAcknowledgementInput = {
  certificateNumber: Scalars['String']['input'];
  reasonInformation?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  status: CoreStatus;
  systemUserName?: InputMaybe<Scalars['String']['input']>;
};

export type ExportSpsAcknowledgementResponse = {
  __typename?: 'ExportSPSAcknowledgementResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  updatedStatus?: Maybe<Scalars['String']['output']>;
};

export enum ExportStatus {
  Accepted = 'ACCEPTED',
  Acknowledged = 'ACKNOWLEDGED',
  Amended = 'AMENDED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Detained = 'DETAINED',
  Draft = 'DRAFT',
  Partial = 'PARTIAL',
  PendingReplacement = 'PENDING_REPLACEMENT',
  Raised = 'RAISED',
  Rejected = 'REJECTED',
  Replaced = 'REPLACED',
  ReplacementAuthorised = 'REPLACEMENT_AUTHORISED',
  RequestReplacement = 'REQUEST_REPLACEMENT',
  Resubmit = 'RESUBMIT',
  Revoked = 'REVOKED'
}

export type ExtendIntendedOperatorInput = {
  extendIntendedOperator: Array<InputMaybe<CoreLookupInput>>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Field = {
  __typename?: 'Field';
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldBySubmissionLayout = {
  __typename?: 'FieldBySubmissionLayout';
  active: Scalars['Boolean']['output'];
  captionList: Array<ReferenceCaption>;
  defaultDisplayType?: Maybe<Scalars['String']['output']>;
  fieldCategory?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  fieldUniqueId: Scalars['String']['output'];
  referenceDataList: Array<ReferenceDataList>;
  sectionName?: Maybe<Scalars['String']['output']>;
};

export type FieldConfiguration = {
  __typename?: 'FieldConfiguration';
  displayType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type FieldFilterInput = {
  classificationCode: Scalars['String']['input'];
};

export type FieldInfo = {
  __typename?: 'FieldInfo';
  fieldUniqueId: Scalars['String']['output'];
};

export type FieldInput = {
  __typename?: 'FieldInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  fieldRef: Scalars['String']['output'];
  inputType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldV2 = {
  __typename?: 'FieldV2';
  category?: Maybe<Scalars['String']['output']>;
  grouping?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productHierarchy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reference?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FlexiFillingRunData = {
  __typename?: 'FlexiFillingRunData';
  date: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  litres: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
};

export type FlexiFillingRunDataInput = {
  date: Scalars['AWSDateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  litres: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
};

export type FlexiFillingRunInput = {
  processId: Scalars['ID']['input'];
  runs: Array<FlexiFillingRunDataInput>;
};

export type FlexiFillingRunResponse = {
  __typename?: 'FlexiFillingRunResponse';
  processId: Scalars['ID']['output'];
  runs: Array<FlexiFillingRunData>;
};

export type Form = {
  __typename?: 'Form';
  declarations: Array<DeclarationFormletSection>;
  productDetails: Array<FormletField>;
};

export type FormletCollectionFilter = {
  __typename?: 'FormletCollectionFilter';
  attribute: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FormletField = {
  __typename?: 'FormletField';
  charLength?: Maybe<Scalars['Int']['output']>;
  collection?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<FormletCollectionFilter>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nested?: Maybe<Array<Maybe<FormletNestedFields>>>;
  numberConstrain?: Maybe<NumberConstrain>;
  numberOfLines?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<FormletOption>>>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sectionFields?: Maybe<Array<Maybe<FormletField>>>;
  type?: Maybe<FormletFieldType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum FormletFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  LongText = 'LONG_TEXT',
  MultilineText = 'MULTILINE_TEXT',
  MultisearchTable = 'MULTISEARCH_TABLE',
  Nested = 'NESTED',
  Number = 'NUMBER',
  Parallel = 'PARALLEL',
  Party = 'PARTY',
  Radio = 'RADIO',
  Search = 'SEARCH',
  Select = 'SELECT',
  ShortText = 'SHORT_TEXT',
  ShortTextArray = 'SHORT_TEXT_ARRAY'
}

export type FormletNestedFields = {
  __typename?: 'FormletNestedFields';
  collection?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: FormletFieldType;
};

export type FormletOption = {
  __typename?: 'FormletOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ForwardProductTrackingResponse = {
  __typename?: 'ForwardProductTrackingResponse';
  sourceProducts: Array<SourceProductTracking>;
};

export type G2GAccount = {
  __typename?: 'G2GAccount';
  accountType: G2GAccountType;
  comment?: Maybe<Scalars['String']['output']>;
  contactNumber: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  permissions: G2GPermissions;
  profileName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<SuspensionReason>;
  status: G2GAccountStatus;
  subId?: Maybe<Scalars['String']['output']>;
  systemUsername?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type G2GAccountSearchResult = {
  __typename?: 'G2GAccountSearchResult';
  results: Array<G2GAccountSummary>;
  totalCount: Scalars['Int']['output'];
};

export enum G2GAccountStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

export type G2GAccountSummary = {
  __typename?: 'G2GAccountSummary';
  accountType: G2GAccountType;
  agencyName?: Maybe<Scalars['String']['output']>;
  certificateTypes?: Maybe<Array<CoreExportCertificateType>>;
  countries?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inspectionPorts?: Maybe<Array<Scalars['String']['output']>>;
  status: G2GAccountStatus;
  subId?: Maybe<Scalars['String']['output']>;
  systemUsername?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum G2GAccountType {
  G2GReadOnly = 'G2G_READ_ONLY',
  G2GSystem = 'G2G_SYSTEM',
  OcaBorderInspector = 'OCA_BORDER_INSPECTOR'
}

export type G2GPermissions = {
  __typename?: 'G2GPermissions';
  agencyId?: Maybe<Scalars['String']['output']>;
  agencyName?: Maybe<Scalars['String']['output']>;
  certificateTypes: Array<CoreExportCertificateType>;
  countries?: Maybe<Array<Scalars['String']['output']>>;
  inspectionPorts?: Maybe<Array<Scalars['String']['output']>>;
};

export type G2GPermissionsInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>;
  certificateTypes: Array<CoreExportCertificateType>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  inspectionPorts?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GenerateDraftExportCertificateInput = {
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['ID']['input'];
};

export type GenerateOutputPreviewXmlResult = {
  __typename?: 'GenerateOutputPreviewXMLResult';
  templateVersionId: Scalars['ID']['output'];
};

export type GenerateSubmissionPreviewXmlResponse = {
  __typename?: 'GenerateSubmissionPreviewXmlResponse';
  error?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GeneratedCertificate = {
  __typename?: 'GeneratedCertificate';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileVersion?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum GeneratedCertificateType {
  Copy = 'COPY',
  Draft = 'DRAFT',
  Official = 'OFFICIAL',
  Xml = 'XML'
}

export type GetDfeFormInput = {
  recipeType?: InputMaybe<RecipeType>;
  templateId: Scalars['ID']['input'];
  templateVersionId: Scalars['ID']['input'];
};

export type GetDraftCertificateGenerationStatusInput = {
  executionArn: Scalars['String']['input'];
};

export type GetRequestValidationsInput = {
  requestId: Scalars['ID']['input'];
  requestType: CoreRequestType;
  skipFieldValidation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetRequestValidationsResponse = {
  __typename?: 'GetRequestValidationsResponse';
  errors: Array<RequestValidation>;
  warnings: Array<RequestValidation>;
};

export type GetSignedCertificateXmlInput = {
  certificateNumber: Scalars['String']['input'];
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type GetSignedCertificateXmlResponse = {
  __typename?: 'GetSignedCertificateXmlResponse';
  s3Path: Scalars['String']['output'];
};

export type GetSupportingDocumentActionsInput = {
  id: Scalars['ID']['input'];
};

export type GetSupportingDocumentDetailsInput = {
  id: Scalars['ID']['input'];
};

export type GetSupportingDocumentHistoryInput = {
  supportingDocumentId: Scalars['ID']['input'];
};

export type GetTemplateXmlCoreInput = {
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  templateType: Scalars['String']['input'];
};

export type GetTemplateXmlCoreResponse = {
  __typename?: 'GetTemplateXmlCoreResponse';
  template?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type IConfig = {
  fields?: Maybe<Array<Maybe<IConfigField>>>;
};

export type IConfigBase = {
  templateId?: Maybe<Scalars['ID']['output']>;
  templateRevisionId?: Maybe<Scalars['ID']['output']>;
};

export type IConfigField = {
  fuid?: Maybe<Scalars['ID']['output']>;
};

export type IDfeValidationRules = {
  largerThan?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lessThan?: Maybe<Scalars['Float']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
};

export type IDsTemplate = {
  __typename?: 'IDsTemplate';
  as_rows: Array<Scalars['String']['output']>;
  comma_separated: Scalars['String']['output'];
  new_line_separated: Scalars['String']['output'];
};

export type IMeasureTemplate = {
  as_number: Scalars['Float']['output'];
  mpi_unit?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  three_decimals?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IppcHubLogEntry = {
  __typename?: 'IPPCHubLogEntry';
  /** @deprecated Use certificateNumber */
  certificateId?: Maybe<Scalars['String']['output']>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  date: Scalars['AWSDateTime']['output'];
  exportCountryCode: Scalars['String']['output'];
  hubDeliveryNumber: Scalars['String']['output'];
  hubTrackingInfo: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type IppcHubLogInput = {
  /** @deprecated Use certificateNumber */
  certificateId?: InputMaybe<Scalars['String']['input']>;
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  exportCountryCode: Scalars['String']['input'];
  hubDeliveryNumber: Scalars['String']['input'];
  hubTrackingInfo: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type ITemplateProcessGroup = {
  id?: Maybe<Scalars['String']['output']>;
};

export type ImportCertificate = {
  __typename?: 'ImportCertificate';
  certificate_id: Scalars['String']['output'];
  /** @deprecated Use consignment.consignee */
  consignee?: Maybe<SpsParty>;
  consignment: SpsConsignment;
  /** @deprecated Use consignment.consignor */
  consignor?: Maybe<SpsParty>;
  /** @deprecated Use exchanged_document.referenced_documents */
  embeddedDocument: Array<ImportCertificateEmbeddedDocument>;
  exchanged_document: SpsExchangedDocument;
  export_country: SpsCountry;
  id: Scalars['ID']['output'];
  /** @deprecated Use consignment.import_country */
  import_country: SpsCountry;
  /** @deprecated Use exchanged_document.included_notes */
  included_notes: Array<SpsNote>;
  ippcLogs: Array<IppcHubLogEntry>;
  issued?: Maybe<Scalars['AWSDateTime']['output']>;
  /** @deprecated Use exchanged_document.issuer */
  issuer?: Maybe<SpsParty>;
  items: Array<SpsTradeLineItem>;
  /** @deprecated Use consignment.main_carriage_transport_movements */
  last_transport_movement?: Maybe<SpsTransportMovement>;
  /** @deprecated Use consignment.loading_base_port_location */
  loading_base_port_location?: Maybe<SpsLocation>;
  logs: Array<ImportCertificateLogMessage>;
  /** @deprecated Use consignment.main_carriage_transport_movements */
  main_carriage_transport_movements?: Maybe<Array<SpsTransportMovement>>;
  pdf_generated: PdfGenerationStatus;
  /** @deprecated Use exchanged_document.referenced_documents */
  referenced_documents: Array<SpsReferencedDocument>;
  replaced_by?: Maybe<ImportCertificate>;
  replacement_reason?: Maybe<Scalars['String']['output']>;
  replacing?: Maybe<ImportCertificate>;
  replacing_certificate_number?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use exchanged_document.signatories */
  signatories: Array<SpsAuthentication>;
  status: ImportCertificateStatus;
  status_code: Scalars['Int']['output'];
  /** @deprecated Use consignment.transit_countries */
  transit_countries?: Maybe<Array<SpsCountry>>;
  type_code: Scalars['Int']['output'];
  type_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use consignment.unloading_base_port_location */
  unloading_base_port_location?: Maybe<SpsLocation>;
  /** @deprecated Use consignment.utilized_transport_equipment */
  utilized_transport_equipment: Array<SpsTransportEquipment>;
};

export type ImportCertificateEmbeddedDocument = {
  __typename?: 'ImportCertificateEmbeddedDocument';
  description?: Maybe<Scalars['String']['output']>;
  documentID: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
  file_size?: Maybe<Scalars['String']['output']>;
  file_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ImportCertificateExtractItem = {
  __typename?: 'ImportCertificateExtractItem';
  code: Scalars['String']['output'];
  items?: Maybe<Array<ImportCertificateExtractItem>>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ImportCertificateExtractMeasurement = {
  __typename?: 'ImportCertificateExtractMeasurement';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  measures?: Maybe<Array<ImportCertificateExtractItem>>;
  value: Scalars['String']['output'];
};

export type ImportCertificateExtractTemplate = {
  __typename?: 'ImportCertificateExtractTemplate';
  as_items?: Maybe<Scalars['String']['output']>;
};

export type ImportCertificateIntegration = {
  __typename?: 'ImportCertificateIntegration';
  countryCode: Scalars['String']['output'];
  receivingSpsAcknowledgement?: Maybe<ImportCertificateIntegrationResponse>;
  response?: Maybe<ImportCertificateIntegrationResponse>;
};

export enum ImportCertificateIntegrationResponse {
  Accept = 'Accept',
  DeliveredNotReadable = 'DeliveredNotReadable',
  Ignore = 'Ignore'
}

export type ImportCertificateLogMessage = {
  __typename?: 'ImportCertificateLogMessage';
  createdBy: Scalars['String']['output'];
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  relatedCertificate?: Maybe<ImportCertificate>;
  status: ImportCertificateLogStatus;
};

export type ImportCertificateLogMessageInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  relatedCertificateId?: InputMaybe<Scalars['ID']['input']>;
  relatedCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  status: ImportCertificateLogStatus;
};

export enum ImportCertificateLogStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Issued = 'ISSUED',
  PdfDownloaded = 'PDF_DOWNLOADED',
  Rejected = 'REJECTED',
  Replaced = 'REPLACED',
  ReplacementRequested = 'REPLACEMENT_REQUESTED',
  Withdrawn = 'WITHDRAWN'
}

export type ImportCertificateMeasurementTemplate = {
  __typename?: 'ImportCertificateMeasurementTemplate';
  as_new_lines?: Maybe<Scalars['String']['output']>;
};

export type ImportCertificatePackagingTemplate = {
  __typename?: 'ImportCertificatePackagingTemplate';
  as_new_lines?: Maybe<Scalars['String']['output']>;
};

export type ImportCertificatePdf = {
  __typename?: 'ImportCertificatePdf';
  id: Scalars['ID']['output'];
  status: PdfGenerationStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImportCertificatePdfInput = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum ImportCertificateStatus {
  Approved = 'APPROVED',
  Issued = 'ISSUED',
  Rejected = 'REJECTED',
  Replaced = 'REPLACED',
  ReplacementRequested = 'REPLACEMENT_REQUESTED',
  Unrecognised = 'UNRECOGNISED',
  Withdrawn = 'WITHDRAWN'
}

export type ImportCertificateStatusChangeInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export enum ImportCertificateType {
  Phytosanitary = 'PHYTOSANITARY',
  ReexportPhytosanitary = 'REEXPORT_PHYTOSANITARY',
  Sanitary = 'SANITARY'
}

export type ImportCertificateXml = {
  __typename?: 'ImportCertificateXml';
  documentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type ImportConnectionsInput = {
  connectionType?: InputMaybe<ConnectionType>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

export type ImportConnectionsResponse = {
  __typename?: 'ImportConnectionsResponse';
  applyDigitalSignature: Scalars['Boolean']['output'];
  connectionType: ConnectionType;
  countryCode: Scalars['String']['output'];
  receiving?: Maybe<ImportCertificateIntegrationResponse>;
  receivingSpsAcknowledgement?: Maybe<ImportCertificateIntegrationResponse>;
  sending?: Maybe<Scalars['Boolean']['output']>;
  spsAcknowledgement: Scalars['Boolean']['output'];
};

export type ImportConnectionsResponseInput = {
  applyDigitalSignature: Scalars['Boolean']['input'];
  receiving?: InputMaybe<ImportCertificateIntegrationResponse>;
  receivingSpsAcknowledgement?: InputMaybe<ImportCertificateIntegrationResponse>;
  sending?: InputMaybe<Scalars['Boolean']['input']>;
  spsAcknowledgement: Scalars['Boolean']['input'];
};

export type ImportConnectionsType = DecisionTableBaseInput & {
  __typename?: 'ImportConnectionsType';
  connectionType?: Maybe<ConnectionType>;
  countryCode?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IndicatorType = {
  __typename?: 'IndicatorType';
  content: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
};

export type InitSupportingDocumentUploadInput = {
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  fileS3Path: Scalars['String']['input'];
  intendedOperators?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  primaryOperator?: InputMaybe<CoreLookupInput>;
  requestOrigin?: InputMaybe<RequestOrigin>;
};

export type InitSupportingDocumentUploadResponse = {
  __typename?: 'InitSupportingDocumentUploadResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fileId: Scalars['ID']['output'];
};

export type IntTemplate = {
  __typename?: 'IntTemplate';
  in_English: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IntegrationsAmendExportFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xmlS3Path: Scalars['String']['input'];
};

export type IntegrationsAmendTransferFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xmlS3Path: Scalars['String']['input'];
};

export type IntegrationsCreateSupportingDocumentInput = {
  documentReferenceNumber: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  foreignManufacturePremises?: InputMaybe<Scalars['String']['input']>;
  foreignPremisesId?: InputMaybe<Scalars['String']['input']>;
  identificationMarks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intendedOperators?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nzManufacturePremises?: InputMaybe<Scalars['String']['input']>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  primaryOperator: Scalars['String']['input'];
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productionDates?: InputMaybe<Array<InputMaybe<ProductionDateRangeInput>>>;
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsDownloadTransferProcessHistoryXmlInput = {
  certificateId: Scalars['ID']['input'];
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsExportRequestApFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xmlS3Path: Scalars['String']['input'];
  xmlSequenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsExportRequestApInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xml: Scalars['String']['input'];
  xmlSequenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsExportRequestPhytoFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xmlS3Path: Scalars['String']['input'];
  xmlSequenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsExportRequestPhytoInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xml: Scalars['String']['input'];
  xmlSequenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsGetSignedCertificateXmlInput = {
  certificateNumber: Scalars['String']['input'];
  systemAccountName: Scalars['String']['input'];
  userProfileName: Scalars['String']['input'];
};

export type IntegrationsGetTemplateXmlInput = {
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  templateType: Scalars['String']['input'];
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsGetTemplateXmlResponse = {
  __typename?: 'IntegrationsGetTemplateXmlResponse';
  template?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type IntegrationsInitSupportingDocumentUploadInput = {
  fileS3Path: Scalars['String']['input'];
  intendedOperators?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryOperator: Scalars['String']['input'];
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsRaiseTransferFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xmlS3Path: Scalars['String']['input'];
};

export type IntegrationsRaiseTransferInput = {
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xml: Scalars['String']['input'];
};

export type IntegrationsReplaceExportCertificateInput = {
  certificateNumber: Scalars['String']['input'];
  requestOrigin?: InputMaybe<RequestOrigin>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
  xmlS3Path: Scalars['String']['input'];
};

export type IntegrationsRequestAmendmentTransferInput = {
  certificateId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationsRequestReplacementCertificateInput = {
  certificateNumber: Scalars['String']['input'];
  overseasAuthoritiesInvolved: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  systemAccountName?: InputMaybe<Scalars['String']['input']>;
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type Language = {
  __typename?: 'Language';
  languageCode: Scalars['String']['output'];
  languageName: Scalars['String']['output'];
  rightToLeft?: Maybe<Scalars['Boolean']['output']>;
};

export type Layout = {
  __typename?: 'Layout';
  sections: Array<Section>;
};

export type Layouts = {
  __typename?: 'Layouts';
  products: Layout;
  requests: Layout;
};

export type LookupValue = {
  __typename?: 'LookupValue';
  code?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ManualVolumeAdjustment = {
  __typename?: 'ManualVolumeAdjustment';
  changeType?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  litres?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ManualVolumeAdjustmentInput = {
  litres: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
};

/**
 * Master Layout configuration for different submission types.
 * Contains field definitions and layout structure for form generation.
 */
export type MasterLayout = {
  __typename?: 'MasterLayout';
  /** JSON string containing field definitions and validation rules */
  masterFields: Scalars['String']['output'];
  /** JSON string containing the layout structure with sections and blocks */
  masterLayout: Scalars['String']['output'];
};

export type MeasureTemplate = IMeasureTemplate & {
  __typename?: 'MeasureTemplate';
  as_number: Scalars['Float']['output'];
  mpi_unit?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  three_decimals?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use three_decimals */
  three_digits?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Measurment = {
  __typename?: 'Measurment';
  unit?: Maybe<CoreLookup>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type MeasurmentInput = {
  unit?: InputMaybe<CoreLookupInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type MonthTemplate = {
  __typename?: 'MonthTemplate';
  abbreviation: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: IntTemplate;
};

export type MultiCollectionApiKeys = {
  __typename?: 'MultiCollectionApiKeys';
  agency?: Maybe<Scalars['String']['output']>;
  expires: Scalars['AWSDateTime']['output'];
  exportCertificates?: Maybe<Scalars['String']['output']>;
  exporters?: Maybe<Scalars['String']['output']>;
  partyApiKey?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  registrationAll?: Maybe<Scalars['String']['output']>;
  transferRequests?: Maybe<Scalars['String']['output']>;
};

export type MultiCollectionApiKeysV2 = {
  __typename?: 'MultiCollectionApiKeysV2';
  agency?: Maybe<Scalars['String']['output']>;
  expires: Scalars['AWSDateTime']['output'];
  exporters?: Maybe<Scalars['String']['output']>;
  exports?: Maybe<RoleSpecificKeys>;
  ocaExports?: Maybe<Scalars['String']['output']>;
  partyApiKey?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Scalars['String']['output']>;
  supportingDocs?: Maybe<SupportingDocumentKeys>;
  templates?: Maybe<Scalars['String']['output']>;
  transfers?: Maybe<RoleSpecificKeys>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptedTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  addBottlingRuns: BottlingRunResponse;
  addCustomsPermitNumbers: Scalars['Int']['output'];
  addFlexiFillingRuns: FlexiFillingRunResponse;
  addProduct: B2GProduct;
  addProductAndProcessFromTransfer: Array<SavedProductOutput>;
  adjustBatchVolume: VolumeAdjustmentResponse;
  allocateCustomsPermitNumber: Scalars['String']['output'];
  appendIPPCHubLog: IppcHubLogEntry;
  appendImportCertificateLog: Scalars['Boolean']['output'];
  approveExportCertificateRequest?: Maybe<ExportCertificateRequest>;
  attachTemplateDocument: TemplateUploadUrl;
  banWineBatch: Scalars['String']['output'];
  cancelEstarRequest: EstarCancelRequest;
  cancelExportCertificateRequest: B2GExportCertificateRequest;
  cancelProcess: CancelledProcessResponse;
  cancelSupportingDocument?: Maybe<UpdateSupportingDocumentResult>;
  changeExportRequestStatus: ChangeExportRequestStatusResponse;
  changeTransferRequestAmendmentStatus: ChangeTransferRequestAmendmentStatusResponse;
  changeTransferRequestStatus: ChangeTransferRequestStatusResponse;
  completeSensoryProcess: SensoryProcessRequest;
  confirmPackaging: ConfirmPackagingResponse;
  confirmWinemaking: Scalars['String']['output'];
  createAnnouncement: Announcement;
  createSupportingDocument?: Maybe<CoreSupportingDocument>;
  createTemplate: Template;
  createTemplateVersion: Template;
  createTestRegistration?: Maybe<TestRegistration>;
  createTestUser?: Maybe<TestUser>;
  createUser: User;
  deleteAllCustomsPermitNumbers: Scalars['Boolean']['output'];
  deleteAnnouncement: Announcement;
  deleteCoreReferencedDocument?: Maybe<Scalars['String']['output']>;
  deleteExportCertificateRequest: Scalars['Boolean']['output'];
  deleteExportRequest: Scalars['Boolean']['output'];
  deleteExportRequestById: Scalars['Boolean']['output'];
  deleteFieldConfiguration: Scalars['String']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  deleteReferencedDocument: Scalars['ID']['output'];
  deleteReplacementExportRequest: DeleteReplacementExportRequestResponse;
  deleteTemplate: Scalars['String']['output'];
  deleteTransferRequestById: Scalars['Boolean']['output'];
  discardExportCertificateRequest: Scalars['Boolean']['output'];
  downloadExportRequestsAsCsv: ExportCsvResponse;
  downloadSupportingDocumentsAsCsv: ExportCsvResponse;
  downloadTransferProcessHistoryXML?: Maybe<TransferProcessHistoryXmlResponse>;
  downloadTransferRequestsAsCsv: ExportCsvResponse;
  draftExportCertificateRequest: B2GExportCertificateRequest;
  e2eRaiseExportCertificateRequest?: Maybe<B2GExportCertificateRequest>;
  executeChemistryTestEvent: Scalars['Boolean']['output'];
  exhaustTransferProducts: ExhaustTransferProductsResponse;
  exhaustTransferRequest: ExhaustTransferRequestResponse;
  extendIntendedOperator?: Maybe<UpdateSupportingDocumentResult>;
  forceApproveTemplateVersion: TemplateVersion;
  generateDraftExportCertificate: DraftExportCertificate;
  generateDraftPdf: Scalars['String']['output'];
  generateOutputPreviewXML: GenerateOutputPreviewXmlResult;
  generateSpecimenPdf: StandardPdfPreviewResponse;
  generateStandardPdfPreview: StandardPdfPreviewResponse;
  generateSubmissionPreviewXml: GenerateSubmissionPreviewXmlResponse;
  generateTeoConfigurationJson: Scalars['String']['output'];
  getNewTemplateVersionUploadUrl: TemplateUploadUrl;
  getSignedCertificateXml: GetSignedCertificateXmlResponse;
  initSupportingDocumentUpload: InitSupportingDocumentUploadResponse;
  integrationsAmendExport?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsAmendTransfer?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsCreateSupportingDocument?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsDownloadTransferProcessHistoryXML?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsExhaustTransfer?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsGetSignedCertificateXml?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsGetTemplateXml: IntegrationsGetTemplateXmlResponse;
  integrationsInitSupportingDocumentUpload?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRaiseExportRequestAP?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRaiseExportRequestAPV2?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRaiseExportRequestPhyto?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRaiseExportRequestPhytoV2?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRaiseTransfer?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRaiseTransferV2?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsReplaceExportCertificate?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRequestAmendmentTransfer?: Maybe<Scalars['AWSJSON']['output']>;
  integrationsRequestReplacementCertificate?: Maybe<Scalars['AWSJSON']['output']>;
  makeProductEligible: Scalars['String']['output'];
  newCoreReferencedDocument?: Maybe<NewCoreReferencedDocument>;
  newMultiCollectionApiKeys?: Maybe<MultiCollectionApiKeys>;
  newMultiCollectionApiKeysV2?: Maybe<MultiCollectionApiKeysV2>;
  newPartyApiKey?: Maybe<SearchApiKey>;
  newReferencedDocument: NewReferencedDocument;
  newSearchApiKey?: Maybe<SearchApiKey>;
  prepareXmlFileForB2G: PrepareXmlFileForB2GResponse;
  printCertificate: PrintCertificateResponse;
  processB2GIntegration: ProcessB2GIntegrationResponse;
  processCertificateCollection: CertificateCollectionOutput;
  processExportCertificateCollection: ExportCertificateCollectionResponse;
  processExportOCAWithPermissions: OcaWithPermissionsResponse;
  processExportSPSAcknowledgement: ExportSpsAcknowledgementResponse;
  processOCAWithPermissions: OcaWithPermissionsResponse;
  processSpsAcknowledgement: SpsAcknowledgementOutput;
  publishXmlFileProcessed: PrepareXmlFileForB2GResponse;
  raiseExportCertificateRequest?: Maybe<B2GExportCertificateRequest>;
  raiseExportRequest: RaiseExportRequestResponse;
  raiseTransferRequest: RaiseTransferRequestResponse;
  regenerateApprovedTemplates: RegenerateApprovedTemplatesResponse;
  regenerateCertificate: RegenerateCertificateResponse;
  reindexCollection: ReindexResponse;
  reindexDatabaseItem: ReindexResponse;
  rejectImportCertificate?: Maybe<ImportCertificate>;
  removeProductProcesses: RemoveProductProcessesResponse;
  removeProductsFromRequest: Array<CoreProduct>;
  replacementCertificateRequest: B2GExportCertificateRequest;
  requestApprovalToReplaceExportCertificateRequest?: Maybe<Scalars['Boolean']['output']>;
  requestChemistryTest: ChemistryTestResponse;
  requestConfirmation: RequestConfirmationResponse;
  requestReplacementImportCertificate?: Maybe<ImportCertificate>;
  requestedToResubmitExportCertificateRequest?: Maybe<ExportCertificateRequest>;
  resetConfirmationRequest: Scalars['String']['output'];
  salesforceErApproval: SalesforceErApprovalResponse;
  /** @deprecated Use `sfChangeTransferRequestStatus` mutation */
  salesforceTransferRequestVerification: SalesforceTransferRequestVerificationResponse;
  saveChangesToReferenceData: SaveChangesToReferenceDataResponse;
  saveExportCertificateRequest: ExportCertificateRequest;
  saveExportRequest: CoreExportRequest;
  saveFieldConfiguration?: Maybe<TemplateFieldConfiguration>;
  saveFieldConfigurationBatch?: Maybe<TemplateFieldConfigurationAcknowledgement>;
  saveG2GAccount: G2GAccount;
  saveProcessGroupConfig: TemplateProcessGroupsConfigAcknowledgement;
  saveTransferRequest: CoreTransferRequest;
  setTemplateVersionApproved: TemplateVersion;
  setTemplateVersionStatus: TemplateVersion;
  sfCancelExportCertificate?: Maybe<Scalars['Boolean']['output']>;
  sfChangeExportCertificateRequestStatus?: Maybe<ExportCertificateRequest>;
  sfChangeExportRequestStatus: SfChangeExportRequestStatusResponse;
  sfChangeTransferRequestStatus: SfChangeTransferRequestStatusResponse;
  sfDownloadCertificate: SfDownloadCertificateResponse;
  sfRequestExportCertificateReplacement?: Maybe<Scalars['Boolean']['output']>;
  sfUpdateProductExhaustion: SfUpdateProductExhaustionResponse;
  sfUpdateStationerySerialNumbers: SfUpdateStationerySerialNumbersResponse;
  sfUpdateTransferAuditComment: SfUpdateTransferAuditCommentResponse;
  sfVerifyExportCertificateRequestProducts?: Maybe<Array<Maybe<SpsTradeLineItem>>>;
  splitProduct: Array<B2GProduct>;
  startPackaging: ProcessResponse;
  startWinemaking: ProcessResponse;
  transferProduct: B2GProduct;
  updateApprovedTransferTransport?: Maybe<Scalars['Boolean']['output']>;
  updateDecisionTable: DecisionTableRevision;
  updatePrintReason: UpdatePrintReasonResponse;
  updateProductExhaustion?: Maybe<ExhaustionResponse>;
  updateSupportingDocument?: Maybe<UpdateSupportingDocumentResult>;
  updateTemplate: Template;
  updateTemplateVersionGeneralSettings: Template;
  updateTemplateVersionOutput: TemplateVersionOutput;
  uploadReferenceData: UploadReferenceDataResponse;
  uploadTemplateDocumentV2: TemplateUploadUrlV2;
  upsertTemplateDeclarations: TemplateDeclarationsAcknowledgement;
  upsertTemplateSupportingDocuments: Array<TemplateSupportingDocumentAcknowledgement>;
  withdrawImportCertificate?: Maybe<ImportCertificate>;
};


export type MutationAddBottlingRunsArgs = {
  input: BottlingRunInput;
};


export type MutationAddCustomsPermitNumbersArgs = {
  csv: Scalars['String']['input'];
};


export type MutationAddFlexiFillingRunsArgs = {
  input: FlexiFillingRunInput;
};


export type MutationAddProductArgs = {
  ingredients?: InputMaybe<Array<B2GProductInput>>;
  product: B2GProductInput;
};


export type MutationAddProductAndProcessFromTransferArgs = {
  input: AddProductAndProcessFromTransferInput;
};


export type MutationAdjustBatchVolumeArgs = {
  input: VolumeAdjustmentInput;
};


export type MutationAllocateCustomsPermitNumberArgs = {
  certificateRequestId: Scalars['String']['input'];
};


export type MutationAppendIppcHubLogArgs = {
  input: IppcHubLogInput;
};


export type MutationAppendImportCertificateLogArgs = {
  input: ImportCertificateLogMessageInput;
};


export type MutationApproveExportCertificateRequestArgs = {
  input: ApproveCertificateRequestInput;
};


export type MutationAttachTemplateDocumentArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationBanWineBatchArgs = {
  input: Array<B2GBanWineBatchInput>;
};


export type MutationCancelEstarRequestArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  sampleId: Scalars['ID']['input'];
};


export type MutationCancelExportCertificateRequestArgs = {
  input: CancelExportCertificateRequestInput;
};


export type MutationCancelProcessArgs = {
  input: CancelledProcessInput;
};


export type MutationCancelSupportingDocumentArgs = {
  input: CancelSupportingDocumentInput;
};


export type MutationChangeExportRequestStatusArgs = {
  input: ChangeExportRequestStatusInput;
};


export type MutationChangeTransferRequestAmendmentStatusArgs = {
  input: ChangeTransferRequestAmendmentStatusInput;
};


export type MutationChangeTransferRequestStatusArgs = {
  input: ChangeTransferRequestStatusInput;
};


export type MutationCompleteSensoryProcessArgs = {
  input: SensoryProcessInput;
};


export type MutationConfirmPackagingArgs = {
  input: ConfirmPackagingInput;
};


export type MutationConfirmWinemakingArgs = {
  input: ConfirmWinemakingInput;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateSupportingDocumentArgs = {
  input: CoreSupportingDocumentInput;
};


export type MutationCreateTemplateArgs = {
  template: CreateTemplateInput;
};


export type MutationCreateTemplateVersionArgs = {
  template: CreateTemplateGeneralInput;
};


export type MutationCreateTestRegistrationArgs = {
  input: CreateTestRegistrationInput;
};


export type MutationCreateTestUserArgs = {
  input: CreateTestUserInput;
};


export type MutationCreateUserArgs = {
  userDetails: CreateUserInput;
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCoreReferencedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExportCertificateRequestArgs = {
  requestor: Scalars['String']['input'];
  requestor_id: Scalars['String']['input'];
};


export type MutationDeleteExportRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExportRequestByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFieldConfigurationArgs = {
  templateFieldId: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReferencedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReplacementExportRequestArgs = {
  input: DeleteReplacementExportRequestInput;
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTransferRequestByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiscardExportCertificateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadExportRequestsAsCsvArgs = {
  input?: InputMaybe<DownloadExportRequestsCsvInput>;
};


export type MutationDownloadSupportingDocumentsAsCsvArgs = {
  input?: InputMaybe<DownloadSupportingDocumentsCsvInput>;
};


export type MutationDownloadTransferProcessHistoryXmlArgs = {
  input: DownloadTransferProcessHistoryXmlInput;
};


export type MutationDownloadTransferRequestsAsCsvArgs = {
  input: DownloadTransferRequestsCsvInput;
};


export type MutationDraftExportCertificateRequestArgs = {
  request: B2GExportCertificateRequestInput;
};


export type MutationE2eRaiseExportCertificateRequestArgs = {
  id: Scalars['ID']['input'];
  partyId: Scalars['String']['input'];
};


export type MutationExecuteChemistryTestEventArgs = {
  input: ChemistryTestEventDataInput;
};


export type MutationExhaustTransferProductsArgs = {
  input: ExhaustTransferProductsInput;
};


export type MutationExhaustTransferRequestArgs = {
  input: ExhaustTransferRequestInput;
};


export type MutationExtendIntendedOperatorArgs = {
  input: ExtendIntendedOperatorInput;
};


export type MutationForceApproveTemplateVersionArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type MutationGenerateDraftExportCertificateArgs = {
  input: GenerateDraftExportCertificateInput;
};


export type MutationGenerateDraftPdfArgs = {
  isStandardPdfPreviewType?: InputMaybe<Scalars['Boolean']['input']>;
  templateId: Scalars['ID']['input'];
};


export type MutationGenerateOutputPreviewXmlArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type MutationGenerateSpecimenPdfArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  templateVersionId: Scalars['ID']['input'];
};


export type MutationGenerateStandardPdfPreviewArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  templateVersionId: Scalars['ID']['input'];
};


export type MutationGenerateSubmissionPreviewXmlArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type MutationGenerateTeoConfigurationJsonArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type MutationGetNewTemplateVersionUploadUrlArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationGetSignedCertificateXmlArgs = {
  input: GetSignedCertificateXmlInput;
};


export type MutationInitSupportingDocumentUploadArgs = {
  input: InitSupportingDocumentUploadInput;
};


export type MutationIntegrationsAmendExportArgs = {
  input: IntegrationsAmendExportFromUriInput;
};


export type MutationIntegrationsAmendTransferArgs = {
  input: IntegrationsAmendTransferFromUriInput;
};


export type MutationIntegrationsCreateSupportingDocumentArgs = {
  input: IntegrationsCreateSupportingDocumentInput;
};


export type MutationIntegrationsDownloadTransferProcessHistoryXmlArgs = {
  input: IntegrationsDownloadTransferProcessHistoryXmlInput;
};


export type MutationIntegrationsExhaustTransferArgs = {
  input: ExhaustTransferRequestInput;
};


export type MutationIntegrationsGetSignedCertificateXmlArgs = {
  input: IntegrationsGetSignedCertificateXmlInput;
};


export type MutationIntegrationsGetTemplateXmlArgs = {
  input: IntegrationsGetTemplateXmlInput;
};


export type MutationIntegrationsInitSupportingDocumentUploadArgs = {
  input: IntegrationsInitSupportingDocumentUploadInput;
};


export type MutationIntegrationsRaiseExportRequestApArgs = {
  input: IntegrationsExportRequestApInput;
};


export type MutationIntegrationsRaiseExportRequestApv2Args = {
  input: IntegrationsExportRequestApFromUriInput;
};


export type MutationIntegrationsRaiseExportRequestPhytoArgs = {
  input: IntegrationsExportRequestPhytoInput;
};


export type MutationIntegrationsRaiseExportRequestPhytoV2Args = {
  input: IntegrationsExportRequestPhytoFromUriInput;
};


export type MutationIntegrationsRaiseTransferArgs = {
  input: IntegrationsRaiseTransferInput;
};


export type MutationIntegrationsRaiseTransferV2Args = {
  input: IntegrationsRaiseTransferFromUriInput;
};


export type MutationIntegrationsReplaceExportCertificateArgs = {
  input: IntegrationsReplaceExportCertificateInput;
};


export type MutationIntegrationsRequestAmendmentTransferArgs = {
  input: IntegrationsRequestAmendmentTransferInput;
};


export type MutationIntegrationsRequestReplacementCertificateArgs = {
  input: IntegrationsRequestReplacementCertificateInput;
};


export type MutationMakeProductEligibleArgs = {
  market: DestinationMarket;
  productId: Scalars['ID']['input'];
};


export type MutationNewCoreReferencedDocumentArgs = {
  input: NewCoreReferencedDocumentInput;
};


export type MutationNewMultiCollectionApiKeysV2Args = {
  requestOrigin?: InputMaybe<RequestOrigin>;
};


export type MutationNewReferencedDocumentArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPrepareXmlFileForB2GArgs = {
  input: PrepareXmlFileForB2GInput;
};


export type MutationPrintCertificateArgs = {
  input: PrintCertificateInput;
};


export type MutationProcessB2GIntegrationArgs = {
  input: ProcessB2GIntegrationInput;
};


export type MutationProcessCertificateCollectionArgs = {
  input: CertificateCollectionInput;
};


export type MutationProcessExportCertificateCollectionArgs = {
  input: ExportCertificateCollectionInput;
};


export type MutationProcessExportOcaWithPermissionsArgs = {
  input: OcaWithPermissionsInput;
};


export type MutationProcessExportSpsAcknowledgementArgs = {
  input: ExportSpsAcknowledgementInput;
};


export type MutationProcessOcaWithPermissionsArgs = {
  input: OcaWithPermissionsInput;
};


export type MutationProcessSpsAcknowledgementArgs = {
  input: SpsAcknowledgementInput;
};


export type MutationPublishXmlFileProcessedArgs = {
  input: PublishXmlFileProcessedInput;
};


export type MutationRaiseExportCertificateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRaiseExportRequestArgs = {
  input: RaiseExportRequestInput;
};


export type MutationRaiseTransferRequestArgs = {
  input: RaiseTransferRequestInput;
};


export type MutationRegenerateApprovedTemplatesArgs = {
  droolsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  itextOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recipeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  submissionLayouts?: InputMaybe<Array<Scalars['String']['input']>>;
  templateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRegenerateCertificateArgs = {
  input: RegenerateCertificateInput;
};


export type MutationReindexCollectionArgs = {
  collectionName: Scalars['String']['input'];
  options?: InputMaybe<SearchOptions>;
};


export type MutationReindexDatabaseItemArgs = {
  collectionName: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRejectImportCertificateArgs = {
  input: ImportCertificateStatusChangeInput;
};


export type MutationRemoveProductProcessesArgs = {
  input: RemoveProductProcessesInput;
};


export type MutationRemoveProductsFromRequestArgs = {
  input: RemoveProductsFromRequestInput;
};


export type MutationReplacementCertificateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestApprovalToReplaceExportCertificateRequestArgs = {
  input: ApprovalToReplaceExportCertificateRequestInput;
};


export type MutationRequestChemistryTestArgs = {
  input: ChemistryTestInput;
};


export type MutationRequestConfirmationArgs = {
  input: RequestConfirmationInput;
};


export type MutationRequestReplacementImportCertificateArgs = {
  input: ImportCertificateStatusChangeInput;
};


export type MutationRequestedToResubmitExportCertificateRequestArgs = {
  input: SfRequestedToResubmitExportCertificateInput;
};


export type MutationResetConfirmationRequestArgs = {
  input: ResetConfirmationRequestInput;
};


export type MutationSalesforceErApprovalArgs = {
  input: SalesforceErApprovalInput;
};


export type MutationSalesforceTransferRequestVerificationArgs = {
  input: SalesforceTransferRequestVerificationInput;
};


export type MutationSaveChangesToReferenceDataArgs = {
  input: SaveChangesToReferenceDataInput;
};


export type MutationSaveExportCertificateRequestArgs = {
  input: ExportCertificateRequestInput;
};


export type MutationSaveExportRequestArgs = {
  input: CoreExportRequestInput;
};


export type MutationSaveFieldConfigurationArgs = {
  fieldConfig: TemplateFieldConfigurationInput;
  templateVersionId: Scalars['ID']['input'];
};


export type MutationSaveFieldConfigurationBatchArgs = {
  deleteItems?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateVersionId: Scalars['ID']['input'];
  upsertItems?: InputMaybe<Array<TemplateFieldConfigurationInput>>;
};


export type MutationSaveG2GAccountArgs = {
  input: SaveG2GAccountInput;
};


export type MutationSaveProcessGroupConfigArgs = {
  deleteItems?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateVersionId: Scalars['ID']['input'];
  upsertItems?: InputMaybe<Array<UpsertTemplateProcessGroupConfigInput>>;
};


export type MutationSaveTransferRequestArgs = {
  input: CoreTransferRequestInput;
};


export type MutationSetTemplateVersionApprovedArgs = {
  isConfigurableTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  templateVersionId: Scalars['ID']['input'];
};


export type MutationSetTemplateVersionStatusArgs = {
  isConfigurableTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  status: TemplateVersionStatus;
  templateVersionId: Scalars['ID']['input'];
};


export type MutationSfCancelExportCertificateArgs = {
  input: SfCancelExportCertificateInput;
};


export type MutationSfChangeExportCertificateRequestStatusArgs = {
  input: SfChangeExportCertificateRequestStatusInput;
};


export type MutationSfChangeExportRequestStatusArgs = {
  input: SfChangeExportRequestStatusInput;
};


export type MutationSfChangeTransferRequestStatusArgs = {
  input: SfChangeTransferRequestStatusInput;
};


export type MutationSfDownloadCertificateArgs = {
  input: SfDownloadCertificateInput;
};


export type MutationSfRequestExportCertificateReplacementArgs = {
  input: SfRequestExportCertificateReplacementInput;
};


export type MutationSfUpdateProductExhaustionArgs = {
  input: SfUpdateProductExhaustionInput;
};


export type MutationSfUpdateStationerySerialNumbersArgs = {
  input: SfUpdateStationerySerialNumbersInput;
};


export type MutationSfUpdateTransferAuditCommentArgs = {
  input: SfUpdateTransferAuditCommentInput;
};


export type MutationSfVerifyExportCertificateRequestProductsArgs = {
  input: SfVerifyExportCertificateRequestProductsInput;
};


export type MutationSplitProductArgs = {
  fromProduct: Scalars['ID']['input'];
  toProducts: Array<B2GProductInput>;
};


export type MutationStartPackagingArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationStartWinemakingArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationTransferProductArgs = {
  id: Scalars['ID']['input'];
  toPremise: Scalars['ID']['input'];
};


export type MutationUpdateApprovedTransferTransportArgs = {
  input: UpdateApprovedTransferTransportInput;
};


export type MutationUpdateDecisionTableArgs = {
  input: DecisionTableRevisionInput;
};


export type MutationUpdatePrintReasonArgs = {
  input: UpdatePrintReasonInput;
};


export type MutationUpdateProductExhaustionArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateSupportingDocumentArgs = {
  input: UpdateSupportingDocumentInput;
};


export type MutationUpdateTemplateArgs = {
  template: UpdateTemplateInput;
};


export type MutationUpdateTemplateVersionGeneralSettingsArgs = {
  generalSettings: UpdateTemplateGeneralInput;
};


export type MutationUpdateTemplateVersionOutputArgs = {
  templateOutput: TemplateVersionOutputInput;
};


export type MutationUploadReferenceDataArgs = {
  input: UploadReferenceDataInput;
};


export type MutationUploadTemplateDocumentV2Args = {
  templateVersionId: Scalars['ID']['input'];
};


export type MutationUpsertTemplateDeclarationsArgs = {
  input: TemplateDeclarationsInput;
};


export type MutationUpsertTemplateSupportingDocumentsArgs = {
  input: Array<TemplateSupportingDocumentInput>;
};


export type MutationWithdrawImportCertificateArgs = {
  input: ImportCertificateStatusChangeInput;
};

export type NamedCode = {
  __typename?: 'NamedCode';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type NamedCodeInput = {
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NamedCodeTemplate = {
  __typename?: 'NamedCodeTemplate';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type NewCoreReferencedDocument = {
  __typename?: 'NewCoreReferencedDocument';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type NewCoreReferencedDocumentInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
};

export type NewReferencedDocument = {
  __typename?: 'NewReferencedDocument';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type NumberConstrain = {
  __typename?: 'NumberConstrain';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  step: Scalars['Float']['output'];
};

export type OcaWithPermissionsInput = {
  certificateNumber: Scalars['String']['input'];
  correlationId?: InputMaybe<Scalars['String']['input']>;
  overseasAuthoritiesInvolved?: InputMaybe<Scalars['String']['input']>;
  reasonInformation?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  systemAccountName: Scalars['String']['input'];
  userProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type OcaWithPermissionsResponse = {
  __typename?: 'OCAWithPermissionsResponse';
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export enum Optionality {
  Disabled = 'DISABLED',
  Optional = 'OPTIONAL',
  Readonly = 'READONLY',
  Required = 'REQUIRED'
}

export enum PdfAddendum {
  Catch = 'CATCH',
  CatchEu = 'CATCH_EU',
  CatchJapan = 'CATCH_JAPAN',
  CatchUs = 'CATCH_US',
  None = 'NONE'
}

export enum PdfBoxWidth {
  Full = 'FULL',
  Half = 'HALF',
  Quarter = 'QUARTER',
  Third = 'THIRD'
}

export enum PdfLayout {
  Adobe = 'ADOBE',
  ApaRegistration = 'APA_REGISTRATION',
  Catch = 'CATCH',
  CuAnimalProducts = 'CU_ANIMAL_PRODUCTS',
  EuChBeef = 'EU_CH_BEEF',
  EuExport = 'EU_EXPORT',
  EuExport_2015 = 'EU_EXPORT_2015',
  EuExport_2019 = 'EU_EXPORT_2019',
  EuExport_2021 = 'EU_EXPORT_2021',
  EuTransit = 'EU_TRANSIT',
  EuTransit_2021 = 'EU_TRANSIT_2021',
  Nz = 'NZ',
  Nz_2024 = 'NZ_2024',
  NzRtl = 'NZ_RTL',
  NzRtlHalal = 'NZ_RTL_HALAL',
  RussianDairy = 'RUSSIAN_DAIRY',
  RussianSeafood = 'RUSSIAN_SEAFOOD'
}

export type PdfSettings = {
  __typename?: 'PDFSettings';
  boxWidth?: Maybe<PdfBoxWidth>;
  caption?: Maybe<Scalars['String']['output']>;
  captionId?: Maybe<Scalars['ID']['output']>;
  defaultOption?: Maybe<PdfDefaultOption>;
  order?: Maybe<Scalars['Int']['output']>;
  pdfColumnsToDisplay?: Maybe<ColumnsToDisplay>;
};

export type PdfSettingsInput = {
  boxWidth?: InputMaybe<PdfBoxWidth>;
  caption?: InputMaybe<Scalars['ID']['input']>;
  defaultOption?: InputMaybe<PdfDefaultOption>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pdfColumnsToDisplay?: InputMaybe<ColumnsToDisplay>;
};

export type PackageTemplate = {
  __typename?: 'PackageTemplate';
  bottle_size?: Maybe<VolumeMeasureTemplate>;
  bottles_per_case?: Maybe<IntTemplate>;
  cases?: Maybe<IntTemplate>;
  extra_bottles?: Maybe<IntTemplate>;
  total_bottles: IntTemplate;
};

export type Packaging = {
  __typename?: 'Packaging';
  availableLitres: Scalars['Float']['output'];
  confirmation?: Maybe<PackagingConfirmation>;
  exportedLitres: Scalars['Float']['output'];
  runs: Array<PackagingRun>;
  status: PackagingStatus;
  totalPackagedLitres: Scalars['Float']['output'];
  volumeAdjustment?: Maybe<Array<Maybe<ManualVolumeAdjustment>>>;
  wsmp?: Maybe<Scalars['ID']['output']>;
};

export type PackagingConfirmation = {
  __typename?: 'PackagingConfirmation';
  confirmed: Scalars['Boolean']['output'];
  disputeReason?: Maybe<Scalars['String']['output']>;
  disputeResolution?: Maybe<Scalars['String']['output']>;
};

export type PackagingInput = {
  itemMarksOuter?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  nominalGrossVolume?: InputMaybe<MeasurmentInput>;
  nominalGrossWeight?: InputMaybe<MeasurmentInput>;
  outermostNumberOfPacakges?: InputMaybe<Scalars['Int']['input']>;
  packageType?: InputMaybe<CoreLookupInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type PackagingRun = BottlingRunData | FlexiFillingRunData;

export enum PackagingStatus {
  Confirmed = 'CONFIRMED',
  Disputed = 'DISPUTED',
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED'
}

export enum PartyRole {
  Consignee = 'CONSIGNEE',
  Consignor = 'CONSIGNOR',
  ThirdPartyConsignor = 'THIRD_PARTY_CONSIGNOR'
}

export enum PdfCertificateType {
  Copy = 'COPY',
  Draft = 'DRAFT',
  Official = 'OFFICIAL'
}

export enum PdfDefaultOption {
  Blank = 'BLANK',
  NotApplicable = 'NOT_APPLICABLE',
  NotShown = 'NOT_SHOWN',
  Xxxxxx = 'XXXXXX'
}

export enum PdfGenerationStatus {
  Generated = 'GENERATED',
  InProgress = 'IN_PROGRESS',
  NotGenerated = 'NOT_GENERATED'
}

export enum PermissionConstraintType {
  Agency = 'AGENCY',
  CertType = 'CERT_TYPE',
  Country = 'COUNTRY',
  Port = 'PORT',
  Registration = 'REGISTRATION'
}

export enum PhytoDocumentType {
  DeclarationOfConformity = 'DECLARATION_OF_CONFORMITY',
  ImportPermit = 'IMPORT_PERMIT',
  InspectionRecord = 'INSPECTION_RECORD',
  Other = 'OTHER',
  OverseasMultiplicationAgreement = 'OVERSEAS_MULTIPLICATION_AGREEMENT',
  OverseasPhytoCertificate = 'OVERSEAS_PHYTO_CERTIFICATE',
  SeedLaboratoryTestResult = 'SEED_LABORATORY_TEST_RESULT',
  TreatmentCertificate = 'TREATMENT_CERTIFICATE'
}

export type PhytoOcaEmailNotificationsInput = {
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
};

export type PhytoOcaEmailNotificationsResponse = {
  __typename?: 'PhytoOcaEmailNotificationsResponse';
  emailAddress: Scalars['String']['output'];
};

export type PhytoOcaEmailNotificationsResponseInput = {
  emailAddress: Scalars['String']['input'];
};

export type PhytoOcaEmailNotificationsType = DecisionTableBaseInput & {
  __typename?: 'PhytoOcaEmailNotificationsType';
  destinationCountry?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum PhytoSupportingDocumentType {
  Adh = 'ADH',
  Adm = 'ADM',
  Doc = 'DOC',
  Fic = 'FIC',
  Insp = 'INSP',
  Ip = 'IP',
  Oma = 'OMA',
  Opc = 'OPC',
  Org = 'ORG',
  Other = 'OTHER',
  Pac = 'PAC',
  Slab = 'SLAB',
  Trt = 'TRT'
}

export type PortCountryInfo = {
  __typename?: 'PortCountryInfo';
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  portCode: Scalars['String']['output'];
  portName: Scalars['String']['output'];
};

export enum PremisesAddressFormat {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT'
}

export enum PremisesRange {
  All = 'ALL',
  LastInEachProduct = 'LAST_IN_EACH_PRODUCT'
}

export type PrepareXmlFileForB2GInput = {
  fileName: Scalars['String']['input'];
  requestType: XmlRequestType;
  xmlInputId: Scalars['String']['input'];
};

export type PrepareXmlFileForB2GResponse = {
  __typename?: 'PrepareXmlFileForB2GResponse';
  b2gPayload?: Maybe<Scalars['String']['output']>;
  errorMessages: Array<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  requestType: XmlRequestType;
  responseId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  xmlInputId: Scalars['String']['output'];
};

export type PresignedPostField = {
  __typename?: 'PresignedPostField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  link: Scalars['String']['output'];
};

export type PreviewOutputXmlPresignedUrlResult = {
  __typename?: 'PreviewOutputXMLPresignedURLResult';
  presignedUrl: Scalars['String']['output'];
  templateVersionId: Scalars['ID']['output'];
};

export type PrintCertificateInput = {
  exportRequestId: Scalars['ID']['input'];
  pdfType: PdfCertificateType;
};

export type PrintCertificateResponse = {
  __typename?: 'PrintCertificateResponse';
  executionArn?: Maybe<Scalars['String']['output']>;
  exportRequestId: Scalars['ID']['output'];
  exportRequestOutputId?: Maybe<Scalars['String']['output']>;
  pdfCertificateUrl?: Maybe<Scalars['String']['output']>;
};

export type ProcessAttributesResponse = ChemistryTestResponse | Packaging | SensoryProcessRequest | Winemaking;

export type ProcessB2GIntegrationInput = {
  b2gPayload: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  requestType: XmlRequestType;
  xmlInputId: Scalars['String']['input'];
};

export type ProcessB2GIntegrationResponse = {
  __typename?: 'ProcessB2GIntegrationResponse';
  errorMessages: Array<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  requestType: XmlRequestType;
  responseId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  xmlInputId: Scalars['String']['output'];
};

export type ProcessDetail = {
  __typename?: 'ProcessDetail';
  active?: Maybe<Scalars['Boolean']['output']>;
  processCode: Scalars['String']['output'];
  processName?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  unCode?: Maybe<Scalars['String']['output']>;
};

export type ProcessGroupCaptionSettings = {
  __typename?: 'ProcessGroupCaptionSettings';
  caption?: Maybe<Scalars['String']['output']>;
  captionId?: Maybe<Scalars['ID']['output']>;
};

export type ProcessGroupCaptionSettingsInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  captionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProcessGroupDetail = {
  __typename?: 'ProcessGroupDetail';
  active?: Maybe<Scalars['Boolean']['output']>;
  defaultCharacteristic?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupType?: Maybe<Scalars['String']['output']>;
  lowestRank?: Maybe<Scalars['Int']['output']>;
  lowestRankedProcessUnCode?: Maybe<Scalars['String']['output']>;
  overrideCharacteristic?: Maybe<Scalars['String']['output']>;
  overrideUnCode?: Maybe<Scalars['String']['output']>;
  processGroupId: Scalars['Int']['output'];
  processes: Array<ProcessDetail>;
};

export type ProcessGroupInfo = {
  __typename?: 'ProcessGroupInfo';
  groupName: Scalars['String']['output'];
  groupType: Scalars['String']['output'];
  processCode: Scalars['String']['output'];
  processGroupId: Scalars['Int']['output'];
};

export type ProcessInfo = {
  __typename?: 'ProcessInfo';
  id: Scalars['ID']['output'];
  processCode: Scalars['String']['output'];
  processName: Scalars['String']['output'];
};

export type ProcessResponse = {
  __typename?: 'ProcessResponse';
  id: Scalars['ID']['output'];
  task?: Maybe<ProcessTask>;
  type: ProductProcessType;
};

export enum ProcessStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

export type ProcessTask = {
  __typename?: 'ProcessTask';
  assignedTo?: Maybe<Scalars['String']['output']>;
  taskId: Scalars['ID']['output'];
};

export type ProcessType = {
  __typename?: 'ProcessType';
  description: Scalars['String']['output'];
  id: ProductProcessType;
};

export type ProductExhaustionResponse = {
  __typename?: 'ProductExhaustionResponse';
  exhaust?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProductFieldInput = {
  certificateType?: InputMaybe<CertificateType>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket?: InputMaybe<DestinationMarket>;
};

export type ProductFieldResponse = {
  __typename?: 'ProductFieldResponse';
  certificateType?: Maybe<CertificateType>;
  collection?: Maybe<Scalars['String']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  defaultUnit?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  destinationMarket?: Maybe<DestinationMarket>;
  fieldId: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  listOfValues?: Maybe<Array<Scalars['String']['output']>>;
  maxStringLength?: Maybe<Scalars['Int']['output']>;
  required: Optionality;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductFieldResponseInput = {
  defaultUnit?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  listOfValues?: InputMaybe<Array<Scalars['String']['input']>>;
  maxStringLength?: InputMaybe<Scalars['Int']['input']>;
  required: Optionality;
};

export type ProductFieldType = DecisionTableBaseInput & {
  __typename?: 'ProductFieldType';
  certificateType?: Maybe<CertificateType>;
  commodity?: Maybe<Scalars['String']['output']>;
  destinationMarket?: Maybe<DestinationMarket>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ProductFieldsInput = {
  certificateType?: InputMaybe<CertificateType>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<DestinationMarket>;
};

export type ProductProcessFilterInput = {
  processType?: InputMaybe<ProductProcessType>;
  status?: InputMaybe<ProcessStatus>;
};

export type ProductProcessResponse = {
  __typename?: 'ProductProcessResponse';
  attributes: ProcessAttributesResponse;
  confirmationTaskId?: Maybe<Scalars['ID']['output']>;
  processId: Scalars['ID']['output'];
  processType: ProductProcessType;
  requestTaskId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Resetting a request is not a task any longer so this is not required. */
  resetTaskId?: Maybe<Scalars['ID']['output']>;
  taskId?: Maybe<Scalars['ID']['output']>;
};

export enum ProductProcessType {
  BottlingRun = 'BOTTLING_RUN',
  Chemistry = 'CHEMISTRY',
  FlexiFilling = 'FLEXI_FILLING',
  Sensory = 'SENSORY',
  WineMaking = 'WINE_MAKING'
}

export type ProductProcessesInput = {
  filter?: InputMaybe<ProductProcessFilterInput>;
  productId: Scalars['ID']['input'];
};

export type ProductionDateRangeInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type PublishXmlFileProcessedInput = {
  b2gPayload?: InputMaybe<Scalars['String']['input']>;
  errorMessages: Array<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  requestType: XmlRequestType;
  responseId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  xmlInputId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  attestations?: Maybe<Array<Scalars['String']['output']>>;
  availableProcesses: Array<ProcessType>;
  availableTemplates?: Maybe<Array<AvailableTemplateFields>>;
  certificateTemplateFields?: Maybe<Scalars['AWSJSON']['output']>;
  certificateTemplateFlatFields: Array<TemplateSection>;
  certificateTemplateFlattestFields: Array<TemplateSectionField>;
  certificateTemplateFlattestFieldsV2: Array<TemplateSection>;
  checkUserAccess: CheckUserAccessResponse;
  coreReferencedDocument?: Maybe<CoreReferencedDocument>;
  customsPermitNumberUsage: CustomsPermitNumberUsage;
  decisionTable?: Maybe<DecisionTable>;
  downloadCSVFromReference?: Maybe<PresignedUrl>;
  downloadCoreReferencedDocument?: Maybe<CoreReferencedDocumentUrl>;
  downloadDocument: TemplateDocumentUrl;
  downloadExportCertificates: B2GExportCertificatesDownloadUrl;
  downloadProducts: B2GProductsDownloadUrl;
  downloadReferencedDocument: ReferencedDocumentUrl;
  downloadSubmissionXML?: Maybe<SubmissionXmlUrl>;
  e2eCalculateProductEligibilityV2?: Maybe<Array<Maybe<B2GEligibilityStatus>>>;
  e2eProductEligibilityCriteriasV2?: Maybe<Array<Maybe<B2GProductEligibilityCriteriaV2>>>;
  estarOrganisations: Array<EStarOrganisation>;
  executeRules: Array<RulesResponse>;
  exportCertificateAsTemplateValues: SpsCertificateTemplate;
  exportCertificateRequest?: Maybe<B2GExportCertificateRequest>;
  exportCertificateSupportingDocuments: Array<B2GReferencedDocument>;
  fetchFieldsBySubmissionLayout: Array<FieldBySubmissionLayout>;
  fetchRequestPartyRole: PartyRole;
  fetchRequestPartyRoles: RequestPartyRolesResponse;
  findApprovedImportCertificate?: Maybe<TemplateVersion>;
  getActiveTemplateBySubmissionLayout?: Maybe<ActiveTemplateResult>;
  getAllAvailableLanguages: Array<Language>;
  getApprovedProductDetails?: Maybe<ApprovedProductRequest>;
  getApprovedTemplateVersion?: Maybe<TemplateVersion>;
  getClassificationNameByFieldUniqueId?: Maybe<Scalars['String']['output']>;
  getConsignorDetails: ConsignorDetails;
  getDeclarationInputs?: Maybe<GetDeclarationInputsResponse>;
  getDfeForm: DfeForm;
  getDfePermissions: Array<DfePermission>;
  getDfeTransferRequestRecipe?: Maybe<DfeConfig>;
  getDfeTransferRequestTemplateInfo?: Maybe<DfeTemplateInfo>;
  getDraftCertificateGenerationStatus: DraftCertificateGenerationStatusResponse;
  getExportCertificateRequest?: Maybe<ExportCertificateRequest>;
  getExportReqDetails?: Maybe<CoreExportDetails>;
  getExportRequestHistory: Array<ExportRequestHistoryRecord>;
  getExtractHtml?: Maybe<Scalars['String']['output']>;
  getFeatureFlags: Array<Scalars['String']['output']>;
  getFieldConfiguration?: Maybe<FieldConfiguration>;
  getFieldUniqueIdsByClassificationCode?: Maybe<FieldInfo>;
  getFieldsV2?: Maybe<Array<Maybe<FieldV2>>>;
  getForwardProductTracking?: Maybe<ForwardProductTrackingResponse>;
  getG2GAccountDetails?: Maybe<G2GAccount>;
  getImportCertificate?: Maybe<ImportCertificate>;
  getLatestLookupName?: Maybe<LookupValue>;
  getMajorVersionsByCode: Array<Scalars['Int']['output']>;
  /**
   * Fetches the master layout configuration for a specific submission type.
   * Used by frontend applications to generate dynamic forms.
   *
   * Example:
   * query {
   *   getMasterLayout(submissionType: AP_EXPORT) {
   *     masterFields
   *     masterLayout
   *   }
   * }
   */
  getMasterLayout?: Maybe<MasterLayout>;
  getPortCountryInfo?: Maybe<PortCountryInfo>;
  /** Return a presigned url to upload a document to the given `key` in the given `fileStore`. */
  getPresignedUrl: Scalars['String']['output'];
  getPreviewOutputXMLPresignedURL: PreviewOutputXmlPresignedUrlResult;
  getProcessGroupDetailsByGroupIds: Array<ProcessGroupDetail>;
  getProcessGroupNames?: Maybe<Array<Scalars['String']['output']>>;
  getProcessGroupReferenceData: TemplateProcessGroupReferenceData;
  getProcessGroupsByProcessCodes: Array<ProcessGroupInfo>;
  getProductsByTransferReference: TransferReferenceResponse;
  getReferenceData: Array<ReferenceItem>;
  getReferenceItemValidationInfo?: Maybe<ReferenceValidationResponse>;
  getRegistrationTypes?: Maybe<Array<Maybe<RegistrationType>>>;
  getRequestHistoryForSF: Array<RequestHistoryForSf>;
  /**
   * Retrieves validations and warnings for a request.
   * Runs field-level validation (for editable statuses) and warning checkers (source modified, doc changed).
   * Returns errors for editable statuses (blocking), warnings for non-editable statuses (informational).
   */
  getRequestValidations: GetRequestValidationsResponse;
  getSfForwardProductTracking?: Maybe<ForwardProductTrackingResponse>;
  getSnapshotPresignedUrl: SnapshotPresignedUrlResponse;
  getSupportingDocumentActions: SupportingDocumentActionsResponse;
  getSupportingDocumentDetails: CoreSupportingDocument;
  getSupportingDocumentHistory: Array<SupportingDocumentHistoryEntry>;
  getSupportingDocumentPresignedUrl: SupportingDocumentPresignedUrlResponse;
  getSupportingDocumentUsage: Array<SupportingDocumentUsageRecord>;
  getTemplate?: Maybe<Template>;
  getTemplateDetailsByCode?: Maybe<TemplateVersionId>;
  getTemplateDocumentDownloadUrlV2: TemplateDocumentUrlV2;
  getTemplateFieldReferenceData: TemplateFieldReferenceData;
  getTemplateV2?: Maybe<TemplateV2>;
  getTemplateVersion?: Maybe<TemplateVersion>;
  getTemplateVersionV2?: Maybe<TemplateVersionV2>;
  getTemplateWithActiveApproved?: Maybe<Template>;
  getTemplateXmlCore: GetTemplateXmlCoreResponse;
  getTransferRequestDetails?: Maybe<TransferRequestDetails>;
  getTransferRequestHistory: Array<TransferRequestHistoryRecord>;
  getTransferRequestHistoryForSF: Array<RequestHistoryForSf>;
  getUserDetailsById?: Maybe<UserDetailsById>;
  getUserInfo: UserInfo;
  importCertificateEmbeddedDocument: ImportCertificateEmbeddedDocument;
  importCertificatePdf: ImportCertificatePdf;
  importCertificateXml: ImportCertificateXml;
  listAnnouncements: AnnouncementList;
  listImportCertificateIntegrations: Array<ImportCertificateIntegration>;
  listImportCertificates: Array<ImportCertificate>;
  numberOfDocuments: Scalars['Int']['output'];
  product: B2GProduct;
  productFields: Array<Maybe<ProductFieldResponse>>;
  productForm: Array<Maybe<FormletField>>;
  productFormlet: Form;
  productProcesses: Array<ProductProcessResponse>;
  referenceDocuments?: Maybe<Array<Maybe<B2GReferencedDocument>>>;
  referencedDocument?: Maybe<ReferencedDocument>;
  salesForceApplicationId?: Maybe<Scalars['ID']['output']>;
  salesForceProductId?: Maybe<SalesForceProductId>;
  searchDecisionTables: Array<DecisionTable>;
  searchG2GAccounts: G2GAccountSearchResult;
  searchReferenceList: SearchReferenceListResponse;
  searchTemplateVersions: SearchTemplateVersionsResponse;
  searchTemplates: Array<Template>;
  sfDownload?: Maybe<Scalars['String']['output']>;
  sfDownloadCertificate: Scalars['String']['output'];
  sfDownloadSupportingDocument: Scalars['String']['output'];
  sfExporter: SalesForceParty;
  sfGetExportRequest: SfRequest;
  sfGetExportSnapshot: SfRequest;
  sfGetManyExportRequests?: Maybe<Array<Maybe<SfRequest>>>;
  sfGetManyTransferRequests?: Maybe<Array<Maybe<SfRequest>>>;
  sfGetSnapshot: SfRequest;
  sfGetTemplate?: Maybe<Scalars['String']['output']>;
  sfGetTransferRequest: SfRequest;
  sfGetTransferSnapshot: SfRequest;
  sfSearchApprovedTemplates: SfSearchApprovedTemplatesResponse;
  testDecisionTableRevision: Array<DecisionTableTestResult>;
  tradecertUserProfile: UserProfile;
  validate?: Maybe<Array<Maybe<B2GValidationErrors>>>;
  validateDfeRequest?: Maybe<Array<Maybe<B2GValidationErrors>>>;
  validateProduct?: Maybe<Array<Maybe<B2GValidationErrors>>>;
  validateSampleDfeRequest?: Maybe<Array<Maybe<B2GValidationErrors>>>;
};


export type QueryAttestationsArgs = {
  certificateType: CertificateType;
  commodity: Scalars['String']['input'];
  destination: Scalars['String']['input'];
};


export type QueryAvailableProcessesArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryAvailableTemplatesArgs = {
  commodity: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
};


export type QueryCertificateTemplateFieldsArgs = {
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket?: InputMaybe<DestinationMarket>;
  exportCertificateType?: InputMaybe<CertificateType>;
  importCertificateType?: InputMaybe<ImportCertificateType>;
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};


export type QueryCertificateTemplateFlatFieldsArgs = {
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket?: InputMaybe<DestinationMarket>;
  exportCertificateType?: InputMaybe<CertificateType>;
  importCertificateType?: InputMaybe<ImportCertificateType>;
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};


export type QueryCertificateTemplateFlattestFieldsArgs = {
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket?: InputMaybe<DestinationMarket>;
  exportCertificateType?: InputMaybe<CertificateType>;
  importCertificateType?: InputMaybe<ImportCertificateType>;
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};


export type QueryCertificateTemplateFlattestFieldsV2Args = {
  submissionLayout: SubmissionLayoutType;
};


export type QueryCheckUserAccessArgs = {
  input: CheckUserAccessInput;
};


export type QueryCoreReferencedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDecisionTableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDownloadCsvFromReferenceArgs = {
  listCode: Scalars['String']['input'];
};


export type QueryDownloadCoreReferencedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDownloadDocumentArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type QueryDownloadExportCertificatesArgs = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryDownloadProductsArgs = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryDownloadReferencedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDownloadSubmissionXmlArgs = {
  requestId: Scalars['ID']['input'];
  requestType: CoreRequestType;
};


export type QueryE2eCalculateProductEligibilityV2Args = {
  productId: Scalars['ID']['input'];
};


export type QueryE2eProductEligibilityCriteriasV2Args = {
  criterias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  markets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId: Scalars['ID']['input'];
};


export type QueryEstarOrganisationsArgs = {
  filter?: InputMaybe<EStarOrganisationFilter>;
};


export type QueryExecuteRulesArgs = {
  input: RulesExecutionInput;
};


export type QueryExportCertificateAsTemplateValuesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportCertificateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportCertificateSupportingDocumentsArgs = {
  input: ExportCertificateSupportingDocumentsInput;
};


export type QueryFetchFieldsBySubmissionLayoutArgs = {
  fetchNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  submissionLayout: SubmissionLayoutType;
};


export type QueryFetchRequestPartyRoleArgs = {
  input: RequestPartyRoleInput;
};


export type QueryFetchRequestPartyRolesArgs = {
  input: RequestPartyRoleInput;
};


export type QueryFindApprovedImportCertificateArgs = {
  certificateType: ImportCertificateType;
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket: DestinationMarket;
};


export type QueryGetActiveTemplateBySubmissionLayoutArgs = {
  submissionLayout?: InputMaybe<SubmissionLayoutType>;
};


export type QueryGetApprovedProductDetailsArgs = {
  input: ApprovedProductRequestInput;
};


export type QueryGetApprovedTemplateVersionArgs = {
  certificateType: CertificateType;
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationMarket: DestinationMarket;
};


export type QueryGetClassificationNameByFieldUniqueIdArgs = {
  fieldUniqueId: Scalars['String']['input'];
};


export type QueryGetConsignorDetailsArgs = {
  id: Scalars['ID']['input'];
  requestId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetDeclarationInputsArgs = {
  statementCode: Scalars['Int']['input'];
};


export type QueryGetDfeFormArgs = {
  input: GetDfeFormInput;
};


export type QueryGetDfeTransferRequestRecipeArgs = {
  input?: InputMaybe<DfeRequestInput>;
};


export type QueryGetDraftCertificateGenerationStatusArgs = {
  input: GetDraftCertificateGenerationStatusInput;
};


export type QueryGetExportCertificateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetExportReqDetailsArgs = {
  input: ExportDetailsInput;
};


export type QueryGetExportRequestHistoryArgs = {
  input: ExportRequestHistoryInput;
};


export type QueryGetExtractHtmlArgs = {
  requestId: Scalars['ID']['input'];
};


export type QueryGetFieldConfigurationArgs = {
  fieldUniqueId: Scalars['String']['input'];
};


export type QueryGetFieldUniqueIdsByClassificationCodeArgs = {
  input: FieldFilterInput;
};


export type QueryGetFieldsV2Args = {
  templateVersionId: Scalars['ID']['input'];
};


export type QueryGetForwardProductTrackingArgs = {
  transferRequestId: Scalars['ID']['input'];
};


export type QueryGetG2GAccountDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetImportCertificateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLatestLookupNameArgs = {
  code: Scalars['String']['input'];
  fieldUniqueId: Scalars['String']['input'];
};


export type QueryGetMajorVersionsByCodeArgs = {
  templateCode: Scalars['String']['input'];
};


export type QueryGetMasterLayoutArgs = {
  submissionType: SubmissionLayoutType;
};


export type QueryGetPortCountryInfoArgs = {
  portCode: Scalars['String']['input'];
};


export type QueryGetPresignedUrlArgs = {
  fileStore: Scalars['String']['input'];
  key: Scalars['String']['input'];
};


export type QueryGetPreviewOutputXmlPresignedUrlArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type QueryGetProcessGroupDetailsByGroupIdsArgs = {
  groupIds: Array<Scalars['Int']['input']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetProcessGroupReferenceDataArgs = {
  processGroup: Scalars['String']['input'];
};


export type QueryGetProcessGroupsByProcessCodesArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  processCodes: Array<Scalars['String']['input']>;
};


export type QueryGetProductsByTransferReferenceArgs = {
  input: TransferReferenceRequestInput;
};


export type QueryGetReferenceDataArgs = {
  input: ReferenceDataInput;
};


export type QueryGetReferenceItemValidationInfoArgs = {
  fileName: Scalars['String']['input'];
  refListCode: Scalars['ID']['input'];
};


export type QueryGetRegistrationTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetRequestHistoryForSfArgs = {
  input: RequestHistoryForSfInput;
};


export type QueryGetRequestValidationsArgs = {
  input: GetRequestValidationsInput;
};


export type QueryGetSfForwardProductTrackingArgs = {
  transferRequestId: Scalars['ID']['input'];
};


export type QueryGetSnapshotPresignedUrlArgs = {
  historyId: Scalars['ID']['input'];
};


export type QueryGetSupportingDocumentActionsArgs = {
  input: GetSupportingDocumentActionsInput;
};


export type QueryGetSupportingDocumentDetailsArgs = {
  input: GetSupportingDocumentDetailsInput;
};


export type QueryGetSupportingDocumentHistoryArgs = {
  input: GetSupportingDocumentHistoryInput;
};


export type QueryGetSupportingDocumentPresignedUrlArgs = {
  input: SupportingDocumentInput;
};


export type QueryGetSupportingDocumentUsageArgs = {
  input: SupportingDocumentUsageInput;
};


export type QueryGetTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetTemplateDetailsByCodeArgs = {
  majorVersion?: InputMaybe<Scalars['Int']['input']>;
  minorVersion?: InputMaybe<Scalars['Int']['input']>;
  templateCode: Scalars['String']['input'];
};


export type QueryGetTemplateDocumentDownloadUrlV2Args = {
  templateVersionId: Scalars['ID']['input'];
};


export type QueryGetTemplateFieldReferenceDataArgs = {
  fuid: Scalars['ID']['input'];
  submissionLayoutType: SubmissionLayoutType;
};


export type QueryGetTemplateV2Args = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetTemplateVersionArgs = {
  templateVersionId: Scalars['ID']['input'];
};


export type QueryGetTemplateVersionV2Args = {
  includeProcesses?: InputMaybe<Scalars['Boolean']['input']>;
  templateVersionId: Scalars['ID']['input'];
};


export type QueryGetTemplateWithActiveApprovedArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetTemplateXmlCoreArgs = {
  input: GetTemplateXmlCoreInput;
};


export type QueryGetTransferRequestDetailsArgs = {
  input: TransferRequestDetailsInput;
};


export type QueryGetTransferRequestHistoryArgs = {
  input: TransferRequestHistoryInput;
};


export type QueryGetTransferRequestHistoryForSfArgs = {
  input: RequestHistoryForSfInput;
};


export type QueryGetUserDetailsByIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryImportCertificateEmbeddedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportCertificatePdfArgs = {
  input: ImportCertificatePdfInput;
};


export type QueryImportCertificateXmlArgs = {
  id: Scalars['ID']['input'];
  inline?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListAnnouncementsArgs = {
  input?: InputMaybe<AnnouncementListInput>;
};


export type QueryNumberOfDocumentsArgs = {
  collectionName: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductFieldsArgs = {
  input: ProductFieldsInput;
};


export type QueryProductFormArgs = {
  input: ProductFieldsInput;
};


export type QueryProductFormletArgs = {
  input: ProductFieldsInput;
};


export type QueryProductProcessesArgs = {
  input: ProductProcessesInput;
};


export type QueryReferenceDocumentsArgs = {
  exportRequestId: Scalars['ID']['input'];
};


export type QueryReferencedDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesForceApplicationIdArgs = {
  requestId: Scalars['ID']['input'];
};


export type QuerySalesForceProductIdArgs = {
  productId: Scalars['ID']['input'];
};


export type QuerySearchDecisionTablesArgs = {
  filter?: InputMaybe<DecisionTableFilter>;
};


export type QuerySearchG2GAccountsArgs = {
  input?: InputMaybe<SearchG2GAccountsInput>;
};


export type QuerySearchReferenceListArgs = {
  filter?: InputMaybe<ReferenceListFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchTemplateVersionsArgs = {
  filter?: InputMaybe<TemplateFilter>;
  optionalFilter?: InputMaybe<TemplateOptionalFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchTemplatesArgs = {
  filter?: InputMaybe<TemplateFilter>;
  optionalFilter?: InputMaybe<TemplateOptionalFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySfDownloadArgs = {
  input?: InputMaybe<SfDownloadInput>;
};


export type QuerySfDownloadCertificateArgs = {
  input: SfDownloadCertificateInput;
};


export type QuerySfDownloadSupportingDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfExporterArgs = {
  certificateType?: InputMaybe<CertificateType>;
  id: Scalars['ID']['input'];
};


export type QuerySfGetExportRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfGetExportSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfGetManyExportRequestsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySfGetManyTransferRequestsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySfGetSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfGetTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfGetTransferRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfGetTransferSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySfSearchApprovedTemplatesArgs = {
  input?: InputMaybe<SfSearchApprovedTemplatesInput>;
};


export type QueryTestDecisionTableRevisionArgs = {
  input: DecisionTableRevisionInput;
};


export type QueryTradecertUserProfileArgs = {
  certificateType?: InputMaybe<CertificateType>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateDfeRequestArgs = {
  input?: InputMaybe<DfeRequestInput>;
};


export type QueryValidateProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<B2GProductInput>;
};


export type QueryValidateSampleDfeRequestArgs = {
  input?: InputMaybe<EgRequestInput>;
};

export type RaiseExportRequestInput = {
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  requestID: Scalars['ID']['input'];
  requestOrigin?: InputMaybe<RequestOrigin>;
  userId?: InputMaybe<Scalars['String']['input']>;
  validationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type RaiseExportRequestResponse = {
  __typename?: 'RaiseExportRequestResponse';
  certificateNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: CoreStatus;
  submittedAt: Scalars['AWSDateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  warnings?: Maybe<Array<RequestValidation>>;
};

export type RaiseTransferRequestInput = {
  b2gProfileName?: InputMaybe<Scalars['String']['input']>;
  b2gSystemName?: InputMaybe<Scalars['String']['input']>;
  requestID: Scalars['ID']['input'];
  requestOrigin?: InputMaybe<RequestOrigin>;
  userId?: InputMaybe<Scalars['String']['input']>;
  validationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type RaiseTransferRequestResponse = {
  __typename?: 'RaiseTransferRequestResponse';
  certificateNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: CoreStatus;
  submittedAt: Scalars['AWSDateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  warnings?: Maybe<Array<RequestValidation>>;
};

export enum RecipeType {
  Dfe = 'DFE',
  Oca = 'OCA'
}

export enum RefValidationType {
  Change = 'CHANGE',
  Error = 'ERROR',
  Override = 'OVERRIDE'
}

export type ReferenceCaption = {
  __typename?: 'ReferenceCaption';
  caption?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ReferenceDataInput = {
  inputs?: InputMaybe<Array<Scalars['String']['input']>>;
  listCode?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ReferenceDataList = {
  __typename?: 'ReferenceDataList';
  displayValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  tableName?: Maybe<Scalars['String']['output']>;
};

export type ReferenceItem = {
  __typename?: 'ReferenceItem';
  active?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  country_id?: Maybe<Scalars['String']['output']>;
  effective_end_date?: Maybe<Scalars['AWSDate']['output']>;
  effective_start_date?: Maybe<Scalars['AWSDate']['output']>;
  name: Scalars['String']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
};

export type ReferenceList = {
  __typename?: 'ReferenceList';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ReferenceListFilter = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceProcessGroupCaption = {
  __typename?: 'ReferenceProcessGroupCaption';
  caption?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReferenceValidationMode = {
  __typename?: 'ReferenceValidationMode';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: RefValidationType;
};

export type ReferenceValidationResponse = {
  __typename?: 'ReferenceValidationResponse';
  processedResults: Array<ReferenceValidationMode>;
  refListCode: Scalars['ID']['output'];
};

export type ReferencedDocument = {
  __typename?: 'ReferencedDocument';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  uploadInProgress: Scalars['Boolean']['output'];
};

export type ReferencedDocumentUrl = {
  __typename?: 'ReferencedDocumentUrl';
  documentName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RegenerateApprovedTemplatesResponse = {
  __typename?: 'RegenerateApprovedTemplatesResponse';
  failureCount: Scalars['Int']['output'];
  results: Array<RegenerateApprovedTemplatesResult>;
  successCount: Scalars['Int']['output'];
  totalProcessed: Scalars['Int']['output'];
};

export type RegenerateApprovedTemplatesResult = {
  __typename?: 'RegenerateApprovedTemplatesResult';
  actions: Array<Scalars['String']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  destinationCountries?: Maybe<Scalars['AWSJSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  majorVersion: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  templateCode: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  templateRevisionId: Scalars['String']['output'];
};

export type RegenerateCertificateInput = {
  certificateNumber: Scalars['String']['input'];
  systemAccountName: Scalars['String']['input'];
  userProfileName: Scalars['String']['input'];
  xmlOutputType: Scalars['String']['input'];
};

export type RegenerateCertificateResponse = {
  __typename?: 'RegenerateCertificateResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum RegistrationSource {
  EcmeAccountId = 'ECME_ACCOUNT_ID',
  Legacy = 'LEGACY',
  MapsRbm = 'MAPS_RBM',
  MapsRm = 'MAPS_RM'
}

export type RegistrationType = {
  __typename?: 'RegistrationType';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
};

export type ReindexResponse = {
  __typename?: 'ReindexResponse';
  alias: Scalars['String']['output'];
  collectionName: Scalars['String']['output'];
  functionName: Scalars['String']['output'];
};

export type RemoveProductProcessesInput = {
  processIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductProcessesResponse = {
  __typename?: 'RemoveProductProcessesResponse';
  deletedProcessIds: Array<Scalars['ID']['output']>;
};

export type RemoveProductsFromRequestInput = {
  productsToRemove: Array<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

export type RemoveSources = {
  prdId?: InputMaybe<Scalars['ID']['input']>;
  prdSrcId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type RequestConfirmationInput = {
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  wsmp: Scalars['ID']['input'];
};

export type RequestConfirmationResponse = {
  __typename?: 'RequestConfirmationResponse';
  processId: Scalars['ID']['output'];
  wsmp: Scalars['ID']['output'];
};

export type RequestHistoryForSf = {
  __typename?: 'RequestHistoryForSF';
  action?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusNote?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RequestHistoryForSfInput = {
  id: Scalars['ID']['input'];
};

export enum RequestOrigin {
  Dfe = 'DFE',
  DfeEip = 'DFE_EIP',
  Eip = 'EIP',
  Teo = 'TEO'
}

export type RequestPartyRoleInput = {
  requestId: Scalars['ID']['input'];
  requestType: CoreRequestType;
};

export type RequestPartyRolesResponse = {
  __typename?: 'RequestPartyRolesResponse';
  highestPartyRole: PartyRole;
  partyRoles: Array<PartyRole>;
};

export type RequestValidation = {
  __typename?: 'RequestValidation';
  additionalFieldValue?: Maybe<Scalars['AWSJSON']['output']>;
  additionalFuid?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['AWSJSON']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  errorType: ValidationErrorType;
  field?: Maybe<Scalars['String']['output']>;
  fieldFuid?: Maybe<Scalars['String']['output']>;
  fieldValue?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ResetConfirmationRequestInput = {
  processId: Scalars['ID']['input'];
  /** @deprecated Resetting a request is not a task any longer so this is not required. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RoleName {
  ConfirmProduct = 'ConfirmProduct',
  ExternalReadOnly = 'ExternalReadOnly',
  InternalReadOnly = 'InternalReadOnly',
  MpiAgent = 'MPIAgent',
  ManageExports = 'ManageExports',
  ManageProducts = 'ManageProducts',
  ManageTransfers = 'ManageTransfers'
}

export type RoleSpecificKeys = {
  __typename?: 'RoleSpecificKeys';
  exportCertificates?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  registrationAll?: Maybe<Scalars['String']['output']>;
  sourceTransfers?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Scalars['String']['output']>;
  transferRequests?: Maybe<Scalars['String']['output']>;
};

export type Row = {
  __typename?: 'Row';
  fields?: Maybe<Array<FieldInput>>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type RulesExecutionInput = {
  decisionTableId: Scalars['ID']['input'];
  declarations?: InputMaybe<DeclarationsInput>;
  eligibility?: InputMaybe<EligibilityInput>;
  exportCertificateWorkflow?: InputMaybe<ExportCertificateWorkflowInput>;
  importConnections?: InputMaybe<ImportConnectionsInput>;
  phytoOcaEmailNotifications?: InputMaybe<PhytoOcaEmailNotificationsInput>;
  productField?: InputMaybe<ProductFieldInput>;
  wineAnalytesTolerances?: InputMaybe<WineAnalytesTolerancesResponseInput>;
  wineProductField?: InputMaybe<WineProductFieldInput>;
};

export type RulesInput = DeclarationsType | EligibilityType | ExportCertificateWorkflowType | ImportConnectionsType | PhytoOcaEmailNotificationsType | ProductFieldType | WineAnalytesTolerancesType | WineProductFieldType;

export type RulesResponse = DeclarationsResponse | EligibilityResponse | ExportCertificateWorkflowResponse | ImportConnectionsResponse | PhytoOcaEmailNotificationsResponse | ProductFieldResponse | WineAnalytesTolerancesResponse;

export type SpsAddress = {
  __typename?: 'SPSAddress';
  city?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['ID']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  country_subdivision_id?: Maybe<Scalars['ID']['output']>;
  country_subdivision_name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_code?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type_code?: Maybe<AddressTypeCode>;
};

export type SpsAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  city_id?: InputMaybe<Scalars['ID']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  country_name?: InputMaybe<Scalars['String']['input']>;
  country_subdivision_id?: InputMaybe<Scalars['ID']['input']>;
  country_subdivision_name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_code?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type_code?: InputMaybe<AddressTypeCode>;
};

export type SpsAuthentication = {
  __typename?: 'SPSAuthentication';
  actual?: Maybe<Scalars['AWSDateTime']['output']>;
  included_clauses: Array<SpsClause>;
  issue_location?: Maybe<SpsLocation>;
  location_provider_party?: Maybe<SpsParty>;
  provider_party?: Maybe<SpsParty>;
  type_code?: Maybe<NamedCode>;
};

export type SpsAuthenticationInput = {
  actual?: InputMaybe<Scalars['AWSDateTime']['input']>;
  included_clauses?: InputMaybe<Array<SpsClauseInput>>;
  issue_location?: InputMaybe<SpsLocationInput>;
  location_provider_party?: InputMaybe<SpsPartyInput>;
  provider_party?: InputMaybe<SpsPartyInput>;
  type_code?: InputMaybe<NamedCodeInput>;
};

export type SpsCertificate = {
  __typename?: 'SPSCertificate';
  consignment: SpsConsignment;
  exchanged_document: SpsExchangedDocument;
};

export type SpsClassification = {
  __typename?: 'SPSClassification';
  class_code?: Maybe<Scalars['String']['output']>;
  class_name: Scalars['String']['output'];
  system_id?: Maybe<Scalars['String']['output']>;
  system_name: Scalars['String']['output'];
};

export type SpsClassificationInput = {
  class_code?: InputMaybe<Scalars['String']['input']>;
  class_name: Scalars['String']['input'];
  system_id?: InputMaybe<Scalars['String']['input']>;
  system_name: Scalars['String']['input'];
};

export type SpsClause = {
  __typename?: 'SPSClause';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpsClauseInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpsConsignment = {
  __typename?: 'SPSConsignment';
  availability_due_date_time?: Maybe<Scalars['AWSDateTime']['output']>;
  carrier?: Maybe<SpsParty>;
  consignee?: Maybe<SpsParty>;
  consignee_receipt_location?: Maybe<SpsLocation>;
  consignor?: Maybe<SpsParty>;
  customs_transit_agent?: Maybe<SpsParty>;
  delivery?: Maybe<SpsParty>;
  despatch?: Maybe<SpsParty>;
  examination_event?: Maybe<SpsEvent>;
  export_country?: Maybe<SpsCountry>;
  export_exit_date_time?: Maybe<Scalars['AWSDateTime']['output']>;
  exporter_reference?: Maybe<Scalars['String']['output']>;
  gross_weight?: Maybe<Scalars['String']['output']>;
  import_country?: Maybe<SpsCountry>;
  items: Array<SpsConsignmentItem>;
  loading_base_port_location?: Maybe<SpsLocation>;
  main_carriage_transport_movements: Array<SpsTransportMovement>;
  reexport_country?: Maybe<SpsCountry>;
  ship_stores_indicator?: Maybe<IndicatorType>;
  storage_events: Array<SpsEvent>;
  transit_countries: Array<SpsCountry>;
  transit_locations: Array<SpsLocation>;
  unloading_base_port_location?: Maybe<SpsLocation>;
  utilized_transport_equipment: Array<SpsTransportEquipment>;
  wine?: Maybe<WineConsignment>;
};

export type SpsConsignmentInput = {
  availability_due_date_time?: InputMaybe<Scalars['AWSDateTime']['input']>;
  carrier?: InputMaybe<SpsPartyInput>;
  consignee?: InputMaybe<SpsPartyInput>;
  consignee_receipt_location?: InputMaybe<SpsLocationInput>;
  consignor?: InputMaybe<SpsPartyInput>;
  customs_transit_agent?: InputMaybe<SpsPartyInput>;
  delivery?: InputMaybe<SpsPartyInput>;
  despatch?: InputMaybe<SpsPartyInput>;
  examination_event?: InputMaybe<SpsEventInput>;
  export_exit_date_time?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exporter_reference?: InputMaybe<Scalars['String']['input']>;
  gross_weight?: InputMaybe<Scalars['String']['input']>;
  import_country?: InputMaybe<SpsCountryInput>;
  items?: InputMaybe<Array<SpsConsignmentItemInput>>;
  loading_base_port_location?: InputMaybe<SpsLocationInput>;
  main_carriage_transport_movements?: InputMaybe<Array<SpsTransportMovementInput>>;
  storage_events?: InputMaybe<Array<SpsEventInput>>;
  transit_countries?: InputMaybe<Array<SpsCountryInput>>;
  transit_locations?: InputMaybe<Array<SpsLocationInput>>;
  unloading_base_port_location?: InputMaybe<SpsLocationInput>;
  utilized_transport_equipment?: InputMaybe<Array<SpsTransportEquipmentInput>>;
};

export type SpsConsignmentItem = {
  __typename?: 'SPSConsignmentItem';
  gross_weight?: Maybe<Scalars['String']['output']>;
  items: Array<SpsTradeLineItem>;
  nature_identification_cargo: Array<CargoTypeClassificationCode>;
};

export type SpsConsignmentItemInput = {
  gross_weight?: InputMaybe<Scalars['String']['input']>;
  items: Array<SpsTradeLineItemInput>;
  nature_identification_cargo?: InputMaybe<Array<CargoTypeClassificationCode>>;
};

export type SpsContact = {
  __typename?: 'SPSContact';
  person_name?: Maybe<Scalars['String']['output']>;
};

export type SpsContactInput = {
  person_name?: InputMaybe<Scalars['String']['input']>;
};

export type SpsCountry = {
  __typename?: 'SPSCountry';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<SpsCountrySubDivision>;
};

export type SpsCountryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<SpsCountrySubDivisionInput>;
};

export type SpsCountrySubDivision = {
  __typename?: 'SPSCountrySubDivision';
  hierarchicalLevelCode?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsCountrySubDivisionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SpsEvent = {
  __typename?: 'SPSEvent';
  occurrence_location?: Maybe<SpsLocation>;
};

export type SpsEventInput = {
  occurrence_location?: InputMaybe<SpsLocationInput>;
};

export type SpsExchangedDocument = {
  __typename?: 'SPSExchangedDocument';
  certificate_id: Scalars['String']['output'];
  certifier?: Maybe<SpsAuthentication>;
  customs_permit_number?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  included_notes: Array<SpsNote>;
  issue_date_time: Scalars['AWSDateTime']['output'];
  issuer: SpsParty;
  name: Scalars['String']['output'];
  referenced_documents: Array<SpsReferencedDocument>;
  signatories: Array<SpsAuthentication>;
  status_code: Scalars['String']['output'];
  type_code: Scalars['String']['output'];
  verifiers: Array<SpsAuthentication>;
};

export type SpsLocation = {
  __typename?: 'SPSLocation';
  country?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsLocationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SpsNote = {
  __typename?: 'SPSNote';
  content: Scalars['String']['output'];
  content_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_code?: Maybe<Scalars['String']['output']>;
};

export type SpsNoteInput = {
  content: Scalars['String']['input'];
  content_code?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_code?: InputMaybe<Scalars['String']['input']>;
};

export type SpsPackage = {
  __typename?: 'SPSPackage';
  level_code?: Maybe<Scalars['String']['output']>;
  nominal_gross_volume?: Maybe<Scalars['String']['output']>;
  nominal_gross_weight?: Maybe<Scalars['String']['output']>;
  physical_shipping_marks: Array<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  type_code?: Maybe<NamedCode>;
};

export type SpsPackageInput = {
  level_code?: InputMaybe<Scalars['String']['input']>;
  nominal_gross_volume?: InputMaybe<Scalars['String']['input']>;
  nominal_gross_weight?: InputMaybe<Scalars['String']['input']>;
  physical_shipping_marks?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  type_code?: InputMaybe<NamedCodeInput>;
};

export type SpsParty = {
  __typename?: 'SPSParty';
  defined_contacts: Array<SpsContact>;
  name: Scalars['String']['output'];
  party_id?: Maybe<Scalars['String']['output']>;
  role_code?: Maybe<Scalars['String']['output']>;
  specified_address?: Maybe<SpsAddress>;
  specified_person?: Maybe<SpsPerson>;
  type_code?: Maybe<Scalars['Int']['output']>;
};

export type SpsPartyInput = {
  defined_contacts?: InputMaybe<Array<SpsContactInput>>;
  name: Scalars['String']['input'];
  party_id?: InputMaybe<Scalars['String']['input']>;
  role_code?: InputMaybe<Scalars['String']['input']>;
  specified_address?: InputMaybe<SpsAddressInput>;
  specified_person?: InputMaybe<SpsPersonInput>;
  type_code?: InputMaybe<Scalars['Int']['input']>;
};

export type SpsPeriod = {
  __typename?: 'SPSPeriod';
  duration?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['AWSDateTime']['output']>;
  start?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SpsPeriodInput = {
  duration?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['AWSDateTime']['input']>;
  start?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type SpsPerson = {
  __typename?: 'SPSPerson';
  attained_qualifications: Array<SpsQualification>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsPersonInput = {
  attained_qualifications?: InputMaybe<Array<SpsQualificationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SpsProcess = {
  __typename?: 'SPSProcess';
  applicable_process_characteristics: Array<SpsProcessCharacteristic>;
  completion_period?: Maybe<SpsPeriod>;
  operation_country?: Maybe<SpsCountry>;
  operator_party?: Maybe<SpsParty>;
  type_code?: Maybe<NamedCode>;
};

export type SpsProcessCharacteristic = {
  __typename?: 'SPSProcessCharacteristic';
  description?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  type_code?: Maybe<NamedCode>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SpsProcessCharacteristicInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  type_code?: InputMaybe<NamedCodeInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SpsProcessInput = {
  applicable_process_characteristics?: InputMaybe<Array<SpsProcessCharacteristicInput>>;
  completion_period?: InputMaybe<SpsPeriodInput>;
  operation_country?: InputMaybe<SpsCountryInput>;
  operator_party?: InputMaybe<SpsPartyInput>;
  type_code?: InputMaybe<NamedCodeInput>;
};

export type SpsQualification = {
  __typename?: 'SPSQualification';
  abbreviated_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsQualificationInput = {
  abbreviated_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SpsReferencedDocument = {
  __typename?: 'SPSReferencedDocument';
  checksum?: Maybe<Scalars['String']['output']>;
  document_id?: Maybe<Scalars['ID']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  filetype?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  issued?: Maybe<Scalars['AWSDateTime']['output']>;
  relationship_type_code: Scalars['String']['output'];
  type_code?: Maybe<Scalars['String']['output']>;
};

export type SpsSeal = {
  __typename?: 'SPSSeal';
  issuing_party?: Maybe<SpsParty>;
  maximum_id?: Maybe<Scalars['String']['output']>;
  seal_id: Scalars['String']['output'];
};

export type SpsSealInput = {
  issuing_party?: InputMaybe<SpsPartyInput>;
  maximum_id?: InputMaybe<Scalars['String']['input']>;
  seal_id: Scalars['String']['input'];
};

export type SpsTemperature = {
  __typename?: 'SPSTemperature';
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  type_code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SpsTemperatureInput = {
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  type_code?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SpsTradeLineItem = {
  __typename?: 'SPSTradeLineItem';
  additional_information: Array<SpsNote>;
  applied_processes: Array<SpsProcess>;
  asserted_authentications: Array<SpsAuthentication>;
  associated_transport_equipment: Array<SpsTransportEquipment>;
  brand_name?: Maybe<Scalars['String']['output']>;
  classifications: Array<SpsClassification>;
  cn_code?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  common_name?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  expiry_date_time?: Maybe<Scalars['AWSDateTime']['output']>;
  gross_volume?: Maybe<Scalars['String']['output']>;
  gross_weight?: Maybe<Scalars['String']['output']>;
  hs_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  import_certificate_extract?: Maybe<Array<ImportCertificateExtractItem>>;
  import_certificate_measurement?: Maybe<Array<ImportCertificateExtractMeasurement>>;
  import_permit_number?: Maybe<Scalars['String']['output']>;
  intended_use?: Maybe<Scalars['String']['output']>;
  net_volume?: Maybe<Scalars['String']['output']>;
  net_weight?: Maybe<Scalars['String']['output']>;
  origin_countries?: Maybe<Array<SpsCountry>>;
  origin_country?: Maybe<SpsCountry>;
  origin_locations: Array<SpsLocation>;
  other_quantity?: Maybe<Scalars['String']['output']>;
  physical_packages: Array<SpsPackage>;
  production_batch_id?: Maybe<Scalars['String']['output']>;
  referenced_documents: Array<SpsReferencedDocument>;
  requestor_id?: Maybe<Scalars['String']['output']>;
  scientific_name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  verified: Scalars['Boolean']['output'];
  wine?: Maybe<B2GWineFields>;
};

export type SpsTradeLineItemInput = {
  additional_information?: InputMaybe<Array<SpsNoteInput>>;
  applied_processes?: InputMaybe<Array<SpsProcessInput>>;
  asserted_authentications?: InputMaybe<Array<SpsAuthenticationInput>>;
  associated_transport_equipment?: InputMaybe<Array<SpsTransportEquipmentInput>>;
  brand_name?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Array<SpsClassificationInput>>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  common_name?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  expiry_date_time?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gross_volume?: InputMaybe<Scalars['String']['input']>;
  gross_weight?: InputMaybe<Scalars['String']['input']>;
  hs_code?: InputMaybe<Scalars['String']['input']>;
  import_permit_number?: InputMaybe<Scalars['String']['input']>;
  intended_use?: InputMaybe<Scalars['String']['input']>;
  net_volume?: InputMaybe<Scalars['String']['input']>;
  net_weight?: InputMaybe<Scalars['String']['input']>;
  origin_country?: InputMaybe<SpsCountryInput>;
  origin_locations?: InputMaybe<Array<SpsLocationInput>>;
  physical_packages?: InputMaybe<Array<SpsPackageInput>>;
  production_batch_id?: InputMaybe<Scalars['String']['input']>;
  requestor_id?: InputMaybe<Scalars['String']['input']>;
  scientific_name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type SpsTransportEquipment = {
  __typename?: 'SPSTransportEquipment';
  affixed_seals: Array<SpsSeal>;
  temperature_settings: Array<SpsTemperature>;
  transport_equipment_id: Scalars['String']['output'];
};

export type SpsTransportEquipmentInput = {
  affixed_seals?: InputMaybe<Array<SpsSealInput>>;
  temperature_settings?: InputMaybe<Array<SpsTemperatureInput>>;
  transport_equipment_id: Scalars['String']['input'];
};

export type SpsTransportMovement = {
  __typename?: 'SPSTransportMovement';
  mode: TransportModeCode;
  mode_name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  used_transport_means?: Maybe<Scalars['String']['output']>;
};

export type SpsTransportMovementInput = {
  mode: TransportModeCode;
  reference?: InputMaybe<Scalars['String']['input']>;
  used_transport_means?: InputMaybe<Scalars['String']['input']>;
};

export type SpsTransportMovementTemplate = {
  __typename?: 'SPSTransportMovementTemplate';
  id?: Maybe<Scalars['ID']['output']>;
  mode: TransportMovementCodeTemplate;
  used_transport_means?: Maybe<Scalars['String']['output']>;
};

export type SpsWineExporter = {
  __typename?: 'SPSWineExporter';
  name?: Maybe<Scalars['String']['output']>;
};

export type SalesForceAddress = {
  __typename?: 'SalesForceAddress';
  addressType: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
};

export type SalesForceContact = {
  __typename?: 'SalesForceContact';
  emails: Array<SalesForceEmail>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phones: Array<SalesForcePhone>;
  role?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SalesForceEmail = {
  __typename?: 'SalesForceEmail';
  emailAddress: Scalars['String']['output'];
  emailType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
};

export type SalesForceIdentifier = {
  __typename?: 'SalesForceIdentifier';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type SalesForceParty = {
  __typename?: 'SalesForceParty';
  addresses: Array<SalesForceAddress>;
  contacts: Array<SalesForceContact>;
  id: Scalars['String']['output'];
  identifiers: Array<SalesForceIdentifier>;
  name: Scalars['String']['output'];
  nzbn?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<SalesForceAddress>;
  registrationIdentifier?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  tradingAs?: Maybe<Scalars['String']['output']>;
};

export type SalesForcePhone = {
  __typename?: 'SalesForcePhone';
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  phoneType: Scalars['String']['output'];
  telephoneNumber: Scalars['String']['output'];
};

export type SalesForceProductId = {
  __typename?: 'SalesForceProductId';
  productId: Scalars['ID']['output'];
  productRevisionId: Scalars['ID']['output'];
  sfProductId?: Maybe<Scalars['ID']['output']>;
};

export type SalesforceErApprovalInput = {
  exportRequestId: Scalars['ID']['input'];
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  status: SalesforceErStatus;
};

export type SalesforceErApprovalResponse = {
  __typename?: 'SalesforceErApprovalResponse';
  exportRequestId: Scalars['ID']['output'];
  status: SalesforceErStatus;
};

export enum SalesforceErStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export enum SalesforceTransferRequestStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Resubmit = 'RESUBMIT',
  ToBeAmended = 'TO_BE_AMENDED'
}

export type SalesforceTransferRequestVerificationInput = {
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  status: SalesforceTransferRequestStatus;
  transferRequestId: Scalars['ID']['input'];
};

export type SalesforceTransferRequestVerificationResponse = {
  __typename?: 'SalesforceTransferRequestVerificationResponse';
  transferRequestId: Scalars['ID']['output'];
};

export type SaveChangesToReferenceDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isFileUploaded: Scalars['Boolean']['input'];
  listCode: Scalars['String']['input'];
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type SaveChangesToReferenceDataResponse = {
  __typename?: 'SaveChangesToReferenceDataResponse';
  isDescUpdated: Scalars['Boolean']['output'];
  isFileUploaded: Scalars['Boolean']['output'];
};

export type SaveG2GAccountInput = {
  accountType: G2GAccountType;
  comment?: InputMaybe<Scalars['String']['input']>;
  contactNumber: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  permissions: G2GPermissionsInput;
  profileName?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<SuspensionReason>;
  status: G2GAccountStatus;
  subId?: InputMaybe<Scalars['String']['input']>;
  systemUsername?: InputMaybe<Scalars['String']['input']>;
};

export type SavedClassificationOutput = {
  __typename?: 'SavedClassificationOutput';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SavedProcessOutput = {
  __typename?: 'SavedProcessOutput';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SavedProductOutput = {
  __typename?: 'SavedProductOutput';
  classification?: Maybe<Array<Maybe<SavedClassificationOutput>>>;
  containerId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  process?: Maybe<Array<Maybe<SavedProcessOutput>>>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type SearchApiKey = {
  __typename?: 'SearchApiKey';
  apiKey: Scalars['String']['output'];
  expires: Scalars['AWSDateTime']['output'];
};

export type SearchG2GAccountsInput = {
  accountType?: InputMaybe<G2GAccountType>;
  certificateType?: InputMaybe<CoreExportCertificateType>;
  country?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<G2GAccountStatus>;
};

export type SearchOptions = {
  fromDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startWithEmptyCollection: Scalars['Boolean']['input'];
};

export type SearchReferenceListResponse = {
  __typename?: 'SearchReferenceListResponse';
  list?: Maybe<Array<ReferenceList>>;
  totalCount: Scalars['Int']['output'];
};

export type SearchTemplateVersionsResponse = {
  __typename?: 'SearchTemplateVersionsResponse';
  results: Array<TemplateVersion>;
  totalCount: Scalars['Int']['output'];
};

export type Section = {
  __typename?: 'Section';
  children: Array<Block>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SensoryProcessInput = {
  assessmentDate: Scalars['AWSDateTime']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  disputed: Scalars['Boolean']['input'];
  disputedReason?: InputMaybe<WineDisputedReason>;
  productId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
  winemaker: B2GContactInput;
};

export type SensoryProcessRequest = {
  __typename?: 'SensoryProcessRequest';
  assessmentDate: Scalars['AWSDateTime']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  disputed: Scalars['Boolean']['output'];
  disputedReason?: Maybe<WineDisputedReason>;
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  winemaker: B2GContact;
};

export type SfApplication = {
  __typename?: 'SfApplication';
  CNInspection?: Maybe<Scalars['String']['output']>;
  EUCommodityCode?: Maybe<Scalars['String']['output']>;
  EUTransit?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  administrativeTerritorialUnit?: Maybe<Scalars['String']['output']>;
  approvedByName?: Maybe<Scalars['String']['output']>;
  approvedBySFUserId?: Maybe<Scalars['String']['output']>;
  approvedCertificateEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  approvedDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  arrivalDateTime?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  categoryOfGoods?: Maybe<Scalars['String']['output']>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  certificateType?: Maybe<Scalars['String']['output']>;
  certificates?: Maybe<Array<Maybe<SfGeneratedCertificate>>>;
  certifyingAgencyIdentifier?: Maybe<Scalars['String']['output']>;
  commodityCode?: Maybe<Scalars['String']['output']>;
  consigneeIdentifier?: Maybe<Scalars['String']['output']>;
  consignorIdentifier?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  conveyanceReference?: Maybe<Scalars['String']['output']>;
  deliveryDetails?: Maybe<Scalars['String']['output']>;
  deliveryDispatchDetails?: Maybe<Scalars['String']['output']>;
  departureDateTime?: Maybe<Scalars['String']['output']>;
  destinationCountry?: Maybe<Scalars['String']['output']>;
  dischargePort?: Maybe<Scalars['String']['output']>;
  exporterIdentifier?: Maybe<Scalars['String']['output']>;
  exportingCountry?: Maybe<Scalars['String']['output']>;
  finalDestination?: Maybe<Scalars['String']['output']>;
  forImportOrAdmission?: Maybe<Scalars['String']['output']>;
  freeTextDeclaration?: Maybe<Scalars['String']['output']>;
  halalAuditor?: Maybe<Scalars['String']['output']>;
  halalCertificateNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  importPermitNumbers?: Maybe<Scalars['String']['output']>;
  inspectionDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  inspectionPort?: Maybe<Scalars['String']['output']>;
  isAutoApproval?: Maybe<Scalars['Boolean']['output']>;
  isExhausted?: Maybe<Scalars['Boolean']['output']>;
  isShipStore?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedByName?: Maybe<Scalars['String']['output']>;
  lastModifiedBySFUserId?: Maybe<Scalars['String']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  letterOfCreditRefCode?: Maybe<Scalars['String']['output']>;
  loadingPort?: Maybe<Scalars['String']['output']>;
  localCarrier?: Maybe<Scalars['String']['output']>;
  localCarrierReference?: Maybe<Scalars['String']['output']>;
  lot?: Maybe<Scalars['String']['output']>;
  manufacturerRegistration?: Maybe<Scalars['String']['output']>;
  manufacturingPremisesName?: Maybe<Scalars['String']['output']>;
  markingOfSealOnTransportContainer?: Maybe<Scalars['String']['output']>;
  nameRegistrationAndAddressOfSemenCollection?: Maybe<Scalars['String']['output']>;
  netWeightInWords?: Maybe<Scalars['String']['output']>;
  numberOfDoses?: Maybe<Scalars['Int']['output']>;
  numberOfEmbryos?: Maybe<Scalars['Int']['output']>;
  numberOfPackagescontainers?: Maybe<Scalars['Int']['output']>;
  officialStatement?: Maybe<Scalars['String']['output']>;
  phytoCertSubType?: Maybe<Scalars['String']['output']>;
  phytoLotReferenceNumber?: Maybe<Scalars['String']['output']>;
  phytoPackhouse?: Maybe<Scalars['String']['output']>;
  phytoSchemeControl?: Maybe<Scalars['String']['output']>;
  phytoStatementOfRelabelling?: Maybe<Scalars['String']['output']>;
  placeAndDateOfQuarantine?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  purposeBR?: Maybe<Scalars['String']['output']>;
  requestorReference?: Maybe<Scalars['String']['output']>;
  russianDairyExporterReference?: Maybe<Scalars['String']['output']>;
  sanitaryCertificateNumber?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  signatory?: Maybe<Scalars['String']['output']>;
  signingOffice?: Maybe<Scalars['String']['output']>;
  statementOfRelabelling?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  subStatus?: Maybe<Scalars['String']['output']>;
  submittedByName?: Maybe<Scalars['String']['output']>;
  submittedBySFUserId?: Maybe<Scalars['String']['output']>;
  submittedDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  summaryOfRecordsFor?: Maybe<Scalars['String']['output']>;
  totalGrossWeight?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['String']['output']>;
  transitCountries?: Maybe<Scalars['String']['output']>;
  transport?: Maybe<Scalars['String']['output']>;
  transportMode?: Maybe<Scalars['String']['output']>;
  uniqueConsignmentReference?: Maybe<Scalars['String']['output']>;
  unofficialInformation?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<Scalars['String']['output']>;
  verifyingAgencyIdentifier?: Maybe<Scalars['String']['output']>;
};

export type SfApprovedTemplateVersion = {
  __typename?: 'SfApprovedTemplateVersion';
  code: Scalars['String']['output'];
  commodity?: Maybe<Scalars['String']['output']>;
  destinationCountries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  majorVersion: Scalars['Int']['output'];
  minorVersion: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type SfCancelExportCertificateInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['String']['input'];
};

export type SfChangeExportCertificateRequestStatusInput = {
  reason_for_status_change?: InputMaybe<Scalars['String']['input']>;
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['String']['input'];
  status: ExportCertificateStatus;
};

export type SfChangeExportRequestStatusInput = {
  action?: InputMaybe<ChangeExportRequestAction>;
  id: Scalars['ID']['input'];
  reasonCategories?: InputMaybe<Array<InputMaybe<EditReasonCategory>>>;
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  sfUpdatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sfUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  status: ChangeExportRequestStatus;
  substatus?: InputMaybe<CoreSubstatus>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SfChangeExportRequestStatusResponse = {
  __typename?: 'SfChangeExportRequestStatusResponse';
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SfChangeTransferRequestStatusInput = {
  id: Scalars['ID']['input'];
  reasonCategories?: InputMaybe<Array<InputMaybe<ExportReasonCategory>>>;
  reasonForStatusChange?: InputMaybe<Scalars['String']['input']>;
  sfUpdatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sfUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  status: ChangeTransferRequestStatus;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SfChangeTransferRequestStatusResponse = {
  __typename?: 'SfChangeTransferRequestStatusResponse';
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SfDownloadCertificateInput = {
  id: Scalars['ID']['input'];
  reasonForReprint?: InputMaybe<Scalars['String']['input']>;
  type: SfGeneratedCertificateType;
  updatedAt: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
};

export type SfDownloadCertificateResponse = {
  __typename?: 'SfDownloadCertificateResponse';
  presignedURL?: Maybe<Scalars['String']['output']>;
};

export type SfDownloadInput = {
  reasonForReprint?: InputMaybe<Scalars['String']['input']>;
  s3URI?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type SfGeneratedCertificate = {
  __typename?: 'SfGeneratedCertificate';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileVersion?: Maybe<Scalars['String']['output']>;
  s3URI?: Maybe<Scalars['String']['output']>;
};

export enum SfGeneratedCertificateType {
  CopyPdf = 'COPY_PDF',
  DraftPdf = 'DRAFT_PDF',
  OfficialPdf = 'OFFICIAL_PDF',
  XmlOutput = 'XML_OUTPUT'
}

export type SfPrintHistory = {
  __typename?: 'SfPrintHistory';
  datePrinted?: Maybe<Scalars['AWSDateTime']['output']>;
  reasonForReprinting?: Maybe<Scalars['String']['output']>;
  sfUserId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GeneratedCertificateType>;
};

export type SfRequest = {
  __typename?: 'SfRequest';
  application?: Maybe<Scalars['String']['output']>;
  applicationHistory?: Maybe<Scalars['String']['output']>;
  applicationTemplate?: Maybe<Scalars['String']['output']>;
  applicationWarnings?: Maybe<Scalars['String']['output']>;
  certificatePrintHistory?: Maybe<Scalars['String']['output']>;
  certificates?: Maybe<Scalars['String']['output']>;
  declarations?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  processes?: Maybe<Scalars['String']['output']>;
  productWarnings?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Scalars['String']['output']>;
  sourceProducts?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Scalars['String']['output']>;
};

export type SfRequestExportCertificateReplacementInput = {
  reason_for_status_change?: InputMaybe<Scalars['String']['input']>;
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['String']['input'];
};

export type SfRequestedToResubmitExportCertificateInput = {
  products_to_unverify?: InputMaybe<Array<SfUnverifyProductInput>>;
  reason_for_status_change?: InputMaybe<Scalars['String']['input']>;
  requestor?: InputMaybe<Scalars['String']['input']>;
  requestor_id: Scalars['String']['input'];
};

export type SfSearchApprovedTemplatesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SfSearchApprovedTemplatesResponse = {
  __typename?: 'SfSearchApprovedTemplatesResponse';
  templates: Array<SfApprovedTemplateVersion>;
  totalCount: Scalars['Int']['output'];
};

export type SfSupportingDocumentMetadata = {
  __typename?: 'SfSupportingDocumentMetadata';
  comment?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentReferenceNumber?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileVersion?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  originCountry?: Maybe<Scalars['String']['output']>;
  printWithPDF?: Maybe<Scalars['Boolean']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SupportingDocumentStatus>;
};

export type SfUnverifyProductInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  requestor_product_id: Scalars['String']['input'];
};

export type SfUpdateProductExhaustionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  exhaust: Scalars['Boolean']['input'];
  productIds: Array<Scalars['ID']['input']>;
  updatedBy: Scalars['String']['input'];
};

export type SfUpdateProductExhaustionResponse = {
  __typename?: 'SfUpdateProductExhaustionResponse';
  exhaust?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Array<Maybe<ProductExhaustionResponse>>>;
  transferId?: Maybe<Scalars['String']['output']>;
};

export type SfUpdateStationerySerialNumbersInput = {
  id: Scalars['ID']['input'];
  stationerySerialNumbers: Scalars['String']['input'];
  updatedAt: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
};

export type SfUpdateStationerySerialNumbersResponse = {
  __typename?: 'SfUpdateStationerySerialNumbersResponse';
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Scalars['String']['output']>;
};

export type SfUpdateTransferAuditCommentInput = {
  auditComment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  sfUpdatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sfUpdatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type SfUpdateTransferAuditCommentResponse = {
  __typename?: 'SfUpdateTransferAuditCommentResponse';
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SfVerifyExportCertificateRequestProductsInput = {
  products: Array<SfVerifyProductInput>;
  requestor?: InputMaybe<Scalars['String']['input']>;
};

export type SfVerifyProductInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  requestor_product_id: Scalars['String']['input'];
  verified: Scalars['Boolean']['input'];
};

export enum Signatory {
  None = 'NONE',
  NonVet = 'NON_VET',
  ThirdParty = 'THIRD_PARTY',
  Vet = 'VET'
}

export type SnapshotPresignedUrlResponse = {
  __typename?: 'SnapshotPresignedUrlResponse';
  url: Scalars['String']['output'];
};

export enum SortOrder {
  Code = 'CODE',
  Text = 'TEXT'
}

export type SourceProductTracking = {
  __typename?: 'SourceProductTracking';
  description?: Maybe<Scalars['String']['output']>;
  destinations: Array<DestinationProductTracking>;
  id: Scalars['ID']['output'];
  outgoingCount: Scalars['Int']['output'];
  productNumber: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  totalPackages: Scalars['Int']['output'];
};

export type SourceTransfer = {
  __typename?: 'SourceTransfer';
  approvalDate?: Maybe<Scalars['AWSDateTime']['output']>;
  isPaperSource?: Maybe<Scalars['Boolean']['output']>;
  lineItemNumber?: Maybe<Scalars['Int']['output']>;
  requestNumber: Scalars['String']['output'];
  sourceTransferId?: Maybe<Scalars['ID']['output']>;
};

export type SourcedProduct = {
  __typename?: 'SourcedProduct';
  details?: Maybe<SourcedProductDetails>;
  id: Scalars['String']['output'];
  isExhausted?: Maybe<Scalars['Boolean']['output']>;
  isPaperSourced?: Maybe<Scalars['Boolean']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  transferRequestId?: Maybe<Scalars['String']['output']>;
  transferRequestNumber?: Maybe<Scalars['String']['output']>;
};

export type SourcedProductAttributes = {
  __typename?: 'SourcedProductAttributes';
  NZHSCode?: Maybe<CoreLookup>;
  expiryDateFrom?: Maybe<Scalars['AWSDate']['output']>;
  expiryDateTo?: Maybe<Scalars['AWSDate']['output']>;
  grossVolume?: Maybe<Measurment>;
  grossWeight?: Maybe<Measurment>;
  inspectionType?: Maybe<CoreLookup>;
  intendedUse?: Maybe<Array<Maybe<CoreLookup>>>;
  netVolume?: Maybe<Measurment>;
  netWeight?: Maybe<Measurment>;
  origin?: Maybe<CoreLookup>;
  productionBatchIds?: Maybe<Array<Scalars['String']['output']>>;
  scientificName?: Maybe<Array<Maybe<CoreLookup>>>;
  speciesCommonName?: Maybe<Array<Maybe<CoreLookup>>>;
  temperature?: Maybe<CoreLookup>;
};

export type SourcedProductDetails = {
  __typename?: 'SourcedProductDetails';
  attributes?: Maybe<SourcedProductAttributes>;
  classification?: Maybe<Array<Maybe<CoreProductClassificationResponse>>>;
  containers?: Maybe<Array<CoreExportContainer>>;
  eligibilityCountries?: Maybe<Array<CoreLookup>>;
  itemDescription?: Maybe<CoreLookup>;
  packaging?: Maybe<Array<Maybe<CorePackaging>>>;
  productReference?: Maybe<Scalars['String']['output']>;
  productStatement?: Maybe<Scalars['String']['output']>;
};

export type SpsAcknowledgementInput = {
  certificateNumber: Scalars['String']['input'];
  reasonInformation?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  status: CoreStatus;
  systemUserName?: InputMaybe<Scalars['String']['input']>;
};

export type SpsAcknowledgementOutput = {
  __typename?: 'SpsAcknowledgementOutput';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  updatedStatus?: Maybe<Scalars['String']['output']>;
};

export type SpsAddressTemplate = {
  __typename?: 'SpsAddressTemplate';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['ID']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  country_subdivision_id?: Maybe<Scalars['ID']['output']>;
  country_subdivision_name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_code?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_with_commas?: Maybe<Scalars['String']['output']>;
  street_with_line_breaks?: Maybe<Scalars['String']['output']>;
  type_code?: Maybe<Scalars['String']['output']>;
  with_commas?: Maybe<Scalars['String']['output']>;
  with_line_breaks?: Maybe<Scalars['String']['output']>;
};

export type SpsAuthenticationTemplate = {
  __typename?: 'SpsAuthenticationTemplate';
  actual?: Maybe<DateTimeTemplate>;
  ic_label?: Maybe<Scalars['String']['output']>;
  ic_value?: Maybe<Scalars['String']['output']>;
  included_clauses?: Maybe<Array<SpsClauseTemplate>>;
  issue_location?: Maybe<SpsLocationTemplate>;
  location_provider_party?: Maybe<SpsPartyTemplate>;
  provider_party?: Maybe<SpsPartyTemplate>;
  type_code?: Maybe<NamedCodeTemplate>;
};

export type SpsCertificateTemplate = {
  __typename?: 'SpsCertificateTemplate';
  consignment: SpsConsignmentTemplate;
  exchanged_document: SpsExchangedDocumentTemplate;
};

export type SpsClassificationTemplate = {
  __typename?: 'SpsClassificationTemplate';
  class_code?: Maybe<Scalars['String']['output']>;
  class_name: Scalars['String']['output'];
  system_id?: Maybe<Scalars['String']['output']>;
  system_name: Scalars['String']['output'];
};

export type SpsClauseTemplate = {
  __typename?: 'SpsClauseTemplate';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpsConsignmentItemTemplate = {
  __typename?: 'SpsConsignmentItemTemplate';
  gross_weight?: Maybe<Scalars['String']['output']>;
  items: Array<SpsTradeLineItemTemplate>;
  nature_identification_cargo?: Maybe<Array<Scalars['String']['output']>>;
};

export type SpsConsignmentTemplate = {
  __typename?: 'SpsConsignmentTemplate';
  authentication_parties?: Maybe<Array<SpsPartyTemplate>>;
  availability_due_date_time?: Maybe<DateTimeTemplate>;
  carrier?: Maybe<SpsPartyTemplate>;
  consignee?: Maybe<SpsPartyTemplate>;
  consignee_receipt_location?: Maybe<SpsLocationTemplate>;
  consignor?: Maybe<SpsPartyTemplate>;
  customs_transit_agent?: Maybe<SpsPartyTemplate>;
  delivery?: Maybe<SpsPartyTemplate>;
  despatch?: Maybe<SpsPartyTemplate>;
  examination_event?: Maybe<SpsEventTemplate>;
  export_country?: Maybe<SpsCountryTemplate>;
  export_exit_date_time?: Maybe<DateTimeTemplate>;
  gross_weight?: Maybe<MeasureTemplate>;
  id?: Maybe<Scalars['ID']['output']>;
  import_country?: Maybe<SpsCountryTemplate>;
  items: Array<SpsConsignmentItemTemplate>;
  loading_base_port_location?: Maybe<SpsLocationTemplate>;
  main_carriage_transport_movements?: Maybe<Array<SpsTransportMovementTemplate>>;
  party_table?: Maybe<Array<CombinedPartyTemplate>>;
  processor_parties?: Maybe<Array<SpsPartyTemplate>>;
  reexport_country?: Maybe<SpsCountryTemplate>;
  storage_events?: Maybe<Array<SpsEventTemplate>>;
  transit_countries?: Maybe<Array<SpsCountryTemplate>>;
  transit_locations?: Maybe<Array<SpsLocationTemplate>>;
  unique_production_batch_ids?: Maybe<IDsTemplate>;
  unique_seal_number_ids: Scalars['String']['output'];
  unique_transport_equipment_ids?: Maybe<IDsTemplate>;
  unloading_base_port_location?: Maybe<SpsLocationTemplate>;
  utilized_transport_equipment?: Maybe<Array<SpsTransportEquipmentTemplate>>;
  verifiers?: Maybe<Array<SpsAuthenticationTemplate>>;
  wine?: Maybe<WineConsignmentTemplate>;
};

export type SpsContactTemplate = {
  __typename?: 'SpsContactTemplate';
  person_name?: Maybe<Scalars['String']['output']>;
};

export type SpsCountrySubDivisionTemplate = {
  __typename?: 'SpsCountrySubDivisionTemplate';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsCountryTemplate = {
  __typename?: 'SpsCountryTemplate';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<SpsCountrySubDivisionTemplate>;
};

export type SpsEventTemplate = {
  __typename?: 'SpsEventTemplate';
  occurrence_location?: Maybe<SpsLocationTemplate>;
};

export type SpsExchangedDocumentTemplate = {
  __typename?: 'SpsExchangedDocumentTemplate';
  additional_declarations?: Maybe<Scalars['String']['output']>;
  additional_information?: Maybe<Scalars['String']['output']>;
  additional_official_information?: Maybe<Scalars['String']['output']>;
  certifier?: Maybe<SpsAuthenticationTemplate>;
  customs_permit_number?: Maybe<Scalars['String']['output']>;
  date_of_inspection?: Maybe<DateTimeTemplate>;
  description?: Maybe<Scalars['String']['output']>;
  distinguishing_marks?: Maybe<Scalars['String']['output']>;
  financial_liability?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  import_permit?: Maybe<Scalars['String']['output']>;
  issue_date_time?: Maybe<DateTimeTemplate>;
  issuer?: Maybe<SpsPartyTemplate>;
  name?: Maybe<Scalars['String']['output']>;
  replacement_certificate?: Maybe<SpsReplacementCertificateTemplate>;
  signatories?: Maybe<Array<Maybe<SpsAuthenticationTemplate>>>;
  status_code?: Maybe<Scalars['String']['output']>;
  status_name?: Maybe<Scalars['String']['output']>;
  type_code?: Maybe<Scalars['String']['output']>;
  type_name?: Maybe<Scalars['String']['output']>;
};

export type SpsLocationTemplate = {
  __typename?: 'SpsLocationTemplate';
  country?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsNoteTemplate = {
  __typename?: 'SpsNoteTemplate';
  content?: Maybe<Scalars['String']['output']>;
  content_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_code?: Maybe<Scalars['String']['output']>;
};

export type SpsPackageTemplate = {
  __typename?: 'SpsPackageTemplate';
  level_code?: Maybe<Scalars['String']['output']>;
  nominal_gross_volume?: Maybe<MeasureTemplate>;
  nominal_gross_weight?: Maybe<MeasureTemplate>;
  physical_shipping_marks?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<DecimalTemplate>;
  type_code?: Maybe<NamedCodeTemplate>;
};

export type SpsPartyTemplate = {
  __typename?: 'SpsPartyTemplate';
  defined_contacts?: Maybe<Array<SpsContactTemplate>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role_code?: Maybe<Scalars['String']['output']>;
  specified_address?: Maybe<SpsAddressTemplate>;
  specified_person?: Maybe<SpsPersonTemplate>;
  type_code?: Maybe<Scalars['String']['output']>;
};

export type SpsPeriodTemplate = {
  __typename?: 'SpsPeriodTemplate';
  duration?: Maybe<MeasureTemplate>;
  end?: Maybe<DateTimeTemplate>;
  start?: Maybe<DateTimeTemplate>;
};

export type SpsPersonTemplate = {
  __typename?: 'SpsPersonTemplate';
  attained_qualifications?: Maybe<Array<SpsQualificationTemplate>>;
  name?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type SpsProcessCharacteristicTemplate = {
  __typename?: 'SpsProcessCharacteristicTemplate';
  description?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<MeasureTemplate>;
  minimum?: Maybe<MeasureTemplate>;
  type_code?: Maybe<NamedCodeTemplate>;
  value?: Maybe<MeasureTemplate>;
};

export type SpsProcessTemplate = {
  __typename?: 'SpsProcessTemplate';
  applicable_process_characteristics?: Maybe<Array<SpsProcessCharacteristicTemplate>>;
  completion_period?: Maybe<SpsPeriodTemplate>;
  operation_country?: Maybe<SpsCountryTemplate>;
  operator_party?: Maybe<SpsPartyTemplate>;
  type_code?: Maybe<NamedCodeTemplate>;
};

export type SpsQualificationTemplate = {
  __typename?: 'SpsQualificationTemplate';
  abbreviated_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SpsReplacementCertificateTemplate = {
  __typename?: 'SpsReplacementCertificateTemplate';
  additional_declaration?: Maybe<Scalars['String']['output']>;
  replaced_certificate_issue_date?: Maybe<DateTimeTemplate>;
  replaced_certificate_number?: Maybe<Scalars['String']['output']>;
  replacement_reason?: Maybe<Scalars['String']['output']>;
};

export type SpsSealTemplate = {
  __typename?: 'SpsSealTemplate';
  id: Scalars['String']['output'];
  issuing_party?: Maybe<SpsPartyTemplate>;
  maximum_id?: Maybe<Scalars['String']['output']>;
};

export type SpsTemperatureTemplate = {
  __typename?: 'SpsTemperatureTemplate';
  maximum?: Maybe<MeasureTemplate>;
  minimum?: Maybe<MeasureTemplate>;
  type_code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<MeasureTemplate>;
};

export type SpsTradeLineItemTemplate = {
  __typename?: 'SpsTradeLineItemTemplate';
  additional_information?: Maybe<Array<SpsNoteTemplate>>;
  applied_processes?: Maybe<Array<SpsProcessTemplate>>;
  asserted_authentications?: Maybe<Array<SpsAuthenticationTemplate>>;
  associated_transport_equipment?: Maybe<Array<SpsTransportEquipmentTemplate>>;
  brand_name?: Maybe<Scalars['String']['output']>;
  classifications?: Maybe<Array<SpsClassificationTemplate>>;
  cn_code?: Maybe<Scalars['String']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  common_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiry_date_time?: Maybe<DateTimeTemplate>;
  gross_volume?: Maybe<MeasureTemplate>;
  gross_weight?: Maybe<MeasureTemplate>;
  hs_code?: Maybe<Scalars['String']['output']>;
  import_certificate_extract?: Maybe<ImportCertificateExtractTemplate>;
  import_certificate_measurement?: Maybe<ImportCertificateMeasurementTemplate>;
  import_permit_number?: Maybe<Scalars['String']['output']>;
  intended_use?: Maybe<Scalars['String']['output']>;
  net_volume?: Maybe<MeasureTemplate>;
  net_weight?: Maybe<MeasureTemplate>;
  origin_country?: Maybe<SpsCountryTemplate>;
  origin_locations?: Maybe<Array<SpsLocationTemplate>>;
  packaging?: Maybe<ImportCertificatePackagingTemplate>;
  physical_packages?: Maybe<Array<SpsPackageTemplate>>;
  production_batch_id?: Maybe<Scalars['String']['output']>;
  scientific_name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<TreatmentTemplate>;
  wine?: Maybe<WineFieldsTemplate>;
};

export type SpsTransportEquipmentTemplate = {
  __typename?: 'SpsTransportEquipmentTemplate';
  affixed_seals?: Maybe<Array<SpsSealTemplate>>;
  id: Scalars['String']['output'];
  temperature_settings?: Maybe<Array<SpsTemperatureTemplate>>;
};

export type StandardPdfPreviewResponse = {
  __typename?: 'StandardPdfPreviewResponse';
  error?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  status: StandardPdfPreviewStatus;
};

export enum StandardPdfPreviewStatus {
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ready = 'READY'
}

export enum SubmissionLayoutType {
  ApExport = 'AP_EXPORT',
  ApTransfer = 'AP_TRANSFER',
  Custom = 'CUSTOM',
  PhytoExport = 'PHYTO_EXPORT'
}

export type SubmissionSettings = {
  __typename?: 'SubmissionSettings';
  caption?: Maybe<Scalars['String']['output']>;
  customLookup?: Maybe<CustomLookupType>;
  displayType?: Maybe<DisplayType>;
  displayTypeSettings?: Maybe<DisplayTypeSettings>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type SubmissionSettingsInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  customLookup?: InputMaybe<CustomLookupType>;
  displayType?: InputMaybe<DisplayType>;
  displayTypeSettings?: InputMaybe<DisplayTypeSettingsInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmissionXmlUrl = {
  __typename?: 'SubmissionXmlUrl';
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onXmlFileProcessed: PrepareXmlFileForB2GResponse;
};


export type SubscriptionOnXmlFileProcessedArgs = {
  xmlInputId: Scalars['String']['input'];
};

export type SupportingDocumentActionsResponse = {
  __typename?: 'SupportingDocumentActionsResponse';
  allowedActions: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type SupportingDocumentHistoryEntry = {
  __typename?: 'SupportingDocumentHistoryEntry';
  action?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  dateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  supportingDocumentId: Scalars['ID']['output'];
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  updatedByProfile?: Maybe<Scalars['String']['output']>;
  updatedByProfileFullName?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type SupportingDocumentInput = {
  file_id: Scalars['String']['input'];
};

export type SupportingDocumentKeys = {
  __typename?: 'SupportingDocumentKeys';
  registration?: Maybe<Scalars['String']['output']>;
  registrationAll?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Scalars['String']['output']>;
};

export type SupportingDocumentPresignedUrlResponse = {
  __typename?: 'SupportingDocumentPresignedUrlResponse';
  expiresIn: Scalars['Int']['output'];
  presignedUrl: Scalars['String']['output'];
};

export enum SupportingDocumentStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Replaced = 'REPLACED'
}

export type SupportingDocumentUsageInput = {
  supportingDocumentId: Scalars['ID']['input'];
};

export type SupportingDocumentUsageRecord = {
  __typename?: 'SupportingDocumentUsageRecord';
  certificateNumber: Scalars['String']['output'];
  consigneeRegistration?: Maybe<Scalars['String']['output']>;
  consignorRegistration?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  requestId: Scalars['ID']['output'];
  requestType: CoreRequestType;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  unofficialInfo?: Maybe<Scalars['String']['output']>;
};

export enum SuspensionReason {
  AccessNoLongerRequired = 'ACCESS_NO_LONGER_REQUIRED',
  BreachOfUserAgreement = 'BREACH_OF_USER_AGREEMENT',
  NonPayment = 'NON_PAYMENT',
  PersonSuspended = 'PERSON_SUSPENDED'
}

export type Template = {
  __typename?: 'Template';
  approvedVersion?: Maybe<TemplateVersion>;
  id: Scalars['ID']['output'];
  importantVersions?: Maybe<Array<Maybe<TemplateVersion>>>;
  lastVersion: TemplateVersion;
  versions?: Maybe<Array<Maybe<TemplateVersion>>>;
};

export type TemplateDeclarationGroup = {
  __typename?: 'TemplateDeclarationGroup';
  id: Scalars['ID']['output'];
  indent: Scalars['Int']['output'];
  numbering: DeclarationGroupNumbering;
  sequenceNumber: Scalars['Int']['output'];
  startAt: Scalars['Int']['output'];
  statements?: Maybe<Array<DeclarationStatement>>;
  type: DeclarationGroupType;
};

export type TemplateDeclarationsAcknowledgement = {
  __typename?: 'TemplateDeclarationsAcknowledgement';
  delete?: Maybe<TemplateDeclarationsDeleteAcknowledgement>;
  group?: Maybe<Array<TemplateDeclarationsGroupAcknowledgement>>;
  statement?: Maybe<Array<TemplateDeclarationsStatementAcknowledgement>>;
  traces?: Maybe<Array<TemplateDeclarationsTraceAcknowledgement>>;
};

export type TemplateDeclarationsDeleteAcknowledgement = {
  __typename?: 'TemplateDeclarationsDeleteAcknowledgement';
  groupId?: Maybe<Array<Scalars['ID']['output']>>;
  statementId?: Maybe<Array<Scalars['ID']['output']>>;
  tracesId?: Maybe<Array<Scalars['ID']['output']>>;
};

export type TemplateDeclarationsDeleteInput = {
  groupId?: InputMaybe<Array<Scalars['ID']['input']>>;
  statementId?: InputMaybe<Array<Scalars['ID']['input']>>;
  tracesId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TemplateDeclarationsGroupAcknowledgement = {
  __typename?: 'TemplateDeclarationsGroupAcknowledgement';
  groupId: Scalars['ID']['output'];
};

export type TemplateDeclarationsGroupInput = {
  groupSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<DeclarationGroupType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  indent?: InputMaybe<Scalars['Int']['input']>;
  numbering?: InputMaybe<DeclarationGroupNumbering>;
  startAt?: InputMaybe<Scalars['Int']['input']>;
  statement?: InputMaybe<Array<TemplateDeclarationsStatementInput>>;
};

export type TemplateDeclarationsInput = {
  delete?: InputMaybe<TemplateDeclarationsDeleteInput>;
  group?: InputMaybe<Array<TemplateDeclarationsGroupInput>>;
  templateVersionId: Scalars['ID']['input'];
};

export type TemplateDeclarationsStatementAcknowledgement = {
  __typename?: 'TemplateDeclarationsStatementAcknowledgement';
  groupId: Scalars['ID']['output'];
  statementId: Scalars['ID']['output'];
};

export type TemplateDeclarationsStatementInput = {
  customNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  statementCode?: InputMaybe<Scalars['Int']['input']>;
  statementSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  statementText?: InputMaybe<Scalars['String']['input']>;
  statementTextTranslations?: InputMaybe<Scalars['AWSJSON']['input']>;
  traces?: InputMaybe<Array<TemplateDeclarationsTracesInput>>;
};

export type TemplateDeclarationsTraceAcknowledgement = {
  __typename?: 'TemplateDeclarationsTraceAcknowledgement';
  statementId: Scalars['ID']['output'];
  traceId: Scalars['ID']['output'];
};

export type TemplateDeclarationsTracesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tracesContent?: InputMaybe<Scalars['String']['input']>;
  tracesId?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateDocumentUrl = {
  __typename?: 'TemplateDocumentUrl';
  documentName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TemplateDocumentUrlV2 = {
  __typename?: 'TemplateDocumentUrlV2';
  documentName: Scalars['String']['output'];
  templateVersionId: Scalars['ID']['output'];
  uploadedAt: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TemplateFieldConfiguration = {
  __typename?: 'TemplateFieldConfiguration';
  fieldCategory?: Maybe<Scalars['String']['output']>;
  fuid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pdfSettings?: Maybe<PdfSettings>;
  sectionName?: Maybe<Scalars['String']['output']>;
  submissionSettings?: Maybe<SubmissionSettings>;
  viewInPdf?: Maybe<Scalars['Boolean']['output']>;
  viewInSubmission?: Maybe<Scalars['Boolean']['output']>;
  viewInXML?: Maybe<Scalars['Boolean']['output']>;
  xmlSettings?: Maybe<XmlSettings>;
};

export type TemplateFieldConfigurationAcknowledgement = {
  __typename?: 'TemplateFieldConfigurationAcknowledgement';
  delete?: Maybe<Array<Scalars['ID']['output']>>;
  upsert?: Maybe<Array<Scalars['ID']['output']>>;
};

export type TemplateFieldConfigurationInput = {
  fuid: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  pdfSettings?: InputMaybe<PdfSettingsInput>;
  submissionLayoutType: SubmissionLayoutType;
  submissionSettings?: InputMaybe<SubmissionSettingsInput>;
  viewInPdf?: InputMaybe<Scalars['Boolean']['input']>;
  viewInSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  viewInXML?: InputMaybe<Scalars['Boolean']['input']>;
  xmlSettings?: InputMaybe<XmlSettingsInput>;
};

export type TemplateFieldConfigurationV2 = {
  __typename?: 'TemplateFieldConfigurationV2';
  classificationCode?: Maybe<Scalars['String']['output']>;
  fieldCategory?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  fuid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pdfSettings?: Maybe<PdfSettings>;
  sectionName: Scalars['String']['output'];
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  submissionSettings?: Maybe<SubmissionSettings>;
  viewInPdf?: Maybe<Scalars['Boolean']['output']>;
  viewInSubmission?: Maybe<Scalars['Boolean']['output']>;
  viewInXML?: Maybe<Scalars['Boolean']['output']>;
  xmlSettings?: Maybe<XmlSettings>;
};

export type TemplateFieldReferenceData = {
  __typename?: 'TemplateFieldReferenceData';
  captionList?: Maybe<Array<Maybe<ReferenceCaption>>>;
  defaultDisplayType?: Maybe<Scalars['String']['output']>;
  fieldCategory?: Maybe<Scalars['String']['output']>;
  referenceDataList?: Maybe<Array<Maybe<ReferenceDataList>>>;
  sectionName?: Maybe<Scalars['String']['output']>;
};

export type TemplateFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateGeneralSettingsV2 = {
  __typename?: 'TemplateGeneralSettingsV2';
  agencies?: Maybe<Array<Maybe<Agency>>>;
  allowForeignPremises?: Maybe<Scalars['Boolean']['output']>;
  allowPackageLevels?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  businessArea?: Maybe<BusinessArea>;
  code: Scalars['String']['output'];
  commodities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commodity: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationCountries?: Maybe<Array<Scalars['String']['output']>>;
  destinationCountryNames?: Maybe<Array<Scalars['String']['output']>>;
  displayedDescription?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  effective?: Maybe<Scalars['AWSDateTime']['output']>;
  expire?: Maybe<Scalars['AWSDateTime']['output']>;
  exportCertificateType?: Maybe<CertificateType>;
  exportingCountry?: Maybe<Scalars['String']['output']>;
  exportingCountryName?: Maybe<Scalars['String']['output']>;
  importCertificateType?: Maybe<ImportCertificateType>;
  industryAccess?: Maybe<Scalars['Boolean']['output']>;
  majorVersion?: Maybe<Scalars['Int']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  ocaAccess?: Maybe<Scalars['Boolean']['output']>;
  officialVersion?: Maybe<Scalars['Int']['output']>;
  outputSubtitle?: Maybe<Scalars['String']['output']>;
  outputSubtitleTranslation?: Maybe<Array<Maybe<Translation>>>;
  outputTitle?: Maybe<Scalars['String']['output']>;
  outputTitleTranslation?: Maybe<Array<Maybe<Translation>>>;
  reasonForUpdate?: Maybe<Scalars['String']['output']>;
  release?: Maybe<Scalars['AWSDateTime']['output']>;
  signatory?: Maybe<Scalars['String']['output']>;
  status: TemplateVersionStatus;
  submissionLayout: SubmissionLayoutType;
  templateId: Scalars['ID']['output'];
  templateType?: Maybe<TemplateType>;
  title: Scalars['String']['output'];
  transferCertificateType?: Maybe<TransferCertificateType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type TemplateHistory = {
  __typename?: 'TemplateHistory';
  fieldName: Scalars['String']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type TemplateOptionalFilter = {
  commodity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destinationMarket?: InputMaybe<Array<InputMaybe<DestinationMarket>>>;
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  effectiveDateEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  effectiveDateStart?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expiryDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expiryDateEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expiryDateStart?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastEditedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastEditedDateEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastEditedDateStart?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<TemplateVersionStatus>>>;
};

export type TemplateOutputV2 = {
  __typename?: 'TemplateOutputV2';
  competentAuthority?: Maybe<CompetentAuthorityType>;
  competentAuthorityOther?: Maybe<Scalars['String']['output']>;
  declarationHeading?: Maybe<DeclarationHeadingType>;
  declarationHeadingOther?: Maybe<Scalars['String']['output']>;
  destinationSystem?: Maybe<DestinationSystem>;
  forceNzCountryOrigin: Scalars['Boolean']['output'];
  languages: Array<Scalars['String']['output']>;
  pdfAddendum: PdfAddendum;
  pdfLayout: PdfLayout;
  processGroups?: Maybe<Array<Maybe<TemplateProcessGroups>>>;
  producePdf: Scalars['Boolean']['output'];
  sendToTraces: Scalars['Boolean']['output'];
  templateSupportingDocuments?: Maybe<Array<TemplateSupportingDocument>>;
  useAllLanguages: Scalars['Boolean']['output'];
  usePortOfCountryLanguages: Scalars['Boolean']['output'];
  usePortOfDischargeLanguages: Scalars['Boolean']['output'];
  usePortOfInspectionLanguages: Scalars['Boolean']['output'];
  useTheseLanguages: Scalars['Boolean']['output'];
  xmlLayout: XmlLayout;
};

export type TemplateProcessGroupReferenceData = {
  __typename?: 'TemplateProcessGroupReferenceData';
  captions?: Maybe<Array<Maybe<ReferenceProcessGroupCaption>>>;
  groupId: Scalars['Int']['output'];
  groupName: Scalars['String']['output'];
  groupType: Scalars['String']['output'];
};

export type TemplateProcessGroups = {
  __typename?: 'TemplateProcessGroups';
  dateFormat?: Maybe<Scalars['String']['output']>;
  dateRange?: Maybe<Scalars['String']['output']>;
  defaultAction?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeOverseasProcesses?: Maybe<Scalars['Boolean']['output']>;
  isPDF?: Maybe<Scalars['Boolean']['output']>;
  isXML?: Maybe<Scalars['Boolean']['output']>;
  operatorActivityType?: Maybe<Scalars['String']['output']>;
  pdfSettings?: Maybe<ProcessGroupCaptionSettings>;
  premisesAddressFormat?: Maybe<Scalars['String']['output']>;
  premisesRange?: Maybe<Scalars['String']['output']>;
  processGroupId?: Maybe<Scalars['Int']['output']>;
  processGroupName: Scalars['String']['output'];
  processGroupType: Scalars['String']['output'];
  processes?: Maybe<Array<Maybe<ProcessInfo>>>;
  sortOrder: Scalars['Int']['output'];
  width?: Maybe<Scalars['String']['output']>;
  xmlSettings?: Maybe<ProcessGroupCaptionSettings>;
};

export type TemplateProcessGroupsConfigAcknowledgement = {
  __typename?: 'TemplateProcessGroupsConfigAcknowledgement';
  delete?: Maybe<Array<Scalars['ID']['output']>>;
  upsert?: Maybe<Array<Scalars['ID']['output']>>;
};

export type TemplateSection = {
  __typename?: 'TemplateSection';
  fields: Array<TemplateSectionField>;
  name: Scalars['String']['output'];
};

export type TemplateSectionField = {
  __typename?: 'TemplateSectionField';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TemplateSectionType {
  Declarations = 'DECLARATIONS',
  Fields = 'FIELDS',
  ProcessGroups = 'PROCESS_GROUPS',
  SupportingDocuments = 'SUPPORTING_DOCUMENTS'
}

export type TemplateSupportingDocument = {
  __typename?: 'TemplateSupportingDocument';
  documentType: TemplateSupportingDocumentType;
  id: Scalars['ID']['output'];
  includeInXml: Scalars['Boolean']['output'];
  printWithPdf: Scalars['Boolean']['output'];
  templateVersionId: Scalars['ID']['output'];
};

export type TemplateSupportingDocumentAcknowledgement = {
  __typename?: 'TemplateSupportingDocumentAcknowledgement';
  id: Scalars['ID']['output'];
  templateVersionId: Scalars['ID']['output'];
};

export type TemplateSupportingDocumentInput = {
  documentType: TemplateSupportingDocumentType;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeInXml: Scalars['Boolean']['input'];
  printWithPdf: Scalars['Boolean']['input'];
  templateVersionId: Scalars['ID']['input'];
};

export enum TemplateSupportingDocumentType {
  Adh = 'ADH',
  Adm = 'ADM',
  Doc = 'DOC',
  Fic = 'FIC',
  Insp = 'INSP',
  Ip = 'IP',
  Oma = 'OMA',
  Opc = 'OPC',
  Org = 'ORG',
  Other = 'OTHER',
  Pac = 'PAC',
  Slab = 'SLAB',
  Trt = 'TRT'
}

export enum TemplateType {
  Export = 'EXPORT',
  Import = 'IMPORT',
  Transfer = 'TRANSFER'
}

export type TemplateUploadUrl = {
  __typename?: 'TemplateUploadUrl';
  lastVersion: TemplateVersion;
  url: Scalars['String']['output'];
};

export type TemplateUploadUrlV2 = {
  __typename?: 'TemplateUploadUrlV2';
  lastTemplateVersionId: Scalars['ID']['output'];
  s3Url: AwsS3PostUploadUrl;
  templateVersionId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type TemplateV2 = {
  __typename?: 'TemplateV2';
  approvedVersion?: Maybe<TemplateVersion>;
  id: Scalars['ID']['output'];
  lastVersion: TemplateVersion;
  versionsV2?: Maybe<Array<Maybe<TemplateVersion>>>;
};

export type TemplateVersion = {
  __typename?: 'TemplateVersion';
  agencies?: Maybe<Array<Maybe<Agency>>>;
  allowForeignPremises?: Maybe<Scalars['Boolean']['output']>;
  allowPackageLevels?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  businessArea?: Maybe<BusinessArea>;
  certificateType?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  commodities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commodity?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationCountries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  destinationMarket: DestinationMarket;
  displayedDescription?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentRevision?: Maybe<TemplateVersion>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  effective?: Maybe<Scalars['AWSDateTime']['output']>;
  expire?: Maybe<Scalars['AWSDateTime']['output']>;
  exportCertificateType?: Maybe<CertificateType>;
  exportingCountry?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<Field>>>;
  history?: Maybe<Array<TemplateHistory>>;
  id: Scalars['ID']['output'];
  importCertificateType?: Maybe<ImportCertificateType>;
  industryAccess?: Maybe<Scalars['Boolean']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  majorVersion: Scalars['Int']['output'];
  minorVersion: Scalars['Int']['output'];
  newFileUpload: Scalars['Boolean']['output'];
  ocaAccess?: Maybe<Scalars['Boolean']['output']>;
  officialVersion?: Maybe<Scalars['Int']['output']>;
  outputSubtitle?: Maybe<Scalars['String']['output']>;
  outputSubtitleTranslation?: Maybe<Array<Maybe<Translation>>>;
  outputTitle?: Maybe<Scalars['String']['output']>;
  outputTitleTranslation?: Maybe<Array<Maybe<Translation>>>;
  pdfLayout?: Maybe<Scalars['String']['output']>;
  reasonForUpdate?: Maybe<Scalars['String']['output']>;
  release?: Maybe<Scalars['AWSDateTime']['output']>;
  s3key?: Maybe<Scalars['String']['output']>;
  s3uri?: Maybe<Scalars['String']['output']>;
  signatory?: Maybe<Scalars['String']['output']>;
  status: TemplateVersionStatus;
  submissionLayout?: Maybe<SubmissionLayoutType>;
  templateId: Scalars['String']['output'];
  templateType?: Maybe<TemplateType>;
  title: Scalars['String']['output'];
  transferCertificateType?: Maybe<TransferCertificateType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uploadInProgress: Scalars['Boolean']['output'];
};

export type TemplateVersionId = {
  __typename?: 'TemplateVersionId';
  certificateType?: Maybe<Scalars['String']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  majorVersion?: Maybe<Scalars['Int']['output']>;
  submissionLayout?: Maybe<SubmissionLayoutType>;
  templateId?: Maybe<Scalars['ID']['output']>;
};

export type TemplateVersionOutput = {
  __typename?: 'TemplateVersionOutput';
  id: Scalars['ID']['output'];
};

export type TemplateVersionOutputInput = {
  competentAuthority?: InputMaybe<CompetentAuthorityType>;
  competentAuthorityOther?: InputMaybe<Scalars['String']['input']>;
  declarationHeading?: InputMaybe<DeclarationHeadingType>;
  declarationHeadingOther?: InputMaybe<Scalars['String']['input']>;
  destinationSystem?: InputMaybe<DestinationSystem>;
  forceNzCountryOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  languages: Array<Scalars['String']['input']>;
  pdfAddendum: PdfAddendum;
  pdfLayout: PdfLayout;
  producePdf: Scalars['Boolean']['input'];
  sendToTraces?: InputMaybe<Scalars['Boolean']['input']>;
  useAllLanguages?: InputMaybe<Scalars['Boolean']['input']>;
  usePortOfCountryLanguages?: InputMaybe<Scalars['Boolean']['input']>;
  usePortOfDischargeLanguages?: InputMaybe<Scalars['Boolean']['input']>;
  usePortOfInspectionLanguages?: InputMaybe<Scalars['Boolean']['input']>;
  useTheseLanguages?: InputMaybe<Scalars['Boolean']['input']>;
  xmlLayout: XmlLayout;
};

export enum TemplateVersionStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Review = 'REVIEW',
  Suspended = 'SUSPENDED'
}

export type TemplateVersionV2 = {
  __typename?: 'TemplateVersionV2';
  declarations?: Maybe<Array<TemplateDeclarationGroup>>;
  fields?: Maybe<Array<TemplateFieldConfigurationV2>>;
  general: TemplateGeneralSettingsV2;
  output?: Maybe<TemplateOutputV2>;
  templateVersionId: Scalars['ID']['output'];
};

export type TestRegistration = {
  __typename?: 'TestRegistration';
  accountName?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nzbn?: Maybe<Scalars['String']['output']>;
  operatorDisplayName?: Maybe<Scalars['String']['output']>;
  registrationDescription?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<Scalars['String']['output']>;
  registrationTypeId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<RegistrationSource>;
};

export type TestUser = {
  __typename?: 'TestUser';
  email?: Maybe<Scalars['String']['output']>;
  g2gUser?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<UserPermission>;
  profileName?: Maybe<Scalars['String']['output']>;
  systemUser?: Maybe<Scalars['Boolean']['output']>;
  systemUsername?: Maybe<Scalars['String']['output']>;
};

export type TimeTemplate = {
  __typename?: 'TimeTemplate';
  hour: IntTemplate;
  minute: IntTemplate;
  second: Scalars['String']['output'];
};

export enum TransferCertificateType {
  AnimalProductTransfer = 'ANIMAL_PRODUCT_TRANSFER'
}

export type TransferProcessHistoryXmlResponse = {
  __typename?: 'TransferProcessHistoryXmlResponse';
  certificateNumber: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
  transferRequestId: Scalars['ID']['output'];
};

export type TransferProductDetails = {
  __typename?: 'TransferProductDetails';
  aggregatedProcessHistory?: Maybe<Array<Maybe<CoreProcessHistory>>>;
  attributes?: Maybe<CoreProductAttributes>;
  classification?: Maybe<Array<Maybe<CoreProductClassificationResponse>>>;
  commodity?: Maybe<Scalars['String']['output']>;
  containers: Array<CoreExportContainer>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  eligibilityCountries?: Maybe<Array<CoreLookup>>;
  exhausted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isSourceOf?: Maybe<Scalars['ID']['output']>;
  itemDescription?: Maybe<CoreLookup>;
  packaging?: Maybe<Array<Maybe<CorePackaging>>>;
  processHistory?: Maybe<Array<Maybe<AggregatedProcessHistory>>>;
  processes: Array<CoreProductProcess>;
  productDeclaration?: Maybe<Scalars['String']['output']>;
  productGroupId?: Maybe<Scalars['ID']['output']>;
  productItemRelation?: Maybe<Array<Maybe<CoreProductItemRelation>>>;
  productNumber?: Maybe<Scalars['String']['output']>;
  productReference?: Maybe<Scalars['String']['output']>;
  productStatement?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Measurment>;
  registrationId?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sourceProcessCount?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Array<SourcedProduct>>;
  standaloneProductNumber?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<CoreTransferProductSupportingDocument>>;
  tradeLineGroupNumber?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer supported as this was created for nested Source Products retrieval */
  transferRequestId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated No longer supported as this was created for nested Source Products retrieval */
  transferRequestNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TransferReferenceError = {
  __typename?: 'TransferReferenceError';
  errorCode: TransferReferenceErrorCode;
  errorMessage: Scalars['String']['output'];
  lineItem: Scalars['Int']['output'];
  transferNumber: Scalars['String']['output'];
};

export enum TransferReferenceErrorCode {
  Exhausted = 'EXHAUSTED',
  LineNotFound = 'LINE_NOT_FOUND',
  NotApproved = 'NOT_APPROVED',
  NotFound = 'NOT_FOUND',
  NoAccess = 'NO_ACCESS',
  TooManyReferences = 'TOO_MANY_REFERENCES'
}

export type TransferReferenceInput = {
  lineItem: Scalars['Int']['input'];
  transferNumber: Scalars['String']['input'];
};

export type TransferReferenceRequestInput = {
  references: Array<TransferReferenceInput>;
};

export type TransferReferenceResponse = {
  __typename?: 'TransferReferenceResponse';
  errors: Array<TransferReferenceError>;
  products: Array<TransferProductDetails>;
};

export type TransferRequestDetails = {
  __typename?: 'TransferRequestDetails';
  action?: Maybe<CoreHistoryTransferActions>;
  approvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<CoreExportRequestAttributes>;
  auditComment?: Maybe<Scalars['String']['output']>;
  auditedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  auditedBy?: Maybe<Scalars['String']['output']>;
  certificateNumber: Scalars['String']['output'];
  commodity: CoreCommodity;
  consignee?: Maybe<CoreRegistration>;
  consigneeRegId?: Maybe<Scalars['String']['output']>;
  consignor?: Maybe<CoreRegistration>;
  consignorRegId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  destinationCountry: CoreCountry;
  eligibility_declaration?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isExhausted?: Maybe<Scalars['Boolean']['output']>;
  products: Array<TransferProductDetails>;
  reasonForStateChangeCategories?: Maybe<Array<Maybe<CoreLookup>>>;
  reasonForStatusChange?: Maybe<Scalars['String']['output']>;
  requiresAttention?: Maybe<Scalars['Boolean']['output']>;
  status: CoreRequestStatus;
  submittedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  substatus?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<Maybe<CoreSupportingDocument>>>;
  template?: Maybe<CoreTemplate>;
  templateCode?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  thirdPartyConsignor?: Maybe<Array<Maybe<CoreLookup>>>;
  transport?: Maybe<CoreTransport>;
  uniqueConsignmentReference?: Maybe<Scalars['String']['output']>;
  unofficialInformation?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  updatedBySystem?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<CoreLookup>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TransferRequestDetailsInput = {
  transferId: Scalars['ID']['input'];
};

export type TransferRequestHistoryInput = {
  transferRequestId: Scalars['ID']['input'];
};

export type TransferRequestHistoryRecord = {
  __typename?: 'TransferRequestHistoryRecord';
  action?: Maybe<Scalars['String']['output']>;
  autoApproved?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  nzxmlURI?: Maybe<Scalars['String']['output']>;
  reasonCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reasonForStatusChange?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  substatus?: Maybe<Scalars['String']['output']>;
  templateVersionId?: Maybe<Scalars['ID']['output']>;
  transferRequestId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  updatedByProfileFullName?: Maybe<Scalars['String']['output']>;
  updatedByProfileName?: Maybe<Scalars['String']['output']>;
  updatedBySystem?: Maybe<Scalars['String']['output']>;
};

export type Translation = {
  __typename?: 'Translation';
  lang: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type TranslationInput = {
  lang: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum TransportModeCode {
  AirTransport = 'AIR_TRANSPORT',
  FixedTransportInstallation = 'FIXED_TRANSPORT_INSTALLATION',
  InlandWaterTransport = 'INLAND_WATER_TRANSPORT',
  Mail = 'MAIL',
  MaritimeTransport = 'MARITIME_TRANSPORT',
  MultimodalTransport = 'MULTIMODAL_TRANSPORT',
  NotApplicable = 'NOT_APPLICABLE',
  NotSpecified = 'NOT_SPECIFIED',
  RailTransport = 'RAIL_TRANSPORT',
  RoadTransport = 'ROAD_TRANSPORT'
}

export type TransportMovementCodeTemplate = {
  __typename?: 'TransportMovementCodeTemplate';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TreatmentTemplate = {
  __typename?: 'TreatmentTemplate';
  full_information?: Maybe<Scalars['String']['output']>;
};

export type UpdateApprovedTransferTransportInput = {
  thirdPartyAccess?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  transferId: Scalars['ID']['input'];
  transport?: InputMaybe<CoreTransportInput>;
};

export type UpdateApprovedTransferTransportResponse = {
  __typename?: 'UpdateApprovedTransferTransportResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdatePrintReasonInput = {
  exportRequestId: Scalars['ID']['input'];
  exportRequestOutputId: Scalars['ID']['input'];
  printReason: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrintReasonResponse = {
  __typename?: 'UpdatePrintReasonResponse';
  createdAt: Scalars['AWSDateTime']['output'];
  exportRequestOutputId: Scalars['ID']['output'];
  outputEventId: Scalars['ID']['output'];
  reasonForReprinting: Scalars['String']['output'];
};

export type UpdateSupportingDocumentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  documentReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  foreignManufacturePremises?: InputMaybe<Scalars['String']['input']>;
  foreignPremisesId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  identificationMarks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intendedOperators?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>;
  nzManufacturePremises?: InputMaybe<Scalars['String']['input']>;
  originCountry?: InputMaybe<CoreLookupInput>;
  primaryOperator?: InputMaybe<CoreLookupInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productionDates?: InputMaybe<Array<InputMaybe<CoreDateRangeInput>>>;
  reason: Scalars['String']['input'];
};

export type UpdateSupportingDocumentResult = {
  __typename?: 'UpdateSupportingDocumentResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  supportingDocument?: Maybe<CoreSupportingDocument>;
};

export type UpdateTemplateGeneralInput = {
  agencies?: InputMaybe<Array<InputMaybe<AgencyInput>>>;
  allowForeignPremises?: InputMaybe<Scalars['Boolean']['input']>;
  allowPackageLevels?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  businessArea?: InputMaybe<BusinessArea>;
  code: Scalars['String']['input'];
  commodities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  commodity: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  destinationCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  displayedDescription: Scalars['String']['input'];
  effective?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expire?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exportCertificateType?: InputMaybe<CertificateType>;
  exportingCountry?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  importCertificateType?: InputMaybe<ImportCertificateType>;
  industryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  majorVersion: Scalars['Int']['input'];
  minorVersion: Scalars['Int']['input'];
  ocaAccess?: InputMaybe<Scalars['Boolean']['input']>;
  officialVersion?: InputMaybe<Scalars['Int']['input']>;
  outputSubtitle?: InputMaybe<Scalars['String']['input']>;
  outputSubtitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  outputTitle?: InputMaybe<Scalars['String']['input']>;
  outputTitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  reasonForUpdate?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['AWSDateTime']['input']>;
  signatory?: InputMaybe<Scalars['String']['input']>;
  skipCopyFor?: InputMaybe<Array<InputMaybe<TemplateSectionType>>>;
  status?: InputMaybe<TemplateVersionStatus>;
  submissionLayout: SubmissionLayoutType;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};

export type UpdateTemplateInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  businessArea?: InputMaybe<BusinessArea>;
  code: Scalars['String']['input'];
  commodities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  commodity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationMarket: DestinationMarket;
  displayedDescription?: InputMaybe<Scalars['String']['input']>;
  effective?: InputMaybe<Scalars['AWSDateTime']['input']>;
  expire?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exportCertificateType?: InputMaybe<CertificateType>;
  id: Scalars['ID']['input'];
  importCertificateType?: InputMaybe<ImportCertificateType>;
  majorVersion: Scalars['Int']['input'];
  minorVersion: Scalars['Int']['input'];
  reasonForUpdate?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  transferCertificateType?: InputMaybe<TransferCertificateType>;
};

export type UploadReferenceDataInput = {
  listCode: Scalars['String']['input'];
};

export type UploadReferenceDataResponse = {
  __typename?: 'UploadReferenceDataResponse';
  fields: Array<PresignedPostField>;
  presignedUrl: Scalars['String']['output'];
  s3Location: Scalars['String']['output'];
};

export type UpsertTemplateProcessGroupConfigInput = {
  dateFormat?: InputMaybe<DateFormat>;
  dateRange?: InputMaybe<DateRange>;
  defaultAction?: InputMaybe<DefaultAction>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeOverseasProcesses?: InputMaybe<Scalars['Boolean']['input']>;
  isPDF?: InputMaybe<Scalars['Boolean']['input']>;
  isXML?: InputMaybe<Scalars['Boolean']['input']>;
  operatorActivityType?: InputMaybe<Scalars['String']['input']>;
  pdfSettings?: InputMaybe<ProcessGroupCaptionSettingsInput>;
  premisesAddressFormat?: InputMaybe<PremisesAddressFormat>;
  premisesRange?: InputMaybe<PremisesRange>;
  processGroupId: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
  width?: InputMaybe<DisplayedBoxWidth>;
  xmlSettings?: InputMaybe<ProcessGroupCaptionSettingsInput>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UserDetailsById = {
  __typename?: 'UserDetailsById';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  registrations: Array<Scalars['String']['output']>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  agencyId?: Maybe<Scalars['ID']['output']>;
  constraintType?: Maybe<PermissionConstraintType>;
  constraintValue?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<RoleName>;
};

export type UserPermissionInput = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  constraintType: PermissionConstraintType;
  constraintValue: Scalars['String']['input'];
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  role: RoleName;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  organisationName?: Maybe<Scalars['String']['output']>;
  organisationPartyId: Scalars['ID']['output'];
  organisationPrimaryAddress?: Maybe<B2GAddress>;
  /** @deprecated Use registrationIdentifier */
  registartionNumberId?: Maybe<Scalars['String']['output']>;
  registrationIdentifier?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use registrationNumber */
  registrationNumberValue?: Maybe<Scalars['String']['output']>;
  userContactId?: Maybe<Scalars['ID']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userPrimaryPhone?: Maybe<Scalars['String']['output']>;
};

export type Validation = {
  __typename?: 'Validation';
  errorType: ValidationErrorType;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export enum ValidationErrorType {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export type VolumeAdjustmentInput = {
  productId: Scalars['ID']['input'];
  volumeAdjustment: ManualVolumeAdjustmentInput;
};

export type VolumeAdjustmentResponse = {
  __typename?: 'VolumeAdjustmentResponse';
  productId: Scalars['ID']['output'];
  volumeAdjustment: ManualVolumeAdjustment;
};

export type VolumeMeasureTemplate = IMeasureTemplate & {
  __typename?: 'VolumeMeasureTemplate';
  as_number: Scalars['Float']['output'];
  in_litres?: Maybe<MeasureTemplate>;
  mpi_unit?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  three_decimals?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type WineAnalytesTolerancesInput = {
  chemistryTest?: InputMaybe<Scalars['String']['input']>;
  dealcoholisedWine?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  red?: InputMaybe<Scalars['Boolean']['input']>;
  shippingFormat?: InputMaybe<WinePackaging>;
  wineCategory?: InputMaybe<Scalars['String']['input']>;
};

export type WineAnalytesTolerancesResponse = {
  __typename?: 'WineAnalytesTolerancesResponse';
  destinationMarket?: Maybe<DestinationMarket>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
};

export type WineAnalytesTolerancesResponseInput = {
  dealcoholisedWine?: InputMaybe<Scalars['String']['input']>;
  red: Scalars['Boolean']['input'];
  shippingFormat: WinePackaging;
  testResults: Array<ChemistryTest>;
  wineCategory?: InputMaybe<Scalars['String']['input']>;
};

export type WineAnalytesTolerancesResponseRowInput = {
  destinationMarket?: InputMaybe<DestinationMarket>;
};

export type WineAnalytesTolerancesType = DecisionTableBaseInput & {
  __typename?: 'WineAnalytesTolerancesType';
  chemistryTest?: Maybe<Scalars['String']['output']>;
  dealcoholisedWine?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  red?: Maybe<Scalars['Boolean']['output']>;
  shippingFormat?: Maybe<WinePackaging>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
  wineCategory?: Maybe<Scalars['String']['output']>;
};

export type WineChemistryTemplate = {
  __typename?: 'WineChemistryTemplate';
  actual_alcohol_content?: Maybe<MeasureTemplate>;
  citric_acidity?: Maybe<MeasureTemplate>;
  laboratory?: Maybe<SpsPartyTemplate>;
  laboratory_reference?: Maybe<Scalars['String']['output']>;
  methyl_alcohol?: Maybe<MeasureTemplate>;
  reduced_dry_extract?: Maybe<MeasureTemplate>;
  sugar_content?: Maybe<MeasureTemplate>;
  sugar_content_qualifier?: Maybe<Scalars['String']['output']>;
  total_acidity_7_0?: Maybe<MeasureTemplate>;
  total_acidity_8_2_meql?: Maybe<MeasureTemplate>;
  total_alcoholic_strength?: Maybe<MeasureTemplate>;
  total_dry_extract?: Maybe<MeasureTemplate>;
  total_sulphates?: Maybe<MeasureTemplate>;
  total_sulphur_dioxide?: Maybe<MeasureTemplate>;
  volatile_acidity?: Maybe<MeasureTemplate>;
  volatile_acidity_meql?: Maybe<MeasureTemplate>;
};

export type WineConsignment = {
  __typename?: 'WineConsignment';
  cases?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use producer */
  exporter?: Maybe<SpsWineExporter>;
  is_bulk?: Maybe<Scalars['String']['output']>;
  net_volume?: Maybe<Scalars['String']['output']>;
  producer?: Maybe<SpsWineExporter>;
};

export type WineConsignmentTemplate = {
  __typename?: 'WineConsignmentTemplate';
  cases?: Maybe<IntTemplate>;
  /** @deprecated Use producer */
  exporter?: Maybe<SpsPartyTemplate>;
  is_bulk?: Maybe<Scalars['String']['output']>;
  net_volume?: Maybe<MeasureTemplate>;
  producer?: Maybe<SpsPartyTemplate>;
};

export enum WineDisputedReason {
  Malodorous = 'MALODOROUS',
  Oxidised = 'OXIDISED',
  Tainted = 'TAINTED'
}

export type WineFieldsTemplate = {
  __typename?: 'WineFieldsTemplate';
  batch_number?: Maybe<Scalars['String']['output']>;
  bottler_reference?: Maybe<Scalars['String']['output']>;
  br_brand_name?: Maybe<Scalars['String']['output']>;
  br_classification?: Maybe<BrClassificationTemplate>;
  chemistry?: Maybe<WineChemistryTemplate>;
  colour?: Maybe<Scalars['String']['output']>;
  eu_category?: Maybe<Scalars['String']['output']>;
  eu_ingredients?: Maybe<EuIngredientsTemplate>;
  geographic_indication?: Maybe<Scalars['String']['output']>;
  grape_variety?: Maybe<Scalars['String']['output']>;
  is_dealcoholised?: Maybe<Scalars['String']['output']>;
  is_eu_eligible?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  package?: Maybe<PackageTemplate>;
  special_process?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
  wine_description?: Maybe<Scalars['String']['output']>;
};

export enum WinePackaging {
  Cs = 'CS',
  Ft = 'FT'
}

export type WineProductFieldInput = {
  certificateType?: InputMaybe<CertificateType>;
  destinationMarket?: InputMaybe<DestinationMarket>;
};

export type WineProductFieldType = DecisionTableBaseInput & {
  __typename?: 'WineProductFieldType';
  certificateType?: Maybe<CertificateType>;
  destinationMarket?: Maybe<DestinationMarket>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type Winemaking = {
  __typename?: 'Winemaking';
  confirmations?: Maybe<Array<Maybe<WinemakingConfirmation>>>;
  status?: Maybe<ProcessStatus>;
  wsmp?: Maybe<Scalars['ID']['output']>;
};

export type WinemakingConfirmation = {
  __typename?: 'WinemakingConfirmation';
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  disputedReason?: Maybe<Scalars['String']['output']>;
  disputedResolution?: Maybe<Scalars['String']['output']>;
  market: DestinationMarket;
  status: WinemakingStatus;
};

export type WinemakingConfirmationInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  disputedReason?: InputMaybe<Scalars['String']['input']>;
  disputedResolution?: InputMaybe<Scalars['String']['input']>;
  market: DestinationMarket;
};

export enum WinemakingStatus {
  Confirmed = 'CONFIRMED',
  Disputed = 'DISPUTED',
  NotApplicable = 'NOT_APPLICABLE',
  Requested = 'REQUESTED'
}

export enum XmlLayout {
  EuCatchXml = 'EU_CATCH_XML',
  EuImportXml = 'EU_IMPORT_XML',
  EuProcStatementXml = 'EU_PROC_STATEMENT_XML',
  EuTransitXml = 'EU_TRANSIT_XML',
  IppcPhytoXml = 'IPPC_PHYTO_XML',
  None = 'NONE',
  Official_2_9_1 = 'OFFICIAL_2_9_1',
  Uncefact = 'UNCEFACT'
}

export type XmlSettings = {
  __typename?: 'XMLSettings';
  caption?: Maybe<Scalars['String']['output']>;
  captionId?: Maybe<Scalars['ID']['output']>;
  defaultOption?: Maybe<XmlDefaultOption>;
  order?: Maybe<Scalars['Int']['output']>;
  xmlColumnsToDisplay?: Maybe<ColumnsToDisplay>;
};

export type XmlSettingsInput = {
  caption?: InputMaybe<Scalars['ID']['input']>;
  defaultOption?: InputMaybe<XmlDefaultOption>;
  order?: InputMaybe<Scalars['Int']['input']>;
  xmlColumnsToDisplay?: InputMaybe<ColumnsToDisplay>;
};

export enum XmlDefaultOption {
  NotApplicable = 'NOT_APPLICABLE',
  TagNotIncluded = 'TAG_NOT_INCLUDED',
  Xxxxxx = 'XXXXXX'
}

export enum XmlRequestType {
  ApExport = 'AP_EXPORT',
  PhytoExport = 'PHYTO_EXPORT',
  Transfer = 'TRANSFER'
}

export type AddProductAndProcessFromTransferInput = {
  products: Array<Scalars['String']['input']>;
  transferId: Scalars['ID']['input'];
};

export type AwsS3PostUploadUrl = {
  __typename?: 'awsS3PostUploadUrl';
  fields: Array<AwsS3Fields>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GetDeclarationInputsResponse = {
  __typename?: 'getDeclarationInputsResponse';
  statementInputs: Scalars['Int']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  PackagingRun: ( BottlingRunData ) | ( FlexiFillingRunData );
  ProcessAttributesResponse: ( ChemistryTestResponse ) | ( Omit<Packaging, 'runs'> & { runs: Array<_RefType['PackagingRun']> } ) | ( SensoryProcessRequest ) | ( Winemaking );
  RulesInput: ( DeclarationsType ) | ( EligibilityType ) | ( ExportCertificateWorkflowType ) | ( ImportConnectionsType ) | ( PhytoOcaEmailNotificationsType ) | ( ProductFieldType ) | ( WineAnalytesTolerancesType ) | ( WineProductFieldType );
  RulesResponse: ( DeclarationsResponse ) | ( EligibilityResponse ) | ( ExportCertificateWorkflowResponse ) | ( ImportConnectionsResponse ) | ( PhytoOcaEmailNotificationsResponse ) | ( ProductFieldResponse ) | ( WineAnalytesTolerancesResponse );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  CoreRequest: ( CoreExportRequest ) | ( CoreTransferRequest );
  DecisionTableBaseInput: ( DeclarationsType ) | ( EligibilityType ) | ( ExportCertificateWorkflowType ) | ( ImportConnectionsType ) | ( PhytoOcaEmailNotificationsType ) | ( ProductFieldType ) | ( WineAnalytesTolerancesType ) | ( WineProductFieldType );
  IConfig: ( BusinessRulesConfig ) | ( DfeConfig );
  IConfigBase: ( BusinessRulesConfig ) | ( DfeConfig ) | ( DfeTemplateInfo );
  IConfigField: ( BusinessRuleField ) | ( DfeField );
  IDfeValidationRules: never;
  IMeasureTemplate: ( MeasureTemplate ) | ( VolumeMeasureTemplate );
  ITemplateProcessGroup: never;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>;
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>;
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  ActiveTemplateResult: ResolverTypeWrapper<ActiveTemplateResult>;
  AddressTypeCode: AddressTypeCode;
  Agency: ResolverTypeWrapper<Agency>;
  AgencyInput: AgencyInput;
  AgencyType: AgencyType;
  AggregatedProcessHistory: ResolverTypeWrapper<AggregatedProcessHistory>;
  Announcement: ResolverTypeWrapper<Announcement>;
  AnnouncementList: ResolverTypeWrapper<AnnouncementList>;
  AnnouncementListInput: AnnouncementListInput;
  AnnouncementStatus: AnnouncementStatus;
  ApprovalToReplaceExportCertificateRequestInput: ApprovalToReplaceExportCertificateRequestInput;
  ApproveCertificateRequestInput: ApproveCertificateRequestInput;
  ApprovedProductRequest: ResolverTypeWrapper<ApprovedProductRequest>;
  ApprovedProductRequestInput: ApprovedProductRequestInput;
  AuthenticationType: AuthenticationType;
  AvailableTemplateFields: ResolverTypeWrapper<AvailableTemplateFields>;
  AwsS3Fields: ResolverTypeWrapper<AwsS3Fields>;
  B2GAddress: ResolverTypeWrapper<B2GAddress>;
  B2GAddressInput: B2GAddressInput;
  B2GAuthentication: ResolverTypeWrapper<B2GAuthentication>;
  B2GAuthenticationInput: B2GAuthenticationInput;
  B2GBanWineBatchInput: B2GBanWineBatchInput;
  B2GCertificateDelivery: ResolverTypeWrapper<B2GCertificateDelivery>;
  B2GCertificateDeliveryInput: B2GCertificateDeliveryInput;
  B2GCertificateDeliveryMethod: B2GCertificateDeliveryMethod;
  B2GClassification: ResolverTypeWrapper<B2GClassification>;
  B2GClassificationInput: B2GClassificationInput;
  B2GClause: ResolverTypeWrapper<B2GClause>;
  B2GClauseInput: B2GClauseInput;
  B2GCollectionMethod: B2GCollectionMethod;
  B2GConsignment: ResolverTypeWrapper<B2GConsignment>;
  B2GConsignmentInput: B2GConsignmentInput;
  B2GContact: ResolverTypeWrapper<B2GContact>;
  B2GContactInput: B2GContactInput;
  B2GContainer: ResolverTypeWrapper<B2GContainer>;
  B2GContainerInput: B2GContainerInput;
  B2GCountry: ResolverTypeWrapper<B2GCountry>;
  B2GCountryInput: B2GCountryInput;
  B2GCountrySubDivision: ResolverTypeWrapper<B2GCountrySubDivision>;
  B2GCountrySubDivisionInput: B2GCountrySubDivisionInput;
  B2GDeclaration: ResolverTypeWrapper<B2GDeclaration>;
  B2GDeclarationInput: B2GDeclarationInput;
  B2GEligibilityCriteriaMet: ResolverTypeWrapper<B2GEligibilityCriteriaMet>;
  B2GEligibilityCriteriaMetInput: B2GEligibilityCriteriaMetInput;
  B2GEligibilityStatus: ResolverTypeWrapper<B2GEligibilityStatus>;
  B2GEligibilityStatusType: B2GEligibilityStatusType;
  B2GError: B2GError;
  B2GExportCertificateRequest: ResolverTypeWrapper<B2GExportCertificateRequest>;
  B2GExportCertificateRequestInput: B2GExportCertificateRequestInput;
  B2GExportCertificatesDownloadUrl: ResolverTypeWrapper<B2GExportCertificatesDownloadUrl>;
  B2GExporterDeclaration: ResolverTypeWrapper<B2GExporterDeclaration>;
  B2GExporterDeclarationInput: B2GExporterDeclarationInput;
  B2GLocation: ResolverTypeWrapper<B2GLocation>;
  B2GLocationInput: B2GLocationInput;
  B2GNote: ResolverTypeWrapper<B2GNote>;
  B2GNoteInput: B2GNoteInput;
  B2GPackage: ResolverTypeWrapper<B2GPackage>;
  B2GPackageInput: B2GPackageInput;
  B2GParty: ResolverTypeWrapper<B2GParty>;
  B2GPartyInput: B2GPartyInput;
  B2GPeriod: ResolverTypeWrapper<B2GPeriod>;
  B2GPeriodInput: B2GPeriodInput;
  B2GPerson: ResolverTypeWrapper<B2GPerson>;
  B2GPersonInput: B2GPersonInput;
  B2GPremise: ResolverTypeWrapper<B2GPremise>;
  B2GPremiseInput: B2GPremiseInput;
  B2GProcess: ResolverTypeWrapper<B2GProcess>;
  B2GProcessCharacteristic: ResolverTypeWrapper<B2GProcessCharacteristic>;
  B2GProcessCharacteristicInput: B2GProcessCharacteristicInput;
  B2GProcessInput: B2GProcessInput;
  B2GProduct: ResolverTypeWrapper<B2GProduct>;
  B2GProductEligibility: ResolverTypeWrapper<B2GProductEligibility>;
  B2GProductEligibilityCriteriaV2: ResolverTypeWrapper<B2GProductEligibilityCriteriaV2>;
  B2GProductEligibilityInput: B2GProductEligibilityInput;
  B2GProductEvent: ResolverTypeWrapper<B2GProductEvent>;
  B2GProductEventType: B2GProductEventType;
  B2GProductInput: B2GProductInput;
  B2GProductsDownloadUrl: ResolverTypeWrapper<B2GProductsDownloadUrl>;
  B2GQualification: ResolverTypeWrapper<B2GQualification>;
  B2GQualificationInput: B2GQualificationInput;
  B2GReferencedDocument: ResolverTypeWrapper<B2GReferencedDocument>;
  B2GReferencedDocumentInput: B2GReferencedDocumentInput;
  B2GRegistrationDetails: ResolverTypeWrapper<B2GRegistrationDetails>;
  B2GRegistrationDetailsInput: B2GRegistrationDetailsInput;
  B2GSeal: ResolverTypeWrapper<B2GSeal>;
  B2GSealInput: B2GSealInput;
  B2GTemperature: ResolverTypeWrapper<B2GTemperature>;
  B2GTemperatureInput: B2GTemperatureInput;
  B2GTradeLineItem: ResolverTypeWrapper<B2GTradeLineItem>;
  B2GTradeLineItemContainer: ResolverTypeWrapper<B2GTradeLineItemContainer>;
  B2GTradeLineItemContainerInput: B2GTradeLineItemContainerInput;
  B2GTradeLineItemInput: B2GTradeLineItemInput;
  B2GTransportMovement: ResolverTypeWrapper<B2GTransportMovement>;
  B2GTransportMovementInput: B2GTransportMovementInput;
  B2GValidationErrors: ResolverTypeWrapper<B2GValidationErrors>;
  B2GWineChemistry: ResolverTypeWrapper<B2GWineChemistry>;
  B2GWineConsignment: ResolverTypeWrapper<B2GWineConsignment>;
  B2GWineConsignmentInput: B2GWineConsignmentInput;
  B2GWineFields: ResolverTypeWrapper<B2GWineFields>;
  B2GWineFieldsInput: B2GWineFieldsInput;
  B2GWinePackage: ResolverTypeWrapper<B2GWinePackage>;
  B2GWinePackageInput: B2GWinePackageInput;
  BRClassification: ResolverTypeWrapper<BrClassification>;
  BRClassificationInput: BrClassificationInput;
  BRClassificationTemplate: ResolverTypeWrapper<BrClassificationTemplate>;
  Block: ResolverTypeWrapper<Block>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BottlingRunData: ResolverTypeWrapper<BottlingRunData>;
  BottlingRunDataInput: BottlingRunDataInput;
  BottlingRunInput: BottlingRunInput;
  BottlingRunResponse: ResolverTypeWrapper<BottlingRunResponse>;
  BusinessArea: BusinessArea;
  BusinessRule: ResolverTypeWrapper<BusinessRule>;
  BusinessRuleConfigInput: BusinessRuleConfigInput;
  BusinessRuleField: ResolverTypeWrapper<BusinessRuleField>;
  BusinessRuleFieldInput: BusinessRuleFieldInput;
  BusinessRuleInput: BusinessRuleInput;
  BusinessRulesConfig: ResolverTypeWrapper<BusinessRulesConfig>;
  CTAssayTestDataInput: CtAssayTestDataInput;
  CTCancellationDataInput: CtCancellationDataInput;
  CTCancelledDataInput: CtCancelledDataInput;
  CTCompoundDataInput: CtCompoundDataInput;
  CTErrorDataInput: CtErrorDataInput;
  CTFailStatusDataInput: CtFailStatusDataInput;
  CTFirstReportedDateDataInput: CtFirstReportedDateDataInput;
  CTInProgressStatusDataInput: CtInProgressStatusDataInput;
  CTNCancellationErrorDataInput: CtnCancellationErrorDataInput;
  CTNoOrgErrorDataInput: CtNoOrgErrorDataInput;
  CTPassStatusDataInput: CtPassStatusDataInput;
  CTRepetitionDataInput: CtRepetitionDataInput;
  CTRequestedStatusDataInput: CtRequestedStatusDataInput;
  CTStatusEventType: CtStatusEventType;
  CTUnsuitableStatusDataInput: CtUnsuitableStatusDataInput;
  CancelExportCertificateRequestInput: CancelExportCertificateRequestInput;
  CancelSupportingDocumentInput: CancelSupportingDocumentInput;
  CancelledProcessInput: CancelledProcessInput;
  CancelledProcessResponse: ResolverTypeWrapper<CancelledProcessResponse>;
  CargoTypeClassificationCode: CargoTypeClassificationCode;
  CertificateCollectionInput: CertificateCollectionInput;
  CertificateCollectionOutput: ResolverTypeWrapper<CertificateCollectionOutput>;
  CertificateType: CertificateType;
  ChangeExportRequestAction: ChangeExportRequestAction;
  ChangeExportRequestStatus: ChangeExportRequestStatus;
  ChangeExportRequestStatusInput: ChangeExportRequestStatusInput;
  ChangeExportRequestStatusResponse: ResolverTypeWrapper<ChangeExportRequestStatusResponse>;
  ChangeTransferRequestAmendmentStatusInput: ChangeTransferRequestAmendmentStatusInput;
  ChangeTransferRequestAmendmentStatusResponse: ResolverTypeWrapper<ChangeTransferRequestAmendmentStatusResponse>;
  ChangeTransferRequestStatus: ChangeTransferRequestStatus;
  ChangeTransferRequestStatusInput: ChangeTransferRequestStatusInput;
  ChangeTransferRequestStatusResponse: ResolverTypeWrapper<ChangeTransferRequestStatusResponse>;
  CheckUserAccessInput: CheckUserAccessInput;
  CheckUserAccessResponse: ResolverTypeWrapper<CheckUserAccessResponse>;
  ChemistryTest: ChemistryTest;
  ChemistryTestEventDataInput: ChemistryTestEventDataInput;
  ChemistryTestInput: ChemistryTestInput;
  ChemistryTestReceipt: ResolverTypeWrapper<ChemistryTestReceipt>;
  ChemistryTestRequest: ResolverTypeWrapper<ChemistryTestRequest>;
  ChemistryTestRequestInput: ChemistryTestRequestInput;
  ChemistryTestResponse: ResolverTypeWrapper<ChemistryTestResponse>;
  ChemistryTestResult: ResolverTypeWrapper<ChemistryTestResult>;
  ChemistryTestStatus: ChemistryTestStatus;
  ColumnsToDisplay: ColumnsToDisplay;
  CombinedPartyTemplate: ResolverTypeWrapper<CombinedPartyTemplate>;
  CompetentAuthorityType: CompetentAuthorityType;
  ConfirmPackagingInput: ConfirmPackagingInput;
  ConfirmPackagingResponse: ResolverTypeWrapper<ConfirmPackagingResponse>;
  ConfirmWinemakingInput: ConfirmWinemakingInput;
  ConnectionType: ConnectionType;
  ConsignorDetails: ResolverTypeWrapper<ConsignorDetails>;
  ConsignorIdentifier: ResolverTypeWrapper<ConsignorIdentifier>;
  CoreAddress: ResolverTypeWrapper<CoreAddress>;
  CoreB2GFile: ResolverTypeWrapper<CoreB2GFile>;
  CoreB2GFileInput: CoreB2GFileInput;
  CoreCommodity: ResolverTypeWrapper<CoreCommodity>;
  CoreContainer: ResolverTypeWrapper<CoreContainer>;
  CoreContainerInput: CoreContainerInput;
  CoreCountry: ResolverTypeWrapper<CoreCountry>;
  CoreDateRange: ResolverTypeWrapper<CoreDateRange>;
  CoreDateRangeInput: CoreDateRangeInput;
  CoreDeclarationInputValueOutput: ResolverTypeWrapper<CoreDeclarationInputValueOutput>;
  CoreDeclarationOutput: ResolverTypeWrapper<CoreDeclarationOutput>;
  CoreDeclarationTranslatedText: ResolverTypeWrapper<CoreDeclarationTranslatedText>;
  CoreExportCertificateType: CoreExportCertificateType;
  CoreExportContainer: ResolverTypeWrapper<CoreExportContainer>;
  CoreExportDetails: ResolverTypeWrapper<CoreExportDetails>;
  CoreExportRequest: ResolverTypeWrapper<CoreExportRequest>;
  CoreExportRequestAddress: CoreExportRequestAddress;
  CoreExportRequestAddressType: ResolverTypeWrapper<CoreExportRequestAddressType>;
  CoreExportRequestAttributes: ResolverTypeWrapper<CoreExportRequestAttributes>;
  CoreExportRequestAttributesInput: CoreExportRequestAttributesInput;
  CoreExportRequestImporter: CoreExportRequestImporter;
  CoreExportRequestImporterType: ResolverTypeWrapper<CoreExportRequestImporterType>;
  CoreExportRequestInput: CoreExportRequestInput;
  CoreExportRequestParty: CoreExportRequestParty;
  CoreExportRequestPartyType: ResolverTypeWrapper<CoreExportRequestPartyType>;
  CoreExportSupportingDocuments: ResolverTypeWrapper<CoreExportSupportingDocuments>;
  CoreExportSupportingDocumentsInput: CoreExportSupportingDocumentsInput;
  CoreExportTransport: ResolverTypeWrapper<CoreExportTransport>;
  CoreGroup: ResolverTypeWrapper<CoreGroup>;
  CoreHistoryExportActions: CoreHistoryExportActions;
  CoreHistoryTransferActions: CoreHistoryTransferActions;
  CoreLocation: ResolverTypeWrapper<CoreLocation>;
  CoreLookup: ResolverTypeWrapper<CoreLookup>;
  CoreLookupInput: CoreLookupInput;
  CorePackaging: ResolverTypeWrapper<CorePackaging>;
  CorePrintDetails: ResolverTypeWrapper<CorePrintDetails>;
  CoreProcessAttributes: ResolverTypeWrapper<CoreProcessAttributes>;
  CoreProcessAttributesInput: CoreProcessAttributesInput;
  CoreProcessHistory: ResolverTypeWrapper<CoreProcessHistory>;
  CoreProcessTypeLookup: ResolverTypeWrapper<CoreProcessTypeLookup>;
  CoreProduct: ResolverTypeWrapper<CoreProduct>;
  CoreProductAttributes: ResolverTypeWrapper<CoreProductAttributes>;
  CoreProductAttributesInput: CoreProductAttributesInput;
  CoreProductClassificationInput: CoreProductClassificationInput;
  CoreProductClassificationResponse: ResolverTypeWrapper<CoreProductClassificationResponse>;
  CoreProductItemGroup: ResolverTypeWrapper<CoreProductItemGroup>;
  CoreProductItemInput: CoreProductItemInput;
  CoreProductItemRelation: ResolverTypeWrapper<CoreProductItemRelation>;
  CoreProductProcess: ResolverTypeWrapper<CoreProductProcess>;
  CoreProductProcessInput: CoreProductProcessInput;
  CoreProductRefrence: CoreProductRefrence;
  CoreProductSupportingDocumentInput: CoreProductSupportingDocumentInput;
  CoreReferencedDocument: ResolverTypeWrapper<CoreReferencedDocument>;
  CoreReferencedDocumentUrl: ResolverTypeWrapper<CoreReferencedDocumentUrl>;
  CoreRegistration: ResolverTypeWrapper<CoreRegistration>;
  CoreRequest: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CoreRequest']>;
  CoreRequestStatus: ResolverTypeWrapper<CoreRequestStatus>;
  CoreRequestSubstatus: ResolverTypeWrapper<CoreRequestSubstatus>;
  CoreRequestType: CoreRequestType;
  CoreStatus: CoreStatus;
  CoreSubstatus: CoreSubstatus;
  CoreSupportingDocument: ResolverTypeWrapper<CoreSupportingDocument>;
  CoreSupportingDocumentInput: CoreSupportingDocumentInput;
  CoreTemplate: ResolverTypeWrapper<CoreTemplate>;
  CoreTransferProductSupportingDocument: ResolverTypeWrapper<CoreTransferProductSupportingDocument>;
  CoreTransferRequest: ResolverTypeWrapper<CoreTransferRequest>;
  CoreTransferRequestInput: CoreTransferRequestInput;
  CoreTransport: ResolverTypeWrapper<CoreTransport>;
  CoreTransportInput: CoreTransportInput;
  Country: Country;
  CreateAnnouncementInput: CreateAnnouncementInput;
  CreateDfeConfigRequest: ResolverTypeWrapper<CreateDfeConfigRequest>;
  CreateDfeConfigResponse: ResolverTypeWrapper<CreateDfeConfigResponse>;
  CreateTemplateGeneralInput: CreateTemplateGeneralInput;
  CreateTemplateInput: CreateTemplateInput;
  CreateTestRegistrationInput: CreateTestRegistrationInput;
  CreateTestUserInput: CreateTestUserInput;
  CreateUserInput: CreateUserInput;
  CustomLookupType: CustomLookupType;
  CustomsPermitNumberUsage: ResolverTypeWrapper<CustomsPermitNumberUsage>;
  DFEForm: ResolverTypeWrapper<DfeForm>;
  DFEPermission: ResolverTypeWrapper<DfePermission>;
  DateFormat: DateFormat;
  DateRange: DateRange;
  DateTemplate: ResolverTypeWrapper<DateTemplate>;
  DateTimeTemplate: ResolverTypeWrapper<DateTimeTemplate>;
  DecimalTemplate: ResolverTypeWrapper<DecimalTemplate>;
  DecisionTable: ResolverTypeWrapper<Omit<DecisionTable, 'approvedRevision' | 'lastRevision' | 'revisions'> & { approvedRevision?: Maybe<ResolversTypes['DecisionTableRevision']>, lastRevision?: Maybe<ResolversTypes['DecisionTableRevision']>, revisions: Array<ResolversTypes['DecisionTableRevision']> }>;
  DecisionTableBaseInput: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['DecisionTableBaseInput']>;
  DecisionTableColumn: ResolverTypeWrapper<DecisionTableColumn>;
  DecisionTableDataType: DecisionTableDataType;
  DecisionTableExpectation: ResolverTypeWrapper<Omit<DecisionTableExpectation, 'input' | 'response'> & { input: ResolversTypes['RulesInput'], response: ResolversTypes['RulesResponse'] }>;
  DecisionTableField: ResolverTypeWrapper<DecisionTableField>;
  DecisionTableFilter: DecisionTableFilter;
  DecisionTableRevision: ResolverTypeWrapper<Omit<DecisionTableRevision, 'expectations' | 'rows'> & { expectations: Array<ResolversTypes['DecisionTableExpectation']>, rows: Array<ResolversTypes['DecisionTableRow']> }>;
  DecisionTableRevisionInput: DecisionTableRevisionInput;
  DecisionTableRevisionStatus: DecisionTableRevisionStatus;
  DecisionTableRow: ResolverTypeWrapper<Omit<DecisionTableRow, 'input' | 'response'> & { input: ResolversTypes['RulesInput'], response: ResolversTypes['RulesResponse'] }>;
  DecisionTableRowInput: DecisionTableRowInput;
  DecisionTableTestResult: ResolverTypeWrapper<DecisionTableTestResult>;
  DeclarationFormletFields: ResolverTypeWrapper<DeclarationFormletFields>;
  DeclarationFormletSection: ResolverTypeWrapper<DeclarationFormletSection>;
  DeclarationGroupNumbering: DeclarationGroupNumbering;
  DeclarationGroupType: DeclarationGroupType;
  DeclarationHeadingType: DeclarationHeadingType;
  DeclarationInput: DeclarationInput;
  DeclarationInputValueInput: DeclarationInputValueInput;
  DeclarationInputValueOutput: ResolverTypeWrapper<DeclarationInputValueOutput>;
  DeclarationOutput: ResolverTypeWrapper<DeclarationOutput>;
  DeclarationStatement: ResolverTypeWrapper<DeclarationStatement>;
  DeclarationStatementInput: ResolverTypeWrapper<DeclarationStatementInput>;
  DeclarationStatementInputType: DeclarationStatementInputType;
  DeclarationStatementTrace: ResolverTypeWrapper<DeclarationStatementTrace>;
  DeclarationsInput: DeclarationsInput;
  DeclarationsResponse: ResolverTypeWrapper<DeclarationsResponse>;
  DeclarationsResponseInput: DeclarationsResponseInput;
  DeclarationsType: ResolverTypeWrapper<DeclarationsType>;
  DefaultAction: DefaultAction;
  DeleteReplacementExportRequestInput: DeleteReplacementExportRequestInput;
  DeleteReplacementExportRequestResponse: ResolverTypeWrapper<DeleteReplacementExportRequestResponse>;
  DestinationMarket: DestinationMarket;
  DestinationProductTracking: ResolverTypeWrapper<DestinationProductTracking>;
  DestinationSystem: DestinationSystem;
  DfeCondition: ResolverTypeWrapper<DfeCondition>;
  DfeConditionInput: DfeConditionInput;
  DfeConfig: ResolverTypeWrapper<DfeConfig>;
  DfeConfigInput: DfeConfigInput;
  DfeCrossExclusion: ResolverTypeWrapper<DfeCrossExclusion>;
  DfeCrossFieldValidation: ResolverTypeWrapper<DfeCrossFieldValidation>;
  DfeCustomRule: ResolverTypeWrapper<DfeCustomRule>;
  DfeCustomRuleInput: DfeCustomRuleInput;
  DfeDeclarationBlockType: DfeDeclarationBlockType;
  DfeDeclarationGroup: ResolverTypeWrapper<DfeDeclarationGroup>;
  DfeDeclarationStatement: ResolverTypeWrapper<DfeDeclarationStatement>;
  DfeDeclarationStatementInput: ResolverTypeWrapper<DfeDeclarationStatementInput>;
  DfeDeclarationStatementInputType: DfeDeclarationStatementInputType;
  DfeExclusiveGroup: ResolverTypeWrapper<DfeExclusiveGroup>;
  DfeField: ResolverTypeWrapper<DfeField>;
  DfeFieldDisableGroup: ResolverTypeWrapper<DfeFieldDisableGroup>;
  DfeFieldInput: DfeFieldInput;
  DfeFieldType: DfeFieldType;
  DfeMeta: ResolverTypeWrapper<DfeMeta>;
  DfeMetaCatalogueType: DfeMetaCatalogueType;
  DfeOperatorType: DfeOperatorType;
  DfeRequestInput: DfeRequestInput;
  DfeTemplateInfo: ResolverTypeWrapper<DfeTemplateInfo>;
  DfeValidation: ResolverTypeWrapper<DfeValidation>;
  DfeValidationInput: DfeValidationInput;
  DfeValidationMessages: ResolverTypeWrapper<DfeValidationMessages>;
  DfeValidationMessagesInput: DfeValidationMessagesInput;
  DfeValidationRules: ResolverTypeWrapper<DfeValidationRules>;
  DfeValidationRulesInput: DfeValidationRulesInput;
  DfeValueUnitPair: ResolverTypeWrapper<DfeValueUnitPair>;
  DisplayType: DisplayType;
  DisplayTypeSettings: ResolverTypeWrapper<DisplayTypeSettings>;
  DisplayTypeSettingsInput: DisplayTypeSettingsInput;
  DisplayedBoxWidth: DisplayedBoxWidth;
  DownloadExportRequestsCsvInput: DownloadExportRequestsCsvInput;
  DownloadSupportingDocumentsCsvInput: DownloadSupportingDocumentsCsvInput;
  DownloadTransferProcessHistoryXMLInput: DownloadTransferProcessHistoryXmlInput;
  DownloadTransferRequestsCsvInput: DownloadTransferRequestsCsvInput;
  DraftCertificateExecutionStatus: DraftCertificateExecutionStatus;
  DraftCertificateGenerationStatusResponse: ResolverTypeWrapper<DraftCertificateGenerationStatusResponse>;
  DraftExportCertificate: ResolverTypeWrapper<DraftExportCertificate>;
  EStarOrganisation: ResolverTypeWrapper<EStarOrganisation>;
  EStarOrganisationFilter: EStarOrganisationFilter;
  EUIngredient: ResolverTypeWrapper<EuIngredient>;
  EUIngredientInput: EuIngredientInput;
  EUIngredientsTemplate: ResolverTypeWrapper<EuIngredientsTemplate>;
  EditReasonCategory: EditReasonCategory;
  EgRequestInput: EgRequestInput;
  EligibilityInput: EligibilityInput;
  EligibilityResponse: ResolverTypeWrapper<EligibilityResponse>;
  EligibilityResponseInput: EligibilityResponseInput;
  EligibilityType: ResolverTypeWrapper<EligibilityType>;
  EnumerationInfo: ResolverTypeWrapper<EnumerationInfo>;
  EstarCancelRequest: ResolverTypeWrapper<EstarCancelRequest>;
  ExhaustTransferProductsInput: ExhaustTransferProductsInput;
  ExhaustTransferProductsResponse: ResolverTypeWrapper<ExhaustTransferProductsResponse>;
  ExhaustTransferRequestInput: ExhaustTransferRequestInput;
  ExhaustTransferRequestResponse: ResolverTypeWrapper<ExhaustTransferRequestResponse>;
  ExhaustionResponse: ResolverTypeWrapper<ExhaustionResponse>;
  ExportCertificateCollectionInput: ExportCertificateCollectionInput;
  ExportCertificateCollectionResponse: ResolverTypeWrapper<ExportCertificateCollectionResponse>;
  ExportCertificateRequest: ResolverTypeWrapper<ExportCertificateRequest>;
  ExportCertificateRequestInput: ExportCertificateRequestInput;
  ExportCertificateStatus: ExportCertificateStatus;
  ExportCertificateSupportingDocumentsInput: ExportCertificateSupportingDocumentsInput;
  ExportCertificateWorkflowInput: ExportCertificateWorkflowInput;
  ExportCertificateWorkflowResponse: ResolverTypeWrapper<ExportCertificateWorkflowResponse>;
  ExportCertificateWorkflowResponseInput: ExportCertificateWorkflowResponseInput;
  ExportCertificateWorkflowType: ResolverTypeWrapper<ExportCertificateWorkflowType>;
  ExportCsvResponse: ResolverTypeWrapper<ExportCsvResponse>;
  ExportDetailsInput: ExportDetailsInput;
  ExportReasonCategory: ExportReasonCategory;
  ExportRequestHistoryInput: ExportRequestHistoryInput;
  ExportRequestHistoryRecord: ResolverTypeWrapper<ExportRequestHistoryRecord>;
  ExportRequestOutputAssuranceType: ExportRequestOutputAssuranceType;
  ExportRequestOutputFileType: ExportRequestOutputFileType;
  ExportRequestOutputStatus: ExportRequestOutputStatus;
  ExportRequestType: ExportRequestType;
  ExportSPSAcknowledgementInput: ExportSpsAcknowledgementInput;
  ExportSPSAcknowledgementResponse: ResolverTypeWrapper<ExportSpsAcknowledgementResponse>;
  ExportStatus: ExportStatus;
  ExtendIntendedOperatorInput: ExtendIntendedOperatorInput;
  Field: ResolverTypeWrapper<Field>;
  FieldBySubmissionLayout: ResolverTypeWrapper<FieldBySubmissionLayout>;
  FieldConfiguration: ResolverTypeWrapper<FieldConfiguration>;
  FieldFilterInput: FieldFilterInput;
  FieldInfo: ResolverTypeWrapper<FieldInfo>;
  FieldInput: ResolverTypeWrapper<FieldInput>;
  FieldV2: ResolverTypeWrapper<FieldV2>;
  FlexiFillingRunData: ResolverTypeWrapper<FlexiFillingRunData>;
  FlexiFillingRunDataInput: FlexiFillingRunDataInput;
  FlexiFillingRunInput: FlexiFillingRunInput;
  FlexiFillingRunResponse: ResolverTypeWrapper<FlexiFillingRunResponse>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  Form: ResolverTypeWrapper<Form>;
  FormletCollectionFilter: ResolverTypeWrapper<FormletCollectionFilter>;
  FormletField: ResolverTypeWrapper<FormletField>;
  FormletFieldType: FormletFieldType;
  FormletNestedFields: ResolverTypeWrapper<FormletNestedFields>;
  FormletOption: ResolverTypeWrapper<FormletOption>;
  ForwardProductTrackingResponse: ResolverTypeWrapper<ForwardProductTrackingResponse>;
  G2GAccount: ResolverTypeWrapper<G2GAccount>;
  G2GAccountSearchResult: ResolverTypeWrapper<G2GAccountSearchResult>;
  G2GAccountStatus: G2GAccountStatus;
  G2GAccountSummary: ResolverTypeWrapper<G2GAccountSummary>;
  G2GAccountType: G2GAccountType;
  G2GPermissions: ResolverTypeWrapper<G2GPermissions>;
  G2GPermissionsInput: G2GPermissionsInput;
  GenerateDraftExportCertificateInput: GenerateDraftExportCertificateInput;
  GenerateOutputPreviewXMLResult: ResolverTypeWrapper<GenerateOutputPreviewXmlResult>;
  GenerateSubmissionPreviewXmlResponse: ResolverTypeWrapper<GenerateSubmissionPreviewXmlResponse>;
  GeneratedCertificate: ResolverTypeWrapper<GeneratedCertificate>;
  GeneratedCertificateType: GeneratedCertificateType;
  GetDfeFormInput: GetDfeFormInput;
  GetDraftCertificateGenerationStatusInput: GetDraftCertificateGenerationStatusInput;
  GetRequestValidationsInput: GetRequestValidationsInput;
  GetRequestValidationsResponse: ResolverTypeWrapper<GetRequestValidationsResponse>;
  GetSignedCertificateXmlInput: GetSignedCertificateXmlInput;
  GetSignedCertificateXmlResponse: ResolverTypeWrapper<GetSignedCertificateXmlResponse>;
  GetSupportingDocumentActionsInput: GetSupportingDocumentActionsInput;
  GetSupportingDocumentDetailsInput: GetSupportingDocumentDetailsInput;
  GetSupportingDocumentHistoryInput: GetSupportingDocumentHistoryInput;
  GetTemplateXmlCoreInput: GetTemplateXmlCoreInput;
  GetTemplateXmlCoreResponse: ResolverTypeWrapper<GetTemplateXmlCoreResponse>;
  IConfig: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IConfig']>;
  IConfigBase: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IConfigBase']>;
  IConfigField: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IConfigField']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IDfeValidationRules: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IDfeValidationRules']>;
  IDsTemplate: ResolverTypeWrapper<IDsTemplate>;
  IMeasureTemplate: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IMeasureTemplate']>;
  IPPCHubLogEntry: ResolverTypeWrapper<IppcHubLogEntry>;
  IPPCHubLogInput: IppcHubLogInput;
  ITemplateProcessGroup: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ITemplateProcessGroup']>;
  ImportCertificate: ResolverTypeWrapper<ImportCertificate>;
  ImportCertificateEmbeddedDocument: ResolverTypeWrapper<ImportCertificateEmbeddedDocument>;
  ImportCertificateExtractItem: ResolverTypeWrapper<ImportCertificateExtractItem>;
  ImportCertificateExtractMeasurement: ResolverTypeWrapper<ImportCertificateExtractMeasurement>;
  ImportCertificateExtractTemplate: ResolverTypeWrapper<ImportCertificateExtractTemplate>;
  ImportCertificateIntegration: ResolverTypeWrapper<ImportCertificateIntegration>;
  ImportCertificateIntegrationResponse: ImportCertificateIntegrationResponse;
  ImportCertificateLogMessage: ResolverTypeWrapper<ImportCertificateLogMessage>;
  ImportCertificateLogMessageInput: ImportCertificateLogMessageInput;
  ImportCertificateLogStatus: ImportCertificateLogStatus;
  ImportCertificateMeasurementTemplate: ResolverTypeWrapper<ImportCertificateMeasurementTemplate>;
  ImportCertificatePackagingTemplate: ResolverTypeWrapper<ImportCertificatePackagingTemplate>;
  ImportCertificatePdf: ResolverTypeWrapper<ImportCertificatePdf>;
  ImportCertificatePdfInput: ImportCertificatePdfInput;
  ImportCertificateStatus: ImportCertificateStatus;
  ImportCertificateStatusChangeInput: ImportCertificateStatusChangeInput;
  ImportCertificateType: ImportCertificateType;
  ImportCertificateXml: ResolverTypeWrapper<ImportCertificateXml>;
  ImportConnectionsInput: ImportConnectionsInput;
  ImportConnectionsResponse: ResolverTypeWrapper<ImportConnectionsResponse>;
  ImportConnectionsResponseInput: ImportConnectionsResponseInput;
  ImportConnectionsType: ResolverTypeWrapper<ImportConnectionsType>;
  IndicatorType: ResolverTypeWrapper<IndicatorType>;
  InitSupportingDocumentUploadInput: InitSupportingDocumentUploadInput;
  InitSupportingDocumentUploadResponse: ResolverTypeWrapper<InitSupportingDocumentUploadResponse>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntTemplate: ResolverTypeWrapper<IntTemplate>;
  IntegrationsAmendExportFromURIInput: IntegrationsAmendExportFromUriInput;
  IntegrationsAmendTransferFromURIInput: IntegrationsAmendTransferFromUriInput;
  IntegrationsCreateSupportingDocumentInput: IntegrationsCreateSupportingDocumentInput;
  IntegrationsDownloadTransferProcessHistoryXMLInput: IntegrationsDownloadTransferProcessHistoryXmlInput;
  IntegrationsExportRequestAPFromURIInput: IntegrationsExportRequestApFromUriInput;
  IntegrationsExportRequestAPInput: IntegrationsExportRequestApInput;
  IntegrationsExportRequestPhytoFromURIInput: IntegrationsExportRequestPhytoFromUriInput;
  IntegrationsExportRequestPhytoInput: IntegrationsExportRequestPhytoInput;
  IntegrationsGetSignedCertificateXmlInput: IntegrationsGetSignedCertificateXmlInput;
  IntegrationsGetTemplateXmlInput: IntegrationsGetTemplateXmlInput;
  IntegrationsGetTemplateXmlResponse: ResolverTypeWrapper<IntegrationsGetTemplateXmlResponse>;
  IntegrationsInitSupportingDocumentUploadInput: IntegrationsInitSupportingDocumentUploadInput;
  IntegrationsRaiseTransferFromURIInput: IntegrationsRaiseTransferFromUriInput;
  IntegrationsRaiseTransferInput: IntegrationsRaiseTransferInput;
  IntegrationsReplaceExportCertificateInput: IntegrationsReplaceExportCertificateInput;
  IntegrationsRequestAmendmentTransferInput: IntegrationsRequestAmendmentTransferInput;
  IntegrationsRequestReplacementCertificateInput: IntegrationsRequestReplacementCertificateInput;
  Language: ResolverTypeWrapper<Language>;
  Layout: ResolverTypeWrapper<Layout>;
  Layouts: ResolverTypeWrapper<Layouts>;
  LookupValue: ResolverTypeWrapper<LookupValue>;
  ManualVolumeAdjustment: ResolverTypeWrapper<ManualVolumeAdjustment>;
  ManualVolumeAdjustmentInput: ManualVolumeAdjustmentInput;
  MasterLayout: ResolverTypeWrapper<MasterLayout>;
  MeasureTemplate: ResolverTypeWrapper<MeasureTemplate>;
  Measurment: ResolverTypeWrapper<Measurment>;
  MeasurmentInput: MeasurmentInput;
  MonthTemplate: ResolverTypeWrapper<MonthTemplate>;
  MultiCollectionApiKeys: ResolverTypeWrapper<MultiCollectionApiKeys>;
  MultiCollectionApiKeysV2: ResolverTypeWrapper<MultiCollectionApiKeysV2>;
  Mutation: ResolverTypeWrapper<{}>;
  NamedCode: ResolverTypeWrapper<NamedCode>;
  NamedCodeInput: NamedCodeInput;
  NamedCodeTemplate: ResolverTypeWrapper<NamedCodeTemplate>;
  NewCoreReferencedDocument: ResolverTypeWrapper<NewCoreReferencedDocument>;
  NewCoreReferencedDocumentInput: NewCoreReferencedDocumentInput;
  NewReferencedDocument: ResolverTypeWrapper<NewReferencedDocument>;
  NumberConstrain: ResolverTypeWrapper<NumberConstrain>;
  OCAWithPermissionsInput: OcaWithPermissionsInput;
  OCAWithPermissionsResponse: ResolverTypeWrapper<OcaWithPermissionsResponse>;
  Optionality: Optionality;
  PDFAddendum: PdfAddendum;
  PDFBoxWidth: PdfBoxWidth;
  PDFLayout: PdfLayout;
  PDFSettings: ResolverTypeWrapper<PdfSettings>;
  PDFSettingsInput: PdfSettingsInput;
  PackageTemplate: ResolverTypeWrapper<PackageTemplate>;
  Packaging: ResolverTypeWrapper<Omit<Packaging, 'runs'> & { runs: Array<ResolversTypes['PackagingRun']> }>;
  PackagingConfirmation: ResolverTypeWrapper<PackagingConfirmation>;
  PackagingInput: PackagingInput;
  PackagingRun: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PackagingRun']>;
  PackagingStatus: PackagingStatus;
  PartyRole: PartyRole;
  PdfCertificateType: PdfCertificateType;
  PdfDefaultOption: PdfDefaultOption;
  PdfGenerationStatus: PdfGenerationStatus;
  PermissionConstraintType: PermissionConstraintType;
  PhytoDocumentType: PhytoDocumentType;
  PhytoOcaEmailNotificationsInput: PhytoOcaEmailNotificationsInput;
  PhytoOcaEmailNotificationsResponse: ResolverTypeWrapper<PhytoOcaEmailNotificationsResponse>;
  PhytoOcaEmailNotificationsResponseInput: PhytoOcaEmailNotificationsResponseInput;
  PhytoOcaEmailNotificationsType: ResolverTypeWrapper<PhytoOcaEmailNotificationsType>;
  PhytoSupportingDocumentType: PhytoSupportingDocumentType;
  PortCountryInfo: ResolverTypeWrapper<PortCountryInfo>;
  PremisesAddressFormat: PremisesAddressFormat;
  PremisesRange: PremisesRange;
  PrepareXmlFileForB2GInput: PrepareXmlFileForB2GInput;
  PrepareXmlFileForB2GResponse: ResolverTypeWrapper<PrepareXmlFileForB2GResponse>;
  PresignedPostField: ResolverTypeWrapper<PresignedPostField>;
  PresignedUrl: ResolverTypeWrapper<PresignedUrl>;
  PreviewOutputXMLPresignedURLResult: ResolverTypeWrapper<PreviewOutputXmlPresignedUrlResult>;
  PrintCertificateInput: PrintCertificateInput;
  PrintCertificateResponse: ResolverTypeWrapper<PrintCertificateResponse>;
  ProcessAttributesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ProcessAttributesResponse']>;
  ProcessB2GIntegrationInput: ProcessB2GIntegrationInput;
  ProcessB2GIntegrationResponse: ResolverTypeWrapper<ProcessB2GIntegrationResponse>;
  ProcessDetail: ResolverTypeWrapper<ProcessDetail>;
  ProcessGroupCaptionSettings: ResolverTypeWrapper<ProcessGroupCaptionSettings>;
  ProcessGroupCaptionSettingsInput: ProcessGroupCaptionSettingsInput;
  ProcessGroupDetail: ResolverTypeWrapper<ProcessGroupDetail>;
  ProcessGroupInfo: ResolverTypeWrapper<ProcessGroupInfo>;
  ProcessInfo: ResolverTypeWrapper<ProcessInfo>;
  ProcessResponse: ResolverTypeWrapper<ProcessResponse>;
  ProcessStatus: ProcessStatus;
  ProcessTask: ResolverTypeWrapper<ProcessTask>;
  ProcessType: ResolverTypeWrapper<ProcessType>;
  ProductExhaustionResponse: ResolverTypeWrapper<ProductExhaustionResponse>;
  ProductFieldInput: ProductFieldInput;
  ProductFieldResponse: ResolverTypeWrapper<ProductFieldResponse>;
  ProductFieldResponseInput: ProductFieldResponseInput;
  ProductFieldType: ResolverTypeWrapper<ProductFieldType>;
  ProductFieldsInput: ProductFieldsInput;
  ProductProcessFilterInput: ProductProcessFilterInput;
  ProductProcessResponse: ResolverTypeWrapper<Omit<ProductProcessResponse, 'attributes'> & { attributes: ResolversTypes['ProcessAttributesResponse'] }>;
  ProductProcessType: ProductProcessType;
  ProductProcessesInput: ProductProcessesInput;
  ProductionDateRangeInput: ProductionDateRangeInput;
  PublishXmlFileProcessedInput: PublishXmlFileProcessedInput;
  Query: ResolverTypeWrapper<{}>;
  RaiseExportRequestInput: RaiseExportRequestInput;
  RaiseExportRequestResponse: ResolverTypeWrapper<RaiseExportRequestResponse>;
  RaiseTransferRequestInput: RaiseTransferRequestInput;
  RaiseTransferRequestResponse: ResolverTypeWrapper<RaiseTransferRequestResponse>;
  RecipeType: RecipeType;
  RefValidationType: RefValidationType;
  ReferenceCaption: ResolverTypeWrapper<ReferenceCaption>;
  ReferenceDataInput: ReferenceDataInput;
  ReferenceDataList: ResolverTypeWrapper<ReferenceDataList>;
  ReferenceItem: ResolverTypeWrapper<ReferenceItem>;
  ReferenceList: ResolverTypeWrapper<ReferenceList>;
  ReferenceListFilter: ReferenceListFilter;
  ReferenceProcessGroupCaption: ResolverTypeWrapper<ReferenceProcessGroupCaption>;
  ReferenceValidationMode: ResolverTypeWrapper<ReferenceValidationMode>;
  ReferenceValidationResponse: ResolverTypeWrapper<ReferenceValidationResponse>;
  ReferencedDocument: ResolverTypeWrapper<ReferencedDocument>;
  ReferencedDocumentUrl: ResolverTypeWrapper<ReferencedDocumentUrl>;
  RegenerateApprovedTemplatesResponse: ResolverTypeWrapper<RegenerateApprovedTemplatesResponse>;
  RegenerateApprovedTemplatesResult: ResolverTypeWrapper<RegenerateApprovedTemplatesResult>;
  RegenerateCertificateInput: RegenerateCertificateInput;
  RegenerateCertificateResponse: ResolverTypeWrapper<RegenerateCertificateResponse>;
  RegistrationSource: RegistrationSource;
  RegistrationType: ResolverTypeWrapper<RegistrationType>;
  ReindexResponse: ResolverTypeWrapper<ReindexResponse>;
  RemoveProductProcessesInput: RemoveProductProcessesInput;
  RemoveProductProcessesResponse: ResolverTypeWrapper<RemoveProductProcessesResponse>;
  RemoveProductsFromRequestInput: RemoveProductsFromRequestInput;
  RemoveSources: RemoveSources;
  RequestConfirmationInput: RequestConfirmationInput;
  RequestConfirmationResponse: ResolverTypeWrapper<RequestConfirmationResponse>;
  RequestHistoryForSF: ResolverTypeWrapper<RequestHistoryForSf>;
  RequestHistoryForSFInput: RequestHistoryForSfInput;
  RequestOrigin: RequestOrigin;
  RequestPartyRoleInput: RequestPartyRoleInput;
  RequestPartyRolesResponse: ResolverTypeWrapper<RequestPartyRolesResponse>;
  RequestValidation: ResolverTypeWrapper<RequestValidation>;
  ResetConfirmationRequestInput: ResetConfirmationRequestInput;
  RoleName: RoleName;
  RoleSpecificKeys: ResolverTypeWrapper<RoleSpecificKeys>;
  Row: ResolverTypeWrapper<Row>;
  RulesExecutionInput: RulesExecutionInput;
  RulesInput: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RulesInput']>;
  RulesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RulesResponse']>;
  SPSAddress: ResolverTypeWrapper<SpsAddress>;
  SPSAddressInput: SpsAddressInput;
  SPSAuthentication: ResolverTypeWrapper<SpsAuthentication>;
  SPSAuthenticationInput: SpsAuthenticationInput;
  SPSCertificate: ResolverTypeWrapper<SpsCertificate>;
  SPSClassification: ResolverTypeWrapper<SpsClassification>;
  SPSClassificationInput: SpsClassificationInput;
  SPSClause: ResolverTypeWrapper<SpsClause>;
  SPSClauseInput: SpsClauseInput;
  SPSConsignment: ResolverTypeWrapper<SpsConsignment>;
  SPSConsignmentInput: SpsConsignmentInput;
  SPSConsignmentItem: ResolverTypeWrapper<SpsConsignmentItem>;
  SPSConsignmentItemInput: SpsConsignmentItemInput;
  SPSContact: ResolverTypeWrapper<SpsContact>;
  SPSContactInput: SpsContactInput;
  SPSCountry: ResolverTypeWrapper<SpsCountry>;
  SPSCountryInput: SpsCountryInput;
  SPSCountrySubDivision: ResolverTypeWrapper<SpsCountrySubDivision>;
  SPSCountrySubDivisionInput: SpsCountrySubDivisionInput;
  SPSEvent: ResolverTypeWrapper<SpsEvent>;
  SPSEventInput: SpsEventInput;
  SPSExchangedDocument: ResolverTypeWrapper<SpsExchangedDocument>;
  SPSLocation: ResolverTypeWrapper<SpsLocation>;
  SPSLocationInput: SpsLocationInput;
  SPSNote: ResolverTypeWrapper<SpsNote>;
  SPSNoteInput: SpsNoteInput;
  SPSPackage: ResolverTypeWrapper<SpsPackage>;
  SPSPackageInput: SpsPackageInput;
  SPSParty: ResolverTypeWrapper<SpsParty>;
  SPSPartyInput: SpsPartyInput;
  SPSPeriod: ResolverTypeWrapper<SpsPeriod>;
  SPSPeriodInput: SpsPeriodInput;
  SPSPerson: ResolverTypeWrapper<SpsPerson>;
  SPSPersonInput: SpsPersonInput;
  SPSProcess: ResolverTypeWrapper<SpsProcess>;
  SPSProcessCharacteristic: ResolverTypeWrapper<SpsProcessCharacteristic>;
  SPSProcessCharacteristicInput: SpsProcessCharacteristicInput;
  SPSProcessInput: SpsProcessInput;
  SPSQualification: ResolverTypeWrapper<SpsQualification>;
  SPSQualificationInput: SpsQualificationInput;
  SPSReferencedDocument: ResolverTypeWrapper<SpsReferencedDocument>;
  SPSSeal: ResolverTypeWrapper<SpsSeal>;
  SPSSealInput: SpsSealInput;
  SPSTemperature: ResolverTypeWrapper<SpsTemperature>;
  SPSTemperatureInput: SpsTemperatureInput;
  SPSTradeLineItem: ResolverTypeWrapper<SpsTradeLineItem>;
  SPSTradeLineItemInput: SpsTradeLineItemInput;
  SPSTransportEquipment: ResolverTypeWrapper<SpsTransportEquipment>;
  SPSTransportEquipmentInput: SpsTransportEquipmentInput;
  SPSTransportMovement: ResolverTypeWrapper<SpsTransportMovement>;
  SPSTransportMovementInput: SpsTransportMovementInput;
  SPSTransportMovementTemplate: ResolverTypeWrapper<SpsTransportMovementTemplate>;
  SPSWineExporter: ResolverTypeWrapper<SpsWineExporter>;
  SalesForceAddress: ResolverTypeWrapper<SalesForceAddress>;
  SalesForceContact: ResolverTypeWrapper<SalesForceContact>;
  SalesForceEmail: ResolverTypeWrapper<SalesForceEmail>;
  SalesForceIdentifier: ResolverTypeWrapper<SalesForceIdentifier>;
  SalesForceParty: ResolverTypeWrapper<SalesForceParty>;
  SalesForcePhone: ResolverTypeWrapper<SalesForcePhone>;
  SalesForceProductId: ResolverTypeWrapper<SalesForceProductId>;
  SalesforceErApprovalInput: SalesforceErApprovalInput;
  SalesforceErApprovalResponse: ResolverTypeWrapper<SalesforceErApprovalResponse>;
  SalesforceErStatus: SalesforceErStatus;
  SalesforceTransferRequestStatus: SalesforceTransferRequestStatus;
  SalesforceTransferRequestVerificationInput: SalesforceTransferRequestVerificationInput;
  SalesforceTransferRequestVerificationResponse: ResolverTypeWrapper<SalesforceTransferRequestVerificationResponse>;
  SaveChangesToReferenceDataInput: SaveChangesToReferenceDataInput;
  SaveChangesToReferenceDataResponse: ResolverTypeWrapper<SaveChangesToReferenceDataResponse>;
  SaveG2GAccountInput: SaveG2GAccountInput;
  SavedClassificationOutput: ResolverTypeWrapper<SavedClassificationOutput>;
  SavedProcessOutput: ResolverTypeWrapper<SavedProcessOutput>;
  SavedProductOutput: ResolverTypeWrapper<SavedProductOutput>;
  SearchApiKey: ResolverTypeWrapper<SearchApiKey>;
  SearchG2GAccountsInput: SearchG2GAccountsInput;
  SearchOptions: SearchOptions;
  SearchReferenceListResponse: ResolverTypeWrapper<SearchReferenceListResponse>;
  SearchTemplateVersionsResponse: ResolverTypeWrapper<SearchTemplateVersionsResponse>;
  Section: ResolverTypeWrapper<Section>;
  SensoryProcessInput: SensoryProcessInput;
  SensoryProcessRequest: ResolverTypeWrapper<SensoryProcessRequest>;
  SfApplication: ResolverTypeWrapper<SfApplication>;
  SfApprovedTemplateVersion: ResolverTypeWrapper<SfApprovedTemplateVersion>;
  SfCancelExportCertificateInput: SfCancelExportCertificateInput;
  SfChangeExportCertificateRequestStatusInput: SfChangeExportCertificateRequestStatusInput;
  SfChangeExportRequestStatusInput: SfChangeExportRequestStatusInput;
  SfChangeExportRequestStatusResponse: ResolverTypeWrapper<SfChangeExportRequestStatusResponse>;
  SfChangeTransferRequestStatusInput: SfChangeTransferRequestStatusInput;
  SfChangeTransferRequestStatusResponse: ResolverTypeWrapper<SfChangeTransferRequestStatusResponse>;
  SfDownloadCertificateInput: SfDownloadCertificateInput;
  SfDownloadCertificateResponse: ResolverTypeWrapper<SfDownloadCertificateResponse>;
  SfDownloadInput: SfDownloadInput;
  SfGeneratedCertificate: ResolverTypeWrapper<SfGeneratedCertificate>;
  SfGeneratedCertificateType: SfGeneratedCertificateType;
  SfPrintHistory: ResolverTypeWrapper<SfPrintHistory>;
  SfRequest: ResolverTypeWrapper<SfRequest>;
  SfRequestExportCertificateReplacementInput: SfRequestExportCertificateReplacementInput;
  SfRequestedToResubmitExportCertificateInput: SfRequestedToResubmitExportCertificateInput;
  SfSearchApprovedTemplatesInput: SfSearchApprovedTemplatesInput;
  SfSearchApprovedTemplatesResponse: ResolverTypeWrapper<SfSearchApprovedTemplatesResponse>;
  SfSupportingDocumentMetadata: ResolverTypeWrapper<SfSupportingDocumentMetadata>;
  SfUnverifyProductInput: SfUnverifyProductInput;
  SfUpdateProductExhaustionInput: SfUpdateProductExhaustionInput;
  SfUpdateProductExhaustionResponse: ResolverTypeWrapper<SfUpdateProductExhaustionResponse>;
  SfUpdateStationerySerialNumbersInput: SfUpdateStationerySerialNumbersInput;
  SfUpdateStationerySerialNumbersResponse: ResolverTypeWrapper<SfUpdateStationerySerialNumbersResponse>;
  SfUpdateTransferAuditCommentInput: SfUpdateTransferAuditCommentInput;
  SfUpdateTransferAuditCommentResponse: ResolverTypeWrapper<SfUpdateTransferAuditCommentResponse>;
  SfVerifyExportCertificateRequestProductsInput: SfVerifyExportCertificateRequestProductsInput;
  SfVerifyProductInput: SfVerifyProductInput;
  Signatory: Signatory;
  SnapshotPresignedUrlResponse: ResolverTypeWrapper<SnapshotPresignedUrlResponse>;
  SortOrder: SortOrder;
  SourceProductTracking: ResolverTypeWrapper<SourceProductTracking>;
  SourceTransfer: ResolverTypeWrapper<SourceTransfer>;
  SourcedProduct: ResolverTypeWrapper<SourcedProduct>;
  SourcedProductAttributes: ResolverTypeWrapper<SourcedProductAttributes>;
  SourcedProductDetails: ResolverTypeWrapper<SourcedProductDetails>;
  SpsAcknowledgementInput: SpsAcknowledgementInput;
  SpsAcknowledgementOutput: ResolverTypeWrapper<SpsAcknowledgementOutput>;
  SpsAddressTemplate: ResolverTypeWrapper<SpsAddressTemplate>;
  SpsAuthenticationTemplate: ResolverTypeWrapper<SpsAuthenticationTemplate>;
  SpsCertificateTemplate: ResolverTypeWrapper<SpsCertificateTemplate>;
  SpsClassificationTemplate: ResolverTypeWrapper<SpsClassificationTemplate>;
  SpsClauseTemplate: ResolverTypeWrapper<SpsClauseTemplate>;
  SpsConsignmentItemTemplate: ResolverTypeWrapper<SpsConsignmentItemTemplate>;
  SpsConsignmentTemplate: ResolverTypeWrapper<SpsConsignmentTemplate>;
  SpsContactTemplate: ResolverTypeWrapper<SpsContactTemplate>;
  SpsCountrySubDivisionTemplate: ResolverTypeWrapper<SpsCountrySubDivisionTemplate>;
  SpsCountryTemplate: ResolverTypeWrapper<SpsCountryTemplate>;
  SpsEventTemplate: ResolverTypeWrapper<SpsEventTemplate>;
  SpsExchangedDocumentTemplate: ResolverTypeWrapper<SpsExchangedDocumentTemplate>;
  SpsLocationTemplate: ResolverTypeWrapper<SpsLocationTemplate>;
  SpsNoteTemplate: ResolverTypeWrapper<SpsNoteTemplate>;
  SpsPackageTemplate: ResolverTypeWrapper<SpsPackageTemplate>;
  SpsPartyTemplate: ResolverTypeWrapper<SpsPartyTemplate>;
  SpsPeriodTemplate: ResolverTypeWrapper<SpsPeriodTemplate>;
  SpsPersonTemplate: ResolverTypeWrapper<SpsPersonTemplate>;
  SpsProcessCharacteristicTemplate: ResolverTypeWrapper<SpsProcessCharacteristicTemplate>;
  SpsProcessTemplate: ResolverTypeWrapper<SpsProcessTemplate>;
  SpsQualificationTemplate: ResolverTypeWrapper<SpsQualificationTemplate>;
  SpsReplacementCertificateTemplate: ResolverTypeWrapper<SpsReplacementCertificateTemplate>;
  SpsSealTemplate: ResolverTypeWrapper<SpsSealTemplate>;
  SpsTemperatureTemplate: ResolverTypeWrapper<SpsTemperatureTemplate>;
  SpsTradeLineItemTemplate: ResolverTypeWrapper<SpsTradeLineItemTemplate>;
  SpsTransportEquipmentTemplate: ResolverTypeWrapper<SpsTransportEquipmentTemplate>;
  StandardPdfPreviewResponse: ResolverTypeWrapper<StandardPdfPreviewResponse>;
  StandardPdfPreviewStatus: StandardPdfPreviewStatus;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubmissionLayoutType: SubmissionLayoutType;
  SubmissionSettings: ResolverTypeWrapper<SubmissionSettings>;
  SubmissionSettingsInput: SubmissionSettingsInput;
  SubmissionXmlUrl: ResolverTypeWrapper<SubmissionXmlUrl>;
  Subscription: ResolverTypeWrapper<{}>;
  SupportingDocumentActionsResponse: ResolverTypeWrapper<SupportingDocumentActionsResponse>;
  SupportingDocumentHistoryEntry: ResolverTypeWrapper<SupportingDocumentHistoryEntry>;
  SupportingDocumentInput: SupportingDocumentInput;
  SupportingDocumentKeys: ResolverTypeWrapper<SupportingDocumentKeys>;
  SupportingDocumentPresignedUrlResponse: ResolverTypeWrapper<SupportingDocumentPresignedUrlResponse>;
  SupportingDocumentStatus: SupportingDocumentStatus;
  SupportingDocumentUsageInput: SupportingDocumentUsageInput;
  SupportingDocumentUsageRecord: ResolverTypeWrapper<SupportingDocumentUsageRecord>;
  SuspensionReason: SuspensionReason;
  Template: ResolverTypeWrapper<Template>;
  TemplateDeclarationGroup: ResolverTypeWrapper<TemplateDeclarationGroup>;
  TemplateDeclarationsAcknowledgement: ResolverTypeWrapper<TemplateDeclarationsAcknowledgement>;
  TemplateDeclarationsDeleteAcknowledgement: ResolverTypeWrapper<TemplateDeclarationsDeleteAcknowledgement>;
  TemplateDeclarationsDeleteInput: TemplateDeclarationsDeleteInput;
  TemplateDeclarationsGroupAcknowledgement: ResolverTypeWrapper<TemplateDeclarationsGroupAcknowledgement>;
  TemplateDeclarationsGroupInput: TemplateDeclarationsGroupInput;
  TemplateDeclarationsInput: TemplateDeclarationsInput;
  TemplateDeclarationsStatementAcknowledgement: ResolverTypeWrapper<TemplateDeclarationsStatementAcknowledgement>;
  TemplateDeclarationsStatementInput: TemplateDeclarationsStatementInput;
  TemplateDeclarationsTraceAcknowledgement: ResolverTypeWrapper<TemplateDeclarationsTraceAcknowledgement>;
  TemplateDeclarationsTracesInput: TemplateDeclarationsTracesInput;
  TemplateDocumentUrl: ResolverTypeWrapper<TemplateDocumentUrl>;
  TemplateDocumentUrlV2: ResolverTypeWrapper<TemplateDocumentUrlV2>;
  TemplateFieldConfiguration: ResolverTypeWrapper<TemplateFieldConfiguration>;
  TemplateFieldConfigurationAcknowledgement: ResolverTypeWrapper<TemplateFieldConfigurationAcknowledgement>;
  TemplateFieldConfigurationInput: TemplateFieldConfigurationInput;
  TemplateFieldConfigurationV2: ResolverTypeWrapper<TemplateFieldConfigurationV2>;
  TemplateFieldReferenceData: ResolverTypeWrapper<TemplateFieldReferenceData>;
  TemplateFilter: TemplateFilter;
  TemplateGeneralSettingsV2: ResolverTypeWrapper<TemplateGeneralSettingsV2>;
  TemplateHistory: ResolverTypeWrapper<TemplateHistory>;
  TemplateOptionalFilter: TemplateOptionalFilter;
  TemplateOutputV2: ResolverTypeWrapper<TemplateOutputV2>;
  TemplateProcessGroupReferenceData: ResolverTypeWrapper<TemplateProcessGroupReferenceData>;
  TemplateProcessGroups: ResolverTypeWrapper<TemplateProcessGroups>;
  TemplateProcessGroupsConfigAcknowledgement: ResolverTypeWrapper<TemplateProcessGroupsConfigAcknowledgement>;
  TemplateSection: ResolverTypeWrapper<TemplateSection>;
  TemplateSectionField: ResolverTypeWrapper<TemplateSectionField>;
  TemplateSectionType: TemplateSectionType;
  TemplateSupportingDocument: ResolverTypeWrapper<TemplateSupportingDocument>;
  TemplateSupportingDocumentAcknowledgement: ResolverTypeWrapper<TemplateSupportingDocumentAcknowledgement>;
  TemplateSupportingDocumentInput: TemplateSupportingDocumentInput;
  TemplateSupportingDocumentType: TemplateSupportingDocumentType;
  TemplateType: TemplateType;
  TemplateUploadUrl: ResolverTypeWrapper<TemplateUploadUrl>;
  TemplateUploadUrlV2: ResolverTypeWrapper<TemplateUploadUrlV2>;
  TemplateV2: ResolverTypeWrapper<TemplateV2>;
  TemplateVersion: ResolverTypeWrapper<TemplateVersion>;
  TemplateVersionId: ResolverTypeWrapper<TemplateVersionId>;
  TemplateVersionOutput: ResolverTypeWrapper<TemplateVersionOutput>;
  TemplateVersionOutputInput: TemplateVersionOutputInput;
  TemplateVersionStatus: TemplateVersionStatus;
  TemplateVersionV2: ResolverTypeWrapper<TemplateVersionV2>;
  TestRegistration: ResolverTypeWrapper<TestRegistration>;
  TestUser: ResolverTypeWrapper<TestUser>;
  TimeTemplate: ResolverTypeWrapper<TimeTemplate>;
  TransferCertificateType: TransferCertificateType;
  TransferProcessHistoryXmlResponse: ResolverTypeWrapper<TransferProcessHistoryXmlResponse>;
  TransferProductDetails: ResolverTypeWrapper<TransferProductDetails>;
  TransferReferenceError: ResolverTypeWrapper<TransferReferenceError>;
  TransferReferenceErrorCode: TransferReferenceErrorCode;
  TransferReferenceInput: TransferReferenceInput;
  TransferReferenceRequestInput: TransferReferenceRequestInput;
  TransferReferenceResponse: ResolverTypeWrapper<TransferReferenceResponse>;
  TransferRequestDetails: ResolverTypeWrapper<TransferRequestDetails>;
  TransferRequestDetailsInput: TransferRequestDetailsInput;
  TransferRequestHistoryInput: TransferRequestHistoryInput;
  TransferRequestHistoryRecord: ResolverTypeWrapper<TransferRequestHistoryRecord>;
  Translation: ResolverTypeWrapper<Translation>;
  TranslationInput: TranslationInput;
  TransportModeCode: TransportModeCode;
  TransportMovementCodeTemplate: ResolverTypeWrapper<TransportMovementCodeTemplate>;
  TreatmentTemplate: ResolverTypeWrapper<TreatmentTemplate>;
  UpdateApprovedTransferTransportInput: UpdateApprovedTransferTransportInput;
  UpdateApprovedTransferTransportResponse: ResolverTypeWrapper<UpdateApprovedTransferTransportResponse>;
  UpdatePrintReasonInput: UpdatePrintReasonInput;
  UpdatePrintReasonResponse: ResolverTypeWrapper<UpdatePrintReasonResponse>;
  UpdateSupportingDocumentInput: UpdateSupportingDocumentInput;
  UpdateSupportingDocumentResult: ResolverTypeWrapper<UpdateSupportingDocumentResult>;
  UpdateTemplateGeneralInput: UpdateTemplateGeneralInput;
  UpdateTemplateInput: UpdateTemplateInput;
  UploadReferenceDataInput: UploadReferenceDataInput;
  UploadReferenceDataResponse: ResolverTypeWrapper<UploadReferenceDataResponse>;
  UpsertTemplateProcessGroupConfigInput: UpsertTemplateProcessGroupConfigInput;
  User: ResolverTypeWrapper<User>;
  UserDetailsById: ResolverTypeWrapper<UserDetailsById>;
  UserInfo: ResolverTypeWrapper<UserInfo>;
  UserPermission: ResolverTypeWrapper<UserPermission>;
  UserPermissionInput: UserPermissionInput;
  UserProfile: ResolverTypeWrapper<UserProfile>;
  Validation: ResolverTypeWrapper<Validation>;
  ValidationErrorType: ValidationErrorType;
  VolumeAdjustmentInput: VolumeAdjustmentInput;
  VolumeAdjustmentResponse: ResolverTypeWrapper<VolumeAdjustmentResponse>;
  VolumeMeasureTemplate: ResolverTypeWrapper<VolumeMeasureTemplate>;
  WineAnalytesTolerancesInput: WineAnalytesTolerancesInput;
  WineAnalytesTolerancesResponse: ResolverTypeWrapper<WineAnalytesTolerancesResponse>;
  WineAnalytesTolerancesResponseInput: WineAnalytesTolerancesResponseInput;
  WineAnalytesTolerancesResponseRowInput: WineAnalytesTolerancesResponseRowInput;
  WineAnalytesTolerancesType: ResolverTypeWrapper<WineAnalytesTolerancesType>;
  WineChemistryTemplate: ResolverTypeWrapper<WineChemistryTemplate>;
  WineConsignment: ResolverTypeWrapper<WineConsignment>;
  WineConsignmentTemplate: ResolverTypeWrapper<WineConsignmentTemplate>;
  WineDisputedReason: WineDisputedReason;
  WineFieldsTemplate: ResolverTypeWrapper<WineFieldsTemplate>;
  WinePackaging: WinePackaging;
  WineProductFieldInput: WineProductFieldInput;
  WineProductFieldType: ResolverTypeWrapper<WineProductFieldType>;
  Winemaking: ResolverTypeWrapper<Winemaking>;
  WinemakingConfirmation: ResolverTypeWrapper<WinemakingConfirmation>;
  WinemakingConfirmationInput: WinemakingConfirmationInput;
  WinemakingStatus: WinemakingStatus;
  XMLLayout: XmlLayout;
  XMLSettings: ResolverTypeWrapper<XmlSettings>;
  XMLSettingsInput: XmlSettingsInput;
  XmlDefaultOption: XmlDefaultOption;
  XmlRequestType: XmlRequestType;
  addProductAndProcessFromTransferInput: AddProductAndProcessFromTransferInput;
  awsS3PostUploadUrl: ResolverTypeWrapper<AwsS3PostUploadUrl>;
  getDeclarationInputsResponse: ResolverTypeWrapper<GetDeclarationInputsResponse>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AWSDate: Scalars['AWSDate']['output'];
  AWSDateTime: Scalars['AWSDateTime']['output'];
  AWSEmail: Scalars['AWSEmail']['output'];
  AWSIPAddress: Scalars['AWSIPAddress']['output'];
  AWSJSON: Scalars['AWSJSON']['output'];
  AWSPhone: Scalars['AWSPhone']['output'];
  AWSTime: Scalars['AWSTime']['output'];
  AWSTimestamp: Scalars['AWSTimestamp']['output'];
  AWSURL: Scalars['AWSURL']['output'];
  ActiveTemplateResult: ActiveTemplateResult;
  Agency: Agency;
  AgencyInput: AgencyInput;
  AggregatedProcessHistory: AggregatedProcessHistory;
  Announcement: Announcement;
  AnnouncementList: AnnouncementList;
  AnnouncementListInput: AnnouncementListInput;
  ApprovalToReplaceExportCertificateRequestInput: ApprovalToReplaceExportCertificateRequestInput;
  ApproveCertificateRequestInput: ApproveCertificateRequestInput;
  ApprovedProductRequest: ApprovedProductRequest;
  ApprovedProductRequestInput: ApprovedProductRequestInput;
  AvailableTemplateFields: AvailableTemplateFields;
  AwsS3Fields: AwsS3Fields;
  B2GAddress: B2GAddress;
  B2GAddressInput: B2GAddressInput;
  B2GAuthentication: B2GAuthentication;
  B2GAuthenticationInput: B2GAuthenticationInput;
  B2GBanWineBatchInput: B2GBanWineBatchInput;
  B2GCertificateDelivery: B2GCertificateDelivery;
  B2GCertificateDeliveryInput: B2GCertificateDeliveryInput;
  B2GClassification: B2GClassification;
  B2GClassificationInput: B2GClassificationInput;
  B2GClause: B2GClause;
  B2GClauseInput: B2GClauseInput;
  B2GConsignment: B2GConsignment;
  B2GConsignmentInput: B2GConsignmentInput;
  B2GContact: B2GContact;
  B2GContactInput: B2GContactInput;
  B2GContainer: B2GContainer;
  B2GContainerInput: B2GContainerInput;
  B2GCountry: B2GCountry;
  B2GCountryInput: B2GCountryInput;
  B2GCountrySubDivision: B2GCountrySubDivision;
  B2GCountrySubDivisionInput: B2GCountrySubDivisionInput;
  B2GDeclaration: B2GDeclaration;
  B2GDeclarationInput: B2GDeclarationInput;
  B2GEligibilityCriteriaMet: B2GEligibilityCriteriaMet;
  B2GEligibilityCriteriaMetInput: B2GEligibilityCriteriaMetInput;
  B2GEligibilityStatus: B2GEligibilityStatus;
  B2GExportCertificateRequest: B2GExportCertificateRequest;
  B2GExportCertificateRequestInput: B2GExportCertificateRequestInput;
  B2GExportCertificatesDownloadUrl: B2GExportCertificatesDownloadUrl;
  B2GExporterDeclaration: B2GExporterDeclaration;
  B2GExporterDeclarationInput: B2GExporterDeclarationInput;
  B2GLocation: B2GLocation;
  B2GLocationInput: B2GLocationInput;
  B2GNote: B2GNote;
  B2GNoteInput: B2GNoteInput;
  B2GPackage: B2GPackage;
  B2GPackageInput: B2GPackageInput;
  B2GParty: B2GParty;
  B2GPartyInput: B2GPartyInput;
  B2GPeriod: B2GPeriod;
  B2GPeriodInput: B2GPeriodInput;
  B2GPerson: B2GPerson;
  B2GPersonInput: B2GPersonInput;
  B2GPremise: B2GPremise;
  B2GPremiseInput: B2GPremiseInput;
  B2GProcess: B2GProcess;
  B2GProcessCharacteristic: B2GProcessCharacteristic;
  B2GProcessCharacteristicInput: B2GProcessCharacteristicInput;
  B2GProcessInput: B2GProcessInput;
  B2GProduct: B2GProduct;
  B2GProductEligibility: B2GProductEligibility;
  B2GProductEligibilityCriteriaV2: B2GProductEligibilityCriteriaV2;
  B2GProductEligibilityInput: B2GProductEligibilityInput;
  B2GProductEvent: B2GProductEvent;
  B2GProductInput: B2GProductInput;
  B2GProductsDownloadUrl: B2GProductsDownloadUrl;
  B2GQualification: B2GQualification;
  B2GQualificationInput: B2GQualificationInput;
  B2GReferencedDocument: B2GReferencedDocument;
  B2GReferencedDocumentInput: B2GReferencedDocumentInput;
  B2GRegistrationDetails: B2GRegistrationDetails;
  B2GRegistrationDetailsInput: B2GRegistrationDetailsInput;
  B2GSeal: B2GSeal;
  B2GSealInput: B2GSealInput;
  B2GTemperature: B2GTemperature;
  B2GTemperatureInput: B2GTemperatureInput;
  B2GTradeLineItem: B2GTradeLineItem;
  B2GTradeLineItemContainer: B2GTradeLineItemContainer;
  B2GTradeLineItemContainerInput: B2GTradeLineItemContainerInput;
  B2GTradeLineItemInput: B2GTradeLineItemInput;
  B2GTransportMovement: B2GTransportMovement;
  B2GTransportMovementInput: B2GTransportMovementInput;
  B2GValidationErrors: B2GValidationErrors;
  B2GWineChemistry: B2GWineChemistry;
  B2GWineConsignment: B2GWineConsignment;
  B2GWineConsignmentInput: B2GWineConsignmentInput;
  B2GWineFields: B2GWineFields;
  B2GWineFieldsInput: B2GWineFieldsInput;
  B2GWinePackage: B2GWinePackage;
  B2GWinePackageInput: B2GWinePackageInput;
  BRClassification: BrClassification;
  BRClassificationInput: BrClassificationInput;
  BRClassificationTemplate: BrClassificationTemplate;
  Block: Block;
  Boolean: Scalars['Boolean']['output'];
  BottlingRunData: BottlingRunData;
  BottlingRunDataInput: BottlingRunDataInput;
  BottlingRunInput: BottlingRunInput;
  BottlingRunResponse: BottlingRunResponse;
  BusinessRule: BusinessRule;
  BusinessRuleConfigInput: BusinessRuleConfigInput;
  BusinessRuleField: BusinessRuleField;
  BusinessRuleFieldInput: BusinessRuleFieldInput;
  BusinessRuleInput: BusinessRuleInput;
  BusinessRulesConfig: BusinessRulesConfig;
  CTAssayTestDataInput: CtAssayTestDataInput;
  CTCancellationDataInput: CtCancellationDataInput;
  CTCancelledDataInput: CtCancelledDataInput;
  CTCompoundDataInput: CtCompoundDataInput;
  CTErrorDataInput: CtErrorDataInput;
  CTFailStatusDataInput: CtFailStatusDataInput;
  CTFirstReportedDateDataInput: CtFirstReportedDateDataInput;
  CTInProgressStatusDataInput: CtInProgressStatusDataInput;
  CTNCancellationErrorDataInput: CtnCancellationErrorDataInput;
  CTNoOrgErrorDataInput: CtNoOrgErrorDataInput;
  CTPassStatusDataInput: CtPassStatusDataInput;
  CTRepetitionDataInput: CtRepetitionDataInput;
  CTRequestedStatusDataInput: CtRequestedStatusDataInput;
  CTUnsuitableStatusDataInput: CtUnsuitableStatusDataInput;
  CancelExportCertificateRequestInput: CancelExportCertificateRequestInput;
  CancelSupportingDocumentInput: CancelSupportingDocumentInput;
  CancelledProcessInput: CancelledProcessInput;
  CancelledProcessResponse: CancelledProcessResponse;
  CertificateCollectionInput: CertificateCollectionInput;
  CertificateCollectionOutput: CertificateCollectionOutput;
  ChangeExportRequestStatusInput: ChangeExportRequestStatusInput;
  ChangeExportRequestStatusResponse: ChangeExportRequestStatusResponse;
  ChangeTransferRequestAmendmentStatusInput: ChangeTransferRequestAmendmentStatusInput;
  ChangeTransferRequestAmendmentStatusResponse: ChangeTransferRequestAmendmentStatusResponse;
  ChangeTransferRequestStatusInput: ChangeTransferRequestStatusInput;
  ChangeTransferRequestStatusResponse: ChangeTransferRequestStatusResponse;
  CheckUserAccessInput: CheckUserAccessInput;
  CheckUserAccessResponse: CheckUserAccessResponse;
  ChemistryTest: ChemistryTest;
  ChemistryTestEventDataInput: ChemistryTestEventDataInput;
  ChemistryTestInput: ChemistryTestInput;
  ChemistryTestReceipt: ChemistryTestReceipt;
  ChemistryTestRequest: ChemistryTestRequest;
  ChemistryTestRequestInput: ChemistryTestRequestInput;
  ChemistryTestResponse: ChemistryTestResponse;
  ChemistryTestResult: ChemistryTestResult;
  CombinedPartyTemplate: CombinedPartyTemplate;
  ConfirmPackagingInput: ConfirmPackagingInput;
  ConfirmPackagingResponse: ConfirmPackagingResponse;
  ConfirmWinemakingInput: ConfirmWinemakingInput;
  ConsignorDetails: ConsignorDetails;
  ConsignorIdentifier: ConsignorIdentifier;
  CoreAddress: CoreAddress;
  CoreB2GFile: CoreB2GFile;
  CoreB2GFileInput: CoreB2GFileInput;
  CoreCommodity: CoreCommodity;
  CoreContainer: CoreContainer;
  CoreContainerInput: CoreContainerInput;
  CoreCountry: CoreCountry;
  CoreDateRange: CoreDateRange;
  CoreDateRangeInput: CoreDateRangeInput;
  CoreDeclarationInputValueOutput: CoreDeclarationInputValueOutput;
  CoreDeclarationOutput: CoreDeclarationOutput;
  CoreDeclarationTranslatedText: CoreDeclarationTranslatedText;
  CoreExportContainer: CoreExportContainer;
  CoreExportDetails: CoreExportDetails;
  CoreExportRequest: CoreExportRequest;
  CoreExportRequestAddress: CoreExportRequestAddress;
  CoreExportRequestAddressType: CoreExportRequestAddressType;
  CoreExportRequestAttributes: CoreExportRequestAttributes;
  CoreExportRequestAttributesInput: CoreExportRequestAttributesInput;
  CoreExportRequestImporter: CoreExportRequestImporter;
  CoreExportRequestImporterType: CoreExportRequestImporterType;
  CoreExportRequestInput: CoreExportRequestInput;
  CoreExportRequestParty: CoreExportRequestParty;
  CoreExportRequestPartyType: CoreExportRequestPartyType;
  CoreExportSupportingDocuments: CoreExportSupportingDocuments;
  CoreExportSupportingDocumentsInput: CoreExportSupportingDocumentsInput;
  CoreExportTransport: CoreExportTransport;
  CoreGroup: CoreGroup;
  CoreLocation: CoreLocation;
  CoreLookup: CoreLookup;
  CoreLookupInput: CoreLookupInput;
  CorePackaging: CorePackaging;
  CorePrintDetails: CorePrintDetails;
  CoreProcessAttributes: CoreProcessAttributes;
  CoreProcessAttributesInput: CoreProcessAttributesInput;
  CoreProcessHistory: CoreProcessHistory;
  CoreProcessTypeLookup: CoreProcessTypeLookup;
  CoreProduct: CoreProduct;
  CoreProductAttributes: CoreProductAttributes;
  CoreProductAttributesInput: CoreProductAttributesInput;
  CoreProductClassificationInput: CoreProductClassificationInput;
  CoreProductClassificationResponse: CoreProductClassificationResponse;
  CoreProductItemGroup: CoreProductItemGroup;
  CoreProductItemInput: CoreProductItemInput;
  CoreProductItemRelation: CoreProductItemRelation;
  CoreProductProcess: CoreProductProcess;
  CoreProductProcessInput: CoreProductProcessInput;
  CoreProductRefrence: CoreProductRefrence;
  CoreProductSupportingDocumentInput: CoreProductSupportingDocumentInput;
  CoreReferencedDocument: CoreReferencedDocument;
  CoreReferencedDocumentUrl: CoreReferencedDocumentUrl;
  CoreRegistration: CoreRegistration;
  CoreRequest: ResolversInterfaceTypes<ResolversParentTypes>['CoreRequest'];
  CoreRequestStatus: CoreRequestStatus;
  CoreRequestSubstatus: CoreRequestSubstatus;
  CoreSupportingDocument: CoreSupportingDocument;
  CoreSupportingDocumentInput: CoreSupportingDocumentInput;
  CoreTemplate: CoreTemplate;
  CoreTransferProductSupportingDocument: CoreTransferProductSupportingDocument;
  CoreTransferRequest: CoreTransferRequest;
  CoreTransferRequestInput: CoreTransferRequestInput;
  CoreTransport: CoreTransport;
  CoreTransportInput: CoreTransportInput;
  CreateAnnouncementInput: CreateAnnouncementInput;
  CreateDfeConfigRequest: CreateDfeConfigRequest;
  CreateDfeConfigResponse: CreateDfeConfigResponse;
  CreateTemplateGeneralInput: CreateTemplateGeneralInput;
  CreateTemplateInput: CreateTemplateInput;
  CreateTestRegistrationInput: CreateTestRegistrationInput;
  CreateTestUserInput: CreateTestUserInput;
  CreateUserInput: CreateUserInput;
  CustomsPermitNumberUsage: CustomsPermitNumberUsage;
  DFEForm: DfeForm;
  DFEPermission: DfePermission;
  DateTemplate: DateTemplate;
  DateTimeTemplate: DateTimeTemplate;
  DecimalTemplate: DecimalTemplate;
  DecisionTable: Omit<DecisionTable, 'approvedRevision' | 'lastRevision' | 'revisions'> & { approvedRevision?: Maybe<ResolversParentTypes['DecisionTableRevision']>, lastRevision?: Maybe<ResolversParentTypes['DecisionTableRevision']>, revisions: Array<ResolversParentTypes['DecisionTableRevision']> };
  DecisionTableBaseInput: ResolversInterfaceTypes<ResolversParentTypes>['DecisionTableBaseInput'];
  DecisionTableColumn: DecisionTableColumn;
  DecisionTableExpectation: Omit<DecisionTableExpectation, 'input' | 'response'> & { input: ResolversParentTypes['RulesInput'], response: ResolversParentTypes['RulesResponse'] };
  DecisionTableField: DecisionTableField;
  DecisionTableFilter: DecisionTableFilter;
  DecisionTableRevision: Omit<DecisionTableRevision, 'expectations' | 'rows'> & { expectations: Array<ResolversParentTypes['DecisionTableExpectation']>, rows: Array<ResolversParentTypes['DecisionTableRow']> };
  DecisionTableRevisionInput: DecisionTableRevisionInput;
  DecisionTableRow: Omit<DecisionTableRow, 'input' | 'response'> & { input: ResolversParentTypes['RulesInput'], response: ResolversParentTypes['RulesResponse'] };
  DecisionTableRowInput: DecisionTableRowInput;
  DecisionTableTestResult: DecisionTableTestResult;
  DeclarationFormletFields: DeclarationFormletFields;
  DeclarationFormletSection: DeclarationFormletSection;
  DeclarationInput: DeclarationInput;
  DeclarationInputValueInput: DeclarationInputValueInput;
  DeclarationInputValueOutput: DeclarationInputValueOutput;
  DeclarationOutput: DeclarationOutput;
  DeclarationStatement: DeclarationStatement;
  DeclarationStatementInput: DeclarationStatementInput;
  DeclarationStatementTrace: DeclarationStatementTrace;
  DeclarationsInput: DeclarationsInput;
  DeclarationsResponse: DeclarationsResponse;
  DeclarationsResponseInput: DeclarationsResponseInput;
  DeclarationsType: DeclarationsType;
  DeleteReplacementExportRequestInput: DeleteReplacementExportRequestInput;
  DeleteReplacementExportRequestResponse: DeleteReplacementExportRequestResponse;
  DestinationProductTracking: DestinationProductTracking;
  DfeCondition: DfeCondition;
  DfeConditionInput: DfeConditionInput;
  DfeConfig: DfeConfig;
  DfeConfigInput: DfeConfigInput;
  DfeCrossExclusion: DfeCrossExclusion;
  DfeCrossFieldValidation: DfeCrossFieldValidation;
  DfeCustomRule: DfeCustomRule;
  DfeCustomRuleInput: DfeCustomRuleInput;
  DfeDeclarationGroup: DfeDeclarationGroup;
  DfeDeclarationStatement: DfeDeclarationStatement;
  DfeDeclarationStatementInput: DfeDeclarationStatementInput;
  DfeExclusiveGroup: DfeExclusiveGroup;
  DfeField: DfeField;
  DfeFieldDisableGroup: DfeFieldDisableGroup;
  DfeFieldInput: DfeFieldInput;
  DfeMeta: DfeMeta;
  DfeRequestInput: DfeRequestInput;
  DfeTemplateInfo: DfeTemplateInfo;
  DfeValidation: DfeValidation;
  DfeValidationInput: DfeValidationInput;
  DfeValidationMessages: DfeValidationMessages;
  DfeValidationMessagesInput: DfeValidationMessagesInput;
  DfeValidationRules: DfeValidationRules;
  DfeValidationRulesInput: DfeValidationRulesInput;
  DfeValueUnitPair: DfeValueUnitPair;
  DisplayTypeSettings: DisplayTypeSettings;
  DisplayTypeSettingsInput: DisplayTypeSettingsInput;
  DownloadExportRequestsCsvInput: DownloadExportRequestsCsvInput;
  DownloadSupportingDocumentsCsvInput: DownloadSupportingDocumentsCsvInput;
  DownloadTransferProcessHistoryXMLInput: DownloadTransferProcessHistoryXmlInput;
  DownloadTransferRequestsCsvInput: DownloadTransferRequestsCsvInput;
  DraftCertificateGenerationStatusResponse: DraftCertificateGenerationStatusResponse;
  DraftExportCertificate: DraftExportCertificate;
  EStarOrganisation: EStarOrganisation;
  EStarOrganisationFilter: EStarOrganisationFilter;
  EUIngredient: EuIngredient;
  EUIngredientInput: EuIngredientInput;
  EUIngredientsTemplate: EuIngredientsTemplate;
  EgRequestInput: EgRequestInput;
  EligibilityInput: EligibilityInput;
  EligibilityResponse: EligibilityResponse;
  EligibilityResponseInput: EligibilityResponseInput;
  EligibilityType: EligibilityType;
  EnumerationInfo: EnumerationInfo;
  EstarCancelRequest: EstarCancelRequest;
  ExhaustTransferProductsInput: ExhaustTransferProductsInput;
  ExhaustTransferProductsResponse: ExhaustTransferProductsResponse;
  ExhaustTransferRequestInput: ExhaustTransferRequestInput;
  ExhaustTransferRequestResponse: ExhaustTransferRequestResponse;
  ExhaustionResponse: ExhaustionResponse;
  ExportCertificateCollectionInput: ExportCertificateCollectionInput;
  ExportCertificateCollectionResponse: ExportCertificateCollectionResponse;
  ExportCertificateRequest: ExportCertificateRequest;
  ExportCertificateRequestInput: ExportCertificateRequestInput;
  ExportCertificateSupportingDocumentsInput: ExportCertificateSupportingDocumentsInput;
  ExportCertificateWorkflowInput: ExportCertificateWorkflowInput;
  ExportCertificateWorkflowResponse: ExportCertificateWorkflowResponse;
  ExportCertificateWorkflowResponseInput: ExportCertificateWorkflowResponseInput;
  ExportCertificateWorkflowType: ExportCertificateWorkflowType;
  ExportCsvResponse: ExportCsvResponse;
  ExportDetailsInput: ExportDetailsInput;
  ExportRequestHistoryInput: ExportRequestHistoryInput;
  ExportRequestHistoryRecord: ExportRequestHistoryRecord;
  ExportSPSAcknowledgementInput: ExportSpsAcknowledgementInput;
  ExportSPSAcknowledgementResponse: ExportSpsAcknowledgementResponse;
  ExtendIntendedOperatorInput: ExtendIntendedOperatorInput;
  Field: Field;
  FieldBySubmissionLayout: FieldBySubmissionLayout;
  FieldConfiguration: FieldConfiguration;
  FieldFilterInput: FieldFilterInput;
  FieldInfo: FieldInfo;
  FieldInput: FieldInput;
  FieldV2: FieldV2;
  FlexiFillingRunData: FlexiFillingRunData;
  FlexiFillingRunDataInput: FlexiFillingRunDataInput;
  FlexiFillingRunInput: FlexiFillingRunInput;
  FlexiFillingRunResponse: FlexiFillingRunResponse;
  Float: Scalars['Float']['output'];
  Form: Form;
  FormletCollectionFilter: FormletCollectionFilter;
  FormletField: FormletField;
  FormletNestedFields: FormletNestedFields;
  FormletOption: FormletOption;
  ForwardProductTrackingResponse: ForwardProductTrackingResponse;
  G2GAccount: G2GAccount;
  G2GAccountSearchResult: G2GAccountSearchResult;
  G2GAccountSummary: G2GAccountSummary;
  G2GPermissions: G2GPermissions;
  G2GPermissionsInput: G2GPermissionsInput;
  GenerateDraftExportCertificateInput: GenerateDraftExportCertificateInput;
  GenerateOutputPreviewXMLResult: GenerateOutputPreviewXmlResult;
  GenerateSubmissionPreviewXmlResponse: GenerateSubmissionPreviewXmlResponse;
  GeneratedCertificate: GeneratedCertificate;
  GetDfeFormInput: GetDfeFormInput;
  GetDraftCertificateGenerationStatusInput: GetDraftCertificateGenerationStatusInput;
  GetRequestValidationsInput: GetRequestValidationsInput;
  GetRequestValidationsResponse: GetRequestValidationsResponse;
  GetSignedCertificateXmlInput: GetSignedCertificateXmlInput;
  GetSignedCertificateXmlResponse: GetSignedCertificateXmlResponse;
  GetSupportingDocumentActionsInput: GetSupportingDocumentActionsInput;
  GetSupportingDocumentDetailsInput: GetSupportingDocumentDetailsInput;
  GetSupportingDocumentHistoryInput: GetSupportingDocumentHistoryInput;
  GetTemplateXmlCoreInput: GetTemplateXmlCoreInput;
  GetTemplateXmlCoreResponse: GetTemplateXmlCoreResponse;
  IConfig: ResolversInterfaceTypes<ResolversParentTypes>['IConfig'];
  IConfigBase: ResolversInterfaceTypes<ResolversParentTypes>['IConfigBase'];
  IConfigField: ResolversInterfaceTypes<ResolversParentTypes>['IConfigField'];
  ID: Scalars['ID']['output'];
  IDfeValidationRules: ResolversInterfaceTypes<ResolversParentTypes>['IDfeValidationRules'];
  IDsTemplate: IDsTemplate;
  IMeasureTemplate: ResolversInterfaceTypes<ResolversParentTypes>['IMeasureTemplate'];
  IPPCHubLogEntry: IppcHubLogEntry;
  IPPCHubLogInput: IppcHubLogInput;
  ITemplateProcessGroup: ResolversInterfaceTypes<ResolversParentTypes>['ITemplateProcessGroup'];
  ImportCertificate: ImportCertificate;
  ImportCertificateEmbeddedDocument: ImportCertificateEmbeddedDocument;
  ImportCertificateExtractItem: ImportCertificateExtractItem;
  ImportCertificateExtractMeasurement: ImportCertificateExtractMeasurement;
  ImportCertificateExtractTemplate: ImportCertificateExtractTemplate;
  ImportCertificateIntegration: ImportCertificateIntegration;
  ImportCertificateLogMessage: ImportCertificateLogMessage;
  ImportCertificateLogMessageInput: ImportCertificateLogMessageInput;
  ImportCertificateMeasurementTemplate: ImportCertificateMeasurementTemplate;
  ImportCertificatePackagingTemplate: ImportCertificatePackagingTemplate;
  ImportCertificatePdf: ImportCertificatePdf;
  ImportCertificatePdfInput: ImportCertificatePdfInput;
  ImportCertificateStatusChangeInput: ImportCertificateStatusChangeInput;
  ImportCertificateXml: ImportCertificateXml;
  ImportConnectionsInput: ImportConnectionsInput;
  ImportConnectionsResponse: ImportConnectionsResponse;
  ImportConnectionsResponseInput: ImportConnectionsResponseInput;
  ImportConnectionsType: ImportConnectionsType;
  IndicatorType: IndicatorType;
  InitSupportingDocumentUploadInput: InitSupportingDocumentUploadInput;
  InitSupportingDocumentUploadResponse: InitSupportingDocumentUploadResponse;
  Int: Scalars['Int']['output'];
  IntTemplate: IntTemplate;
  IntegrationsAmendExportFromURIInput: IntegrationsAmendExportFromUriInput;
  IntegrationsAmendTransferFromURIInput: IntegrationsAmendTransferFromUriInput;
  IntegrationsCreateSupportingDocumentInput: IntegrationsCreateSupportingDocumentInput;
  IntegrationsDownloadTransferProcessHistoryXMLInput: IntegrationsDownloadTransferProcessHistoryXmlInput;
  IntegrationsExportRequestAPFromURIInput: IntegrationsExportRequestApFromUriInput;
  IntegrationsExportRequestAPInput: IntegrationsExportRequestApInput;
  IntegrationsExportRequestPhytoFromURIInput: IntegrationsExportRequestPhytoFromUriInput;
  IntegrationsExportRequestPhytoInput: IntegrationsExportRequestPhytoInput;
  IntegrationsGetSignedCertificateXmlInput: IntegrationsGetSignedCertificateXmlInput;
  IntegrationsGetTemplateXmlInput: IntegrationsGetTemplateXmlInput;
  IntegrationsGetTemplateXmlResponse: IntegrationsGetTemplateXmlResponse;
  IntegrationsInitSupportingDocumentUploadInput: IntegrationsInitSupportingDocumentUploadInput;
  IntegrationsRaiseTransferFromURIInput: IntegrationsRaiseTransferFromUriInput;
  IntegrationsRaiseTransferInput: IntegrationsRaiseTransferInput;
  IntegrationsReplaceExportCertificateInput: IntegrationsReplaceExportCertificateInput;
  IntegrationsRequestAmendmentTransferInput: IntegrationsRequestAmendmentTransferInput;
  IntegrationsRequestReplacementCertificateInput: IntegrationsRequestReplacementCertificateInput;
  Language: Language;
  Layout: Layout;
  Layouts: Layouts;
  LookupValue: LookupValue;
  ManualVolumeAdjustment: ManualVolumeAdjustment;
  ManualVolumeAdjustmentInput: ManualVolumeAdjustmentInput;
  MasterLayout: MasterLayout;
  MeasureTemplate: MeasureTemplate;
  Measurment: Measurment;
  MeasurmentInput: MeasurmentInput;
  MonthTemplate: MonthTemplate;
  MultiCollectionApiKeys: MultiCollectionApiKeys;
  MultiCollectionApiKeysV2: MultiCollectionApiKeysV2;
  Mutation: {};
  NamedCode: NamedCode;
  NamedCodeInput: NamedCodeInput;
  NamedCodeTemplate: NamedCodeTemplate;
  NewCoreReferencedDocument: NewCoreReferencedDocument;
  NewCoreReferencedDocumentInput: NewCoreReferencedDocumentInput;
  NewReferencedDocument: NewReferencedDocument;
  NumberConstrain: NumberConstrain;
  OCAWithPermissionsInput: OcaWithPermissionsInput;
  OCAWithPermissionsResponse: OcaWithPermissionsResponse;
  PDFSettings: PdfSettings;
  PDFSettingsInput: PdfSettingsInput;
  PackageTemplate: PackageTemplate;
  Packaging: Omit<Packaging, 'runs'> & { runs: Array<ResolversParentTypes['PackagingRun']> };
  PackagingConfirmation: PackagingConfirmation;
  PackagingInput: PackagingInput;
  PackagingRun: ResolversUnionTypes<ResolversParentTypes>['PackagingRun'];
  PhytoOcaEmailNotificationsInput: PhytoOcaEmailNotificationsInput;
  PhytoOcaEmailNotificationsResponse: PhytoOcaEmailNotificationsResponse;
  PhytoOcaEmailNotificationsResponseInput: PhytoOcaEmailNotificationsResponseInput;
  PhytoOcaEmailNotificationsType: PhytoOcaEmailNotificationsType;
  PortCountryInfo: PortCountryInfo;
  PrepareXmlFileForB2GInput: PrepareXmlFileForB2GInput;
  PrepareXmlFileForB2GResponse: PrepareXmlFileForB2GResponse;
  PresignedPostField: PresignedPostField;
  PresignedUrl: PresignedUrl;
  PreviewOutputXMLPresignedURLResult: PreviewOutputXmlPresignedUrlResult;
  PrintCertificateInput: PrintCertificateInput;
  PrintCertificateResponse: PrintCertificateResponse;
  ProcessAttributesResponse: ResolversUnionTypes<ResolversParentTypes>['ProcessAttributesResponse'];
  ProcessB2GIntegrationInput: ProcessB2GIntegrationInput;
  ProcessB2GIntegrationResponse: ProcessB2GIntegrationResponse;
  ProcessDetail: ProcessDetail;
  ProcessGroupCaptionSettings: ProcessGroupCaptionSettings;
  ProcessGroupCaptionSettingsInput: ProcessGroupCaptionSettingsInput;
  ProcessGroupDetail: ProcessGroupDetail;
  ProcessGroupInfo: ProcessGroupInfo;
  ProcessInfo: ProcessInfo;
  ProcessResponse: ProcessResponse;
  ProcessTask: ProcessTask;
  ProcessType: ProcessType;
  ProductExhaustionResponse: ProductExhaustionResponse;
  ProductFieldInput: ProductFieldInput;
  ProductFieldResponse: ProductFieldResponse;
  ProductFieldResponseInput: ProductFieldResponseInput;
  ProductFieldType: ProductFieldType;
  ProductFieldsInput: ProductFieldsInput;
  ProductProcessFilterInput: ProductProcessFilterInput;
  ProductProcessResponse: Omit<ProductProcessResponse, 'attributes'> & { attributes: ResolversParentTypes['ProcessAttributesResponse'] };
  ProductProcessesInput: ProductProcessesInput;
  ProductionDateRangeInput: ProductionDateRangeInput;
  PublishXmlFileProcessedInput: PublishXmlFileProcessedInput;
  Query: {};
  RaiseExportRequestInput: RaiseExportRequestInput;
  RaiseExportRequestResponse: RaiseExportRequestResponse;
  RaiseTransferRequestInput: RaiseTransferRequestInput;
  RaiseTransferRequestResponse: RaiseTransferRequestResponse;
  ReferenceCaption: ReferenceCaption;
  ReferenceDataInput: ReferenceDataInput;
  ReferenceDataList: ReferenceDataList;
  ReferenceItem: ReferenceItem;
  ReferenceList: ReferenceList;
  ReferenceListFilter: ReferenceListFilter;
  ReferenceProcessGroupCaption: ReferenceProcessGroupCaption;
  ReferenceValidationMode: ReferenceValidationMode;
  ReferenceValidationResponse: ReferenceValidationResponse;
  ReferencedDocument: ReferencedDocument;
  ReferencedDocumentUrl: ReferencedDocumentUrl;
  RegenerateApprovedTemplatesResponse: RegenerateApprovedTemplatesResponse;
  RegenerateApprovedTemplatesResult: RegenerateApprovedTemplatesResult;
  RegenerateCertificateInput: RegenerateCertificateInput;
  RegenerateCertificateResponse: RegenerateCertificateResponse;
  RegistrationType: RegistrationType;
  ReindexResponse: ReindexResponse;
  RemoveProductProcessesInput: RemoveProductProcessesInput;
  RemoveProductProcessesResponse: RemoveProductProcessesResponse;
  RemoveProductsFromRequestInput: RemoveProductsFromRequestInput;
  RemoveSources: RemoveSources;
  RequestConfirmationInput: RequestConfirmationInput;
  RequestConfirmationResponse: RequestConfirmationResponse;
  RequestHistoryForSF: RequestHistoryForSf;
  RequestHistoryForSFInput: RequestHistoryForSfInput;
  RequestPartyRoleInput: RequestPartyRoleInput;
  RequestPartyRolesResponse: RequestPartyRolesResponse;
  RequestValidation: RequestValidation;
  ResetConfirmationRequestInput: ResetConfirmationRequestInput;
  RoleSpecificKeys: RoleSpecificKeys;
  Row: Row;
  RulesExecutionInput: RulesExecutionInput;
  RulesInput: ResolversUnionTypes<ResolversParentTypes>['RulesInput'];
  RulesResponse: ResolversUnionTypes<ResolversParentTypes>['RulesResponse'];
  SPSAddress: SpsAddress;
  SPSAddressInput: SpsAddressInput;
  SPSAuthentication: SpsAuthentication;
  SPSAuthenticationInput: SpsAuthenticationInput;
  SPSCertificate: SpsCertificate;
  SPSClassification: SpsClassification;
  SPSClassificationInput: SpsClassificationInput;
  SPSClause: SpsClause;
  SPSClauseInput: SpsClauseInput;
  SPSConsignment: SpsConsignment;
  SPSConsignmentInput: SpsConsignmentInput;
  SPSConsignmentItem: SpsConsignmentItem;
  SPSConsignmentItemInput: SpsConsignmentItemInput;
  SPSContact: SpsContact;
  SPSContactInput: SpsContactInput;
  SPSCountry: SpsCountry;
  SPSCountryInput: SpsCountryInput;
  SPSCountrySubDivision: SpsCountrySubDivision;
  SPSCountrySubDivisionInput: SpsCountrySubDivisionInput;
  SPSEvent: SpsEvent;
  SPSEventInput: SpsEventInput;
  SPSExchangedDocument: SpsExchangedDocument;
  SPSLocation: SpsLocation;
  SPSLocationInput: SpsLocationInput;
  SPSNote: SpsNote;
  SPSNoteInput: SpsNoteInput;
  SPSPackage: SpsPackage;
  SPSPackageInput: SpsPackageInput;
  SPSParty: SpsParty;
  SPSPartyInput: SpsPartyInput;
  SPSPeriod: SpsPeriod;
  SPSPeriodInput: SpsPeriodInput;
  SPSPerson: SpsPerson;
  SPSPersonInput: SpsPersonInput;
  SPSProcess: SpsProcess;
  SPSProcessCharacteristic: SpsProcessCharacteristic;
  SPSProcessCharacteristicInput: SpsProcessCharacteristicInput;
  SPSProcessInput: SpsProcessInput;
  SPSQualification: SpsQualification;
  SPSQualificationInput: SpsQualificationInput;
  SPSReferencedDocument: SpsReferencedDocument;
  SPSSeal: SpsSeal;
  SPSSealInput: SpsSealInput;
  SPSTemperature: SpsTemperature;
  SPSTemperatureInput: SpsTemperatureInput;
  SPSTradeLineItem: SpsTradeLineItem;
  SPSTradeLineItemInput: SpsTradeLineItemInput;
  SPSTransportEquipment: SpsTransportEquipment;
  SPSTransportEquipmentInput: SpsTransportEquipmentInput;
  SPSTransportMovement: SpsTransportMovement;
  SPSTransportMovementInput: SpsTransportMovementInput;
  SPSTransportMovementTemplate: SpsTransportMovementTemplate;
  SPSWineExporter: SpsWineExporter;
  SalesForceAddress: SalesForceAddress;
  SalesForceContact: SalesForceContact;
  SalesForceEmail: SalesForceEmail;
  SalesForceIdentifier: SalesForceIdentifier;
  SalesForceParty: SalesForceParty;
  SalesForcePhone: SalesForcePhone;
  SalesForceProductId: SalesForceProductId;
  SalesforceErApprovalInput: SalesforceErApprovalInput;
  SalesforceErApprovalResponse: SalesforceErApprovalResponse;
  SalesforceTransferRequestVerificationInput: SalesforceTransferRequestVerificationInput;
  SalesforceTransferRequestVerificationResponse: SalesforceTransferRequestVerificationResponse;
  SaveChangesToReferenceDataInput: SaveChangesToReferenceDataInput;
  SaveChangesToReferenceDataResponse: SaveChangesToReferenceDataResponse;
  SaveG2GAccountInput: SaveG2GAccountInput;
  SavedClassificationOutput: SavedClassificationOutput;
  SavedProcessOutput: SavedProcessOutput;
  SavedProductOutput: SavedProductOutput;
  SearchApiKey: SearchApiKey;
  SearchG2GAccountsInput: SearchG2GAccountsInput;
  SearchOptions: SearchOptions;
  SearchReferenceListResponse: SearchReferenceListResponse;
  SearchTemplateVersionsResponse: SearchTemplateVersionsResponse;
  Section: Section;
  SensoryProcessInput: SensoryProcessInput;
  SensoryProcessRequest: SensoryProcessRequest;
  SfApplication: SfApplication;
  SfApprovedTemplateVersion: SfApprovedTemplateVersion;
  SfCancelExportCertificateInput: SfCancelExportCertificateInput;
  SfChangeExportCertificateRequestStatusInput: SfChangeExportCertificateRequestStatusInput;
  SfChangeExportRequestStatusInput: SfChangeExportRequestStatusInput;
  SfChangeExportRequestStatusResponse: SfChangeExportRequestStatusResponse;
  SfChangeTransferRequestStatusInput: SfChangeTransferRequestStatusInput;
  SfChangeTransferRequestStatusResponse: SfChangeTransferRequestStatusResponse;
  SfDownloadCertificateInput: SfDownloadCertificateInput;
  SfDownloadCertificateResponse: SfDownloadCertificateResponse;
  SfDownloadInput: SfDownloadInput;
  SfGeneratedCertificate: SfGeneratedCertificate;
  SfPrintHistory: SfPrintHistory;
  SfRequest: SfRequest;
  SfRequestExportCertificateReplacementInput: SfRequestExportCertificateReplacementInput;
  SfRequestedToResubmitExportCertificateInput: SfRequestedToResubmitExportCertificateInput;
  SfSearchApprovedTemplatesInput: SfSearchApprovedTemplatesInput;
  SfSearchApprovedTemplatesResponse: SfSearchApprovedTemplatesResponse;
  SfSupportingDocumentMetadata: SfSupportingDocumentMetadata;
  SfUnverifyProductInput: SfUnverifyProductInput;
  SfUpdateProductExhaustionInput: SfUpdateProductExhaustionInput;
  SfUpdateProductExhaustionResponse: SfUpdateProductExhaustionResponse;
  SfUpdateStationerySerialNumbersInput: SfUpdateStationerySerialNumbersInput;
  SfUpdateStationerySerialNumbersResponse: SfUpdateStationerySerialNumbersResponse;
  SfUpdateTransferAuditCommentInput: SfUpdateTransferAuditCommentInput;
  SfUpdateTransferAuditCommentResponse: SfUpdateTransferAuditCommentResponse;
  SfVerifyExportCertificateRequestProductsInput: SfVerifyExportCertificateRequestProductsInput;
  SfVerifyProductInput: SfVerifyProductInput;
  SnapshotPresignedUrlResponse: SnapshotPresignedUrlResponse;
  SourceProductTracking: SourceProductTracking;
  SourceTransfer: SourceTransfer;
  SourcedProduct: SourcedProduct;
  SourcedProductAttributes: SourcedProductAttributes;
  SourcedProductDetails: SourcedProductDetails;
  SpsAcknowledgementInput: SpsAcknowledgementInput;
  SpsAcknowledgementOutput: SpsAcknowledgementOutput;
  SpsAddressTemplate: SpsAddressTemplate;
  SpsAuthenticationTemplate: SpsAuthenticationTemplate;
  SpsCertificateTemplate: SpsCertificateTemplate;
  SpsClassificationTemplate: SpsClassificationTemplate;
  SpsClauseTemplate: SpsClauseTemplate;
  SpsConsignmentItemTemplate: SpsConsignmentItemTemplate;
  SpsConsignmentTemplate: SpsConsignmentTemplate;
  SpsContactTemplate: SpsContactTemplate;
  SpsCountrySubDivisionTemplate: SpsCountrySubDivisionTemplate;
  SpsCountryTemplate: SpsCountryTemplate;
  SpsEventTemplate: SpsEventTemplate;
  SpsExchangedDocumentTemplate: SpsExchangedDocumentTemplate;
  SpsLocationTemplate: SpsLocationTemplate;
  SpsNoteTemplate: SpsNoteTemplate;
  SpsPackageTemplate: SpsPackageTemplate;
  SpsPartyTemplate: SpsPartyTemplate;
  SpsPeriodTemplate: SpsPeriodTemplate;
  SpsPersonTemplate: SpsPersonTemplate;
  SpsProcessCharacteristicTemplate: SpsProcessCharacteristicTemplate;
  SpsProcessTemplate: SpsProcessTemplate;
  SpsQualificationTemplate: SpsQualificationTemplate;
  SpsReplacementCertificateTemplate: SpsReplacementCertificateTemplate;
  SpsSealTemplate: SpsSealTemplate;
  SpsTemperatureTemplate: SpsTemperatureTemplate;
  SpsTradeLineItemTemplate: SpsTradeLineItemTemplate;
  SpsTransportEquipmentTemplate: SpsTransportEquipmentTemplate;
  StandardPdfPreviewResponse: StandardPdfPreviewResponse;
  String: Scalars['String']['output'];
  SubmissionSettings: SubmissionSettings;
  SubmissionSettingsInput: SubmissionSettingsInput;
  SubmissionXmlUrl: SubmissionXmlUrl;
  Subscription: {};
  SupportingDocumentActionsResponse: SupportingDocumentActionsResponse;
  SupportingDocumentHistoryEntry: SupportingDocumentHistoryEntry;
  SupportingDocumentInput: SupportingDocumentInput;
  SupportingDocumentKeys: SupportingDocumentKeys;
  SupportingDocumentPresignedUrlResponse: SupportingDocumentPresignedUrlResponse;
  SupportingDocumentUsageInput: SupportingDocumentUsageInput;
  SupportingDocumentUsageRecord: SupportingDocumentUsageRecord;
  Template: Template;
  TemplateDeclarationGroup: TemplateDeclarationGroup;
  TemplateDeclarationsAcknowledgement: TemplateDeclarationsAcknowledgement;
  TemplateDeclarationsDeleteAcknowledgement: TemplateDeclarationsDeleteAcknowledgement;
  TemplateDeclarationsDeleteInput: TemplateDeclarationsDeleteInput;
  TemplateDeclarationsGroupAcknowledgement: TemplateDeclarationsGroupAcknowledgement;
  TemplateDeclarationsGroupInput: TemplateDeclarationsGroupInput;
  TemplateDeclarationsInput: TemplateDeclarationsInput;
  TemplateDeclarationsStatementAcknowledgement: TemplateDeclarationsStatementAcknowledgement;
  TemplateDeclarationsStatementInput: TemplateDeclarationsStatementInput;
  TemplateDeclarationsTraceAcknowledgement: TemplateDeclarationsTraceAcknowledgement;
  TemplateDeclarationsTracesInput: TemplateDeclarationsTracesInput;
  TemplateDocumentUrl: TemplateDocumentUrl;
  TemplateDocumentUrlV2: TemplateDocumentUrlV2;
  TemplateFieldConfiguration: TemplateFieldConfiguration;
  TemplateFieldConfigurationAcknowledgement: TemplateFieldConfigurationAcknowledgement;
  TemplateFieldConfigurationInput: TemplateFieldConfigurationInput;
  TemplateFieldConfigurationV2: TemplateFieldConfigurationV2;
  TemplateFieldReferenceData: TemplateFieldReferenceData;
  TemplateFilter: TemplateFilter;
  TemplateGeneralSettingsV2: TemplateGeneralSettingsV2;
  TemplateHistory: TemplateHistory;
  TemplateOptionalFilter: TemplateOptionalFilter;
  TemplateOutputV2: TemplateOutputV2;
  TemplateProcessGroupReferenceData: TemplateProcessGroupReferenceData;
  TemplateProcessGroups: TemplateProcessGroups;
  TemplateProcessGroupsConfigAcknowledgement: TemplateProcessGroupsConfigAcknowledgement;
  TemplateSection: TemplateSection;
  TemplateSectionField: TemplateSectionField;
  TemplateSupportingDocument: TemplateSupportingDocument;
  TemplateSupportingDocumentAcknowledgement: TemplateSupportingDocumentAcknowledgement;
  TemplateSupportingDocumentInput: TemplateSupportingDocumentInput;
  TemplateUploadUrl: TemplateUploadUrl;
  TemplateUploadUrlV2: TemplateUploadUrlV2;
  TemplateV2: TemplateV2;
  TemplateVersion: TemplateVersion;
  TemplateVersionId: TemplateVersionId;
  TemplateVersionOutput: TemplateVersionOutput;
  TemplateVersionOutputInput: TemplateVersionOutputInput;
  TemplateVersionV2: TemplateVersionV2;
  TestRegistration: TestRegistration;
  TestUser: TestUser;
  TimeTemplate: TimeTemplate;
  TransferProcessHistoryXmlResponse: TransferProcessHistoryXmlResponse;
  TransferProductDetails: TransferProductDetails;
  TransferReferenceError: TransferReferenceError;
  TransferReferenceInput: TransferReferenceInput;
  TransferReferenceRequestInput: TransferReferenceRequestInput;
  TransferReferenceResponse: TransferReferenceResponse;
  TransferRequestDetails: TransferRequestDetails;
  TransferRequestDetailsInput: TransferRequestDetailsInput;
  TransferRequestHistoryInput: TransferRequestHistoryInput;
  TransferRequestHistoryRecord: TransferRequestHistoryRecord;
  Translation: Translation;
  TranslationInput: TranslationInput;
  TransportMovementCodeTemplate: TransportMovementCodeTemplate;
  TreatmentTemplate: TreatmentTemplate;
  UpdateApprovedTransferTransportInput: UpdateApprovedTransferTransportInput;
  UpdateApprovedTransferTransportResponse: UpdateApprovedTransferTransportResponse;
  UpdatePrintReasonInput: UpdatePrintReasonInput;
  UpdatePrintReasonResponse: UpdatePrintReasonResponse;
  UpdateSupportingDocumentInput: UpdateSupportingDocumentInput;
  UpdateSupportingDocumentResult: UpdateSupportingDocumentResult;
  UpdateTemplateGeneralInput: UpdateTemplateGeneralInput;
  UpdateTemplateInput: UpdateTemplateInput;
  UploadReferenceDataInput: UploadReferenceDataInput;
  UploadReferenceDataResponse: UploadReferenceDataResponse;
  UpsertTemplateProcessGroupConfigInput: UpsertTemplateProcessGroupConfigInput;
  User: User;
  UserDetailsById: UserDetailsById;
  UserInfo: UserInfo;
  UserPermission: UserPermission;
  UserPermissionInput: UserPermissionInput;
  UserProfile: UserProfile;
  Validation: Validation;
  VolumeAdjustmentInput: VolumeAdjustmentInput;
  VolumeAdjustmentResponse: VolumeAdjustmentResponse;
  VolumeMeasureTemplate: VolumeMeasureTemplate;
  WineAnalytesTolerancesInput: WineAnalytesTolerancesInput;
  WineAnalytesTolerancesResponse: WineAnalytesTolerancesResponse;
  WineAnalytesTolerancesResponseInput: WineAnalytesTolerancesResponseInput;
  WineAnalytesTolerancesResponseRowInput: WineAnalytesTolerancesResponseRowInput;
  WineAnalytesTolerancesType: WineAnalytesTolerancesType;
  WineChemistryTemplate: WineChemistryTemplate;
  WineConsignment: WineConsignment;
  WineConsignmentTemplate: WineConsignmentTemplate;
  WineFieldsTemplate: WineFieldsTemplate;
  WineProductFieldInput: WineProductFieldInput;
  WineProductFieldType: WineProductFieldType;
  Winemaking: Winemaking;
  WinemakingConfirmation: WinemakingConfirmation;
  WinemakingConfirmationInput: WinemakingConfirmationInput;
  XMLSettings: XmlSettings;
  XMLSettingsInput: XmlSettingsInput;
  addProductAndProcessFromTransferInput: AddProductAndProcessFromTransferInput;
  awsS3PostUploadUrl: AwsS3PostUploadUrl;
  getDeclarationInputsResponse: GetDeclarationInputsResponse;
};

export type Aws_Cognito_User_PoolsDirectiveArgs = {
  cognito_groups?: Maybe<Array<Scalars['String']['input']>>;
};

export type Aws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_IamDirectiveArgs = { };

export type Aws_IamDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_LambdaDirectiveArgs = { };

export type Aws_LambdaDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_LambdaDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_SubscribeDirectiveArgs = {
  mutations: Array<Scalars['String']['input']>;
};

export type Aws_SubscribeDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export interface AwsDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface AwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface AwsEmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export interface AwsipAddressScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress';
}

export interface AwsjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export interface AwsPhoneScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone';
}

export interface AwsTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTime'], any> {
  name: 'AWSTime';
}

export interface AwsTimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp';
}

export interface AwsurlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type ActiveTemplateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveTemplateResult'] = ResolversParentTypes['ActiveTemplateResult']> = {
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateVersionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agency'] = ResolversParentTypes['Agency']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AgencyType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregatedProcessHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregatedProcessHistory'] = ResolversParentTypes['AggregatedProcessHistory']> = {
  concatenated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  currentEndDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  currentStartDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  dateOverride?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  earliestStartDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastProcessEndDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  lastProcessStartDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  latestEndDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  latestSubmissionDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  overriddenEndDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  overriddenStartDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  owned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  premisesIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  premisesName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premisesRegistrationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  processUnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  registrationTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnnouncementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = {
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AnnouncementStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnnouncementListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementList'] = ResolversParentTypes['AnnouncementList']> = {
  items?: Resolver<Array<ResolversTypes['Announcement']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApprovedProductRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApprovedProductRequest'] = ResolversParentTypes['ApprovedProductRequest']> = {
  products?: Resolver<Array<ResolversTypes['TransferProductDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableTemplateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableTemplateFields'] = ResolversParentTypes['AvailableTemplateFields']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationMarket?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  displayedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportCertificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  majorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsS3FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AwsS3Fields'] = ResolversParentTypes['AwsS3Fields']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GAddress'] = ResolversParentTypes['B2GAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cityId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  countryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countrySubdivisionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  countrySubdivisionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcodeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['AddressTypeCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GAuthenticationResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GAuthentication'] = ResolversParentTypes['B2GAuthentication']> = {
  actual?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  includedClauses?: Resolver<Array<ResolversTypes['B2GClause']>, ParentType, ContextType>;
  issueLocation?: Resolver<Maybe<ResolversTypes['B2GLocation']>, ParentType, ContextType>;
  locationProviderParty?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  providerParty?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GCertificateDeliveryResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GCertificateDelivery'] = ResolversParentTypes['B2GCertificateDelivery']> = {
  certificateDeliveryMethod?: Resolver<Maybe<ResolversTypes['B2GCertificateDeliveryMethod']>, ParentType, ContextType>;
  certificateSigningOffice?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  collectionMethod?: Resolver<Maybe<ResolversTypes['B2GCollectionMethod']>, ParentType, ContextType>;
  copies?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  digitalScanRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  recipientAddress?: Resolver<Maybe<ResolversTypes['B2GAddress']>, ParentType, ContextType>;
  recipientContactName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GClassificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GClassification'] = ResolversParentTypes['B2GClassification']> = {
  classCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  className?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  systemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GClauseResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GClause'] = ResolversParentTypes['B2GClause']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GConsignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GConsignment'] = ResolversParentTypes['B2GConsignment']> = {
  EORINumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  consignorReference?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  containers?: Resolver<Array<ResolversTypes['B2GContainer']>, ParentType, ContextType>;
  delivery?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  expectedArrivalDateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  exportExitDateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  grossWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['B2GTradeLineItem']>, ParentType, ContextType>;
  loadingBasePort?: Resolver<Maybe<ResolversTypes['B2GLocation']>, ParentType, ContextType>;
  mainCarriageTransportMovements?: Resolver<Array<ResolversTypes['B2GTransportMovement']>, ParentType, ContextType>;
  unloadingBasePort?: Resolver<Maybe<ResolversTypes['B2GLocation']>, ParentType, ContextType>;
  verifier?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  wineConsignment?: Resolver<Maybe<ResolversTypes['B2GWineConsignment']>, ParentType, ContextType>;
  wineShippingFormat?: Resolver<Maybe<ResolversTypes['WinePackaging']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GContact'] = ResolversParentTypes['B2GContact']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  personName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GContainer'] = ResolversParentTypes['B2GContainer']> = {
  affixedSeals?: Resolver<Array<ResolversTypes['B2GSeal']>, ParentType, ContextType>;
  containerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  temperatureSettings?: Resolver<Array<ResolversTypes['B2GTemperature']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GCountry'] = ResolversParentTypes['B2GCountry']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subdivision?: Resolver<Maybe<ResolversTypes['B2GCountrySubDivision']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GCountrySubDivisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GCountrySubDivision'] = ResolversParentTypes['B2GCountrySubDivision']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GDeclarationResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GDeclaration'] = ResolversParentTypes['B2GDeclaration']> = {
  eligibilityCriteria?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GEligibilityCriteriaMetResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GEligibilityCriteriaMet'] = ResolversParentTypes['B2GEligibilityCriteriaMet']> = {
  effectiveDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  eligibilityCriteria?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GEligibilityStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GEligibilityStatus'] = ResolversParentTypes['B2GEligibilityStatus']> = {
  expiryDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  market?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['B2GEligibilityStatusType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GExportCertificateRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GExportCertificateRequest'] = ResolversParentTypes['B2GExportCertificateRequest']> = {
  certificateDelivery?: Resolver<Maybe<ResolversTypes['B2GCertificateDelivery']>, ParentType, ContextType>;
  certificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignment?: Resolver<Maybe<ResolversTypes['B2GConsignment']>, ParentType, ContextType>;
  customsPermitNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['B2GCountry']>, ParentType, ContextType>;
  exporterDeclaration?: Resolver<Maybe<ResolversTypes['B2GExporterDeclaration']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastStatusChange?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  market?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  referencedDocuments?: Resolver<Array<ResolversTypes['B2GReferencedDocument']>, ParentType, ContextType>;
  replacedBy?: Resolver<Maybe<ResolversTypes['B2GExportCertificateRequest']>, ParentType, ContextType>;
  replacing?: Resolver<Maybe<ResolversTypes['B2GExportCertificateRequest']>, ParentType, ContextType>;
  requestName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestedOnBehalfOfConsignor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ExportCertificateStatus'], ParentType, ContextType>;
  statusLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GExportCertificatesDownloadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GExportCertificatesDownloadUrl'] = ResolversParentTypes['B2GExportCertificatesDownloadUrl']> = {
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GExporterDeclarationResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GExporterDeclaration'] = ResolversParentTypes['B2GExporterDeclaration']> = {
  date?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GLocation'] = ResolversParentTypes['B2GLocation']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GNote'] = ResolversParentTypes['B2GNote']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subjectCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GPackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GPackage'] = ResolversParentTypes['B2GPackage']> = {
  levelCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nominalGrossVolume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nominalGrossWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packaging?: Resolver<Maybe<ResolversTypes['B2GPackage']>, ParentType, ContextType>;
  physicalShippingMarks?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GPartyResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GParty'] = ResolversParentTypes['B2GParty']> = {
  definedContacts?: Resolver<Array<ResolversTypes['B2GContact']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<ResolversTypes['B2GRegistrationDetails']>, ParentType, ContextType>;
  specifiedAddress?: Resolver<Maybe<ResolversTypes['B2GAddress']>, ParentType, ContextType>;
  specifiedPerson?: Resolver<Maybe<ResolversTypes['B2GPerson']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GPeriod'] = ResolversParentTypes['B2GPeriod']> = {
  duration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GPersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GPerson'] = ResolversParentTypes['B2GPerson']> = {
  attainedQualifications?: Resolver<Array<ResolversTypes['B2GQualification']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GPremiseResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GPremise'] = ResolversParentTypes['B2GPremise']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProcessResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProcess'] = ResolversParentTypes['B2GProcess']> = {
  applicableProcessCharacteristics?: Resolver<Array<ResolversTypes['B2GProcessCharacteristic']>, ParentType, ContextType>;
  completionPeriod?: Resolver<Maybe<ResolversTypes['B2GPeriod']>, ParentType, ContextType>;
  operationCountry?: Resolver<Maybe<ResolversTypes['B2GCountry']>, ParentType, ContextType>;
  operatorParty?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProcessCharacteristicResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProcessCharacteristic'] = ResolversParentTypes['B2GProcessCharacteristic']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maximum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProduct'] = ResolversParentTypes['B2GProduct']> = {
  additionalInformation?: Resolver<Array<ResolversTypes['B2GNote']>, ParentType, ContextType>;
  appliedProcesses?: Resolver<Array<ResolversTypes['B2GProcess']>, ParentType, ContextType>;
  assertedAuthentications?: Resolver<Array<ResolversTypes['B2GAuthentication']>, ParentType, ContextType>;
  classifications?: Resolver<Array<ResolversTypes['B2GClassification']>, ParentType, ContextType>;
  cnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commonName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declarations?: Resolver<Maybe<Array<ResolversTypes['B2GDeclaration']>>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligibilityCriteriaFailed?: Resolver<Maybe<Array<ResolversTypes['B2GEligibilityCriteriaMet']>>, ParentType, ContextType>;
  eligibilityCriteriaMet?: Resolver<Maybe<Array<ResolversTypes['B2GEligibilityCriteriaMet']>>, ParentType, ContextType>;
  eligibilityStatus?: Resolver<Maybe<Array<ResolversTypes['B2GEligibilityStatus']>>, ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['B2GProductEvent']>, ParentType, ContextType>;
  expiry?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  exporterReference?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  finalProcessor?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  grossVolume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hsCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  intendedUse?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  migrationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  modifiable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  netVolume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  physicalPackage?: Resolver<Maybe<ResolversTypes['B2GPackage']>, ParentType, ContextType>;
  premise?: Resolver<ResolversTypes['B2GPremise'], ParentType, ContextType>;
  productNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productionBatchIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  referencedDocuments?: Resolver<Array<ResolversTypes['B2GReferencedDocument']>, ParentType, ContextType>;
  scientificName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifier?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  wine?: Resolver<Maybe<ResolversTypes['B2GWineFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProductEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProductEligibility'] = ResolversParentTypes['B2GProductEligibility']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  criteriaId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  executionArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  market?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['B2GEligibilityStatusType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProductEligibilityCriteriaV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProductEligibilityCriteriaV2'] = ResolversParentTypes['B2GProductEligibilityCriteriaV2']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  criteria?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  met?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  processId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  wsmpId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProductEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProductEvent'] = ResolversParentTypes['B2GProductEvent']> = {
  from?: Resolver<ResolversTypes['B2GProduct'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  other?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<ResolversTypes['B2GProduct'], ParentType, ContextType>;
  what?: Resolver<ResolversTypes['B2GProductEventType'], ParentType, ContextType>;
  when?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  where?: Resolver<ResolversTypes['B2GPremise'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GProductsDownloadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GProductsDownloadUrl'] = ResolversParentTypes['B2GProductsDownloadUrl']> = {
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GQualificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GQualification'] = ResolversParentTypes['B2GQualification']> = {
  abbreviatedName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GReferencedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GReferencedDocument'] = ResolversParentTypes['B2GReferencedDocument']> = {
  attachment?: Resolver<Maybe<ResolversTypes['ReferencedDocument']>, ParentType, ContextType>;
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issued?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  relationshipTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestorId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GRegistrationDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GRegistrationDetails'] = ResolversParentTypes['B2GRegistrationDetails']> = {
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GSealResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GSeal'] = ResolversParentTypes['B2GSeal']> = {
  issuingParty?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  sealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GTemperatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GTemperature'] = ResolversParentTypes['B2GTemperature']> = {
  maximum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GTradeLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GTradeLineItem'] = ResolversParentTypes['B2GTradeLineItem']> = {
  associatedTransportEquipment?: Resolver<Array<ResolversTypes['B2GContainer']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  physicalPackage?: Resolver<Maybe<ResolversTypes['B2GPackage']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['B2GProduct']>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GTradeLineItemContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GTradeLineItemContainer'] = ResolversParentTypes['B2GTradeLineItemContainer']> = {
  containerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  grossVolume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netVolume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GTransportMovementResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GTransportMovement'] = ResolversParentTypes['B2GTransportMovement']> = {
  ITDNNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['TransportModeCode'], ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registeredCountry?: Resolver<Maybe<ResolversTypes['B2GCountry']>, ParentType, ContextType>;
  usedTransportMeans?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GValidationErrorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GValidationErrors'] = ResolversParentTypes['B2GValidationErrors']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['B2GError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GWineChemistryResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GWineChemistry'] = ResolversParentTypes['B2GWineChemistry']> = {
  actual_alcohol_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  citric_acidity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  laboratory?: Resolver<Maybe<ResolversTypes['B2GParty']>, ParentType, ContextType>;
  laboratoryReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  methyl_alcohol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reduced_dry_extract?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sugar_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sugar_content_qualifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_acidity_7_0?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_acidity_8_2_meql?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_alcoholic_strength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_dry_extract?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_sulphates?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_sulphur_dioxide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  volatile_acidity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  volatile_acidity_meql?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GWineConsignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GWineConsignment'] = ResolversParentTypes['B2GWineConsignment']> = {
  packaging?: Resolver<Maybe<ResolversTypes['B2GPackage']>, ParentType, ContextType>;
  shippingFormat?: Resolver<Maybe<ResolversTypes['WinePackaging']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GWineFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GWineFields'] = ResolversParentTypes['B2GWineFields']> = {
  BRClassification?: Resolver<Maybe<ResolversTypes['BRClassification']>, ParentType, ContextType>;
  EUCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EUIngredients?: Resolver<Maybe<Array<ResolversTypes['EUIngredient']>>, ParentType, ContextType>;
  alternateWineNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  availableLitres?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  batchNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bottlerReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chemistry?: Resolver<Maybe<ResolversTypes['B2GWineChemistry']>, ParentType, ContextType>;
  colour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportedLitres?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  geographicIndication?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  grapeVariety?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isEUEligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainNamePrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainNameSuffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  package?: Resolver<Maybe<ResolversTypes['B2GWinePackage']>, ParentType, ContextType>;
  shippingFormat?: Resolver<Maybe<ResolversTypes['WinePackaging']>, ParentType, ContextType>;
  specialProcess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalPackagedLitres?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vintage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  volumeAdjustment?: Resolver<Maybe<Array<ResolversTypes['ManualVolumeAdjustment']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type B2GWinePackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2GWinePackage'] = ResolversParentTypes['B2GWinePackage']> = {
  bottleSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bottlesPerCase?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cases?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  extraBottles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nameForDocuments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalBottles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrClassificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BRClassification'] = ResolversParentTypes['BRClassification']> = {
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sugarContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrClassificationTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BRClassificationTemplate'] = ResolversParentTypes['BRClassificationTemplate']> = {
  class_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sugar_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockResolvers<ContextType = any, ParentType extends ResolversParentTypes['Block'] = ResolversParentTypes['Block']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<ResolversTypes['Row']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BottlingRunDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['BottlingRunData'] = ResolversParentTypes['BottlingRunData']> = {
  bottleVolume?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bottlesPerCase?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cases?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  extraBottles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  litres?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BottlingRunResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BottlingRunResponse'] = ResolversParentTypes['BottlingRunResponse']> = {
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  runs?: Resolver<Array<ResolversTypes['BottlingRunData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessRule'] = ResolversParentTypes['BusinessRule']> = {
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessRuleFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessRuleField'] = ResolversParentTypes['BusinessRuleField']> = {
  BusinessRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessRule']>>>, ParentType, ContextType>;
  fuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessRulesConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessRulesConfig'] = ResolversParentTypes['BusinessRulesConfig']> = {
  businessRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessRule']>>>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessRuleField']>>>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  templateRevisionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelledProcessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelledProcessResponse'] = ResolversParentTypes['CancelledProcessResponse']> = {
  cancelledReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstResultReportedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receipt?: Resolver<ResolversTypes['ChemistryTestReceipt'], ParentType, ContextType>;
  request?: Resolver<ResolversTypes['ChemistryTestRequest'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateCollectionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateCollectionOutput'] = ResolversParentTypes['CertificateCollectionOutput']> = {
  certificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeExportRequestStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeExportRequestStatusResponse'] = ResolversParentTypes['ChangeExportRequestStatusResponse']> = {
  exportRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeTransferRequestAmendmentStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeTransferRequestAmendmentStatusResponse'] = ResolversParentTypes['ChangeTransferRequestAmendmentStatusResponse']> = {
  certificateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeTransferRequestStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeTransferRequestStatusResponse'] = ResolversParentTypes['ChangeTransferRequestStatusResponse']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckUserAccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckUserAccessResponse'] = ResolversParentTypes['CheckUserAccessResponse']> = {
  allowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChemistryTestReceiptResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChemistryTestReceipt'] = ResolversParentTypes['ChemistryTestReceipt']> = {
  laboratoryReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiptDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  sampleSuitable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unsuitableReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChemistryTestRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChemistryTestRequest'] = ResolversParentTypes['ChemistryTestRequest']> = {
  expectedAlcoholContent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  laboratory?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  packagingDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  packagingReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleCollectionDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  sampleReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  testRequired?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  wineTestReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChemistryTestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChemistryTestResponse'] = ResolversParentTypes['ChemistryTestResponse']> = {
  cancelledReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstResultReportedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passedDestinationMarkets?: Resolver<Maybe<Array<ResolversTypes['DestinationMarket']>>, ParentType, ContextType>;
  receipt?: Resolver<ResolversTypes['ChemistryTestReceipt'], ParentType, ContextType>;
  request?: Resolver<ResolversTypes['ChemistryTestRequest'], ParentType, ContextType>;
  requestedDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<ResolversTypes['ChemistryTestResult']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChemistryTestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChemistryTestResult'] = ResolversParentTypes['ChemistryTestResult']> = {
  assayTestName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assayTestNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qualifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportedDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  resultState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CombinedPartyTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CombinedPartyTemplate'] = ResolversParentTypes['CombinedPartyTemplate']> = {
  authenticator?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmPackagingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmPackagingResponse'] = ResolversParentTypes['ConfirmPackagingResponse']> = {
  confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disputeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputeResolution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsignorDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConsignorDetails'] = ResolversParentTypes['ConsignorDetails']> = {
  identifiers?: Resolver<Array<ResolversTypes['ConsignorIdentifier']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  physicalAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsignorIdentifierResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConsignorIdentifier'] = ResolversParentTypes['ConsignorIdentifier']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreAddress'] = ResolversParentTypes['CoreAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lines?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreB2GFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreB2GFile'] = ResolversParentTypes['CoreB2GFile']> = {
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extensionType?: Resolver<Maybe<ResolversTypes['PhytoSupportingDocumentType']>, ParentType, ContextType>;
  fileContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreCommodityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreCommodity'] = ResolversParentTypes['CoreCommodity']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreContainer'] = ResolversParentTypes['CoreContainer']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seals?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreCountry'] = ResolversParentTypes['CoreCountry']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreDateRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreDateRange'] = ResolversParentTypes['CoreDateRange']> = {
  from?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreDeclarationInputValueOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreDeclarationInputValueOutput'] = ResolversParentTypes['CoreDeclarationInputValueOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  inputValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreDeclarationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreDeclarationOutput'] = ResolversParentTypes['CoreDeclarationOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  inputs?: Resolver<Maybe<Array<ResolversTypes['CoreDeclarationInputValueOutput']>>, ParentType, ContextType>;
  selected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  statementCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  substitutedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substitutedTranslatedText?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreDeclarationTranslatedText']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreDeclarationTranslatedTextResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreDeclarationTranslatedText'] = ResolversParentTypes['CoreDeclarationTranslatedText']> = {
  languageCode?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportContainer'] = ResolversParentTypes['CoreExportContainer']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  productItemId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  seals?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportDetails'] = ResolversParentTypes['CoreExportDetails']> = {
  action?: Resolver<Maybe<ResolversTypes['CoreHistoryExportActions']>, ParentType, ContextType>;
  additionalDeclaration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalDeclarationCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  approvedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedCertificateEmailAddresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  approverQualification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attributes?: Resolver<Maybe<ResolversTypes['CoreExportRequestAttributes']>, ParentType, ContextType>;
  calculatedTotalGrossWeight?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  certificateNumberReplacedById?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateNumberReplacesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificate_type?: Resolver<Maybe<ResolversTypes['CoreExportCertificateType']>, ParentType, ContextType>;
  certifyingAgencyId?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['CoreCommodity'], ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  consigneeRegId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  consignorRegId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copiedFromId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customsTransitAgent?: Resolver<Maybe<ResolversTypes['CoreExportRequestPartyType']>, ParentType, ContextType>;
  declarations?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreDeclarationOutput']>>>, ParentType, ContextType>;
  deliveryDetails?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  deliveryDispatchDetails?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  destinationCountry?: Resolver<ResolversTypes['CoreCountry'], ParentType, ContextType>;
  destinationParty?: Resolver<Maybe<ResolversTypes['CoreExportRequestPartyType']>, ParentType, ContextType>;
  externalConsignor?: Resolver<Maybe<ResolversTypes['CoreExportRequestPartyType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importer?: Resolver<Maybe<ResolversTypes['CoreExportRequestImporterType']>, ParentType, ContextType>;
  officialStatement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officialStatementCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputTranslationLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  overseasAuthorityInvolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  printDetails?: Resolver<Maybe<ResolversTypes['CorePrintDetails']>, ParentType, ContextType>;
  productGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  productItemGroupDetails?: Resolver<Maybe<ResolversTypes['CoreProductItemGroup']>, ParentType, ContextType>;
  reasonCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  reasonForStatusChange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacedById?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacesApprovedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  replacesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiresAttention?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  signingOffice?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  sourceTransfer?: Resolver<Maybe<Array<ResolversTypes['SourceTransfer']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ExportStatus']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  submittedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreSupportingDocument']>>>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['CoreTemplate']>, ParentType, ContextType>;
  templateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  templateVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdParty?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  thirdPartyConsignor?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  transitCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['CoreExportTransport']>, ParentType, ContextType>;
  uniqueConsignmentReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unofficialInformation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urgency?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  verifyingAgencyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifyingAgencyIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportRequest'] = ResolversParentTypes['CoreExportRequest']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['CoreCommodity'], ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  containers?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreContainer']>>>, ParentType, ContextType>;
  declarations?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeclarationOutput']>>>, ParentType, ContextType>;
  destinationCountry?: Resolver<ResolversTypes['CoreCountry'], ParentType, ContextType>;
  externalConsignor?: Resolver<Maybe<ResolversTypes['CoreExportRequestPartyType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importer?: Resolver<Maybe<ResolversTypes['CoreExportRequestImporterType']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['SavedProductOutput']>>>, ParentType, ContextType>;
  sequenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CoreRequestStatus'], ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['CoreRequestSubstatus']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreSupportingDocument']>>>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['CoreTemplate']>, ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['CoreTransport']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportRequestAddressTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportRequestAddressType'] = ResolversParentTypes['CoreExportRequestAddressType']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  lines?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportRequestAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportRequestAttributes'] = ResolversParentTypes['CoreExportRequestAttributes']> = {
  address?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  administrativeTerritorialUnit?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  brandName?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  categoryOfGoods?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  cnInspection?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  contractNo?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  edReference?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  euCommodityCode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  euTransit?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  expRef?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  exporterRef?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  exporterSignature?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  exportingCountryId?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  forImportorAdmission?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  halalAuditor?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  halalCertificateNumber?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  importPermitNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  importPermitNumbersCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inspectionDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  inspectionDateCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuingAuthority?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  issuingAuthority1?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  letterOfCreditRefCode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  manifacturingpremisesname?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  manufacturerRegistration?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  markingofsealontransportcontai?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  nameRegistrationandAddressofse?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  netWeightInWords?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  numberOfDoses?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  numberOfEmbryos?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  numberOfPackagesContainers?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  orgCertRefCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoCertSubType?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoCertificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoLotRefNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoPackhouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoSchemeControl?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoStatementOfRelabelling?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeandDateofQuarantine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productDescription?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  purposeBR?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  sanitoryCertificateNumber?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  shipStores?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  summaryofRecordsfor?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  totalGrossWeight?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  totalQuantity?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportRequestImporterTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportRequestImporterType'] = ResolversParentTypes['CoreExportRequestImporterType']> = {
  address?: Resolver<Maybe<ResolversTypes['CoreExportRequestAddressType']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  representative?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportRequestPartyTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportRequestPartyType'] = ResolversParentTypes['CoreExportRequestPartyType']> = {
  address?: Resolver<Maybe<ResolversTypes['CoreExportRequestAddressType']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportSupportingDocumentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportSupportingDocuments'] = ResolversParentTypes['CoreExportSupportingDocuments']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['PhytoSupportingDocumentType'], ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreExportTransportResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreExportTransport'] = ResolversParentTypes['CoreExportTransport']> = {
  _transportMode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  carrierName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conveyanceReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departureDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  dischargePort?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  expectedArrivalDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  finalDestination?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  inspectionPort?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  loadingPort?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  localCarrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCarrierReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportMode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreGroup'] = ResolversParentTypes['CoreGroup']> = {
  addressFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreLocation'] = ResolversParentTypes['CoreLocation']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreLookupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreLookup'] = ResolversParentTypes['CoreLookup']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CorePackagingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorePackaging'] = ResolversParentTypes['CorePackaging']> = {
  itemMarksOuter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemMarksOuterCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nominalGrossVolume?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  nominalGrossWeight?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  outermostNumberOfPacakges?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  packageType?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CorePrintDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorePrintDetails'] = ResolversParentTypes['CorePrintDetails']> = {
  officialPrinted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reasonForReprinting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProcessAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProcessAttributes'] = ResolversParentTypes['CoreProcessAttributes']> = {
  additionalTreatment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chemicalDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  concentration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProcessHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProcessHistory'] = ResolversParentTypes['CoreProcessHistory']> = {
  country?: Resolver<Maybe<ResolversTypes['CoreCountry']>, ParentType, ContextType>;
  earliestStartDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  endDatePDF?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  group?: Resolver<Maybe<ResolversTypes['CoreGroup']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  latestEndDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  premise?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startDatePDF?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  unTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProcessTypeLookupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProcessTypeLookup'] = ResolversParentTypes['CoreProcessTypeLookup']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProduct'] = ResolversParentTypes['CoreProduct']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProductAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProductAttributes'] = ResolversParentTypes['CoreProductAttributes']> = {
  NZHSCode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  commonName?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  expiryDateFrom?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  expiryDateTo?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  grossVolume?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  grossWeight?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  inspectionType?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  intendedUse?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  netUnits?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  netVolume?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  originCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  otherQuantity?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  overseasCertIDs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  phytoApprovedSeedCategory?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoBotanicalName?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoClass?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoClassCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoCommonName?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoEndPointInspectionRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoGrowers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoInspectionLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoIsInspectionOnOriginal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoIsOriginalCert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoIsOriginalContainer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoIsRepacked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoLableDescription?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoMixtureName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoObservation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoPackhouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoPercentageByWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phytoQuantityMeasure?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  phytoQuantityType?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoSeedLotApproval?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoSeedLotReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoSubClass?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  phytoSubClassCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoSupplier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoVariety?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productBatchIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  productReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productStatement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productionBatchIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scientificName?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  speciesCommonName?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProductClassificationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProductClassificationResponse'] = ResolversParentTypes['CoreProductClassificationResponse']> = {
  classificationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classificationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldUniqueId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  itemCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProductItemGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProductItemGroup'] = ResolversParentTypes['CoreProductItemGroup']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupType?: Resolver<Maybe<ResolversTypes['CoreRequestType']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['TransferProductDetails']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProductItemRelationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProductItemRelation'] = ResolversParentTypes['CoreProductItemRelation']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  fromId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  toId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreProductProcessResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreProductProcess'] = ResolversParentTypes['CoreProductProcess']> = {
  _processType?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  attributes?: Resolver<Maybe<ResolversTypes['CoreProcessAttributes']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  foreignPremises?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foreignPremisesCountryID?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  foreignPremisesIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSourceProcess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  overrideProcessDate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  premises?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  processGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processType?: Resolver<Maybe<ResolversTypes['CoreProcessTypeLookup']>, ParentType, ContextType>;
  productItemId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sequenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreReferencedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreReferencedDocument'] = ResolversParentTypes['CoreReferencedDocument']> = {
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreReferencedDocumentUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreReferencedDocumentUrl'] = ResolversParentTypes['CoreReferencedDocumentUrl']> = {
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreRegistrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRegistration'] = ResolversParentTypes['CoreRegistration']> = {
  addresses?: Resolver<Maybe<ResolversTypes['CoreAddress']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRequest'] = ResolversParentTypes['CoreRequest']> = {
  __resolveType: TypeResolveFn<'CoreExportRequest' | 'CoreTransferRequest', ParentType, ContextType>;
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['CoreCommodity'], ParentType, ContextType>;
  destinationCountry?: Resolver<ResolversTypes['CoreCountry'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CoreRequestStatus'], ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['CoreRequestSubstatus']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['CoreTemplate']>, ParentType, ContextType>;
};

export type CoreRequestStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRequestStatus'] = ResolversParentTypes['CoreRequestStatus']> = {
  code?: Resolver<Maybe<ResolversTypes['CoreStatus']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreRequestSubstatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRequestSubstatus'] = ResolversParentTypes['CoreRequestSubstatus']> = {
  code?: Resolver<Maybe<ResolversTypes['CoreSubstatus']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreSupportingDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreSupportingDocument'] = ResolversParentTypes['CoreSupportingDocument']> = {
  b2gFile?: Resolver<Maybe<ResolversTypes['CoreB2GFile']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentSequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foreignManufacturePremises?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foreignPremisesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  identificationMarks?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  intendedOperators?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  isLinked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nzManufacturePremises?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originCountry?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  primaryOperator?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  productDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productionDates?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreDateRange']>>>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacedByDocumentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacedById?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacesDocumentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreTemplate'] = ResolversParentTypes['CoreTemplate']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  majorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requestType?: Resolver<Maybe<ResolversTypes['CoreRequestType']>, ParentType, ContextType>;
  templateVersionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreTransferProductSupportingDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreTransferProductSupportingDocument'] = ResolversParentTypes['CoreTransferProductSupportingDocument']> = {
  b2gFile?: Resolver<Maybe<ResolversTypes['CoreB2GFile']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foreignManufacturePremises?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foreignPremisesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  identificationMarks?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  intendedOperators?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  isInherited?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLinked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nzManufacturePremises?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  originCountry?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  primaryOperator?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  productDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productionDates?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreDateRange']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreTransferRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreTransferRequest'] = ResolversParentTypes['CoreTransferRequest']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['CoreCommodity'], ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  containers?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreContainer']>>>, ParentType, ContextType>;
  destinationCountry?: Resolver<ResolversTypes['CoreCountry'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['SavedProductOutput']>>>, ParentType, ContextType>;
  reasonForStatusChange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CoreRequestStatus'], ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['CoreRequestSubstatus']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['CoreTemplate']>, ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['CoreTransport']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreTransportResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreTransport'] = ResolversParentTypes['CoreTransport']> = {
  carrierName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conveyanceReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departureDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  dischargePort?: Resolver<Maybe<ResolversTypes['CoreLocation']>, ParentType, ContextType>;
  expectedArrivalDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  finalDestination?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  inspectionPort?: Resolver<Maybe<ResolversTypes['CoreLocation']>, ParentType, ContextType>;
  loadingPort?: Resolver<Maybe<ResolversTypes['CoreLocation']>, ParentType, ContextType>;
  localCarrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCarrierReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportMode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDfeConfigRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDfeConfigRequest'] = ResolversParentTypes['CreateDfeConfigRequest']> = {
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDfeConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDfeConfigResponse'] = ResolversParentTypes['CreateDfeConfigResponse']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomsPermitNumberUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomsPermitNumberUsage'] = ResolversParentTypes['CustomsPermitNumberUsage']> = {
  allocatedInPastThirtyDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unallocated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeFormResolvers<ContextType = any, ParentType extends ResolversParentTypes['DFEForm'] = ResolversParentTypes['DFEForm']> = {
  config?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfePermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DFEPermission'] = ResolversParentTypes['DFEPermission']> = {
  permissions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DateTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateTemplate'] = ResolversParentTypes['DateTemplate']> = {
  day?: Resolver<ResolversTypes['IntTemplate'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['MonthTemplate'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['IntTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DateTimeTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateTimeTemplate'] = ResolversParentTypes['DateTimeTemplate']> = {
  date?: Resolver<ResolversTypes['DateTemplate'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['TimeTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecimalTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecimalTemplate'] = ResolversParentTypes['DecimalTemplate']> = {
  in_English?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTable'] = ResolversParentTypes['DecisionTable']> = {
  approvedRevision?: Resolver<Maybe<ResolversTypes['DecisionTableRevision']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputColumns?: Resolver<Array<ResolversTypes['DecisionTableColumn']>, ParentType, ContextType>;
  lastRevision?: Resolver<Maybe<ResolversTypes['DecisionTableRevision']>, ParentType, ContextType>;
  responseColumns?: Resolver<Array<ResolversTypes['DecisionTableColumn']>, ParentType, ContextType>;
  revisions?: Resolver<Array<ResolversTypes['DecisionTableRevision']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableBaseInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableBaseInput'] = ResolversParentTypes['DecisionTableBaseInput']> = {
  __resolveType: TypeResolveFn<'DeclarationsType' | 'EligibilityType' | 'ExportCertificateWorkflowType' | 'ImportConnectionsType' | 'PhytoOcaEmailNotificationsType' | 'ProductFieldType' | 'WineAnalytesTolerancesType' | 'WineProductFieldType', ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
};

export type DecisionTableColumnResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableColumn'] = ResolversParentTypes['DecisionTableColumn']> = {
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataType?: Resolver<ResolversTypes['DecisionTableDataType'], ParentType, ContextType>;
  enumeration?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  enumerationInfo?: Resolver<Maybe<Array<ResolversTypes['EnumerationInfo']>>, ParentType, ContextType>;
  header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mandatory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableExpectationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableExpectation'] = ResolversParentTypes['DecisionTableExpectation']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  input?: Resolver<ResolversTypes['RulesInput'], ParentType, ContextType>;
  response?: Resolver<ResolversTypes['RulesResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableField'] = ResolversParentTypes['DecisionTableField']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mandatory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableRevisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableRevision'] = ResolversParentTypes['DecisionTableRevision']> = {
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectations?: Resolver<Array<ResolversTypes['DecisionTableExpectation']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revisionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rows?: Resolver<Array<ResolversTypes['DecisionTableRow']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DecisionTableRevisionStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableRow'] = ResolversParentTypes['DecisionTableRow']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  input?: Resolver<ResolversTypes['RulesInput'], ParentType, ContextType>;
  response?: Resolver<ResolversTypes['RulesResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DecisionTableTestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DecisionTableTestResult'] = ResolversParentTypes['DecisionTableTestResult']> = {
  error_message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  succes?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationFormletFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationFormletFields'] = ResolversParentTypes['DeclarationFormletFields']> = {
  eligibilityCriteria?: Resolver<ResolversTypes['FormletField'], ParentType, ContextType>;
  market?: Resolver<ResolversTypes['FormletField'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['FormletField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationFormletSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationFormletSection'] = ResolversParentTypes['DeclarationFormletSection']> = {
  fields?: Resolver<ResolversTypes['DeclarationFormletFields'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FormletFieldType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationInputValueOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationInputValueOutput'] = ResolversParentTypes['DeclarationInputValueOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationOutput'] = ResolversParentTypes['DeclarationOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  inputs?: Resolver<Maybe<Array<ResolversTypes['DeclarationInputValueOutput']>>, ParentType, ContextType>;
  statementCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationStatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationStatement'] = ResolversParentTypes['DeclarationStatement']> = {
  code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  customNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputs?: Resolver<Maybe<Array<ResolversTypes['DeclarationStatementInput']>>, ParentType, ContextType>;
  sequenceNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statementDisplayCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  traces?: Resolver<Maybe<Array<ResolversTypes['DeclarationStatementTrace']>>, ParentType, ContextType>;
  translations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationStatementInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationStatementInput'] = ResolversParentTypes['DeclarationStatementInput']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputSequenceNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['DeclarationStatementInputType'], ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tracesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationStatementTraceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationStatementTrace'] = ResolversParentTypes['DeclarationStatementTrace']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tracesContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tracesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationsResponse'] = ResolversParentTypes['DeclarationsResponse']> = {
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declaration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  eligibilityCriteria?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclarationsTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclarationsType'] = ResolversParentTypes['DeclarationsType']> = {
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  processType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteReplacementExportRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteReplacementExportRequestResponse'] = ResolversParentTypes['DeleteReplacementExportRequestResponse']> = {
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DestinationProductTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DestinationProductTracking'] = ResolversParentTypes['DestinationProductTracking']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isExhausted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  packagingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productItem?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  requestNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeCondition'] = ResolversParentTypes['DfeCondition']> = {
  fieldRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['DfeOperatorType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeConfig'] = ResolversParentTypes['DfeConfig']> = {
  declarationGroups?: Resolver<Array<ResolversTypes['DfeDeclarationGroup']>, ParentType, ContextType>;
  fields?: Resolver<Array<ResolversTypes['DfeField']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['DfeMeta'], ParentType, ContextType>;
  products?: Resolver<ResolversTypes['Layout'], ParentType, ContextType>;
  requests?: Resolver<ResolversTypes['Layout'], ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  templateRevisionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeCrossExclusionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeCrossExclusion'] = ResolversParentTypes['DfeCrossExclusion']> = {
  fieldA?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fieldB?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeCrossFieldValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeCrossFieldValidation'] = ResolversParentTypes['DfeCrossFieldValidation']> = {
  crossExclusions?: Resolver<Maybe<Array<ResolversTypes['DfeCrossExclusion']>>, ParentType, ContextType>;
  exclusiveGroups?: Resolver<Maybe<Array<ResolversTypes['DfeExclusiveGroup']>>, ParentType, ContextType>;
  fieldDisableGroups?: Resolver<Maybe<Array<ResolversTypes['DfeFieldDisableGroup']>>, ParentType, ContextType>;
  valueUnitPairs?: Resolver<Maybe<Array<ResolversTypes['DfeValueUnitPair']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeCustomRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeCustomRule'] = ResolversParentTypes['DfeCustomRule']> = {
  if?: Resolver<Maybe<ResolversTypes['DfeCondition']>, ParentType, ContextType>;
  then?: Resolver<Maybe<ResolversTypes['DfeCondition']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeDeclarationGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeDeclarationGroup'] = ResolversParentTypes['DfeDeclarationGroup']> = {
  blockType?: Resolver<ResolversTypes['DfeDeclarationBlockType'], ParentType, ContextType>;
  declarationGroupType?: Resolver<ResolversTypes['DeclarationGroupType'], ParentType, ContextType>;
  statements?: Resolver<Array<ResolversTypes['DfeDeclarationStatement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeDeclarationStatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeDeclarationStatement'] = ResolversParentTypes['DfeDeclarationStatement']> = {
  inputs?: Resolver<Maybe<Array<ResolversTypes['DfeDeclarationStatementInput']>>, ParentType, ContextType>;
  statementCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statementDisplayCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statementNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statementText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeDeclarationStatementInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeDeclarationStatementInput'] = ResolversParentTypes['DfeDeclarationStatementInput']> = {
  dataType?: Resolver<ResolversTypes['DeclarationStatementInputType'], ParentType, ContextType>;
  fieldRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inputSequenceNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['DfeDeclarationStatementInputType'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeExclusiveGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeExclusiveGroup'] = ResolversParentTypes['DfeExclusiveGroup']> = {
  fieldAUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fieldAValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fieldBUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fieldBValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeField'] = ResolversParentTypes['DfeField']> = {
  dataType?: Resolver<ResolversTypes['DfeFieldType'], ParentType, ContextType>;
  defaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validation?: Resolver<ResolversTypes['DfeValidation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeFieldDisableGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeFieldDisableGroup'] = ResolversParentTypes['DfeFieldDisableGroup']> = {
  disable?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whenActive?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeMeta'] = ResolversParentTypes['DfeMeta']> = {
  catalogue?: Resolver<Maybe<Array<Maybe<ResolversTypes['DfeMetaCatalogueType']>>>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effective?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  expire?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  majorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeTemplateInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeTemplateInfo'] = ResolversParentTypes['DfeTemplateInfo']> = {
  templateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  templateRevisionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeValidation'] = ResolversParentTypes['DfeValidation']> = {
  messages?: Resolver<Maybe<ResolversTypes['DfeValidationMessages']>, ParentType, ContextType>;
  rules?: Resolver<Maybe<ResolversTypes['DfeValidationRules']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeValidationMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeValidationMessages'] = ResolversParentTypes['DfeValidationMessages']> = {
  custom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  greaterThan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lessThan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pattern?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeValidationRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeValidationRules'] = ResolversParentTypes['DfeValidationRules']> = {
  crossFieldValidation?: Resolver<Maybe<ResolversTypes['DfeCrossFieldValidation']>, ParentType, ContextType>;
  custom?: Resolver<Maybe<ResolversTypes['DfeCustomRule']>, ParentType, ContextType>;
  greaterThan?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  length?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lessThan?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pattern?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DfeValueUnitPairResolvers<ContextType = any, ParentType extends ResolversParentTypes['DfeValueUnitPair'] = ResolversParentTypes['DfeValueUnitPair']> = {
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayTypeSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayTypeSettings'] = ResolversParentTypes['DisplayTypeSettings']> = {
  columnsToDisplay?: Resolver<Maybe<ResolversTypes['ColumnsToDisplay']>, ParentType, ContextType>;
  maxFieldLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceDataList?: Resolver<Maybe<ResolversTypes['ReferenceDataList']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['SortOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftCertificateGenerationStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftCertificateGenerationStatusResponse'] = ResolversParentTypes['DraftCertificateGenerationStatusResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportRequestOutputId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pdfCertificateUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DraftCertificateExecutionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftExportCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftExportCertificate'] = ResolversParentTypes['DraftExportCertificate']> = {
  executionArn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EStarOrganisationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EStarOrganisation'] = ResolversParentTypes['EStarOrganisation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EuIngredientResolvers<ContextType = any, ParentType extends ResolversParentTypes['EUIngredient'] = ResolversParentTypes['EUIngredient']> = {
  allergen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  functionalCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ingredient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useENumber?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EuIngredientsTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EUIngredientsTemplate'] = ResolversParentTypes['EUIngredientsTemplate']> = {
  as_formatted_paragraph?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityResponse'] = ResolversParentTypes['EligibilityResponse']> = {
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  eligibilityCriteria?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityType'] = ResolversParentTypes['EligibilityType']> = {
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnumerationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnumerationInfo'] = ResolversParentTypes['EnumerationInfo']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstarCancelRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstarCancelRequest'] = ResolversParentTypes['EstarCancelRequest']> = {
  executionArn?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExhaustTransferProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExhaustTransferProductsResponse'] = ResolversParentTypes['ExhaustTransferProductsResponse']> = {
  isFullyExhausted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['TransferProductDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExhaustTransferRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExhaustTransferRequestResponse'] = ResolversParentTypes['ExhaustTransferRequestResponse']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isFullyExhausted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transferRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExhaustionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExhaustionResponse'] = ResolversParentTypes['ExhaustionResponse']> = {
  exhaust?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductExhaustionResponse']>>>, ParentType, ContextType>;
  transferId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportCertificateCollectionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportCertificateCollectionResponse'] = ResolversParentTypes['ExportCertificateCollectionResponse']> = {
  certificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportCertificateRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportCertificateRequest'] = ResolversParentTypes['ExportCertificateRequest']> = {
  certificate_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificate_type?: Resolver<ResolversTypes['CertificateType'], ParentType, ContextType>;
  certifier?: Resolver<Maybe<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignment?: Resolver<ResolversTypes['SPSConsignment'], ParentType, ContextType>;
  destination_market?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason_for_status_change?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestor_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state_machine_execution_arn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ExportCertificateStatus'], ParentType, ContextType>;
  verifiers?: Resolver<Array<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportCertificateWorkflowResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportCertificateWorkflowResponse'] = ResolversParentTypes['ExportCertificateWorkflowResponse']> = {
  validatonNeeded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportCertificateWorkflowTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportCertificateWorkflowType'] = ResolversParentTypes['ExportCertificateWorkflowType']> = {
  certificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportCsvResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportCsvResponse'] = ResolversParentTypes['ExportCsvResponse']> = {
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportRequestHistoryRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportRequestHistoryRecord'] = ResolversParentTypes['ExportRequestHistoryRecord']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nzxmlURI?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overseasAuthorityInvolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reasonCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  reasonForReprinting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonForStatusChange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacesId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateVersionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByProfileFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByProfileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBySystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportSpsAcknowledgementResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportSPSAcknowledgementResponse'] = ResolversParentTypes['ExportSPSAcknowledgementResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['Field'] = ResolversParentTypes['Field']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldBySubmissionLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldBySubmissionLayout'] = ResolversParentTypes['FieldBySubmissionLayout']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  captionList?: Resolver<Array<ResolversTypes['ReferenceCaption']>, ParentType, ContextType>;
  defaultDisplayType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fieldUniqueId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceDataList?: Resolver<Array<ResolversTypes['ReferenceDataList']>, ParentType, ContextType>;
  sectionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldConfiguration'] = ResolversParentTypes['FieldConfiguration']> = {
  displayType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldInfo'] = ResolversParentTypes['FieldInfo']> = {
  fieldUniqueId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldInput'] = ResolversParentTypes['FieldInput']> = {
  defaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  readOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldV2'] = ResolversParentTypes['FieldV2']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grouping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productHierarchy?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexiFillingRunDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexiFillingRunData'] = ResolversParentTypes['FlexiFillingRunData']> = {
  date?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  litres?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexiFillingRunResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexiFillingRunResponse'] = ResolversParentTypes['FlexiFillingRunResponse']> = {
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  runs?: Resolver<Array<ResolversTypes['FlexiFillingRunData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormResolvers<ContextType = any, ParentType extends ResolversParentTypes['Form'] = ResolversParentTypes['Form']> = {
  declarations?: Resolver<Array<ResolversTypes['DeclarationFormletSection']>, ParentType, ContextType>;
  productDetails?: Resolver<Array<ResolversTypes['FormletField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormletCollectionFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormletCollectionFilter'] = ResolversParentTypes['FormletCollectionFilter']> = {
  attribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormletFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormletField'] = ResolversParentTypes['FormletField']> = {
  charLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter?: Resolver<Maybe<ResolversTypes['FormletCollectionFilter']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nested?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormletNestedFields']>>>, ParentType, ContextType>;
  numberConstrain?: Resolver<Maybe<ResolversTypes['NumberConstrain']>, ParentType, ContextType>;
  numberOfLines?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormletOption']>>>, ParentType, ContextType>;
  readonly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sectionFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormletField']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FormletFieldType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormletNestedFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormletNestedFields'] = ResolversParentTypes['FormletNestedFields']> = {
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FormletFieldType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormletOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormletOption'] = ResolversParentTypes['FormletOption']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForwardProductTrackingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForwardProductTrackingResponse'] = ResolversParentTypes['ForwardProductTrackingResponse']> = {
  sourceProducts?: Resolver<Array<ResolversTypes['SourceProductTracking']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type G2GAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['G2GAccount'] = ResolversParentTypes['G2GAccount']> = {
  accountType?: Resolver<ResolversTypes['G2GAccountType'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissions?: Resolver<ResolversTypes['G2GPermissions'], ParentType, ContextType>;
  profileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['SuspensionReason']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['G2GAccountStatus'], ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type G2GAccountSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['G2GAccountSearchResult'] = ResolversParentTypes['G2GAccountSearchResult']> = {
  results?: Resolver<Array<ResolversTypes['G2GAccountSummary']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type G2GAccountSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['G2GAccountSummary'] = ResolversParentTypes['G2GAccountSummary']> = {
  accountType?: Resolver<ResolversTypes['G2GAccountType'], ParentType, ContextType>;
  agencyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateTypes?: Resolver<Maybe<Array<ResolversTypes['CoreExportCertificateType']>>, ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inspectionPorts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['G2GAccountStatus'], ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type G2GPermissionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['G2GPermissions'] = ResolversParentTypes['G2GPermissions']> = {
  agencyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agencyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateTypes?: Resolver<Array<ResolversTypes['CoreExportCertificateType']>, ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  inspectionPorts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateOutputPreviewXmlResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateOutputPreviewXMLResult'] = ResolversParentTypes['GenerateOutputPreviewXMLResult']> = {
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateSubmissionPreviewXmlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateSubmissionPreviewXmlResponse'] = ResolversParentTypes['GenerateSubmissionPreviewXmlResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  presignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneratedCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneratedCertificate'] = ResolversParentTypes['GeneratedCertificate']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetRequestValidationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetRequestValidationsResponse'] = ResolversParentTypes['GetRequestValidationsResponse']> = {
  errors?: Resolver<Array<ResolversTypes['RequestValidation']>, ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['RequestValidation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSignedCertificateXmlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSignedCertificateXmlResponse'] = ResolversParentTypes['GetSignedCertificateXmlResponse']> = {
  s3Path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetTemplateXmlCoreResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetTemplateXmlCoreResponse'] = ResolversParentTypes['GetTemplateXmlCoreResponse']> = {
  template?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['IConfig'] = ResolversParentTypes['IConfig']> = {
  __resolveType: TypeResolveFn<'BusinessRulesConfig' | 'DfeConfig', ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['IConfigField']>>>, ParentType, ContextType>;
};

export type IConfigBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IConfigBase'] = ResolversParentTypes['IConfigBase']> = {
  __resolveType: TypeResolveFn<'BusinessRulesConfig' | 'DfeConfig' | 'DfeTemplateInfo', ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  templateRevisionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type IConfigFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['IConfigField'] = ResolversParentTypes['IConfigField']> = {
  __resolveType: TypeResolveFn<'BusinessRuleField' | 'DfeField', ParentType, ContextType>;
  fuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type IDfeValidationRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['IDfeValidationRules'] = ResolversParentTypes['IDfeValidationRules']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  largerThan?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  length?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lessThan?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pattern?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IDsTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['IDsTemplate'] = ResolversParentTypes['IDsTemplate']> = {
  as_rows?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  comma_separated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  new_line_separated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IMeasureTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['IMeasureTemplate'] = ResolversParentTypes['IMeasureTemplate']> = {
  __resolveType: TypeResolveFn<'MeasureTemplate' | 'VolumeMeasureTemplate', ParentType, ContextType>;
  as_number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mpi_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  three_decimals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IppcHubLogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['IPPCHubLogEntry'] = ResolversParentTypes['IPPCHubLogEntry']> = {
  certificateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  exportCountryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hubDeliveryNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hubTrackingInfo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ITemplateProcessGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ITemplateProcessGroup'] = ResolversParentTypes['ITemplateProcessGroup']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ImportCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificate'] = ResolversParentTypes['ImportCertificate']> = {
  certificate_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  consignment?: Resolver<ResolversTypes['SPSConsignment'], ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  embeddedDocument?: Resolver<Array<ResolversTypes['ImportCertificateEmbeddedDocument']>, ParentType, ContextType>;
  exchanged_document?: Resolver<ResolversTypes['SPSExchangedDocument'], ParentType, ContextType>;
  export_country?: Resolver<ResolversTypes['SPSCountry'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  import_country?: Resolver<ResolversTypes['SPSCountry'], ParentType, ContextType>;
  included_notes?: Resolver<Array<ResolversTypes['SPSNote']>, ParentType, ContextType>;
  ippcLogs?: Resolver<Array<ResolversTypes['IPPCHubLogEntry']>, ParentType, ContextType>;
  issued?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SPSTradeLineItem']>, ParentType, ContextType>;
  last_transport_movement?: Resolver<Maybe<ResolversTypes['SPSTransportMovement']>, ParentType, ContextType>;
  loading_base_port_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  logs?: Resolver<Array<ResolversTypes['ImportCertificateLogMessage']>, ParentType, ContextType>;
  main_carriage_transport_movements?: Resolver<Maybe<Array<ResolversTypes['SPSTransportMovement']>>, ParentType, ContextType>;
  pdf_generated?: Resolver<ResolversTypes['PdfGenerationStatus'], ParentType, ContextType>;
  referenced_documents?: Resolver<Array<ResolversTypes['SPSReferencedDocument']>, ParentType, ContextType>;
  replaced_by?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType>;
  replacement_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacing?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType>;
  replacing_certificate_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signatories?: Resolver<Array<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ImportCertificateStatus'], ParentType, ContextType>;
  status_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transit_countries?: Resolver<Maybe<Array<ResolversTypes['SPSCountry']>>, ParentType, ContextType>;
  type_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unloading_base_port_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  utilized_transport_equipment?: Resolver<Array<ResolversTypes['SPSTransportEquipment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateEmbeddedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateEmbeddedDocument'] = ResolversParentTypes['ImportCertificateEmbeddedDocument']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  file_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  file_size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateExtractItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateExtractItem'] = ResolversParentTypes['ImportCertificateExtractItem']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['ImportCertificateExtractItem']>>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateExtractMeasurementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateExtractMeasurement'] = ResolversParentTypes['ImportCertificateExtractMeasurement']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  measures?: Resolver<Maybe<Array<ResolversTypes['ImportCertificateExtractItem']>>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateExtractTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateExtractTemplate'] = ResolversParentTypes['ImportCertificateExtractTemplate']> = {
  as_items?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateIntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateIntegration'] = ResolversParentTypes['ImportCertificateIntegration']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  receivingSpsAcknowledgement?: Resolver<Maybe<ResolversTypes['ImportCertificateIntegrationResponse']>, ParentType, ContextType>;
  response?: Resolver<Maybe<ResolversTypes['ImportCertificateIntegrationResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateLogMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateLogMessage'] = ResolversParentTypes['ImportCertificateLogMessage']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  relatedCertificate?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ImportCertificateLogStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateMeasurementTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateMeasurementTemplate'] = ResolversParentTypes['ImportCertificateMeasurementTemplate']> = {
  as_new_lines?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificatePackagingTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificatePackagingTemplate'] = ResolversParentTypes['ImportCertificatePackagingTemplate']> = {
  as_new_lines?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificatePdfResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificatePdf'] = ResolversParentTypes['ImportCertificatePdf']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PdfGenerationStatus'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCertificateXmlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCertificateXml'] = ResolversParentTypes['ImportCertificateXml']> = {
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportConnectionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportConnectionsResponse'] = ResolversParentTypes['ImportConnectionsResponse']> = {
  applyDigitalSignature?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  connectionType?: Resolver<ResolversTypes['ConnectionType'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  receiving?: Resolver<Maybe<ResolversTypes['ImportCertificateIntegrationResponse']>, ParentType, ContextType>;
  receivingSpsAcknowledgement?: Resolver<Maybe<ResolversTypes['ImportCertificateIntegrationResponse']>, ParentType, ContextType>;
  sending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  spsAcknowledgement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportConnectionsTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportConnectionsType'] = ResolversParentTypes['ImportConnectionsType']> = {
  connectionType?: Resolver<Maybe<ResolversTypes['ConnectionType']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IndicatorTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IndicatorType'] = ResolversParentTypes['IndicatorType']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitSupportingDocumentUploadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitSupportingDocumentUploadResponse'] = ResolversParentTypes['InitSupportingDocumentUploadResponse']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntTemplate'] = ResolversParentTypes['IntTemplate']> = {
  in_English?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationsGetTemplateXmlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationsGetTemplateXmlResponse'] = ResolversParentTypes['IntegrationsGetTemplateXmlResponse']> = {
  template?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LanguageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Language'] = ResolversParentTypes['Language']> = {
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  languageName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rightToLeft?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Layout'] = ResolversParentTypes['Layout']> = {
  sections?: Resolver<Array<ResolversTypes['Section']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Layouts'] = ResolversParentTypes['Layouts']> = {
  products?: Resolver<ResolversTypes['Layout'], ParentType, ContextType>;
  requests?: Resolver<ResolversTypes['Layout'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['LookupValue'] = ResolversParentTypes['LookupValue']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManualVolumeAdjustmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManualVolumeAdjustment'] = ResolversParentTypes['ManualVolumeAdjustment']> = {
  changeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  litres?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterLayout'] = ResolversParentTypes['MasterLayout']> = {
  masterFields?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  masterLayout?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeasureTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeasureTemplate'] = ResolversParentTypes['MeasureTemplate']> = {
  as_number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mpi_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  three_decimals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  three_digits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeasurmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Measurment'] = ResolversParentTypes['Measurment']> = {
  unit?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonthTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthTemplate'] = ResolversParentTypes['MonthTemplate']> = {
  abbreviation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['IntTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MultiCollectionApiKeysResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiCollectionApiKeys'] = ResolversParentTypes['MultiCollectionApiKeys']> = {
  agency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  exportCertificates?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exporters?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partyApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationAll?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MultiCollectionApiKeysV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiCollectionApiKeysV2'] = ResolversParentTypes['MultiCollectionApiKeysV2']> = {
  agency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  exporters?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exports?: Resolver<Maybe<ResolversTypes['RoleSpecificKeys']>, ParentType, ContextType>;
  ocaExports?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partyApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocs?: Resolver<Maybe<ResolversTypes['SupportingDocumentKeys']>, ParentType, ContextType>;
  templates?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transfers?: Resolver<Maybe<ResolversTypes['RoleSpecificKeys']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptedTermsAndConditions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  addBottlingRuns?: Resolver<ResolversTypes['BottlingRunResponse'], ParentType, ContextType, RequireFields<MutationAddBottlingRunsArgs, 'input'>>;
  addCustomsPermitNumbers?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationAddCustomsPermitNumbersArgs, 'csv'>>;
  addFlexiFillingRuns?: Resolver<ResolversTypes['FlexiFillingRunResponse'], ParentType, ContextType, RequireFields<MutationAddFlexiFillingRunsArgs, 'input'>>;
  addProduct?: Resolver<ResolversTypes['B2GProduct'], ParentType, ContextType, RequireFields<MutationAddProductArgs, 'product'>>;
  addProductAndProcessFromTransfer?: Resolver<Array<ResolversTypes['SavedProductOutput']>, ParentType, ContextType, RequireFields<MutationAddProductAndProcessFromTransferArgs, 'input'>>;
  adjustBatchVolume?: Resolver<ResolversTypes['VolumeAdjustmentResponse'], ParentType, ContextType, RequireFields<MutationAdjustBatchVolumeArgs, 'input'>>;
  allocateCustomsPermitNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationAllocateCustomsPermitNumberArgs, 'certificateRequestId'>>;
  appendIPPCHubLog?: Resolver<ResolversTypes['IPPCHubLogEntry'], ParentType, ContextType, RequireFields<MutationAppendIppcHubLogArgs, 'input'>>;
  appendImportCertificateLog?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAppendImportCertificateLogArgs, 'input'>>;
  approveExportCertificateRequest?: Resolver<Maybe<ResolversTypes['ExportCertificateRequest']>, ParentType, ContextType, RequireFields<MutationApproveExportCertificateRequestArgs, 'input'>>;
  attachTemplateDocument?: Resolver<ResolversTypes['TemplateUploadUrl'], ParentType, ContextType, RequireFields<MutationAttachTemplateDocumentArgs, 'templateId'>>;
  banWineBatch?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationBanWineBatchArgs, 'input'>>;
  cancelEstarRequest?: Resolver<ResolversTypes['EstarCancelRequest'], ParentType, ContextType, RequireFields<MutationCancelEstarRequestArgs, 'sampleId'>>;
  cancelExportCertificateRequest?: Resolver<ResolversTypes['B2GExportCertificateRequest'], ParentType, ContextType, RequireFields<MutationCancelExportCertificateRequestArgs, 'input'>>;
  cancelProcess?: Resolver<ResolversTypes['CancelledProcessResponse'], ParentType, ContextType, RequireFields<MutationCancelProcessArgs, 'input'>>;
  cancelSupportingDocument?: Resolver<Maybe<ResolversTypes['UpdateSupportingDocumentResult']>, ParentType, ContextType, RequireFields<MutationCancelSupportingDocumentArgs, 'input'>>;
  changeExportRequestStatus?: Resolver<ResolversTypes['ChangeExportRequestStatusResponse'], ParentType, ContextType, RequireFields<MutationChangeExportRequestStatusArgs, 'input'>>;
  changeTransferRequestAmendmentStatus?: Resolver<ResolversTypes['ChangeTransferRequestAmendmentStatusResponse'], ParentType, ContextType, RequireFields<MutationChangeTransferRequestAmendmentStatusArgs, 'input'>>;
  changeTransferRequestStatus?: Resolver<ResolversTypes['ChangeTransferRequestStatusResponse'], ParentType, ContextType, RequireFields<MutationChangeTransferRequestStatusArgs, 'input'>>;
  completeSensoryProcess?: Resolver<ResolversTypes['SensoryProcessRequest'], ParentType, ContextType, RequireFields<MutationCompleteSensoryProcessArgs, 'input'>>;
  confirmPackaging?: Resolver<ResolversTypes['ConfirmPackagingResponse'], ParentType, ContextType, RequireFields<MutationConfirmPackagingArgs, 'input'>>;
  confirmWinemaking?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationConfirmWinemakingArgs, 'input'>>;
  createAnnouncement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType, RequireFields<MutationCreateAnnouncementArgs, 'input'>>;
  createSupportingDocument?: Resolver<Maybe<ResolversTypes['CoreSupportingDocument']>, ParentType, ContextType, RequireFields<MutationCreateSupportingDocumentArgs, 'input'>>;
  createTemplate?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationCreateTemplateArgs, 'template'>>;
  createTemplateVersion?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationCreateTemplateVersionArgs, 'template'>>;
  createTestRegistration?: Resolver<Maybe<ResolversTypes['TestRegistration']>, ParentType, ContextType, RequireFields<MutationCreateTestRegistrationArgs, 'input'>>;
  createTestUser?: Resolver<Maybe<ResolversTypes['TestUser']>, ParentType, ContextType, RequireFields<MutationCreateTestUserArgs, 'input'>>;
  createUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'userDetails'>>;
  deleteAllCustomsPermitNumbers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deleteAnnouncement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType, RequireFields<MutationDeleteAnnouncementArgs, 'id'>>;
  deleteCoreReferencedDocument?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteCoreReferencedDocumentArgs, 'id'>>;
  deleteExportCertificateRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteExportCertificateRequestArgs, 'requestor' | 'requestor_id'>>;
  deleteExportRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteExportRequestArgs, 'id'>>;
  deleteExportRequestById?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteExportRequestByIdArgs, 'id'>>;
  deleteFieldConfiguration?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteFieldConfigurationArgs, 'templateFieldId'>>;
  deleteProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteProductArgs, 'id'>>;
  deleteReferencedDocument?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteReferencedDocumentArgs, 'id'>>;
  deleteReplacementExportRequest?: Resolver<ResolversTypes['DeleteReplacementExportRequestResponse'], ParentType, ContextType, RequireFields<MutationDeleteReplacementExportRequestArgs, 'input'>>;
  deleteTemplate?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteTemplateArgs, 'id'>>;
  deleteTransferRequestById?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteTransferRequestByIdArgs, 'id'>>;
  discardExportCertificateRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDiscardExportCertificateRequestArgs, 'id'>>;
  downloadExportRequestsAsCsv?: Resolver<ResolversTypes['ExportCsvResponse'], ParentType, ContextType, Partial<MutationDownloadExportRequestsAsCsvArgs>>;
  downloadSupportingDocumentsAsCsv?: Resolver<ResolversTypes['ExportCsvResponse'], ParentType, ContextType, Partial<MutationDownloadSupportingDocumentsAsCsvArgs>>;
  downloadTransferProcessHistoryXML?: Resolver<Maybe<ResolversTypes['TransferProcessHistoryXmlResponse']>, ParentType, ContextType, RequireFields<MutationDownloadTransferProcessHistoryXmlArgs, 'input'>>;
  downloadTransferRequestsAsCsv?: Resolver<ResolversTypes['ExportCsvResponse'], ParentType, ContextType, RequireFields<MutationDownloadTransferRequestsAsCsvArgs, 'input'>>;
  draftExportCertificateRequest?: Resolver<ResolversTypes['B2GExportCertificateRequest'], ParentType, ContextType, RequireFields<MutationDraftExportCertificateRequestArgs, 'request'>>;
  e2eRaiseExportCertificateRequest?: Resolver<Maybe<ResolversTypes['B2GExportCertificateRequest']>, ParentType, ContextType, RequireFields<MutationE2eRaiseExportCertificateRequestArgs, 'id' | 'partyId'>>;
  executeChemistryTestEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationExecuteChemistryTestEventArgs, 'input'>>;
  exhaustTransferProducts?: Resolver<ResolversTypes['ExhaustTransferProductsResponse'], ParentType, ContextType, RequireFields<MutationExhaustTransferProductsArgs, 'input'>>;
  exhaustTransferRequest?: Resolver<ResolversTypes['ExhaustTransferRequestResponse'], ParentType, ContextType, RequireFields<MutationExhaustTransferRequestArgs, 'input'>>;
  extendIntendedOperator?: Resolver<Maybe<ResolversTypes['UpdateSupportingDocumentResult']>, ParentType, ContextType, RequireFields<MutationExtendIntendedOperatorArgs, 'input'>>;
  forceApproveTemplateVersion?: Resolver<ResolversTypes['TemplateVersion'], ParentType, ContextType, RequireFields<MutationForceApproveTemplateVersionArgs, 'templateVersionId'>>;
  generateDraftExportCertificate?: Resolver<ResolversTypes['DraftExportCertificate'], ParentType, ContextType, RequireFields<MutationGenerateDraftExportCertificateArgs, 'input'>>;
  generateDraftPdf?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationGenerateDraftPdfArgs, 'templateId'>>;
  generateOutputPreviewXML?: Resolver<ResolversTypes['GenerateOutputPreviewXMLResult'], ParentType, ContextType, RequireFields<MutationGenerateOutputPreviewXmlArgs, 'templateVersionId'>>;
  generateSpecimenPdf?: Resolver<ResolversTypes['StandardPdfPreviewResponse'], ParentType, ContextType, RequireFields<MutationGenerateSpecimenPdfArgs, 'templateVersionId'>>;
  generateStandardPdfPreview?: Resolver<ResolversTypes['StandardPdfPreviewResponse'], ParentType, ContextType, RequireFields<MutationGenerateStandardPdfPreviewArgs, 'templateVersionId'>>;
  generateSubmissionPreviewXml?: Resolver<ResolversTypes['GenerateSubmissionPreviewXmlResponse'], ParentType, ContextType, RequireFields<MutationGenerateSubmissionPreviewXmlArgs, 'templateVersionId'>>;
  generateTeoConfigurationJson?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationGenerateTeoConfigurationJsonArgs, 'templateVersionId'>>;
  getNewTemplateVersionUploadUrl?: Resolver<ResolversTypes['TemplateUploadUrl'], ParentType, ContextType, RequireFields<MutationGetNewTemplateVersionUploadUrlArgs, 'templateId'>>;
  getSignedCertificateXml?: Resolver<ResolversTypes['GetSignedCertificateXmlResponse'], ParentType, ContextType, RequireFields<MutationGetSignedCertificateXmlArgs, 'input'>>;
  initSupportingDocumentUpload?: Resolver<ResolversTypes['InitSupportingDocumentUploadResponse'], ParentType, ContextType, RequireFields<MutationInitSupportingDocumentUploadArgs, 'input'>>;
  integrationsAmendExport?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsAmendExportArgs, 'input'>>;
  integrationsAmendTransfer?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsAmendTransferArgs, 'input'>>;
  integrationsCreateSupportingDocument?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsCreateSupportingDocumentArgs, 'input'>>;
  integrationsDownloadTransferProcessHistoryXML?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsDownloadTransferProcessHistoryXmlArgs, 'input'>>;
  integrationsExhaustTransfer?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsExhaustTransferArgs, 'input'>>;
  integrationsGetSignedCertificateXml?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsGetSignedCertificateXmlArgs, 'input'>>;
  integrationsGetTemplateXml?: Resolver<ResolversTypes['IntegrationsGetTemplateXmlResponse'], ParentType, ContextType, RequireFields<MutationIntegrationsGetTemplateXmlArgs, 'input'>>;
  integrationsInitSupportingDocumentUpload?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsInitSupportingDocumentUploadArgs, 'input'>>;
  integrationsRaiseExportRequestAP?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRaiseExportRequestApArgs, 'input'>>;
  integrationsRaiseExportRequestAPV2?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRaiseExportRequestApv2Args, 'input'>>;
  integrationsRaiseExportRequestPhyto?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRaiseExportRequestPhytoArgs, 'input'>>;
  integrationsRaiseExportRequestPhytoV2?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRaiseExportRequestPhytoV2Args, 'input'>>;
  integrationsRaiseTransfer?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRaiseTransferArgs, 'input'>>;
  integrationsRaiseTransferV2?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRaiseTransferV2Args, 'input'>>;
  integrationsReplaceExportCertificate?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsReplaceExportCertificateArgs, 'input'>>;
  integrationsRequestAmendmentTransfer?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRequestAmendmentTransferArgs, 'input'>>;
  integrationsRequestReplacementCertificate?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, RequireFields<MutationIntegrationsRequestReplacementCertificateArgs, 'input'>>;
  makeProductEligible?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationMakeProductEligibleArgs, 'market' | 'productId'>>;
  newCoreReferencedDocument?: Resolver<Maybe<ResolversTypes['NewCoreReferencedDocument']>, ParentType, ContextType, RequireFields<MutationNewCoreReferencedDocumentArgs, 'input'>>;
  newMultiCollectionApiKeys?: Resolver<Maybe<ResolversTypes['MultiCollectionApiKeys']>, ParentType, ContextType>;
  newMultiCollectionApiKeysV2?: Resolver<Maybe<ResolversTypes['MultiCollectionApiKeysV2']>, ParentType, ContextType, Partial<MutationNewMultiCollectionApiKeysV2Args>>;
  newPartyApiKey?: Resolver<Maybe<ResolversTypes['SearchApiKey']>, ParentType, ContextType>;
  newReferencedDocument?: Resolver<ResolversTypes['NewReferencedDocument'], ParentType, ContextType, Partial<MutationNewReferencedDocumentArgs>>;
  newSearchApiKey?: Resolver<Maybe<ResolversTypes['SearchApiKey']>, ParentType, ContextType>;
  prepareXmlFileForB2G?: Resolver<ResolversTypes['PrepareXmlFileForB2GResponse'], ParentType, ContextType, RequireFields<MutationPrepareXmlFileForB2GArgs, 'input'>>;
  printCertificate?: Resolver<ResolversTypes['PrintCertificateResponse'], ParentType, ContextType, RequireFields<MutationPrintCertificateArgs, 'input'>>;
  processB2GIntegration?: Resolver<ResolversTypes['ProcessB2GIntegrationResponse'], ParentType, ContextType, RequireFields<MutationProcessB2GIntegrationArgs, 'input'>>;
  processCertificateCollection?: Resolver<ResolversTypes['CertificateCollectionOutput'], ParentType, ContextType, RequireFields<MutationProcessCertificateCollectionArgs, 'input'>>;
  processExportCertificateCollection?: Resolver<ResolversTypes['ExportCertificateCollectionResponse'], ParentType, ContextType, RequireFields<MutationProcessExportCertificateCollectionArgs, 'input'>>;
  processExportOCAWithPermissions?: Resolver<ResolversTypes['OCAWithPermissionsResponse'], ParentType, ContextType, RequireFields<MutationProcessExportOcaWithPermissionsArgs, 'input'>>;
  processExportSPSAcknowledgement?: Resolver<ResolversTypes['ExportSPSAcknowledgementResponse'], ParentType, ContextType, RequireFields<MutationProcessExportSpsAcknowledgementArgs, 'input'>>;
  processOCAWithPermissions?: Resolver<ResolversTypes['OCAWithPermissionsResponse'], ParentType, ContextType, RequireFields<MutationProcessOcaWithPermissionsArgs, 'input'>>;
  processSpsAcknowledgement?: Resolver<ResolversTypes['SpsAcknowledgementOutput'], ParentType, ContextType, RequireFields<MutationProcessSpsAcknowledgementArgs, 'input'>>;
  publishXmlFileProcessed?: Resolver<ResolversTypes['PrepareXmlFileForB2GResponse'], ParentType, ContextType, RequireFields<MutationPublishXmlFileProcessedArgs, 'input'>>;
  raiseExportCertificateRequest?: Resolver<Maybe<ResolversTypes['B2GExportCertificateRequest']>, ParentType, ContextType, RequireFields<MutationRaiseExportCertificateRequestArgs, 'id'>>;
  raiseExportRequest?: Resolver<ResolversTypes['RaiseExportRequestResponse'], ParentType, ContextType, RequireFields<MutationRaiseExportRequestArgs, 'input'>>;
  raiseTransferRequest?: Resolver<ResolversTypes['RaiseTransferRequestResponse'], ParentType, ContextType, RequireFields<MutationRaiseTransferRequestArgs, 'input'>>;
  regenerateApprovedTemplates?: Resolver<ResolversTypes['RegenerateApprovedTemplatesResponse'], ParentType, ContextType, Partial<MutationRegenerateApprovedTemplatesArgs>>;
  regenerateCertificate?: Resolver<ResolversTypes['RegenerateCertificateResponse'], ParentType, ContextType, RequireFields<MutationRegenerateCertificateArgs, 'input'>>;
  reindexCollection?: Resolver<ResolversTypes['ReindexResponse'], ParentType, ContextType, RequireFields<MutationReindexCollectionArgs, 'collectionName'>>;
  reindexDatabaseItem?: Resolver<ResolversTypes['ReindexResponse'], ParentType, ContextType, RequireFields<MutationReindexDatabaseItemArgs, 'collectionName' | 'ids'>>;
  rejectImportCertificate?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType, RequireFields<MutationRejectImportCertificateArgs, 'input'>>;
  removeProductProcesses?: Resolver<ResolversTypes['RemoveProductProcessesResponse'], ParentType, ContextType, RequireFields<MutationRemoveProductProcessesArgs, 'input'>>;
  removeProductsFromRequest?: Resolver<Array<ResolversTypes['CoreProduct']>, ParentType, ContextType, RequireFields<MutationRemoveProductsFromRequestArgs, 'input'>>;
  replacementCertificateRequest?: Resolver<ResolversTypes['B2GExportCertificateRequest'], ParentType, ContextType, RequireFields<MutationReplacementCertificateRequestArgs, 'id'>>;
  requestApprovalToReplaceExportCertificateRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRequestApprovalToReplaceExportCertificateRequestArgs, 'input'>>;
  requestChemistryTest?: Resolver<ResolversTypes['ChemistryTestResponse'], ParentType, ContextType, RequireFields<MutationRequestChemistryTestArgs, 'input'>>;
  requestConfirmation?: Resolver<ResolversTypes['RequestConfirmationResponse'], ParentType, ContextType, RequireFields<MutationRequestConfirmationArgs, 'input'>>;
  requestReplacementImportCertificate?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType, RequireFields<MutationRequestReplacementImportCertificateArgs, 'input'>>;
  requestedToResubmitExportCertificateRequest?: Resolver<Maybe<ResolversTypes['ExportCertificateRequest']>, ParentType, ContextType, RequireFields<MutationRequestedToResubmitExportCertificateRequestArgs, 'input'>>;
  resetConfirmationRequest?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationResetConfirmationRequestArgs, 'input'>>;
  salesforceErApproval?: Resolver<ResolversTypes['SalesforceErApprovalResponse'], ParentType, ContextType, RequireFields<MutationSalesforceErApprovalArgs, 'input'>>;
  salesforceTransferRequestVerification?: Resolver<ResolversTypes['SalesforceTransferRequestVerificationResponse'], ParentType, ContextType, RequireFields<MutationSalesforceTransferRequestVerificationArgs, 'input'>>;
  saveChangesToReferenceData?: Resolver<ResolversTypes['SaveChangesToReferenceDataResponse'], ParentType, ContextType, RequireFields<MutationSaveChangesToReferenceDataArgs, 'input'>>;
  saveExportCertificateRequest?: Resolver<ResolversTypes['ExportCertificateRequest'], ParentType, ContextType, RequireFields<MutationSaveExportCertificateRequestArgs, 'input'>>;
  saveExportRequest?: Resolver<ResolversTypes['CoreExportRequest'], ParentType, ContextType, RequireFields<MutationSaveExportRequestArgs, 'input'>>;
  saveFieldConfiguration?: Resolver<Maybe<ResolversTypes['TemplateFieldConfiguration']>, ParentType, ContextType, RequireFields<MutationSaveFieldConfigurationArgs, 'fieldConfig' | 'templateVersionId'>>;
  saveFieldConfigurationBatch?: Resolver<Maybe<ResolversTypes['TemplateFieldConfigurationAcknowledgement']>, ParentType, ContextType, RequireFields<MutationSaveFieldConfigurationBatchArgs, 'templateVersionId'>>;
  saveG2GAccount?: Resolver<ResolversTypes['G2GAccount'], ParentType, ContextType, RequireFields<MutationSaveG2GAccountArgs, 'input'>>;
  saveProcessGroupConfig?: Resolver<ResolversTypes['TemplateProcessGroupsConfigAcknowledgement'], ParentType, ContextType, RequireFields<MutationSaveProcessGroupConfigArgs, 'templateVersionId'>>;
  saveTransferRequest?: Resolver<ResolversTypes['CoreTransferRequest'], ParentType, ContextType, RequireFields<MutationSaveTransferRequestArgs, 'input'>>;
  setTemplateVersionApproved?: Resolver<ResolversTypes['TemplateVersion'], ParentType, ContextType, RequireFields<MutationSetTemplateVersionApprovedArgs, 'templateVersionId'>>;
  setTemplateVersionStatus?: Resolver<ResolversTypes['TemplateVersion'], ParentType, ContextType, RequireFields<MutationSetTemplateVersionStatusArgs, 'status' | 'templateVersionId'>>;
  sfCancelExportCertificate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSfCancelExportCertificateArgs, 'input'>>;
  sfChangeExportCertificateRequestStatus?: Resolver<Maybe<ResolversTypes['ExportCertificateRequest']>, ParentType, ContextType, RequireFields<MutationSfChangeExportCertificateRequestStatusArgs, 'input'>>;
  sfChangeExportRequestStatus?: Resolver<ResolversTypes['SfChangeExportRequestStatusResponse'], ParentType, ContextType, RequireFields<MutationSfChangeExportRequestStatusArgs, 'input'>>;
  sfChangeTransferRequestStatus?: Resolver<ResolversTypes['SfChangeTransferRequestStatusResponse'], ParentType, ContextType, RequireFields<MutationSfChangeTransferRequestStatusArgs, 'input'>>;
  sfDownloadCertificate?: Resolver<ResolversTypes['SfDownloadCertificateResponse'], ParentType, ContextType, RequireFields<MutationSfDownloadCertificateArgs, 'input'>>;
  sfRequestExportCertificateReplacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSfRequestExportCertificateReplacementArgs, 'input'>>;
  sfUpdateProductExhaustion?: Resolver<ResolversTypes['SfUpdateProductExhaustionResponse'], ParentType, ContextType, RequireFields<MutationSfUpdateProductExhaustionArgs, 'input'>>;
  sfUpdateStationerySerialNumbers?: Resolver<ResolversTypes['SfUpdateStationerySerialNumbersResponse'], ParentType, ContextType, RequireFields<MutationSfUpdateStationerySerialNumbersArgs, 'input'>>;
  sfUpdateTransferAuditComment?: Resolver<ResolversTypes['SfUpdateTransferAuditCommentResponse'], ParentType, ContextType, RequireFields<MutationSfUpdateTransferAuditCommentArgs, 'input'>>;
  sfVerifyExportCertificateRequestProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['SPSTradeLineItem']>>>, ParentType, ContextType, RequireFields<MutationSfVerifyExportCertificateRequestProductsArgs, 'input'>>;
  splitProduct?: Resolver<Array<ResolversTypes['B2GProduct']>, ParentType, ContextType, RequireFields<MutationSplitProductArgs, 'fromProduct' | 'toProducts'>>;
  startPackaging?: Resolver<ResolversTypes['ProcessResponse'], ParentType, ContextType, RequireFields<MutationStartPackagingArgs, 'productId'>>;
  startWinemaking?: Resolver<ResolversTypes['ProcessResponse'], ParentType, ContextType, RequireFields<MutationStartWinemakingArgs, 'productId'>>;
  transferProduct?: Resolver<ResolversTypes['B2GProduct'], ParentType, ContextType, RequireFields<MutationTransferProductArgs, 'id' | 'toPremise'>>;
  updateApprovedTransferTransport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateApprovedTransferTransportArgs, 'input'>>;
  updateDecisionTable?: Resolver<ResolversTypes['DecisionTableRevision'], ParentType, ContextType, RequireFields<MutationUpdateDecisionTableArgs, 'input'>>;
  updatePrintReason?: Resolver<ResolversTypes['UpdatePrintReasonResponse'], ParentType, ContextType, RequireFields<MutationUpdatePrintReasonArgs, 'input'>>;
  updateProductExhaustion?: Resolver<Maybe<ResolversTypes['ExhaustionResponse']>, ParentType, ContextType, Partial<MutationUpdateProductExhaustionArgs>>;
  updateSupportingDocument?: Resolver<Maybe<ResolversTypes['UpdateSupportingDocumentResult']>, ParentType, ContextType, RequireFields<MutationUpdateSupportingDocumentArgs, 'input'>>;
  updateTemplate?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationUpdateTemplateArgs, 'template'>>;
  updateTemplateVersionGeneralSettings?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationUpdateTemplateVersionGeneralSettingsArgs, 'generalSettings'>>;
  updateTemplateVersionOutput?: Resolver<ResolversTypes['TemplateVersionOutput'], ParentType, ContextType, RequireFields<MutationUpdateTemplateVersionOutputArgs, 'templateOutput'>>;
  uploadReferenceData?: Resolver<ResolversTypes['UploadReferenceDataResponse'], ParentType, ContextType, RequireFields<MutationUploadReferenceDataArgs, 'input'>>;
  uploadTemplateDocumentV2?: Resolver<ResolversTypes['TemplateUploadUrlV2'], ParentType, ContextType, RequireFields<MutationUploadTemplateDocumentV2Args, 'templateVersionId'>>;
  upsertTemplateDeclarations?: Resolver<ResolversTypes['TemplateDeclarationsAcknowledgement'], ParentType, ContextType, RequireFields<MutationUpsertTemplateDeclarationsArgs, 'input'>>;
  upsertTemplateSupportingDocuments?: Resolver<Array<ResolversTypes['TemplateSupportingDocumentAcknowledgement']>, ParentType, ContextType, RequireFields<MutationUpsertTemplateSupportingDocumentsArgs, 'input'>>;
  withdrawImportCertificate?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType, RequireFields<MutationWithdrawImportCertificateArgs, 'input'>>;
};

export type NamedCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NamedCode'] = ResolversParentTypes['NamedCode']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NamedCodeTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['NamedCodeTemplate'] = ResolversParentTypes['NamedCodeTemplate']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewCoreReferencedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewCoreReferencedDocument'] = ResolversParentTypes['NewCoreReferencedDocument']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewReferencedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewReferencedDocument'] = ResolversParentTypes['NewReferencedDocument']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NumberConstrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['NumberConstrain'] = ResolversParentTypes['NumberConstrain']> = {
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  step?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OcaWithPermissionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OCAWithPermissionsResponse'] = ResolversParentTypes['OCAWithPermissionsResponse']> = {
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PdfSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PDFSettings'] = ResolversParentTypes['PDFSettings']> = {
  boxWidth?: Resolver<Maybe<ResolversTypes['PDFBoxWidth']>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  defaultOption?: Resolver<Maybe<ResolversTypes['PdfDefaultOption']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pdfColumnsToDisplay?: Resolver<Maybe<ResolversTypes['ColumnsToDisplay']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackageTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackageTemplate'] = ResolversParentTypes['PackageTemplate']> = {
  bottle_size?: Resolver<Maybe<ResolversTypes['VolumeMeasureTemplate']>, ParentType, ContextType>;
  bottles_per_case?: Resolver<Maybe<ResolversTypes['IntTemplate']>, ParentType, ContextType>;
  cases?: Resolver<Maybe<ResolversTypes['IntTemplate']>, ParentType, ContextType>;
  extra_bottles?: Resolver<Maybe<ResolversTypes['IntTemplate']>, ParentType, ContextType>;
  total_bottles?: Resolver<ResolversTypes['IntTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackagingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Packaging'] = ResolversParentTypes['Packaging']> = {
  availableLitres?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  confirmation?: Resolver<Maybe<ResolversTypes['PackagingConfirmation']>, ParentType, ContextType>;
  exportedLitres?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  runs?: Resolver<Array<ResolversTypes['PackagingRun']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PackagingStatus'], ParentType, ContextType>;
  totalPackagedLitres?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  volumeAdjustment?: Resolver<Maybe<Array<Maybe<ResolversTypes['ManualVolumeAdjustment']>>>, ParentType, ContextType>;
  wsmp?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackagingConfirmationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackagingConfirmation'] = ResolversParentTypes['PackagingConfirmation']> = {
  confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disputeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputeResolution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackagingRunResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackagingRun'] = ResolversParentTypes['PackagingRun']> = {
  __resolveType: TypeResolveFn<'BottlingRunData' | 'FlexiFillingRunData', ParentType, ContextType>;
};

export type PhytoOcaEmailNotificationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhytoOcaEmailNotificationsResponse'] = ResolversParentTypes['PhytoOcaEmailNotificationsResponse']> = {
  emailAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhytoOcaEmailNotificationsTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhytoOcaEmailNotificationsType'] = ResolversParentTypes['PhytoOcaEmailNotificationsType']> = {
  destinationCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortCountryInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortCountryInfo'] = ResolversParentTypes['PortCountryInfo']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrepareXmlFileForB2GResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrepareXmlFileForB2GResponse'] = ResolversParentTypes['PrepareXmlFileForB2GResponse']> = {
  b2gPayload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorMessages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestType?: Resolver<ResolversTypes['XmlRequestType'], ParentType, ContextType>;
  responseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  xmlInputId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PresignedPostFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PresignedPostField'] = ResolversParentTypes['PresignedPostField']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PresignedUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['PresignedUrl'] = ResolversParentTypes['PresignedUrl']> = {
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreviewOutputXmlPresignedUrlResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewOutputXMLPresignedURLResult'] = ResolversParentTypes['PreviewOutputXMLPresignedURLResult']> = {
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrintCertificateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrintCertificateResponse'] = ResolversParentTypes['PrintCertificateResponse']> = {
  executionArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  exportRequestOutputId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfCertificateUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessAttributesResponse'] = ResolversParentTypes['ProcessAttributesResponse']> = {
  __resolveType: TypeResolveFn<'ChemistryTestResponse' | 'Packaging' | 'SensoryProcessRequest' | 'Winemaking', ParentType, ContextType>;
};

export type ProcessB2GIntegrationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessB2GIntegrationResponse'] = ResolversParentTypes['ProcessB2GIntegrationResponse']> = {
  errorMessages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestType?: Resolver<ResolversTypes['XmlRequestType'], ParentType, ContextType>;
  responseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  xmlInputId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessDetail'] = ResolversParentTypes['ProcessDetail']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  processCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranking?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessGroupCaptionSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessGroupCaptionSettings'] = ResolversParentTypes['ProcessGroupCaptionSettings']> = {
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessGroupDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessGroupDetail'] = ResolversParentTypes['ProcessGroupDetail']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  defaultCharacteristic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lowestRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lowestRankedProcessUnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overrideCharacteristic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overrideUnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processGroupId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  processes?: Resolver<Array<ResolversTypes['ProcessDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessGroupInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessGroupInfo'] = ResolversParentTypes['ProcessGroupInfo']> = {
  groupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processGroupId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessInfo'] = ResolversParentTypes['ProcessInfo']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  processCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessResponse'] = ResolversParentTypes['ProcessResponse']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes['ProcessTask']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductProcessType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessTask'] = ResolversParentTypes['ProcessTask']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessType'] = ResolversParentTypes['ProcessType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ProductProcessType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductExhaustionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductExhaustionResponse'] = ResolversParentTypes['ProductExhaustionResponse']> = {
  exhaust?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductFieldResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductFieldResponse'] = ResolversParentTypes['ProductFieldResponse']> = {
  certificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  fieldId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listOfValues?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  maxStringLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Optionality'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductFieldTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductFieldType'] = ResolversParentTypes['ProductFieldType']> = {
  certificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductProcessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductProcessResponse'] = ResolversParentTypes['ProductProcessResponse']> = {
  attributes?: Resolver<ResolversTypes['ProcessAttributesResponse'], ParentType, ContextType>;
  confirmationTaskId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  processType?: Resolver<ResolversTypes['ProductProcessType'], ParentType, ContextType>;
  requestTaskId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  resetTaskId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  attestations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType, RequireFields<QueryAttestationsArgs, 'certificateType' | 'commodity' | 'destination'>>;
  availableProcesses?: Resolver<Array<ResolversTypes['ProcessType']>, ParentType, ContextType, RequireFields<QueryAvailableProcessesArgs, 'productId'>>;
  availableTemplates?: Resolver<Maybe<Array<ResolversTypes['AvailableTemplateFields']>>, ParentType, ContextType, RequireFields<QueryAvailableTemplatesArgs, 'commodity' | 'countryCode'>>;
  certificateTemplateFields?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType, Partial<QueryCertificateTemplateFieldsArgs>>;
  certificateTemplateFlatFields?: Resolver<Array<ResolversTypes['TemplateSection']>, ParentType, ContextType, Partial<QueryCertificateTemplateFlatFieldsArgs>>;
  certificateTemplateFlattestFields?: Resolver<Array<ResolversTypes['TemplateSectionField']>, ParentType, ContextType, Partial<QueryCertificateTemplateFlattestFieldsArgs>>;
  certificateTemplateFlattestFieldsV2?: Resolver<Array<ResolversTypes['TemplateSection']>, ParentType, ContextType, RequireFields<QueryCertificateTemplateFlattestFieldsV2Args, 'submissionLayout'>>;
  checkUserAccess?: Resolver<ResolversTypes['CheckUserAccessResponse'], ParentType, ContextType, RequireFields<QueryCheckUserAccessArgs, 'input'>>;
  coreReferencedDocument?: Resolver<Maybe<ResolversTypes['CoreReferencedDocument']>, ParentType, ContextType, RequireFields<QueryCoreReferencedDocumentArgs, 'id'>>;
  customsPermitNumberUsage?: Resolver<ResolversTypes['CustomsPermitNumberUsage'], ParentType, ContextType>;
  decisionTable?: Resolver<Maybe<ResolversTypes['DecisionTable']>, ParentType, ContextType, RequireFields<QueryDecisionTableArgs, 'id'>>;
  downloadCSVFromReference?: Resolver<Maybe<ResolversTypes['PresignedUrl']>, ParentType, ContextType, RequireFields<QueryDownloadCsvFromReferenceArgs, 'listCode'>>;
  downloadCoreReferencedDocument?: Resolver<Maybe<ResolversTypes['CoreReferencedDocumentUrl']>, ParentType, ContextType, RequireFields<QueryDownloadCoreReferencedDocumentArgs, 'id'>>;
  downloadDocument?: Resolver<ResolversTypes['TemplateDocumentUrl'], ParentType, ContextType, RequireFields<QueryDownloadDocumentArgs, 'templateVersionId'>>;
  downloadExportCertificates?: Resolver<ResolversTypes['B2GExportCertificatesDownloadUrl'], ParentType, ContextType, Partial<QueryDownloadExportCertificatesArgs>>;
  downloadProducts?: Resolver<ResolversTypes['B2GProductsDownloadUrl'], ParentType, ContextType, Partial<QueryDownloadProductsArgs>>;
  downloadReferencedDocument?: Resolver<ResolversTypes['ReferencedDocumentUrl'], ParentType, ContextType, RequireFields<QueryDownloadReferencedDocumentArgs, 'id'>>;
  downloadSubmissionXML?: Resolver<Maybe<ResolversTypes['SubmissionXmlUrl']>, ParentType, ContextType, RequireFields<QueryDownloadSubmissionXmlArgs, 'requestId' | 'requestType'>>;
  e2eCalculateProductEligibilityV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GEligibilityStatus']>>>, ParentType, ContextType, RequireFields<QueryE2eCalculateProductEligibilityV2Args, 'productId'>>;
  e2eProductEligibilityCriteriasV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GProductEligibilityCriteriaV2']>>>, ParentType, ContextType, RequireFields<QueryE2eProductEligibilityCriteriasV2Args, 'productId'>>;
  estarOrganisations?: Resolver<Array<ResolversTypes['EStarOrganisation']>, ParentType, ContextType, Partial<QueryEstarOrganisationsArgs>>;
  executeRules?: Resolver<Array<ResolversTypes['RulesResponse']>, ParentType, ContextType, RequireFields<QueryExecuteRulesArgs, 'input'>>;
  exportCertificateAsTemplateValues?: Resolver<ResolversTypes['SpsCertificateTemplate'], ParentType, ContextType, RequireFields<QueryExportCertificateAsTemplateValuesArgs, 'id'>>;
  exportCertificateRequest?: Resolver<Maybe<ResolversTypes['B2GExportCertificateRequest']>, ParentType, ContextType, RequireFields<QueryExportCertificateRequestArgs, 'id'>>;
  exportCertificateSupportingDocuments?: Resolver<Array<ResolversTypes['B2GReferencedDocument']>, ParentType, ContextType, RequireFields<QueryExportCertificateSupportingDocumentsArgs, 'input'>>;
  fetchFieldsBySubmissionLayout?: Resolver<Array<ResolversTypes['FieldBySubmissionLayout']>, ParentType, ContextType, RequireFields<QueryFetchFieldsBySubmissionLayoutArgs, 'fetchNonActive' | 'submissionLayout'>>;
  fetchRequestPartyRole?: Resolver<ResolversTypes['PartyRole'], ParentType, ContextType, RequireFields<QueryFetchRequestPartyRoleArgs, 'input'>>;
  fetchRequestPartyRoles?: Resolver<ResolversTypes['RequestPartyRolesResponse'], ParentType, ContextType, RequireFields<QueryFetchRequestPartyRolesArgs, 'input'>>;
  findApprovedImportCertificate?: Resolver<Maybe<ResolversTypes['TemplateVersion']>, ParentType, ContextType, RequireFields<QueryFindApprovedImportCertificateArgs, 'certificateType' | 'destinationMarket'>>;
  getActiveTemplateBySubmissionLayout?: Resolver<Maybe<ResolversTypes['ActiveTemplateResult']>, ParentType, ContextType, Partial<QueryGetActiveTemplateBySubmissionLayoutArgs>>;
  getAllAvailableLanguages?: Resolver<Array<ResolversTypes['Language']>, ParentType, ContextType>;
  getApprovedProductDetails?: Resolver<Maybe<ResolversTypes['ApprovedProductRequest']>, ParentType, ContextType, RequireFields<QueryGetApprovedProductDetailsArgs, 'input'>>;
  getApprovedTemplateVersion?: Resolver<Maybe<ResolversTypes['TemplateVersion']>, ParentType, ContextType, RequireFields<QueryGetApprovedTemplateVersionArgs, 'certificateType' | 'destinationMarket'>>;
  getClassificationNameByFieldUniqueId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetClassificationNameByFieldUniqueIdArgs, 'fieldUniqueId'>>;
  getConsignorDetails?: Resolver<ResolversTypes['ConsignorDetails'], ParentType, ContextType, RequireFields<QueryGetConsignorDetailsArgs, 'id'>>;
  getDeclarationInputs?: Resolver<Maybe<ResolversTypes['getDeclarationInputsResponse']>, ParentType, ContextType, RequireFields<QueryGetDeclarationInputsArgs, 'statementCode'>>;
  getDfeForm?: Resolver<ResolversTypes['DFEForm'], ParentType, ContextType, RequireFields<QueryGetDfeFormArgs, 'input'>>;
  getDfePermissions?: Resolver<Array<ResolversTypes['DFEPermission']>, ParentType, ContextType>;
  getDfeTransferRequestRecipe?: Resolver<Maybe<ResolversTypes['DfeConfig']>, ParentType, ContextType, Partial<QueryGetDfeTransferRequestRecipeArgs>>;
  getDfeTransferRequestTemplateInfo?: Resolver<Maybe<ResolversTypes['DfeTemplateInfo']>, ParentType, ContextType>;
  getDraftCertificateGenerationStatus?: Resolver<ResolversTypes['DraftCertificateGenerationStatusResponse'], ParentType, ContextType, RequireFields<QueryGetDraftCertificateGenerationStatusArgs, 'input'>>;
  getExportCertificateRequest?: Resolver<Maybe<ResolversTypes['ExportCertificateRequest']>, ParentType, ContextType, RequireFields<QueryGetExportCertificateRequestArgs, 'id'>>;
  getExportReqDetails?: Resolver<Maybe<ResolversTypes['CoreExportDetails']>, ParentType, ContextType, RequireFields<QueryGetExportReqDetailsArgs, 'input'>>;
  getExportRequestHistory?: Resolver<Array<ResolversTypes['ExportRequestHistoryRecord']>, ParentType, ContextType, RequireFields<QueryGetExportRequestHistoryArgs, 'input'>>;
  getExtractHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetExtractHtmlArgs, 'requestId'>>;
  getFeatureFlags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  getFieldConfiguration?: Resolver<Maybe<ResolversTypes['FieldConfiguration']>, ParentType, ContextType, RequireFields<QueryGetFieldConfigurationArgs, 'fieldUniqueId'>>;
  getFieldUniqueIdsByClassificationCode?: Resolver<Maybe<ResolversTypes['FieldInfo']>, ParentType, ContextType, RequireFields<QueryGetFieldUniqueIdsByClassificationCodeArgs, 'input'>>;
  getFieldsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldV2']>>>, ParentType, ContextType, RequireFields<QueryGetFieldsV2Args, 'templateVersionId'>>;
  getForwardProductTracking?: Resolver<Maybe<ResolversTypes['ForwardProductTrackingResponse']>, ParentType, ContextType, RequireFields<QueryGetForwardProductTrackingArgs, 'transferRequestId'>>;
  getG2GAccountDetails?: Resolver<Maybe<ResolversTypes['G2GAccount']>, ParentType, ContextType, RequireFields<QueryGetG2GAccountDetailsArgs, 'id'>>;
  getImportCertificate?: Resolver<Maybe<ResolversTypes['ImportCertificate']>, ParentType, ContextType, RequireFields<QueryGetImportCertificateArgs, 'id'>>;
  getLatestLookupName?: Resolver<Maybe<ResolversTypes['LookupValue']>, ParentType, ContextType, RequireFields<QueryGetLatestLookupNameArgs, 'code' | 'fieldUniqueId'>>;
  getMajorVersionsByCode?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryGetMajorVersionsByCodeArgs, 'templateCode'>>;
  getMasterLayout?: Resolver<Maybe<ResolversTypes['MasterLayout']>, ParentType, ContextType, RequireFields<QueryGetMasterLayoutArgs, 'submissionType'>>;
  getPortCountryInfo?: Resolver<Maybe<ResolversTypes['PortCountryInfo']>, ParentType, ContextType, RequireFields<QueryGetPortCountryInfoArgs, 'portCode'>>;
  getPresignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetPresignedUrlArgs, 'fileStore' | 'key'>>;
  getPreviewOutputXMLPresignedURL?: Resolver<ResolversTypes['PreviewOutputXMLPresignedURLResult'], ParentType, ContextType, RequireFields<QueryGetPreviewOutputXmlPresignedUrlArgs, 'templateVersionId'>>;
  getProcessGroupDetailsByGroupIds?: Resolver<Array<ResolversTypes['ProcessGroupDetail']>, ParentType, ContextType, RequireFields<QueryGetProcessGroupDetailsByGroupIdsArgs, 'groupIds'>>;
  getProcessGroupNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  getProcessGroupReferenceData?: Resolver<ResolversTypes['TemplateProcessGroupReferenceData'], ParentType, ContextType, RequireFields<QueryGetProcessGroupReferenceDataArgs, 'processGroup'>>;
  getProcessGroupsByProcessCodes?: Resolver<Array<ResolversTypes['ProcessGroupInfo']>, ParentType, ContextType, RequireFields<QueryGetProcessGroupsByProcessCodesArgs, 'processCodes'>>;
  getProductsByTransferReference?: Resolver<ResolversTypes['TransferReferenceResponse'], ParentType, ContextType, RequireFields<QueryGetProductsByTransferReferenceArgs, 'input'>>;
  getReferenceData?: Resolver<Array<ResolversTypes['ReferenceItem']>, ParentType, ContextType, RequireFields<QueryGetReferenceDataArgs, 'input'>>;
  getReferenceItemValidationInfo?: Resolver<Maybe<ResolversTypes['ReferenceValidationResponse']>, ParentType, ContextType, RequireFields<QueryGetReferenceItemValidationInfoArgs, 'fileName' | 'refListCode'>>;
  getRegistrationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegistrationType']>>>, ParentType, ContextType, Partial<QueryGetRegistrationTypesArgs>>;
  getRequestHistoryForSF?: Resolver<Array<ResolversTypes['RequestHistoryForSF']>, ParentType, ContextType, RequireFields<QueryGetRequestHistoryForSfArgs, 'input'>>;
  getRequestValidations?: Resolver<ResolversTypes['GetRequestValidationsResponse'], ParentType, ContextType, RequireFields<QueryGetRequestValidationsArgs, 'input'>>;
  getSfForwardProductTracking?: Resolver<Maybe<ResolversTypes['ForwardProductTrackingResponse']>, ParentType, ContextType, RequireFields<QueryGetSfForwardProductTrackingArgs, 'transferRequestId'>>;
  getSnapshotPresignedUrl?: Resolver<ResolversTypes['SnapshotPresignedUrlResponse'], ParentType, ContextType, RequireFields<QueryGetSnapshotPresignedUrlArgs, 'historyId'>>;
  getSupportingDocumentActions?: Resolver<ResolversTypes['SupportingDocumentActionsResponse'], ParentType, ContextType, RequireFields<QueryGetSupportingDocumentActionsArgs, 'input'>>;
  getSupportingDocumentDetails?: Resolver<ResolversTypes['CoreSupportingDocument'], ParentType, ContextType, RequireFields<QueryGetSupportingDocumentDetailsArgs, 'input'>>;
  getSupportingDocumentHistory?: Resolver<Array<ResolversTypes['SupportingDocumentHistoryEntry']>, ParentType, ContextType, RequireFields<QueryGetSupportingDocumentHistoryArgs, 'input'>>;
  getSupportingDocumentPresignedUrl?: Resolver<ResolversTypes['SupportingDocumentPresignedUrlResponse'], ParentType, ContextType, RequireFields<QueryGetSupportingDocumentPresignedUrlArgs, 'input'>>;
  getSupportingDocumentUsage?: Resolver<Array<ResolversTypes['SupportingDocumentUsageRecord']>, ParentType, ContextType, RequireFields<QueryGetSupportingDocumentUsageArgs, 'input'>>;
  getTemplate?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<QueryGetTemplateArgs, 'templateId'>>;
  getTemplateDetailsByCode?: Resolver<Maybe<ResolversTypes['TemplateVersionId']>, ParentType, ContextType, RequireFields<QueryGetTemplateDetailsByCodeArgs, 'templateCode'>>;
  getTemplateDocumentDownloadUrlV2?: Resolver<ResolversTypes['TemplateDocumentUrlV2'], ParentType, ContextType, RequireFields<QueryGetTemplateDocumentDownloadUrlV2Args, 'templateVersionId'>>;
  getTemplateFieldReferenceData?: Resolver<ResolversTypes['TemplateFieldReferenceData'], ParentType, ContextType, RequireFields<QueryGetTemplateFieldReferenceDataArgs, 'fuid' | 'submissionLayoutType'>>;
  getTemplateV2?: Resolver<Maybe<ResolversTypes['TemplateV2']>, ParentType, ContextType, RequireFields<QueryGetTemplateV2Args, 'templateId'>>;
  getTemplateVersion?: Resolver<Maybe<ResolversTypes['TemplateVersion']>, ParentType, ContextType, RequireFields<QueryGetTemplateVersionArgs, 'templateVersionId'>>;
  getTemplateVersionV2?: Resolver<Maybe<ResolversTypes['TemplateVersionV2']>, ParentType, ContextType, RequireFields<QueryGetTemplateVersionV2Args, 'includeProcesses' | 'templateVersionId'>>;
  getTemplateWithActiveApproved?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<QueryGetTemplateWithActiveApprovedArgs, 'templateId'>>;
  getTemplateXmlCore?: Resolver<ResolversTypes['GetTemplateXmlCoreResponse'], ParentType, ContextType, RequireFields<QueryGetTemplateXmlCoreArgs, 'input'>>;
  getTransferRequestDetails?: Resolver<Maybe<ResolversTypes['TransferRequestDetails']>, ParentType, ContextType, RequireFields<QueryGetTransferRequestDetailsArgs, 'input'>>;
  getTransferRequestHistory?: Resolver<Array<ResolversTypes['TransferRequestHistoryRecord']>, ParentType, ContextType, RequireFields<QueryGetTransferRequestHistoryArgs, 'input'>>;
  getTransferRequestHistoryForSF?: Resolver<Array<ResolversTypes['RequestHistoryForSF']>, ParentType, ContextType, RequireFields<QueryGetTransferRequestHistoryForSfArgs, 'input'>>;
  getUserDetailsById?: Resolver<Maybe<ResolversTypes['UserDetailsById']>, ParentType, ContextType, RequireFields<QueryGetUserDetailsByIdArgs, 'userId'>>;
  getUserInfo?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  importCertificateEmbeddedDocument?: Resolver<ResolversTypes['ImportCertificateEmbeddedDocument'], ParentType, ContextType, RequireFields<QueryImportCertificateEmbeddedDocumentArgs, 'id'>>;
  importCertificatePdf?: Resolver<ResolversTypes['ImportCertificatePdf'], ParentType, ContextType, RequireFields<QueryImportCertificatePdfArgs, 'input'>>;
  importCertificateXml?: Resolver<ResolversTypes['ImportCertificateXml'], ParentType, ContextType, RequireFields<QueryImportCertificateXmlArgs, 'id'>>;
  listAnnouncements?: Resolver<ResolversTypes['AnnouncementList'], ParentType, ContextType, Partial<QueryListAnnouncementsArgs>>;
  listImportCertificateIntegrations?: Resolver<Array<ResolversTypes['ImportCertificateIntegration']>, ParentType, ContextType>;
  listImportCertificates?: Resolver<Array<ResolversTypes['ImportCertificate']>, ParentType, ContextType>;
  numberOfDocuments?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryNumberOfDocumentsArgs, 'collectionName'>>;
  product?: Resolver<ResolversTypes['B2GProduct'], ParentType, ContextType, RequireFields<QueryProductArgs, 'id'>>;
  productFields?: Resolver<Array<Maybe<ResolversTypes['ProductFieldResponse']>>, ParentType, ContextType, RequireFields<QueryProductFieldsArgs, 'input'>>;
  productForm?: Resolver<Array<Maybe<ResolversTypes['FormletField']>>, ParentType, ContextType, RequireFields<QueryProductFormArgs, 'input'>>;
  productFormlet?: Resolver<ResolversTypes['Form'], ParentType, ContextType, RequireFields<QueryProductFormletArgs, 'input'>>;
  productProcesses?: Resolver<Array<ResolversTypes['ProductProcessResponse']>, ParentType, ContextType, RequireFields<QueryProductProcessesArgs, 'input'>>;
  referenceDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GReferencedDocument']>>>, ParentType, ContextType, RequireFields<QueryReferenceDocumentsArgs, 'exportRequestId'>>;
  referencedDocument?: Resolver<Maybe<ResolversTypes['ReferencedDocument']>, ParentType, ContextType, RequireFields<QueryReferencedDocumentArgs, 'id'>>;
  salesForceApplicationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<QuerySalesForceApplicationIdArgs, 'requestId'>>;
  salesForceProductId?: Resolver<Maybe<ResolversTypes['SalesForceProductId']>, ParentType, ContextType, RequireFields<QuerySalesForceProductIdArgs, 'productId'>>;
  searchDecisionTables?: Resolver<Array<ResolversTypes['DecisionTable']>, ParentType, ContextType, Partial<QuerySearchDecisionTablesArgs>>;
  searchG2GAccounts?: Resolver<ResolversTypes['G2GAccountSearchResult'], ParentType, ContextType, Partial<QuerySearchG2GAccountsArgs>>;
  searchReferenceList?: Resolver<ResolversTypes['SearchReferenceListResponse'], ParentType, ContextType, Partial<QuerySearchReferenceListArgs>>;
  searchTemplateVersions?: Resolver<ResolversTypes['SearchTemplateVersionsResponse'], ParentType, ContextType, Partial<QuerySearchTemplateVersionsArgs>>;
  searchTemplates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, Partial<QuerySearchTemplatesArgs>>;
  sfDownload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<QuerySfDownloadArgs>>;
  sfDownloadCertificate?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QuerySfDownloadCertificateArgs, 'input'>>;
  sfDownloadSupportingDocument?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QuerySfDownloadSupportingDocumentArgs, 'id'>>;
  sfExporter?: Resolver<ResolversTypes['SalesForceParty'], ParentType, ContextType, RequireFields<QuerySfExporterArgs, 'id'>>;
  sfGetExportRequest?: Resolver<ResolversTypes['SfRequest'], ParentType, ContextType, RequireFields<QuerySfGetExportRequestArgs, 'id'>>;
  sfGetExportSnapshot?: Resolver<ResolversTypes['SfRequest'], ParentType, ContextType, RequireFields<QuerySfGetExportSnapshotArgs, 'id'>>;
  sfGetManyExportRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['SfRequest']>>>, ParentType, ContextType, RequireFields<QuerySfGetManyExportRequestsArgs, 'ids'>>;
  sfGetManyTransferRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['SfRequest']>>>, ParentType, ContextType, RequireFields<QuerySfGetManyTransferRequestsArgs, 'ids'>>;
  sfGetSnapshot?: Resolver<ResolversTypes['SfRequest'], ParentType, ContextType, RequireFields<QuerySfGetSnapshotArgs, 'id'>>;
  sfGetTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QuerySfGetTemplateArgs, 'id'>>;
  sfGetTransferRequest?: Resolver<ResolversTypes['SfRequest'], ParentType, ContextType, RequireFields<QuerySfGetTransferRequestArgs, 'id'>>;
  sfGetTransferSnapshot?: Resolver<ResolversTypes['SfRequest'], ParentType, ContextType, RequireFields<QuerySfGetTransferSnapshotArgs, 'id'>>;
  sfSearchApprovedTemplates?: Resolver<ResolversTypes['SfSearchApprovedTemplatesResponse'], ParentType, ContextType, Partial<QuerySfSearchApprovedTemplatesArgs>>;
  testDecisionTableRevision?: Resolver<Array<ResolversTypes['DecisionTableTestResult']>, ParentType, ContextType, RequireFields<QueryTestDecisionTableRevisionArgs, 'input'>>;
  tradecertUserProfile?: Resolver<ResolversTypes['UserProfile'], ParentType, ContextType, Partial<QueryTradecertUserProfileArgs>>;
  validate?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GValidationErrors']>>>, ParentType, ContextType, RequireFields<QueryValidateArgs, 'id'>>;
  validateDfeRequest?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GValidationErrors']>>>, ParentType, ContextType, Partial<QueryValidateDfeRequestArgs>>;
  validateProduct?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GValidationErrors']>>>, ParentType, ContextType, Partial<QueryValidateProductArgs>>;
  validateSampleDfeRequest?: Resolver<Maybe<Array<Maybe<ResolversTypes['B2GValidationErrors']>>>, ParentType, ContextType, Partial<QueryValidateSampleDfeRequestArgs>>;
};

export type RaiseExportRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RaiseExportRequestResponse'] = ResolversParentTypes['RaiseExportRequestResponse']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CoreStatus'], ParentType, ContextType>;
  submittedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  warnings?: Resolver<Maybe<Array<ResolversTypes['RequestValidation']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RaiseTransferRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RaiseTransferRequestResponse'] = ResolversParentTypes['RaiseTransferRequestResponse']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CoreStatus'], ParentType, ContextType>;
  submittedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  warnings?: Resolver<Maybe<Array<ResolversTypes['RequestValidation']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceCaptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceCaption'] = ResolversParentTypes['ReferenceCaption']> = {
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceDataListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceDataList'] = ResolversParentTypes['ReferenceDataList']> = {
  displayValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  tableName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceItem'] = ResolversParentTypes['ReferenceItem']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effective_end_date?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  effective_start_date?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceList'] = ResolversParentTypes['ReferenceList']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  listName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceProcessGroupCaptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceProcessGroupCaption'] = ResolversParentTypes['ReferenceProcessGroupCaption']> = {
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceValidationModeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceValidationMode'] = ResolversParentTypes['ReferenceValidationMode']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RefValidationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceValidationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceValidationResponse'] = ResolversParentTypes['ReferenceValidationResponse']> = {
  processedResults?: Resolver<Array<ResolversTypes['ReferenceValidationMode']>, ParentType, ContextType>;
  refListCode?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferencedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferencedDocument'] = ResolversParentTypes['ReferencedDocument']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferencedDocumentUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferencedDocumentUrl'] = ResolversParentTypes['ReferencedDocumentUrl']> = {
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegenerateApprovedTemplatesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegenerateApprovedTemplatesResponse'] = ResolversParentTypes['RegenerateApprovedTemplatesResponse']> = {
  failureCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['RegenerateApprovedTemplatesResult']>, ParentType, ContextType>;
  successCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegenerateApprovedTemplatesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegenerateApprovedTemplatesResult'] = ResolversParentTypes['RegenerateApprovedTemplatesResult']> = {
  actions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationCountries?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  majorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  templateCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateRevisionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegenerateCertificateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegenerateCertificateResponse'] = ResolversParentTypes['RegenerateCertificateResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationType'] = ResolversParentTypes['RegistrationType']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReindexResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReindexResponse'] = ResolversParentTypes['ReindexResponse']> = {
  alias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collectionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  functionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveProductProcessesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveProductProcessesResponse'] = ResolversParentTypes['RemoveProductProcessesResponse']> = {
  deletedProcessIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestConfirmationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestConfirmationResponse'] = ResolversParentTypes['RequestConfirmationResponse']> = {
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  wsmp?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestHistoryForSfResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestHistoryForSF'] = ResolversParentTypes['RequestHistoryForSF']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestPartyRolesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestPartyRolesResponse'] = ResolversParentTypes['RequestPartyRolesResponse']> = {
  highestPartyRole?: Resolver<ResolversTypes['PartyRole'], ParentType, ContextType>;
  partyRoles?: Resolver<Array<ResolversTypes['PartyRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestValidation'] = ResolversParentTypes['RequestValidation']> = {
  additionalFieldValue?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  additionalFuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  errorMsg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorType?: Resolver<ResolversTypes['ValidationErrorType'], ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldFuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldValue?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleSpecificKeysResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleSpecificKeys'] = ResolversParentTypes['RoleSpecificKeys']> = {
  exportCertificates?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationAll?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTransfers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RowResolvers<ContextType = any, ParentType extends ResolversParentTypes['Row'] = ResolversParentTypes['Row']> = {
  fields?: Resolver<Maybe<Array<ResolversTypes['FieldInput']>>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RulesInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RulesInput'] = ResolversParentTypes['RulesInput']> = {
  __resolveType: TypeResolveFn<'DeclarationsType' | 'EligibilityType' | 'ExportCertificateWorkflowType' | 'ImportConnectionsType' | 'PhytoOcaEmailNotificationsType' | 'ProductFieldType' | 'WineAnalytesTolerancesType' | 'WineProductFieldType', ParentType, ContextType>;
};

export type RulesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RulesResponse'] = ResolversParentTypes['RulesResponse']> = {
  __resolveType: TypeResolveFn<'DeclarationsResponse' | 'EligibilityResponse' | 'ExportCertificateWorkflowResponse' | 'ImportConnectionsResponse' | 'PhytoOcaEmailNotificationsResponse' | 'ProductFieldResponse' | 'WineAnalytesTolerancesResponse', ParentType, ContextType>;
};

export type SpsAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSAddress'] = ResolversParentTypes['SPSAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  country_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_subdivision_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  country_subdivision_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['AddressTypeCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsAuthenticationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSAuthentication'] = ResolversParentTypes['SPSAuthentication']> = {
  actual?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  included_clauses?: Resolver<Array<ResolversTypes['SPSClause']>, ParentType, ContextType>;
  issue_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  location_provider_party?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  provider_party?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSCertificate'] = ResolversParentTypes['SPSCertificate']> = {
  consignment?: Resolver<ResolversTypes['SPSConsignment'], ParentType, ContextType>;
  exchanged_document?: Resolver<ResolversTypes['SPSExchangedDocument'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsClassificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSClassification'] = ResolversParentTypes['SPSClassification']> = {
  class_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  class_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  system_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  system_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsClauseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSClause'] = ResolversParentTypes['SPSClause']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsConsignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSConsignment'] = ResolversParentTypes['SPSConsignment']> = {
  availability_due_date_time?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  consignee_receipt_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  customs_transit_agent?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  delivery?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  despatch?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  examination_event?: Resolver<Maybe<ResolversTypes['SPSEvent']>, ParentType, ContextType>;
  export_country?: Resolver<Maybe<ResolversTypes['SPSCountry']>, ParentType, ContextType>;
  export_exit_date_time?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  exporter_reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gross_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  import_country?: Resolver<Maybe<ResolversTypes['SPSCountry']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SPSConsignmentItem']>, ParentType, ContextType>;
  loading_base_port_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  main_carriage_transport_movements?: Resolver<Array<ResolversTypes['SPSTransportMovement']>, ParentType, ContextType>;
  reexport_country?: Resolver<Maybe<ResolversTypes['SPSCountry']>, ParentType, ContextType>;
  ship_stores_indicator?: Resolver<Maybe<ResolversTypes['IndicatorType']>, ParentType, ContextType>;
  storage_events?: Resolver<Array<ResolversTypes['SPSEvent']>, ParentType, ContextType>;
  transit_countries?: Resolver<Array<ResolversTypes['SPSCountry']>, ParentType, ContextType>;
  transit_locations?: Resolver<Array<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  unloading_base_port_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  utilized_transport_equipment?: Resolver<Array<ResolversTypes['SPSTransportEquipment']>, ParentType, ContextType>;
  wine?: Resolver<Maybe<ResolversTypes['WineConsignment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsConsignmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSConsignmentItem'] = ResolversParentTypes['SPSConsignmentItem']> = {
  gross_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SPSTradeLineItem']>, ParentType, ContextType>;
  nature_identification_cargo?: Resolver<Array<ResolversTypes['CargoTypeClassificationCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSContact'] = ResolversParentTypes['SPSContact']> = {
  person_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSCountry'] = ResolversParentTypes['SPSCountry']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subdivision?: Resolver<Maybe<ResolversTypes['SPSCountrySubDivision']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsCountrySubDivisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSCountrySubDivision'] = ResolversParentTypes['SPSCountrySubDivision']> = {
  hierarchicalLevelCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSEvent'] = ResolversParentTypes['SPSEvent']> = {
  occurrence_location?: Resolver<Maybe<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsExchangedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSExchangedDocument'] = ResolversParentTypes['SPSExchangedDocument']> = {
  certificate_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  certifier?: Resolver<Maybe<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  customs_permit_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  included_notes?: Resolver<Array<ResolversTypes['SPSNote']>, ParentType, ContextType>;
  issue_date_time?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  issuer?: Resolver<ResolversTypes['SPSParty'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenced_documents?: Resolver<Array<ResolversTypes['SPSReferencedDocument']>, ParentType, ContextType>;
  signatories?: Resolver<Array<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  status_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verifiers?: Resolver<Array<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSLocation'] = ResolversParentTypes['SPSLocation']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSNote'] = ResolversParentTypes['SPSNote']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSPackage'] = ResolversParentTypes['SPSPackage']> = {
  level_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nominal_gross_volume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nominal_gross_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  physical_shipping_marks?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPartyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSParty'] = ResolversParentTypes['SPSParty']> = {
  defined_contacts?: Resolver<Array<ResolversTypes['SPSContact']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  party_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specified_address?: Resolver<Maybe<ResolversTypes['SPSAddress']>, ParentType, ContextType>;
  specified_person?: Resolver<Maybe<ResolversTypes['SPSPerson']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSPeriod'] = ResolversParentTypes['SPSPeriod']> = {
  duration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSPerson'] = ResolversParentTypes['SPSPerson']> = {
  attained_qualifications?: Resolver<Array<ResolversTypes['SPSQualification']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsProcessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSProcess'] = ResolversParentTypes['SPSProcess']> = {
  applicable_process_characteristics?: Resolver<Array<ResolversTypes['SPSProcessCharacteristic']>, ParentType, ContextType>;
  completion_period?: Resolver<Maybe<ResolversTypes['SPSPeriod']>, ParentType, ContextType>;
  operation_country?: Resolver<Maybe<ResolversTypes['SPSCountry']>, ParentType, ContextType>;
  operator_party?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsProcessCharacteristicResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSProcessCharacteristic'] = ResolversParentTypes['SPSProcessCharacteristic']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maximum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCode']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsQualificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSQualification'] = ResolversParentTypes['SPSQualification']> = {
  abbreviated_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsReferencedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSReferencedDocument'] = ResolversParentTypes['SPSReferencedDocument']> = {
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filetype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issued?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  relationship_type_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsSealResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSSeal'] = ResolversParentTypes['SPSSeal']> = {
  issuing_party?: Resolver<Maybe<ResolversTypes['SPSParty']>, ParentType, ContextType>;
  maximum_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seal_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTemperatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSTemperature'] = ResolversParentTypes['SPSTemperature']> = {
  maximum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTradeLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSTradeLineItem'] = ResolversParentTypes['SPSTradeLineItem']> = {
  additional_information?: Resolver<Array<ResolversTypes['SPSNote']>, ParentType, ContextType>;
  applied_processes?: Resolver<Array<ResolversTypes['SPSProcess']>, ParentType, ContextType>;
  asserted_authentications?: Resolver<Array<ResolversTypes['SPSAuthentication']>, ParentType, ContextType>;
  associated_transport_equipment?: Resolver<Array<ResolversTypes['SPSTransportEquipment']>, ParentType, ContextType>;
  brand_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classifications?: Resolver<Array<ResolversTypes['SPSClassification']>, ParentType, ContextType>;
  cn_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  common_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiry_date_time?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  gross_volume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gross_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hs_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  import_certificate_extract?: Resolver<Maybe<Array<ResolversTypes['ImportCertificateExtractItem']>>, ParentType, ContextType>;
  import_certificate_measurement?: Resolver<Maybe<Array<ResolversTypes['ImportCertificateExtractMeasurement']>>, ParentType, ContextType>;
  import_permit_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intended_use?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  net_volume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  net_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin_countries?: Resolver<Maybe<Array<ResolversTypes['SPSCountry']>>, ParentType, ContextType>;
  origin_country?: Resolver<Maybe<ResolversTypes['SPSCountry']>, ParentType, ContextType>;
  origin_locations?: Resolver<Array<ResolversTypes['SPSLocation']>, ParentType, ContextType>;
  other_quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  physical_packages?: Resolver<Array<ResolversTypes['SPSPackage']>, ParentType, ContextType>;
  production_batch_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenced_documents?: Resolver<Array<ResolversTypes['SPSReferencedDocument']>, ParentType, ContextType>;
  requestor_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scientific_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  wine?: Resolver<Maybe<ResolversTypes['B2GWineFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTransportEquipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSTransportEquipment'] = ResolversParentTypes['SPSTransportEquipment']> = {
  affixed_seals?: Resolver<Array<ResolversTypes['SPSSeal']>, ParentType, ContextType>;
  temperature_settings?: Resolver<Array<ResolversTypes['SPSTemperature']>, ParentType, ContextType>;
  transport_equipment_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTransportMovementResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSTransportMovement'] = ResolversParentTypes['SPSTransportMovement']> = {
  mode?: Resolver<ResolversTypes['TransportModeCode'], ParentType, ContextType>;
  mode_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  used_transport_means?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTransportMovementTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSTransportMovementTemplate'] = ResolversParentTypes['SPSTransportMovementTemplate']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['TransportMovementCodeTemplate'], ParentType, ContextType>;
  used_transport_means?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsWineExporterResolvers<ContextType = any, ParentType extends ResolversParentTypes['SPSWineExporter'] = ResolversParentTypes['SPSWineExporter']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForceAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForceAddress'] = ResolversParentTypes['SalesForceAddress']> = {
  addressType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForceContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForceContact'] = ResolversParentTypes['SalesForceContact']> = {
  emails?: Resolver<Array<ResolversTypes['SalesForceEmail']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phones?: Resolver<Array<ResolversTypes['SalesForcePhone']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForceEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForceEmail'] = ResolversParentTypes['SalesForceEmail']> = {
  emailAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForceIdentifierResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForceIdentifier'] = ResolversParentTypes['SalesForceIdentifier']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForcePartyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForceParty'] = ResolversParentTypes['SalesForceParty']> = {
  addresses?: Resolver<Array<ResolversTypes['SalesForceAddress']>, ParentType, ContextType>;
  contacts?: Resolver<Array<ResolversTypes['SalesForceContact']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  identifiers?: Resolver<Array<ResolversTypes['SalesForceIdentifier']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nzbn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryAddress?: Resolver<Maybe<ResolversTypes['SalesForceAddress']>, ParentType, ContextType>;
  registrationIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingAs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForcePhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForcePhone'] = ResolversParentTypes['SalesForcePhone']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phoneType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  telephoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesForceProductIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesForceProductId'] = ResolversParentTypes['SalesForceProductId']> = {
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productRevisionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sfProductId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesforceErApprovalResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesforceErApprovalResponse'] = ResolversParentTypes['SalesforceErApprovalResponse']> = {
  exportRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SalesforceErStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesforceTransferRequestVerificationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesforceTransferRequestVerificationResponse'] = ResolversParentTypes['SalesforceTransferRequestVerificationResponse']> = {
  transferRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveChangesToReferenceDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveChangesToReferenceDataResponse'] = ResolversParentTypes['SaveChangesToReferenceDataResponse']> = {
  isDescUpdated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFileUploaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedClassificationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedClassificationOutput'] = ResolversParentTypes['SavedClassificationOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedProcessOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedProcessOutput'] = ResolversParentTypes['SavedProcessOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedProductOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedProductOutput'] = ResolversParentTypes['SavedProductOutput']> = {
  classification?: Resolver<Maybe<Array<Maybe<ResolversTypes['SavedClassificationOutput']>>>, ParentType, ContextType>;
  containerId?: Resolver<Maybe<Array<Maybe<ResolversTypes['ID']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  process?: Resolver<Maybe<Array<Maybe<ResolversTypes['SavedProcessOutput']>>>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchApiKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchApiKey'] = ResolversParentTypes['SearchApiKey']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expires?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchReferenceListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchReferenceListResponse'] = ResolversParentTypes['SearchReferenceListResponse']> = {
  list?: Resolver<Maybe<Array<ResolversTypes['ReferenceList']>>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchTemplateVersionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTemplateVersionsResponse'] = ResolversParentTypes['SearchTemplateVersionsResponse']> = {
  results?: Resolver<Array<ResolversTypes['TemplateVersion']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Section'] = ResolversParentTypes['Section']> = {
  children?: Resolver<Array<ResolversTypes['Block']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SensoryProcessRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['SensoryProcessRequest'] = ResolversParentTypes['SensoryProcessRequest']> = {
  assessmentDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disputedReason?: Resolver<Maybe<ResolversTypes['WineDisputedReason']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  winemaker?: Resolver<ResolversTypes['B2GContact'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfApplication'] = ResolversParentTypes['SfApplication']> = {
  CNInspection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EUCommodityCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EUTransit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  administrativeTerritorialUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedBySFUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedCertificateEmailAddresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  approvedDateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  arrivalDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrierName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryOfGoods?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificates?: Resolver<Maybe<Array<Maybe<ResolversTypes['SfGeneratedCertificate']>>>, ParentType, ContextType>;
  certifyingAgencyIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consigneeIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conveyanceReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDispatchDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departureDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dischargePort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exporterIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finalDestination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  forImportOrAdmission?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeTextDeclaration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  halalAuditor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  halalCertificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  importPermitNumbers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inspectionDateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  inspectionPort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAutoApproval?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isExhausted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShipStore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifiedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedBySFUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  letterOfCreditRefCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loadingPort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCarrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCarrierReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturerRegistration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturingPremisesName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  markingOfSealOnTransportContainer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameRegistrationAndAddressOfSemenCollection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netWeightInWords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfDoses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfEmbryos?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfPackagescontainers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officialStatement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoCertSubType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoLotReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoPackhouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoSchemeControl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phytoStatementOfRelabelling?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeAndDateOfQuarantine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purposeBR?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestorReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  russianDairyExporterReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sanitaryCertificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signatory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signingOffice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statementOfRelabelling?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusChangeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedBySFUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedDateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  summaryOfRecordsFor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalGrossWeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalQuantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transitCountries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueConsignmentReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unofficialInformation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urgency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifyingAgencyIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfApprovedTemplateVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfApprovedTemplateVersion'] = ResolversParentTypes['SfApprovedTemplateVersion']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  majorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfChangeExportRequestStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfChangeExportRequestStatusResponse'] = ResolversParentTypes['SfChangeExportRequestStatusResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfChangeTransferRequestStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfChangeTransferRequestStatusResponse'] = ResolversParentTypes['SfChangeTransferRequestStatusResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfDownloadCertificateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfDownloadCertificateResponse'] = ResolversParentTypes['SfDownloadCertificateResponse']> = {
  presignedURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfGeneratedCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfGeneratedCertificate'] = ResolversParentTypes['SfGeneratedCertificate']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3URI?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfPrintHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfPrintHistory'] = ResolversParentTypes['SfPrintHistory']> = {
  datePrinted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  reasonForReprinting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sfUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['GeneratedCertificateType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfRequest'] = ResolversParentTypes['SfRequest']> = {
  application?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationHistory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationWarnings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificatePrintHistory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificates?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declarations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  processes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productWarnings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceProducts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfSearchApprovedTemplatesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfSearchApprovedTemplatesResponse'] = ResolversParentTypes['SfSearchApprovedTemplatesResponse']> = {
  templates?: Resolver<Array<ResolversTypes['SfApprovedTemplateVersion']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfSupportingDocumentMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfSupportingDocumentMetadata'] = ResolversParentTypes['SfSupportingDocumentMetadata']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  originCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  printWithPDF?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['SupportingDocumentStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfUpdateProductExhaustionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfUpdateProductExhaustionResponse'] = ResolversParentTypes['SfUpdateProductExhaustionResponse']> = {
  exhaust?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductExhaustionResponse']>>>, ParentType, ContextType>;
  transferId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfUpdateStationerySerialNumbersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfUpdateStationerySerialNumbersResponse'] = ResolversParentTypes['SfUpdateStationerySerialNumbersResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  warnings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfUpdateTransferAuditCommentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SfUpdateTransferAuditCommentResponse'] = ResolversParentTypes['SfUpdateTransferAuditCommentResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnapshotPresignedUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SnapshotPresignedUrlResponse'] = ResolversParentTypes['SnapshotPresignedUrlResponse']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceProductTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceProductTracking'] = ResolversParentTypes['SourceProductTracking']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinations?: Resolver<Array<ResolversTypes['DestinationProductTracking']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outgoingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalPackages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceTransfer'] = ResolversParentTypes['SourceTransfer']> = {
  approvalDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  isPaperSource?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lineItemNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requestNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceTransferId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourcedProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourcedProduct'] = ResolversParentTypes['SourcedProduct']> = {
  details?: Resolver<Maybe<ResolversTypes['SourcedProductDetails']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isExhausted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPaperSourced?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  transferRequestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferRequestNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourcedProductAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourcedProductAttributes'] = ResolversParentTypes['SourcedProductAttributes']> = {
  NZHSCode?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  expiryDateFrom?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  expiryDateTo?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  grossVolume?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  grossWeight?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  inspectionType?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  intendedUse?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  netVolume?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  productionBatchIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scientificName?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  speciesCommonName?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourcedProductDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourcedProductDetails'] = ResolversParentTypes['SourcedProductDetails']> = {
  attributes?: Resolver<Maybe<ResolversTypes['SourcedProductAttributes']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreProductClassificationResponse']>>>, ParentType, ContextType>;
  containers?: Resolver<Maybe<Array<ResolversTypes['CoreExportContainer']>>, ParentType, ContextType>;
  eligibilityCountries?: Resolver<Maybe<Array<ResolversTypes['CoreLookup']>>, ParentType, ContextType>;
  itemDescription?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  packaging?: Resolver<Maybe<Array<Maybe<ResolversTypes['CorePackaging']>>>, ParentType, ContextType>;
  productReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productStatement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsAcknowledgementOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsAcknowledgementOutput'] = ResolversParentTypes['SpsAcknowledgementOutput']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsAddressTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsAddressTemplate'] = ResolversParentTypes['SpsAddressTemplate']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  country_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_subdivision_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  country_subdivision_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street_with_commas?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street_with_line_breaks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  with_commas?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  with_line_breaks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsAuthenticationTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsAuthenticationTemplate'] = ResolversParentTypes['SpsAuthenticationTemplate']> = {
  actual?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  ic_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ic_value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  included_clauses?: Resolver<Maybe<Array<ResolversTypes['SpsClauseTemplate']>>, ParentType, ContextType>;
  issue_location?: Resolver<Maybe<ResolversTypes['SpsLocationTemplate']>, ParentType, ContextType>;
  location_provider_party?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  provider_party?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCodeTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsCertificateTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsCertificateTemplate'] = ResolversParentTypes['SpsCertificateTemplate']> = {
  consignment?: Resolver<ResolversTypes['SpsConsignmentTemplate'], ParentType, ContextType>;
  exchanged_document?: Resolver<ResolversTypes['SpsExchangedDocumentTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsClassificationTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsClassificationTemplate'] = ResolversParentTypes['SpsClassificationTemplate']> = {
  class_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  class_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  system_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  system_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsClauseTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsClauseTemplate'] = ResolversParentTypes['SpsClauseTemplate']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsConsignmentItemTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsConsignmentItemTemplate'] = ResolversParentTypes['SpsConsignmentItemTemplate']> = {
  gross_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SpsTradeLineItemTemplate']>, ParentType, ContextType>;
  nature_identification_cargo?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsConsignmentTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsConsignmentTemplate'] = ResolversParentTypes['SpsConsignmentTemplate']> = {
  authentication_parties?: Resolver<Maybe<Array<ResolversTypes['SpsPartyTemplate']>>, ParentType, ContextType>;
  availability_due_date_time?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  consignee_receipt_location?: Resolver<Maybe<ResolversTypes['SpsLocationTemplate']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  customs_transit_agent?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  delivery?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  despatch?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  examination_event?: Resolver<Maybe<ResolversTypes['SpsEventTemplate']>, ParentType, ContextType>;
  export_country?: Resolver<Maybe<ResolversTypes['SpsCountryTemplate']>, ParentType, ContextType>;
  export_exit_date_time?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  gross_weight?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  import_country?: Resolver<Maybe<ResolversTypes['SpsCountryTemplate']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SpsConsignmentItemTemplate']>, ParentType, ContextType>;
  loading_base_port_location?: Resolver<Maybe<ResolversTypes['SpsLocationTemplate']>, ParentType, ContextType>;
  main_carriage_transport_movements?: Resolver<Maybe<Array<ResolversTypes['SPSTransportMovementTemplate']>>, ParentType, ContextType>;
  party_table?: Resolver<Maybe<Array<ResolversTypes['CombinedPartyTemplate']>>, ParentType, ContextType>;
  processor_parties?: Resolver<Maybe<Array<ResolversTypes['SpsPartyTemplate']>>, ParentType, ContextType>;
  reexport_country?: Resolver<Maybe<ResolversTypes['SpsCountryTemplate']>, ParentType, ContextType>;
  storage_events?: Resolver<Maybe<Array<ResolversTypes['SpsEventTemplate']>>, ParentType, ContextType>;
  transit_countries?: Resolver<Maybe<Array<ResolversTypes['SpsCountryTemplate']>>, ParentType, ContextType>;
  transit_locations?: Resolver<Maybe<Array<ResolversTypes['SpsLocationTemplate']>>, ParentType, ContextType>;
  unique_production_batch_ids?: Resolver<Maybe<ResolversTypes['IDsTemplate']>, ParentType, ContextType>;
  unique_seal_number_ids?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unique_transport_equipment_ids?: Resolver<Maybe<ResolversTypes['IDsTemplate']>, ParentType, ContextType>;
  unloading_base_port_location?: Resolver<Maybe<ResolversTypes['SpsLocationTemplate']>, ParentType, ContextType>;
  utilized_transport_equipment?: Resolver<Maybe<Array<ResolversTypes['SpsTransportEquipmentTemplate']>>, ParentType, ContextType>;
  verifiers?: Resolver<Maybe<Array<ResolversTypes['SpsAuthenticationTemplate']>>, ParentType, ContextType>;
  wine?: Resolver<Maybe<ResolversTypes['WineConsignmentTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsContactTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsContactTemplate'] = ResolversParentTypes['SpsContactTemplate']> = {
  person_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsCountrySubDivisionTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsCountrySubDivisionTemplate'] = ResolversParentTypes['SpsCountrySubDivisionTemplate']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsCountryTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsCountryTemplate'] = ResolversParentTypes['SpsCountryTemplate']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subdivision?: Resolver<Maybe<ResolversTypes['SpsCountrySubDivisionTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsEventTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsEventTemplate'] = ResolversParentTypes['SpsEventTemplate']> = {
  occurrence_location?: Resolver<Maybe<ResolversTypes['SpsLocationTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsExchangedDocumentTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsExchangedDocumentTemplate'] = ResolversParentTypes['SpsExchangedDocumentTemplate']> = {
  additional_declarations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_official_information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certifier?: Resolver<Maybe<ResolversTypes['SpsAuthenticationTemplate']>, ParentType, ContextType>;
  customs_permit_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_of_inspection?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distinguishing_marks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  financial_liability?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  import_permit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issue_date_time?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacement_certificate?: Resolver<Maybe<ResolversTypes['SpsReplacementCertificateTemplate']>, ParentType, ContextType>;
  signatories?: Resolver<Maybe<Array<Maybe<ResolversTypes['SpsAuthenticationTemplate']>>>, ParentType, ContextType>;
  status_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsLocationTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsLocationTemplate'] = ResolversParentTypes['SpsLocationTemplate']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsNoteTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsNoteTemplate'] = ResolversParentTypes['SpsNoteTemplate']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPackageTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsPackageTemplate'] = ResolversParentTypes['SpsPackageTemplate']> = {
  level_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nominal_gross_volume?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  nominal_gross_weight?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  physical_shipping_marks?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['DecimalTemplate']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCodeTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPartyTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsPartyTemplate'] = ResolversParentTypes['SpsPartyTemplate']> = {
  defined_contacts?: Resolver<Maybe<Array<ResolversTypes['SpsContactTemplate']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specified_address?: Resolver<Maybe<ResolversTypes['SpsAddressTemplate']>, ParentType, ContextType>;
  specified_person?: Resolver<Maybe<ResolversTypes['SpsPersonTemplate']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPeriodTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsPeriodTemplate'] = ResolversParentTypes['SpsPeriodTemplate']> = {
  duration?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsPersonTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsPersonTemplate'] = ResolversParentTypes['SpsPersonTemplate']> = {
  attained_qualifications?: Resolver<Maybe<Array<ResolversTypes['SpsQualificationTemplate']>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsProcessCharacteristicTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsProcessCharacteristicTemplate'] = ResolversParentTypes['SpsProcessCharacteristicTemplate']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maximum?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  minimum?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCodeTemplate']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsProcessTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsProcessTemplate'] = ResolversParentTypes['SpsProcessTemplate']> = {
  applicable_process_characteristics?: Resolver<Maybe<Array<ResolversTypes['SpsProcessCharacteristicTemplate']>>, ParentType, ContextType>;
  completion_period?: Resolver<Maybe<ResolversTypes['SpsPeriodTemplate']>, ParentType, ContextType>;
  operation_country?: Resolver<Maybe<ResolversTypes['SpsCountryTemplate']>, ParentType, ContextType>;
  operator_party?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['NamedCodeTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsQualificationTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsQualificationTemplate'] = ResolversParentTypes['SpsQualificationTemplate']> = {
  abbreviated_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsReplacementCertificateTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsReplacementCertificateTemplate'] = ResolversParentTypes['SpsReplacementCertificateTemplate']> = {
  additional_declaration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replaced_certificate_issue_date?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  replaced_certificate_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacement_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsSealTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsSealTemplate'] = ResolversParentTypes['SpsSealTemplate']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  issuing_party?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  maximum_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTemperatureTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsTemperatureTemplate'] = ResolversParentTypes['SpsTemperatureTemplate']> = {
  maximum?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  minimum?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  type_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTradeLineItemTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsTradeLineItemTemplate'] = ResolversParentTypes['SpsTradeLineItemTemplate']> = {
  additional_information?: Resolver<Maybe<Array<ResolversTypes['SpsNoteTemplate']>>, ParentType, ContextType>;
  applied_processes?: Resolver<Maybe<Array<ResolversTypes['SpsProcessTemplate']>>, ParentType, ContextType>;
  asserted_authentications?: Resolver<Maybe<Array<ResolversTypes['SpsAuthenticationTemplate']>>, ParentType, ContextType>;
  associated_transport_equipment?: Resolver<Maybe<Array<ResolversTypes['SpsTransportEquipmentTemplate']>>, ParentType, ContextType>;
  brand_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classifications?: Resolver<Maybe<Array<ResolversTypes['SpsClassificationTemplate']>>, ParentType, ContextType>;
  cn_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  common_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiry_date_time?: Resolver<Maybe<ResolversTypes['DateTimeTemplate']>, ParentType, ContextType>;
  gross_volume?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  gross_weight?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  hs_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  import_certificate_extract?: Resolver<Maybe<ResolversTypes['ImportCertificateExtractTemplate']>, ParentType, ContextType>;
  import_certificate_measurement?: Resolver<Maybe<ResolversTypes['ImportCertificateMeasurementTemplate']>, ParentType, ContextType>;
  import_permit_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intended_use?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  net_volume?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  net_weight?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  origin_country?: Resolver<Maybe<ResolversTypes['SpsCountryTemplate']>, ParentType, ContextType>;
  origin_locations?: Resolver<Maybe<Array<ResolversTypes['SpsLocationTemplate']>>, ParentType, ContextType>;
  packaging?: Resolver<Maybe<ResolversTypes['ImportCertificatePackagingTemplate']>, ParentType, ContextType>;
  physical_packages?: Resolver<Maybe<Array<ResolversTypes['SpsPackageTemplate']>>, ParentType, ContextType>;
  production_batch_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scientific_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<ResolversTypes['TreatmentTemplate']>, ParentType, ContextType>;
  wine?: Resolver<Maybe<ResolversTypes['WineFieldsTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpsTransportEquipmentTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpsTransportEquipmentTemplate'] = ResolversParentTypes['SpsTransportEquipmentTemplate']> = {
  affixed_seals?: Resolver<Maybe<Array<ResolversTypes['SpsSealTemplate']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  temperature_settings?: Resolver<Maybe<Array<ResolversTypes['SpsTemperatureTemplate']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandardPdfPreviewResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandardPdfPreviewResponse'] = ResolversParentTypes['StandardPdfPreviewResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  presignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StandardPdfPreviewStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmissionSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmissionSettings'] = ResolversParentTypes['SubmissionSettings']> = {
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customLookup?: Resolver<Maybe<ResolversTypes['CustomLookupType']>, ParentType, ContextType>;
  displayType?: Resolver<Maybe<ResolversTypes['DisplayType']>, ParentType, ContextType>;
  displayTypeSettings?: Resolver<Maybe<ResolversTypes['DisplayTypeSettings']>, ParentType, ContextType>;
  mandatory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmissionXmlUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmissionXmlUrl'] = ResolversParentTypes['SubmissionXmlUrl']> = {
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  onXmlFileProcessed?: SubscriptionResolver<ResolversTypes['PrepareXmlFileForB2GResponse'], "onXmlFileProcessed", ParentType, ContextType, RequireFields<SubscriptionOnXmlFileProcessedArgs, 'xmlInputId'>>;
};

export type SupportingDocumentActionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportingDocumentActionsResponse'] = ResolversParentTypes['SupportingDocumentActionsResponse']> = {
  allowedActions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportingDocumentHistoryEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportingDocumentHistoryEntry'] = ResolversParentTypes['SupportingDocumentHistoryEntry']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateTime?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocumentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedByFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByProfileFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportingDocumentKeysResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportingDocumentKeys'] = ResolversParentTypes['SupportingDocumentKeys']> = {
  registration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationAll?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportingDocumentPresignedUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportingDocumentPresignedUrlResponse'] = ResolversParentTypes['SupportingDocumentPresignedUrlResponse']> = {
  expiresIn?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportingDocumentUsageRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportingDocumentUsageRecord'] = ResolversParentTypes['SupportingDocumentUsageRecord']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  consigneeRegistration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorRegistration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departureDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  requestType?: Resolver<ResolversTypes['CoreRequestType'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  unofficialInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = {
  approvedVersion?: Resolver<Maybe<ResolversTypes['TemplateVersion']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importantVersions?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplateVersion']>>>, ParentType, ContextType>;
  lastVersion?: Resolver<ResolversTypes['TemplateVersion'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplateVersion']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDeclarationGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDeclarationGroup'] = ResolversParentTypes['TemplateDeclarationGroup']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numbering?: Resolver<ResolversTypes['DeclarationGroupNumbering'], ParentType, ContextType>;
  sequenceNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statements?: Resolver<Maybe<Array<ResolversTypes['DeclarationStatement']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeclarationGroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDeclarationsAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDeclarationsAcknowledgement'] = ResolversParentTypes['TemplateDeclarationsAcknowledgement']> = {
  delete?: Resolver<Maybe<ResolversTypes['TemplateDeclarationsDeleteAcknowledgement']>, ParentType, ContextType>;
  group?: Resolver<Maybe<Array<ResolversTypes['TemplateDeclarationsGroupAcknowledgement']>>, ParentType, ContextType>;
  statement?: Resolver<Maybe<Array<ResolversTypes['TemplateDeclarationsStatementAcknowledgement']>>, ParentType, ContextType>;
  traces?: Resolver<Maybe<Array<ResolversTypes['TemplateDeclarationsTraceAcknowledgement']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDeclarationsDeleteAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDeclarationsDeleteAcknowledgement'] = ResolversParentTypes['TemplateDeclarationsDeleteAcknowledgement']> = {
  groupId?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  statementId?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  tracesId?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDeclarationsGroupAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDeclarationsGroupAcknowledgement'] = ResolversParentTypes['TemplateDeclarationsGroupAcknowledgement']> = {
  groupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDeclarationsStatementAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDeclarationsStatementAcknowledgement'] = ResolversParentTypes['TemplateDeclarationsStatementAcknowledgement']> = {
  groupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statementId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDeclarationsTraceAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDeclarationsTraceAcknowledgement'] = ResolversParentTypes['TemplateDeclarationsTraceAcknowledgement']> = {
  statementId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  traceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDocumentUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDocumentUrl'] = ResolversParentTypes['TemplateDocumentUrl']> = {
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateDocumentUrlV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateDocumentUrlV2'] = ResolversParentTypes['TemplateDocumentUrlV2']> = {
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateFieldConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateFieldConfiguration'] = ResolversParentTypes['TemplateFieldConfiguration']> = {
  fieldCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pdfSettings?: Resolver<Maybe<ResolversTypes['PDFSettings']>, ParentType, ContextType>;
  sectionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submissionSettings?: Resolver<Maybe<ResolversTypes['SubmissionSettings']>, ParentType, ContextType>;
  viewInPdf?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewInSubmission?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewInXML?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  xmlSettings?: Resolver<Maybe<ResolversTypes['XMLSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateFieldConfigurationAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateFieldConfigurationAcknowledgement'] = ResolversParentTypes['TemplateFieldConfigurationAcknowledgement']> = {
  delete?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  upsert?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateFieldConfigurationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateFieldConfigurationV2'] = ResolversParentTypes['TemplateFieldConfigurationV2']> = {
  classificationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pdfSettings?: Resolver<Maybe<ResolversTypes['PDFSettings']>, ParentType, ContextType>;
  sectionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submissionSettings?: Resolver<Maybe<ResolversTypes['SubmissionSettings']>, ParentType, ContextType>;
  viewInPdf?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewInSubmission?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewInXML?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  xmlSettings?: Resolver<Maybe<ResolversTypes['XMLSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateFieldReferenceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateFieldReferenceData'] = ResolversParentTypes['TemplateFieldReferenceData']> = {
  captionList?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReferenceCaption']>>>, ParentType, ContextType>;
  defaultDisplayType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceDataList?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReferenceDataList']>>>, ParentType, ContextType>;
  sectionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateGeneralSettingsV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateGeneralSettingsV2'] = ResolversParentTypes['TemplateGeneralSettingsV2']> = {
  agencies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agency']>>>, ParentType, ContextType>;
  allowForeignPremises?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowPackageLevels?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessArea?: Resolver<Maybe<ResolversTypes['BusinessArea']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodities?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationCountries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  destinationCountryNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  displayedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effective?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  expire?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  exportCertificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  exportingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportingCountryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  importCertificateType?: Resolver<Maybe<ResolversTypes['ImportCertificateType']>, ParentType, ContextType>;
  industryAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  majorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ocaAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  officialVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  outputSubtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputSubtitleTranslation?: Resolver<Maybe<Array<Maybe<ResolversTypes['Translation']>>>, ParentType, ContextType>;
  outputTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputTitleTranslation?: Resolver<Maybe<Array<Maybe<ResolversTypes['Translation']>>>, ParentType, ContextType>;
  reasonForUpdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  release?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  signatory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TemplateVersionStatus'], ParentType, ContextType>;
  submissionLayout?: Resolver<ResolversTypes['SubmissionLayoutType'], ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  templateType?: Resolver<Maybe<ResolversTypes['TemplateType']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferCertificateType?: Resolver<Maybe<ResolversTypes['TransferCertificateType']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateHistory'] = ResolversParentTypes['TemplateHistory']> = {
  fieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateOutputV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateOutputV2'] = ResolversParentTypes['TemplateOutputV2']> = {
  competentAuthority?: Resolver<Maybe<ResolversTypes['CompetentAuthorityType']>, ParentType, ContextType>;
  competentAuthorityOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declarationHeading?: Resolver<Maybe<ResolversTypes['DeclarationHeadingType']>, ParentType, ContextType>;
  declarationHeadingOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationSystem?: Resolver<Maybe<ResolversTypes['DestinationSystem']>, ParentType, ContextType>;
  forceNzCountryOrigin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  languages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  pdfAddendum?: Resolver<ResolversTypes['PDFAddendum'], ParentType, ContextType>;
  pdfLayout?: Resolver<ResolversTypes['PDFLayout'], ParentType, ContextType>;
  processGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplateProcessGroups']>>>, ParentType, ContextType>;
  producePdf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendToTraces?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  templateSupportingDocuments?: Resolver<Maybe<Array<ResolversTypes['TemplateSupportingDocument']>>, ParentType, ContextType>;
  useAllLanguages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  usePortOfCountryLanguages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  usePortOfDischargeLanguages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  usePortOfInspectionLanguages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  useTheseLanguages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  xmlLayout?: Resolver<ResolversTypes['XMLLayout'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateProcessGroupReferenceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateProcessGroupReferenceData'] = ResolversParentTypes['TemplateProcessGroupReferenceData']> = {
  captions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReferenceProcessGroupCaption']>>>, ParentType, ContextType>;
  groupId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  groupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateProcessGroupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateProcessGroups'] = ResolversParentTypes['TemplateProcessGroups']> = {
  dateFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateRange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includeOverseasProcesses?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPDF?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isXML?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  operatorActivityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfSettings?: Resolver<Maybe<ResolversTypes['ProcessGroupCaptionSettings']>, ParentType, ContextType>;
  premisesAddressFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premisesRange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  processGroupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processGroupType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProcessInfo']>>>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xmlSettings?: Resolver<Maybe<ResolversTypes['ProcessGroupCaptionSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateProcessGroupsConfigAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateProcessGroupsConfigAcknowledgement'] = ResolversParentTypes['TemplateProcessGroupsConfigAcknowledgement']> = {
  delete?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  upsert?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateSection'] = ResolversParentTypes['TemplateSection']> = {
  fields?: Resolver<Array<ResolversTypes['TemplateSectionField']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateSectionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateSectionField'] = ResolversParentTypes['TemplateSectionField']> = {
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateSupportingDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateSupportingDocument'] = ResolversParentTypes['TemplateSupportingDocument']> = {
  documentType?: Resolver<ResolversTypes['TemplateSupportingDocumentType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includeInXml?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  printWithPdf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateSupportingDocumentAcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateSupportingDocumentAcknowledgement'] = ResolversParentTypes['TemplateSupportingDocumentAcknowledgement']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateUploadUrl'] = ResolversParentTypes['TemplateUploadUrl']> = {
  lastVersion?: Resolver<ResolversTypes['TemplateVersion'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateUploadUrlV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateUploadUrlV2'] = ResolversParentTypes['TemplateUploadUrlV2']> = {
  lastTemplateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  s3Url?: Resolver<ResolversTypes['awsS3PostUploadUrl'], ParentType, ContextType>;
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateV2'] = ResolversParentTypes['TemplateV2']> = {
  approvedVersion?: Resolver<Maybe<ResolversTypes['TemplateVersion']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastVersion?: Resolver<ResolversTypes['TemplateVersion'], ParentType, ContextType>;
  versionsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplateVersion']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateVersion'] = ResolversParentTypes['TemplateVersion']> = {
  agencies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agency']>>>, ParentType, ContextType>;
  allowForeignPremises?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowPackageLevels?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessArea?: Resolver<Maybe<ResolversTypes['BusinessArea']>, ParentType, ContextType>;
  certificateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodities?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  destinationMarket?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  displayedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentRevision?: Resolver<Maybe<ResolversTypes['TemplateVersion']>, ParentType, ContextType>;
  editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  effective?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  expire?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  exportCertificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  exportingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['Field']>>>, ParentType, ContextType>;
  history?: Resolver<Maybe<Array<ResolversTypes['TemplateHistory']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importCertificateType?: Resolver<Maybe<ResolversTypes['ImportCertificateType']>, ParentType, ContextType>;
  industryAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEditable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  majorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minorVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  newFileUpload?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ocaAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  officialVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  outputSubtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputSubtitleTranslation?: Resolver<Maybe<Array<Maybe<ResolversTypes['Translation']>>>, ParentType, ContextType>;
  outputTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputTitleTranslation?: Resolver<Maybe<Array<Maybe<ResolversTypes['Translation']>>>, ParentType, ContextType>;
  pdfLayout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonForUpdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  release?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  s3key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signatory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TemplateVersionStatus'], ParentType, ContextType>;
  submissionLayout?: Resolver<Maybe<ResolversTypes['SubmissionLayoutType']>, ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateType?: Resolver<Maybe<ResolversTypes['TemplateType']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferCertificateType?: Resolver<Maybe<ResolversTypes['TransferCertificateType']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateVersionIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateVersionId'] = ResolversParentTypes['TemplateVersionId']> = {
  certificateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  majorVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  submissionLayout?: Resolver<Maybe<ResolversTypes['SubmissionLayoutType']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateVersionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateVersionOutput'] = ResolversParentTypes['TemplateVersionOutput']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateVersionV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateVersionV2'] = ResolversParentTypes['TemplateVersionV2']> = {
  declarations?: Resolver<Maybe<Array<ResolversTypes['TemplateDeclarationGroup']>>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<ResolversTypes['TemplateFieldConfigurationV2']>>, ParentType, ContextType>;
  general?: Resolver<ResolversTypes['TemplateGeneralSettingsV2'], ParentType, ContextType>;
  output?: Resolver<Maybe<ResolversTypes['TemplateOutputV2']>, ParentType, ContextType>;
  templateVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestRegistrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TestRegistration'] = ResolversParentTypes['TestRegistration']> = {
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nzbn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['RegistrationSource']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['TestUser'] = ResolversParentTypes['TestUser']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  g2gUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissions?: Resolver<Array<ResolversTypes['UserPermission']>, ParentType, ContextType>;
  profileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  systemUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeTemplate'] = ResolversParentTypes['TimeTemplate']> = {
  hour?: Resolver<ResolversTypes['IntTemplate'], ParentType, ContextType>;
  minute?: Resolver<ResolversTypes['IntTemplate'], ParentType, ContextType>;
  second?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferProcessHistoryXmlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferProcessHistoryXmlResponse'] = ResolversParentTypes['TransferProcessHistoryXmlResponse']> = {
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferProductDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferProductDetails'] = ResolversParentTypes['TransferProductDetails']> = {
  aggregatedProcessHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreProcessHistory']>>>, ParentType, ContextType>;
  attributes?: Resolver<Maybe<ResolversTypes['CoreProductAttributes']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreProductClassificationResponse']>>>, ParentType, ContextType>;
  commodity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  containers?: Resolver<Array<ResolversTypes['CoreExportContainer']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eligibilityCountries?: Resolver<Maybe<Array<ResolversTypes['CoreLookup']>>, ParentType, ContextType>;
  exhausted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSourceOf?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  itemDescription?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  packaging?: Resolver<Maybe<Array<Maybe<ResolversTypes['CorePackaging']>>>, ParentType, ContextType>;
  processHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregatedProcessHistory']>>>, ParentType, ContextType>;
  processes?: Resolver<Array<ResolversTypes['CoreProductProcess']>, ParentType, ContextType>;
  productDeclaration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  productItemRelation?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreProductItemRelation']>>>, ParentType, ContextType>;
  productNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productStatement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Measurment']>, ParentType, ContextType>;
  registrationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceProcessCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sources?: Resolver<Maybe<Array<ResolversTypes['SourcedProduct']>>, ParentType, ContextType>;
  standaloneProductNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<Array<ResolversTypes['CoreTransferProductSupportingDocument']>>, ParentType, ContextType>;
  tradeLineGroupNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  transferRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  transferRequestNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferReferenceErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferReferenceError'] = ResolversParentTypes['TransferReferenceError']> = {
  errorCode?: Resolver<ResolversTypes['TransferReferenceErrorCode'], ParentType, ContextType>;
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lineItem?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transferNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferReferenceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferReferenceResponse'] = ResolversParentTypes['TransferReferenceResponse']> = {
  errors?: Resolver<Array<ResolversTypes['TransferReferenceError']>, ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['TransferProductDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferRequestDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferRequestDetails'] = ResolversParentTypes['TransferRequestDetails']> = {
  action?: Resolver<Maybe<ResolversTypes['CoreHistoryTransferActions']>, ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  approvedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attributes?: Resolver<Maybe<ResolversTypes['CoreExportRequestAttributes']>, ParentType, ContextType>;
  auditComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auditedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  auditedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commodity?: Resolver<ResolversTypes['CoreCommodity'], ParentType, ContextType>;
  consignee?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  consigneeRegId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['CoreRegistration']>, ParentType, ContextType>;
  consignorRegId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationCountry?: Resolver<ResolversTypes['CoreCountry'], ParentType, ContextType>;
  eligibility_declaration?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isExhausted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['TransferProductDetails']>, ParentType, ContextType>;
  reasonForStateChangeCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  reasonForStatusChange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiresAttention?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CoreRequestStatus'], ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  submittedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportingDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreSupportingDocument']>>>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['CoreTemplate']>, ParentType, ContextType>;
  templateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  thirdPartyConsignor?: Resolver<Maybe<Array<Maybe<ResolversTypes['CoreLookup']>>>, ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['CoreTransport']>, ParentType, ContextType>;
  uniqueConsignmentReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unofficialInformation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBySystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urgency?: Resolver<Maybe<ResolversTypes['CoreLookup']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferRequestHistoryRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferRequestHistoryRecord'] = ResolversParentTypes['TransferRequestHistoryRecord']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  autoApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nzxmlURI?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  reasonForStatusChange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateVersionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  transferRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByProfileFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedByProfileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBySystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Translation'] = ResolversParentTypes['Translation']> = {
  lang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportMovementCodeTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportMovementCodeTemplate'] = ResolversParentTypes['TransportMovementCodeTemplate']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentTemplate'] = ResolversParentTypes['TreatmentTemplate']> = {
  full_information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApprovedTransferTransportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateApprovedTransferTransportResponse'] = ResolversParentTypes['UpdateApprovedTransferTransportResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePrintReasonResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePrintReasonResponse'] = ResolversParentTypes['UpdatePrintReasonResponse']> = {
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  exportRequestOutputId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outputEventId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reasonForReprinting?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateSupportingDocumentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSupportingDocumentResult'] = ResolversParentTypes['UpdateSupportingDocumentResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  supportingDocument?: Resolver<Maybe<ResolversTypes['CoreSupportingDocument']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadReferenceDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadReferenceDataResponse'] = ResolversParentTypes['UploadReferenceDataResponse']> = {
  fields?: Resolver<Array<ResolversTypes['PresignedPostField']>, ParentType, ContextType>;
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDetailsByIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDetailsById'] = ResolversParentTypes['UserDetailsById']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInfo'] = ResolversParentTypes['UserInfo']> = {
  registrations?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPermission'] = ResolversParentTypes['UserPermission']> = {
  agencyId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  constraintType?: Resolver<Maybe<ResolversTypes['PermissionConstraintType']>, ParentType, ContextType>;
  constraintValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['RoleName']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProfile'] = ResolversParentTypes['UserProfile']> = {
  organisationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationPartyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organisationPrimaryAddress?: Resolver<Maybe<ResolversTypes['B2GAddress']>, ParentType, ContextType>;
  registartionNumberId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumberValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userContactId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userPrimaryPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Validation'] = ResolversParentTypes['Validation']> = {
  errorType?: Resolver<ResolversTypes['ValidationErrorType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VolumeAdjustmentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VolumeAdjustmentResponse'] = ResolversParentTypes['VolumeAdjustmentResponse']> = {
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  volumeAdjustment?: Resolver<ResolversTypes['ManualVolumeAdjustment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VolumeMeasureTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['VolumeMeasureTemplate'] = ResolversParentTypes['VolumeMeasureTemplate']> = {
  as_number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  in_litres?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  mpi_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  three_decimals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineAnalytesTolerancesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineAnalytesTolerancesResponse'] = ResolversParentTypes['WineAnalytesTolerancesResponse']> = {
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  eligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineAnalytesTolerancesTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineAnalytesTolerancesType'] = ResolversParentTypes['WineAnalytesTolerancesType']> = {
  chemistryTest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealcoholisedWine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shippingFormat?: Resolver<Maybe<ResolversTypes['WinePackaging']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  wineCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineChemistryTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineChemistryTemplate'] = ResolversParentTypes['WineChemistryTemplate']> = {
  actual_alcohol_content?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  citric_acidity?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  laboratory?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  laboratory_reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  methyl_alcohol?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  reduced_dry_extract?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  sugar_content?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  sugar_content_qualifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_acidity_7_0?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  total_acidity_8_2_meql?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  total_alcoholic_strength?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  total_dry_extract?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  total_sulphates?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  total_sulphur_dioxide?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  volatile_acidity?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  volatile_acidity_meql?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineConsignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineConsignment'] = ResolversParentTypes['WineConsignment']> = {
  cases?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  exporter?: Resolver<Maybe<ResolversTypes['SPSWineExporter']>, ParentType, ContextType>;
  is_bulk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  net_volume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  producer?: Resolver<Maybe<ResolversTypes['SPSWineExporter']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineConsignmentTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineConsignmentTemplate'] = ResolversParentTypes['WineConsignmentTemplate']> = {
  cases?: Resolver<Maybe<ResolversTypes['IntTemplate']>, ParentType, ContextType>;
  exporter?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  is_bulk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  net_volume?: Resolver<Maybe<ResolversTypes['MeasureTemplate']>, ParentType, ContextType>;
  producer?: Resolver<Maybe<ResolversTypes['SpsPartyTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineFieldsTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineFieldsTemplate'] = ResolversParentTypes['WineFieldsTemplate']> = {
  batch_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bottler_reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  br_brand_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  br_classification?: Resolver<Maybe<ResolversTypes['BRClassificationTemplate']>, ParentType, ContextType>;
  chemistry?: Resolver<Maybe<ResolversTypes['WineChemistryTemplate']>, ParentType, ContextType>;
  colour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eu_category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eu_ingredients?: Resolver<Maybe<ResolversTypes['EUIngredientsTemplate']>, ParentType, ContextType>;
  geographic_indication?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grape_variety?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_dealcoholised?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_eu_eligible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  package?: Resolver<Maybe<ResolversTypes['PackageTemplate']>, ParentType, ContextType>;
  special_process?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vintage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wine_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WineProductFieldTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WineProductFieldType'] = ResolversParentTypes['WineProductFieldType']> = {
  certificateType?: Resolver<Maybe<ResolversTypes['CertificateType']>, ParentType, ContextType>;
  destinationMarket?: Resolver<Maybe<ResolversTypes['DestinationMarket']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WinemakingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Winemaking'] = ResolversParentTypes['Winemaking']> = {
  confirmations?: Resolver<Maybe<Array<Maybe<ResolversTypes['WinemakingConfirmation']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProcessStatus']>, ParentType, ContextType>;
  wsmp?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WinemakingConfirmationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WinemakingConfirmation'] = ResolversParentTypes['WinemakingConfirmation']> = {
  confirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  disputedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputedResolution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  market?: Resolver<ResolversTypes['DestinationMarket'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WinemakingStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XmlSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['XMLSettings'] = ResolversParentTypes['XMLSettings']> = {
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  defaultOption?: Resolver<Maybe<ResolversTypes['XmlDefaultOption']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  xmlColumnsToDisplay?: Resolver<Maybe<ResolversTypes['ColumnsToDisplay']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsS3PostUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['awsS3PostUploadUrl'] = ResolversParentTypes['awsS3PostUploadUrl']> = {
  fields?: Resolver<Array<ResolversTypes['AwsS3Fields']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetDeclarationInputsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['getDeclarationInputsResponse'] = ResolversParentTypes['getDeclarationInputsResponse']> = {
  statementInputs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  AWSEmail?: GraphQLScalarType;
  AWSIPAddress?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  AWSPhone?: GraphQLScalarType;
  AWSTime?: GraphQLScalarType;
  AWSTimestamp?: GraphQLScalarType;
  AWSURL?: GraphQLScalarType;
  ActiveTemplateResult?: ActiveTemplateResultResolvers<ContextType>;
  Agency?: AgencyResolvers<ContextType>;
  AggregatedProcessHistory?: AggregatedProcessHistoryResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  AnnouncementList?: AnnouncementListResolvers<ContextType>;
  ApprovedProductRequest?: ApprovedProductRequestResolvers<ContextType>;
  AvailableTemplateFields?: AvailableTemplateFieldsResolvers<ContextType>;
  AwsS3Fields?: AwsS3FieldsResolvers<ContextType>;
  B2GAddress?: B2GAddressResolvers<ContextType>;
  B2GAuthentication?: B2GAuthenticationResolvers<ContextType>;
  B2GCertificateDelivery?: B2GCertificateDeliveryResolvers<ContextType>;
  B2GClassification?: B2GClassificationResolvers<ContextType>;
  B2GClause?: B2GClauseResolvers<ContextType>;
  B2GConsignment?: B2GConsignmentResolvers<ContextType>;
  B2GContact?: B2GContactResolvers<ContextType>;
  B2GContainer?: B2GContainerResolvers<ContextType>;
  B2GCountry?: B2GCountryResolvers<ContextType>;
  B2GCountrySubDivision?: B2GCountrySubDivisionResolvers<ContextType>;
  B2GDeclaration?: B2GDeclarationResolvers<ContextType>;
  B2GEligibilityCriteriaMet?: B2GEligibilityCriteriaMetResolvers<ContextType>;
  B2GEligibilityStatus?: B2GEligibilityStatusResolvers<ContextType>;
  B2GExportCertificateRequest?: B2GExportCertificateRequestResolvers<ContextType>;
  B2GExportCertificatesDownloadUrl?: B2GExportCertificatesDownloadUrlResolvers<ContextType>;
  B2GExporterDeclaration?: B2GExporterDeclarationResolvers<ContextType>;
  B2GLocation?: B2GLocationResolvers<ContextType>;
  B2GNote?: B2GNoteResolvers<ContextType>;
  B2GPackage?: B2GPackageResolvers<ContextType>;
  B2GParty?: B2GPartyResolvers<ContextType>;
  B2GPeriod?: B2GPeriodResolvers<ContextType>;
  B2GPerson?: B2GPersonResolvers<ContextType>;
  B2GPremise?: B2GPremiseResolvers<ContextType>;
  B2GProcess?: B2GProcessResolvers<ContextType>;
  B2GProcessCharacteristic?: B2GProcessCharacteristicResolvers<ContextType>;
  B2GProduct?: B2GProductResolvers<ContextType>;
  B2GProductEligibility?: B2GProductEligibilityResolvers<ContextType>;
  B2GProductEligibilityCriteriaV2?: B2GProductEligibilityCriteriaV2Resolvers<ContextType>;
  B2GProductEvent?: B2GProductEventResolvers<ContextType>;
  B2GProductsDownloadUrl?: B2GProductsDownloadUrlResolvers<ContextType>;
  B2GQualification?: B2GQualificationResolvers<ContextType>;
  B2GReferencedDocument?: B2GReferencedDocumentResolvers<ContextType>;
  B2GRegistrationDetails?: B2GRegistrationDetailsResolvers<ContextType>;
  B2GSeal?: B2GSealResolvers<ContextType>;
  B2GTemperature?: B2GTemperatureResolvers<ContextType>;
  B2GTradeLineItem?: B2GTradeLineItemResolvers<ContextType>;
  B2GTradeLineItemContainer?: B2GTradeLineItemContainerResolvers<ContextType>;
  B2GTransportMovement?: B2GTransportMovementResolvers<ContextType>;
  B2GValidationErrors?: B2GValidationErrorsResolvers<ContextType>;
  B2GWineChemistry?: B2GWineChemistryResolvers<ContextType>;
  B2GWineConsignment?: B2GWineConsignmentResolvers<ContextType>;
  B2GWineFields?: B2GWineFieldsResolvers<ContextType>;
  B2GWinePackage?: B2GWinePackageResolvers<ContextType>;
  BRClassification?: BrClassificationResolvers<ContextType>;
  BRClassificationTemplate?: BrClassificationTemplateResolvers<ContextType>;
  Block?: BlockResolvers<ContextType>;
  BottlingRunData?: BottlingRunDataResolvers<ContextType>;
  BottlingRunResponse?: BottlingRunResponseResolvers<ContextType>;
  BusinessRule?: BusinessRuleResolvers<ContextType>;
  BusinessRuleField?: BusinessRuleFieldResolvers<ContextType>;
  BusinessRulesConfig?: BusinessRulesConfigResolvers<ContextType>;
  CancelledProcessResponse?: CancelledProcessResponseResolvers<ContextType>;
  CertificateCollectionOutput?: CertificateCollectionOutputResolvers<ContextType>;
  ChangeExportRequestStatusResponse?: ChangeExportRequestStatusResponseResolvers<ContextType>;
  ChangeTransferRequestAmendmentStatusResponse?: ChangeTransferRequestAmendmentStatusResponseResolvers<ContextType>;
  ChangeTransferRequestStatusResponse?: ChangeTransferRequestStatusResponseResolvers<ContextType>;
  CheckUserAccessResponse?: CheckUserAccessResponseResolvers<ContextType>;
  ChemistryTestReceipt?: ChemistryTestReceiptResolvers<ContextType>;
  ChemistryTestRequest?: ChemistryTestRequestResolvers<ContextType>;
  ChemistryTestResponse?: ChemistryTestResponseResolvers<ContextType>;
  ChemistryTestResult?: ChemistryTestResultResolvers<ContextType>;
  CombinedPartyTemplate?: CombinedPartyTemplateResolvers<ContextType>;
  ConfirmPackagingResponse?: ConfirmPackagingResponseResolvers<ContextType>;
  ConsignorDetails?: ConsignorDetailsResolvers<ContextType>;
  ConsignorIdentifier?: ConsignorIdentifierResolvers<ContextType>;
  CoreAddress?: CoreAddressResolvers<ContextType>;
  CoreB2GFile?: CoreB2GFileResolvers<ContextType>;
  CoreCommodity?: CoreCommodityResolvers<ContextType>;
  CoreContainer?: CoreContainerResolvers<ContextType>;
  CoreCountry?: CoreCountryResolvers<ContextType>;
  CoreDateRange?: CoreDateRangeResolvers<ContextType>;
  CoreDeclarationInputValueOutput?: CoreDeclarationInputValueOutputResolvers<ContextType>;
  CoreDeclarationOutput?: CoreDeclarationOutputResolvers<ContextType>;
  CoreDeclarationTranslatedText?: CoreDeclarationTranslatedTextResolvers<ContextType>;
  CoreExportContainer?: CoreExportContainerResolvers<ContextType>;
  CoreExportDetails?: CoreExportDetailsResolvers<ContextType>;
  CoreExportRequest?: CoreExportRequestResolvers<ContextType>;
  CoreExportRequestAddressType?: CoreExportRequestAddressTypeResolvers<ContextType>;
  CoreExportRequestAttributes?: CoreExportRequestAttributesResolvers<ContextType>;
  CoreExportRequestImporterType?: CoreExportRequestImporterTypeResolvers<ContextType>;
  CoreExportRequestPartyType?: CoreExportRequestPartyTypeResolvers<ContextType>;
  CoreExportSupportingDocuments?: CoreExportSupportingDocumentsResolvers<ContextType>;
  CoreExportTransport?: CoreExportTransportResolvers<ContextType>;
  CoreGroup?: CoreGroupResolvers<ContextType>;
  CoreLocation?: CoreLocationResolvers<ContextType>;
  CoreLookup?: CoreLookupResolvers<ContextType>;
  CorePackaging?: CorePackagingResolvers<ContextType>;
  CorePrintDetails?: CorePrintDetailsResolvers<ContextType>;
  CoreProcessAttributes?: CoreProcessAttributesResolvers<ContextType>;
  CoreProcessHistory?: CoreProcessHistoryResolvers<ContextType>;
  CoreProcessTypeLookup?: CoreProcessTypeLookupResolvers<ContextType>;
  CoreProduct?: CoreProductResolvers<ContextType>;
  CoreProductAttributes?: CoreProductAttributesResolvers<ContextType>;
  CoreProductClassificationResponse?: CoreProductClassificationResponseResolvers<ContextType>;
  CoreProductItemGroup?: CoreProductItemGroupResolvers<ContextType>;
  CoreProductItemRelation?: CoreProductItemRelationResolvers<ContextType>;
  CoreProductProcess?: CoreProductProcessResolvers<ContextType>;
  CoreReferencedDocument?: CoreReferencedDocumentResolvers<ContextType>;
  CoreReferencedDocumentUrl?: CoreReferencedDocumentUrlResolvers<ContextType>;
  CoreRegistration?: CoreRegistrationResolvers<ContextType>;
  CoreRequest?: CoreRequestResolvers<ContextType>;
  CoreRequestStatus?: CoreRequestStatusResolvers<ContextType>;
  CoreRequestSubstatus?: CoreRequestSubstatusResolvers<ContextType>;
  CoreSupportingDocument?: CoreSupportingDocumentResolvers<ContextType>;
  CoreTemplate?: CoreTemplateResolvers<ContextType>;
  CoreTransferProductSupportingDocument?: CoreTransferProductSupportingDocumentResolvers<ContextType>;
  CoreTransferRequest?: CoreTransferRequestResolvers<ContextType>;
  CoreTransport?: CoreTransportResolvers<ContextType>;
  CreateDfeConfigRequest?: CreateDfeConfigRequestResolvers<ContextType>;
  CreateDfeConfigResponse?: CreateDfeConfigResponseResolvers<ContextType>;
  CustomsPermitNumberUsage?: CustomsPermitNumberUsageResolvers<ContextType>;
  DFEForm?: DfeFormResolvers<ContextType>;
  DFEPermission?: DfePermissionResolvers<ContextType>;
  DateTemplate?: DateTemplateResolvers<ContextType>;
  DateTimeTemplate?: DateTimeTemplateResolvers<ContextType>;
  DecimalTemplate?: DecimalTemplateResolvers<ContextType>;
  DecisionTable?: DecisionTableResolvers<ContextType>;
  DecisionTableBaseInput?: DecisionTableBaseInputResolvers<ContextType>;
  DecisionTableColumn?: DecisionTableColumnResolvers<ContextType>;
  DecisionTableExpectation?: DecisionTableExpectationResolvers<ContextType>;
  DecisionTableField?: DecisionTableFieldResolvers<ContextType>;
  DecisionTableRevision?: DecisionTableRevisionResolvers<ContextType>;
  DecisionTableRow?: DecisionTableRowResolvers<ContextType>;
  DecisionTableTestResult?: DecisionTableTestResultResolvers<ContextType>;
  DeclarationFormletFields?: DeclarationFormletFieldsResolvers<ContextType>;
  DeclarationFormletSection?: DeclarationFormletSectionResolvers<ContextType>;
  DeclarationInputValueOutput?: DeclarationInputValueOutputResolvers<ContextType>;
  DeclarationOutput?: DeclarationOutputResolvers<ContextType>;
  DeclarationStatement?: DeclarationStatementResolvers<ContextType>;
  DeclarationStatementInput?: DeclarationStatementInputResolvers<ContextType>;
  DeclarationStatementTrace?: DeclarationStatementTraceResolvers<ContextType>;
  DeclarationsResponse?: DeclarationsResponseResolvers<ContextType>;
  DeclarationsType?: DeclarationsTypeResolvers<ContextType>;
  DeleteReplacementExportRequestResponse?: DeleteReplacementExportRequestResponseResolvers<ContextType>;
  DestinationProductTracking?: DestinationProductTrackingResolvers<ContextType>;
  DfeCondition?: DfeConditionResolvers<ContextType>;
  DfeConfig?: DfeConfigResolvers<ContextType>;
  DfeCrossExclusion?: DfeCrossExclusionResolvers<ContextType>;
  DfeCrossFieldValidation?: DfeCrossFieldValidationResolvers<ContextType>;
  DfeCustomRule?: DfeCustomRuleResolvers<ContextType>;
  DfeDeclarationGroup?: DfeDeclarationGroupResolvers<ContextType>;
  DfeDeclarationStatement?: DfeDeclarationStatementResolvers<ContextType>;
  DfeDeclarationStatementInput?: DfeDeclarationStatementInputResolvers<ContextType>;
  DfeExclusiveGroup?: DfeExclusiveGroupResolvers<ContextType>;
  DfeField?: DfeFieldResolvers<ContextType>;
  DfeFieldDisableGroup?: DfeFieldDisableGroupResolvers<ContextType>;
  DfeMeta?: DfeMetaResolvers<ContextType>;
  DfeTemplateInfo?: DfeTemplateInfoResolvers<ContextType>;
  DfeValidation?: DfeValidationResolvers<ContextType>;
  DfeValidationMessages?: DfeValidationMessagesResolvers<ContextType>;
  DfeValidationRules?: DfeValidationRulesResolvers<ContextType>;
  DfeValueUnitPair?: DfeValueUnitPairResolvers<ContextType>;
  DisplayTypeSettings?: DisplayTypeSettingsResolvers<ContextType>;
  DraftCertificateGenerationStatusResponse?: DraftCertificateGenerationStatusResponseResolvers<ContextType>;
  DraftExportCertificate?: DraftExportCertificateResolvers<ContextType>;
  EStarOrganisation?: EStarOrganisationResolvers<ContextType>;
  EUIngredient?: EuIngredientResolvers<ContextType>;
  EUIngredientsTemplate?: EuIngredientsTemplateResolvers<ContextType>;
  EligibilityResponse?: EligibilityResponseResolvers<ContextType>;
  EligibilityType?: EligibilityTypeResolvers<ContextType>;
  EnumerationInfo?: EnumerationInfoResolvers<ContextType>;
  EstarCancelRequest?: EstarCancelRequestResolvers<ContextType>;
  ExhaustTransferProductsResponse?: ExhaustTransferProductsResponseResolvers<ContextType>;
  ExhaustTransferRequestResponse?: ExhaustTransferRequestResponseResolvers<ContextType>;
  ExhaustionResponse?: ExhaustionResponseResolvers<ContextType>;
  ExportCertificateCollectionResponse?: ExportCertificateCollectionResponseResolvers<ContextType>;
  ExportCertificateRequest?: ExportCertificateRequestResolvers<ContextType>;
  ExportCertificateWorkflowResponse?: ExportCertificateWorkflowResponseResolvers<ContextType>;
  ExportCertificateWorkflowType?: ExportCertificateWorkflowTypeResolvers<ContextType>;
  ExportCsvResponse?: ExportCsvResponseResolvers<ContextType>;
  ExportRequestHistoryRecord?: ExportRequestHistoryRecordResolvers<ContextType>;
  ExportSPSAcknowledgementResponse?: ExportSpsAcknowledgementResponseResolvers<ContextType>;
  Field?: FieldResolvers<ContextType>;
  FieldBySubmissionLayout?: FieldBySubmissionLayoutResolvers<ContextType>;
  FieldConfiguration?: FieldConfigurationResolvers<ContextType>;
  FieldInfo?: FieldInfoResolvers<ContextType>;
  FieldInput?: FieldInputResolvers<ContextType>;
  FieldV2?: FieldV2Resolvers<ContextType>;
  FlexiFillingRunData?: FlexiFillingRunDataResolvers<ContextType>;
  FlexiFillingRunResponse?: FlexiFillingRunResponseResolvers<ContextType>;
  Form?: FormResolvers<ContextType>;
  FormletCollectionFilter?: FormletCollectionFilterResolvers<ContextType>;
  FormletField?: FormletFieldResolvers<ContextType>;
  FormletNestedFields?: FormletNestedFieldsResolvers<ContextType>;
  FormletOption?: FormletOptionResolvers<ContextType>;
  ForwardProductTrackingResponse?: ForwardProductTrackingResponseResolvers<ContextType>;
  G2GAccount?: G2GAccountResolvers<ContextType>;
  G2GAccountSearchResult?: G2GAccountSearchResultResolvers<ContextType>;
  G2GAccountSummary?: G2GAccountSummaryResolvers<ContextType>;
  G2GPermissions?: G2GPermissionsResolvers<ContextType>;
  GenerateOutputPreviewXMLResult?: GenerateOutputPreviewXmlResultResolvers<ContextType>;
  GenerateSubmissionPreviewXmlResponse?: GenerateSubmissionPreviewXmlResponseResolvers<ContextType>;
  GeneratedCertificate?: GeneratedCertificateResolvers<ContextType>;
  GetRequestValidationsResponse?: GetRequestValidationsResponseResolvers<ContextType>;
  GetSignedCertificateXmlResponse?: GetSignedCertificateXmlResponseResolvers<ContextType>;
  GetTemplateXmlCoreResponse?: GetTemplateXmlCoreResponseResolvers<ContextType>;
  IConfig?: IConfigResolvers<ContextType>;
  IConfigBase?: IConfigBaseResolvers<ContextType>;
  IConfigField?: IConfigFieldResolvers<ContextType>;
  IDfeValidationRules?: IDfeValidationRulesResolvers<ContextType>;
  IDsTemplate?: IDsTemplateResolvers<ContextType>;
  IMeasureTemplate?: IMeasureTemplateResolvers<ContextType>;
  IPPCHubLogEntry?: IppcHubLogEntryResolvers<ContextType>;
  ITemplateProcessGroup?: ITemplateProcessGroupResolvers<ContextType>;
  ImportCertificate?: ImportCertificateResolvers<ContextType>;
  ImportCertificateEmbeddedDocument?: ImportCertificateEmbeddedDocumentResolvers<ContextType>;
  ImportCertificateExtractItem?: ImportCertificateExtractItemResolvers<ContextType>;
  ImportCertificateExtractMeasurement?: ImportCertificateExtractMeasurementResolvers<ContextType>;
  ImportCertificateExtractTemplate?: ImportCertificateExtractTemplateResolvers<ContextType>;
  ImportCertificateIntegration?: ImportCertificateIntegrationResolvers<ContextType>;
  ImportCertificateLogMessage?: ImportCertificateLogMessageResolvers<ContextType>;
  ImportCertificateMeasurementTemplate?: ImportCertificateMeasurementTemplateResolvers<ContextType>;
  ImportCertificatePackagingTemplate?: ImportCertificatePackagingTemplateResolvers<ContextType>;
  ImportCertificatePdf?: ImportCertificatePdfResolvers<ContextType>;
  ImportCertificateXml?: ImportCertificateXmlResolvers<ContextType>;
  ImportConnectionsResponse?: ImportConnectionsResponseResolvers<ContextType>;
  ImportConnectionsType?: ImportConnectionsTypeResolvers<ContextType>;
  IndicatorType?: IndicatorTypeResolvers<ContextType>;
  InitSupportingDocumentUploadResponse?: InitSupportingDocumentUploadResponseResolvers<ContextType>;
  IntTemplate?: IntTemplateResolvers<ContextType>;
  IntegrationsGetTemplateXmlResponse?: IntegrationsGetTemplateXmlResponseResolvers<ContextType>;
  Language?: LanguageResolvers<ContextType>;
  Layout?: LayoutResolvers<ContextType>;
  Layouts?: LayoutsResolvers<ContextType>;
  LookupValue?: LookupValueResolvers<ContextType>;
  ManualVolumeAdjustment?: ManualVolumeAdjustmentResolvers<ContextType>;
  MasterLayout?: MasterLayoutResolvers<ContextType>;
  MeasureTemplate?: MeasureTemplateResolvers<ContextType>;
  Measurment?: MeasurmentResolvers<ContextType>;
  MonthTemplate?: MonthTemplateResolvers<ContextType>;
  MultiCollectionApiKeys?: MultiCollectionApiKeysResolvers<ContextType>;
  MultiCollectionApiKeysV2?: MultiCollectionApiKeysV2Resolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NamedCode?: NamedCodeResolvers<ContextType>;
  NamedCodeTemplate?: NamedCodeTemplateResolvers<ContextType>;
  NewCoreReferencedDocument?: NewCoreReferencedDocumentResolvers<ContextType>;
  NewReferencedDocument?: NewReferencedDocumentResolvers<ContextType>;
  NumberConstrain?: NumberConstrainResolvers<ContextType>;
  OCAWithPermissionsResponse?: OcaWithPermissionsResponseResolvers<ContextType>;
  PDFSettings?: PdfSettingsResolvers<ContextType>;
  PackageTemplate?: PackageTemplateResolvers<ContextType>;
  Packaging?: PackagingResolvers<ContextType>;
  PackagingConfirmation?: PackagingConfirmationResolvers<ContextType>;
  PackagingRun?: PackagingRunResolvers<ContextType>;
  PhytoOcaEmailNotificationsResponse?: PhytoOcaEmailNotificationsResponseResolvers<ContextType>;
  PhytoOcaEmailNotificationsType?: PhytoOcaEmailNotificationsTypeResolvers<ContextType>;
  PortCountryInfo?: PortCountryInfoResolvers<ContextType>;
  PrepareXmlFileForB2GResponse?: PrepareXmlFileForB2GResponseResolvers<ContextType>;
  PresignedPostField?: PresignedPostFieldResolvers<ContextType>;
  PresignedUrl?: PresignedUrlResolvers<ContextType>;
  PreviewOutputXMLPresignedURLResult?: PreviewOutputXmlPresignedUrlResultResolvers<ContextType>;
  PrintCertificateResponse?: PrintCertificateResponseResolvers<ContextType>;
  ProcessAttributesResponse?: ProcessAttributesResponseResolvers<ContextType>;
  ProcessB2GIntegrationResponse?: ProcessB2GIntegrationResponseResolvers<ContextType>;
  ProcessDetail?: ProcessDetailResolvers<ContextType>;
  ProcessGroupCaptionSettings?: ProcessGroupCaptionSettingsResolvers<ContextType>;
  ProcessGroupDetail?: ProcessGroupDetailResolvers<ContextType>;
  ProcessGroupInfo?: ProcessGroupInfoResolvers<ContextType>;
  ProcessInfo?: ProcessInfoResolvers<ContextType>;
  ProcessResponse?: ProcessResponseResolvers<ContextType>;
  ProcessTask?: ProcessTaskResolvers<ContextType>;
  ProcessType?: ProcessTypeResolvers<ContextType>;
  ProductExhaustionResponse?: ProductExhaustionResponseResolvers<ContextType>;
  ProductFieldResponse?: ProductFieldResponseResolvers<ContextType>;
  ProductFieldType?: ProductFieldTypeResolvers<ContextType>;
  ProductProcessResponse?: ProductProcessResponseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RaiseExportRequestResponse?: RaiseExportRequestResponseResolvers<ContextType>;
  RaiseTransferRequestResponse?: RaiseTransferRequestResponseResolvers<ContextType>;
  ReferenceCaption?: ReferenceCaptionResolvers<ContextType>;
  ReferenceDataList?: ReferenceDataListResolvers<ContextType>;
  ReferenceItem?: ReferenceItemResolvers<ContextType>;
  ReferenceList?: ReferenceListResolvers<ContextType>;
  ReferenceProcessGroupCaption?: ReferenceProcessGroupCaptionResolvers<ContextType>;
  ReferenceValidationMode?: ReferenceValidationModeResolvers<ContextType>;
  ReferenceValidationResponse?: ReferenceValidationResponseResolvers<ContextType>;
  ReferencedDocument?: ReferencedDocumentResolvers<ContextType>;
  ReferencedDocumentUrl?: ReferencedDocumentUrlResolvers<ContextType>;
  RegenerateApprovedTemplatesResponse?: RegenerateApprovedTemplatesResponseResolvers<ContextType>;
  RegenerateApprovedTemplatesResult?: RegenerateApprovedTemplatesResultResolvers<ContextType>;
  RegenerateCertificateResponse?: RegenerateCertificateResponseResolvers<ContextType>;
  RegistrationType?: RegistrationTypeResolvers<ContextType>;
  ReindexResponse?: ReindexResponseResolvers<ContextType>;
  RemoveProductProcessesResponse?: RemoveProductProcessesResponseResolvers<ContextType>;
  RequestConfirmationResponse?: RequestConfirmationResponseResolvers<ContextType>;
  RequestHistoryForSF?: RequestHistoryForSfResolvers<ContextType>;
  RequestPartyRolesResponse?: RequestPartyRolesResponseResolvers<ContextType>;
  RequestValidation?: RequestValidationResolvers<ContextType>;
  RoleSpecificKeys?: RoleSpecificKeysResolvers<ContextType>;
  Row?: RowResolvers<ContextType>;
  RulesInput?: RulesInputResolvers<ContextType>;
  RulesResponse?: RulesResponseResolvers<ContextType>;
  SPSAddress?: SpsAddressResolvers<ContextType>;
  SPSAuthentication?: SpsAuthenticationResolvers<ContextType>;
  SPSCertificate?: SpsCertificateResolvers<ContextType>;
  SPSClassification?: SpsClassificationResolvers<ContextType>;
  SPSClause?: SpsClauseResolvers<ContextType>;
  SPSConsignment?: SpsConsignmentResolvers<ContextType>;
  SPSConsignmentItem?: SpsConsignmentItemResolvers<ContextType>;
  SPSContact?: SpsContactResolvers<ContextType>;
  SPSCountry?: SpsCountryResolvers<ContextType>;
  SPSCountrySubDivision?: SpsCountrySubDivisionResolvers<ContextType>;
  SPSEvent?: SpsEventResolvers<ContextType>;
  SPSExchangedDocument?: SpsExchangedDocumentResolvers<ContextType>;
  SPSLocation?: SpsLocationResolvers<ContextType>;
  SPSNote?: SpsNoteResolvers<ContextType>;
  SPSPackage?: SpsPackageResolvers<ContextType>;
  SPSParty?: SpsPartyResolvers<ContextType>;
  SPSPeriod?: SpsPeriodResolvers<ContextType>;
  SPSPerson?: SpsPersonResolvers<ContextType>;
  SPSProcess?: SpsProcessResolvers<ContextType>;
  SPSProcessCharacteristic?: SpsProcessCharacteristicResolvers<ContextType>;
  SPSQualification?: SpsQualificationResolvers<ContextType>;
  SPSReferencedDocument?: SpsReferencedDocumentResolvers<ContextType>;
  SPSSeal?: SpsSealResolvers<ContextType>;
  SPSTemperature?: SpsTemperatureResolvers<ContextType>;
  SPSTradeLineItem?: SpsTradeLineItemResolvers<ContextType>;
  SPSTransportEquipment?: SpsTransportEquipmentResolvers<ContextType>;
  SPSTransportMovement?: SpsTransportMovementResolvers<ContextType>;
  SPSTransportMovementTemplate?: SpsTransportMovementTemplateResolvers<ContextType>;
  SPSWineExporter?: SpsWineExporterResolvers<ContextType>;
  SalesForceAddress?: SalesForceAddressResolvers<ContextType>;
  SalesForceContact?: SalesForceContactResolvers<ContextType>;
  SalesForceEmail?: SalesForceEmailResolvers<ContextType>;
  SalesForceIdentifier?: SalesForceIdentifierResolvers<ContextType>;
  SalesForceParty?: SalesForcePartyResolvers<ContextType>;
  SalesForcePhone?: SalesForcePhoneResolvers<ContextType>;
  SalesForceProductId?: SalesForceProductIdResolvers<ContextType>;
  SalesforceErApprovalResponse?: SalesforceErApprovalResponseResolvers<ContextType>;
  SalesforceTransferRequestVerificationResponse?: SalesforceTransferRequestVerificationResponseResolvers<ContextType>;
  SaveChangesToReferenceDataResponse?: SaveChangesToReferenceDataResponseResolvers<ContextType>;
  SavedClassificationOutput?: SavedClassificationOutputResolvers<ContextType>;
  SavedProcessOutput?: SavedProcessOutputResolvers<ContextType>;
  SavedProductOutput?: SavedProductOutputResolvers<ContextType>;
  SearchApiKey?: SearchApiKeyResolvers<ContextType>;
  SearchReferenceListResponse?: SearchReferenceListResponseResolvers<ContextType>;
  SearchTemplateVersionsResponse?: SearchTemplateVersionsResponseResolvers<ContextType>;
  Section?: SectionResolvers<ContextType>;
  SensoryProcessRequest?: SensoryProcessRequestResolvers<ContextType>;
  SfApplication?: SfApplicationResolvers<ContextType>;
  SfApprovedTemplateVersion?: SfApprovedTemplateVersionResolvers<ContextType>;
  SfChangeExportRequestStatusResponse?: SfChangeExportRequestStatusResponseResolvers<ContextType>;
  SfChangeTransferRequestStatusResponse?: SfChangeTransferRequestStatusResponseResolvers<ContextType>;
  SfDownloadCertificateResponse?: SfDownloadCertificateResponseResolvers<ContextType>;
  SfGeneratedCertificate?: SfGeneratedCertificateResolvers<ContextType>;
  SfPrintHistory?: SfPrintHistoryResolvers<ContextType>;
  SfRequest?: SfRequestResolvers<ContextType>;
  SfSearchApprovedTemplatesResponse?: SfSearchApprovedTemplatesResponseResolvers<ContextType>;
  SfSupportingDocumentMetadata?: SfSupportingDocumentMetadataResolvers<ContextType>;
  SfUpdateProductExhaustionResponse?: SfUpdateProductExhaustionResponseResolvers<ContextType>;
  SfUpdateStationerySerialNumbersResponse?: SfUpdateStationerySerialNumbersResponseResolvers<ContextType>;
  SfUpdateTransferAuditCommentResponse?: SfUpdateTransferAuditCommentResponseResolvers<ContextType>;
  SnapshotPresignedUrlResponse?: SnapshotPresignedUrlResponseResolvers<ContextType>;
  SourceProductTracking?: SourceProductTrackingResolvers<ContextType>;
  SourceTransfer?: SourceTransferResolvers<ContextType>;
  SourcedProduct?: SourcedProductResolvers<ContextType>;
  SourcedProductAttributes?: SourcedProductAttributesResolvers<ContextType>;
  SourcedProductDetails?: SourcedProductDetailsResolvers<ContextType>;
  SpsAcknowledgementOutput?: SpsAcknowledgementOutputResolvers<ContextType>;
  SpsAddressTemplate?: SpsAddressTemplateResolvers<ContextType>;
  SpsAuthenticationTemplate?: SpsAuthenticationTemplateResolvers<ContextType>;
  SpsCertificateTemplate?: SpsCertificateTemplateResolvers<ContextType>;
  SpsClassificationTemplate?: SpsClassificationTemplateResolvers<ContextType>;
  SpsClauseTemplate?: SpsClauseTemplateResolvers<ContextType>;
  SpsConsignmentItemTemplate?: SpsConsignmentItemTemplateResolvers<ContextType>;
  SpsConsignmentTemplate?: SpsConsignmentTemplateResolvers<ContextType>;
  SpsContactTemplate?: SpsContactTemplateResolvers<ContextType>;
  SpsCountrySubDivisionTemplate?: SpsCountrySubDivisionTemplateResolvers<ContextType>;
  SpsCountryTemplate?: SpsCountryTemplateResolvers<ContextType>;
  SpsEventTemplate?: SpsEventTemplateResolvers<ContextType>;
  SpsExchangedDocumentTemplate?: SpsExchangedDocumentTemplateResolvers<ContextType>;
  SpsLocationTemplate?: SpsLocationTemplateResolvers<ContextType>;
  SpsNoteTemplate?: SpsNoteTemplateResolvers<ContextType>;
  SpsPackageTemplate?: SpsPackageTemplateResolvers<ContextType>;
  SpsPartyTemplate?: SpsPartyTemplateResolvers<ContextType>;
  SpsPeriodTemplate?: SpsPeriodTemplateResolvers<ContextType>;
  SpsPersonTemplate?: SpsPersonTemplateResolvers<ContextType>;
  SpsProcessCharacteristicTemplate?: SpsProcessCharacteristicTemplateResolvers<ContextType>;
  SpsProcessTemplate?: SpsProcessTemplateResolvers<ContextType>;
  SpsQualificationTemplate?: SpsQualificationTemplateResolvers<ContextType>;
  SpsReplacementCertificateTemplate?: SpsReplacementCertificateTemplateResolvers<ContextType>;
  SpsSealTemplate?: SpsSealTemplateResolvers<ContextType>;
  SpsTemperatureTemplate?: SpsTemperatureTemplateResolvers<ContextType>;
  SpsTradeLineItemTemplate?: SpsTradeLineItemTemplateResolvers<ContextType>;
  SpsTransportEquipmentTemplate?: SpsTransportEquipmentTemplateResolvers<ContextType>;
  StandardPdfPreviewResponse?: StandardPdfPreviewResponseResolvers<ContextType>;
  SubmissionSettings?: SubmissionSettingsResolvers<ContextType>;
  SubmissionXmlUrl?: SubmissionXmlUrlResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SupportingDocumentActionsResponse?: SupportingDocumentActionsResponseResolvers<ContextType>;
  SupportingDocumentHistoryEntry?: SupportingDocumentHistoryEntryResolvers<ContextType>;
  SupportingDocumentKeys?: SupportingDocumentKeysResolvers<ContextType>;
  SupportingDocumentPresignedUrlResponse?: SupportingDocumentPresignedUrlResponseResolvers<ContextType>;
  SupportingDocumentUsageRecord?: SupportingDocumentUsageRecordResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  TemplateDeclarationGroup?: TemplateDeclarationGroupResolvers<ContextType>;
  TemplateDeclarationsAcknowledgement?: TemplateDeclarationsAcknowledgementResolvers<ContextType>;
  TemplateDeclarationsDeleteAcknowledgement?: TemplateDeclarationsDeleteAcknowledgementResolvers<ContextType>;
  TemplateDeclarationsGroupAcknowledgement?: TemplateDeclarationsGroupAcknowledgementResolvers<ContextType>;
  TemplateDeclarationsStatementAcknowledgement?: TemplateDeclarationsStatementAcknowledgementResolvers<ContextType>;
  TemplateDeclarationsTraceAcknowledgement?: TemplateDeclarationsTraceAcknowledgementResolvers<ContextType>;
  TemplateDocumentUrl?: TemplateDocumentUrlResolvers<ContextType>;
  TemplateDocumentUrlV2?: TemplateDocumentUrlV2Resolvers<ContextType>;
  TemplateFieldConfiguration?: TemplateFieldConfigurationResolvers<ContextType>;
  TemplateFieldConfigurationAcknowledgement?: TemplateFieldConfigurationAcknowledgementResolvers<ContextType>;
  TemplateFieldConfigurationV2?: TemplateFieldConfigurationV2Resolvers<ContextType>;
  TemplateFieldReferenceData?: TemplateFieldReferenceDataResolvers<ContextType>;
  TemplateGeneralSettingsV2?: TemplateGeneralSettingsV2Resolvers<ContextType>;
  TemplateHistory?: TemplateHistoryResolvers<ContextType>;
  TemplateOutputV2?: TemplateOutputV2Resolvers<ContextType>;
  TemplateProcessGroupReferenceData?: TemplateProcessGroupReferenceDataResolvers<ContextType>;
  TemplateProcessGroups?: TemplateProcessGroupsResolvers<ContextType>;
  TemplateProcessGroupsConfigAcknowledgement?: TemplateProcessGroupsConfigAcknowledgementResolvers<ContextType>;
  TemplateSection?: TemplateSectionResolvers<ContextType>;
  TemplateSectionField?: TemplateSectionFieldResolvers<ContextType>;
  TemplateSupportingDocument?: TemplateSupportingDocumentResolvers<ContextType>;
  TemplateSupportingDocumentAcknowledgement?: TemplateSupportingDocumentAcknowledgementResolvers<ContextType>;
  TemplateUploadUrl?: TemplateUploadUrlResolvers<ContextType>;
  TemplateUploadUrlV2?: TemplateUploadUrlV2Resolvers<ContextType>;
  TemplateV2?: TemplateV2Resolvers<ContextType>;
  TemplateVersion?: TemplateVersionResolvers<ContextType>;
  TemplateVersionId?: TemplateVersionIdResolvers<ContextType>;
  TemplateVersionOutput?: TemplateVersionOutputResolvers<ContextType>;
  TemplateVersionV2?: TemplateVersionV2Resolvers<ContextType>;
  TestRegistration?: TestRegistrationResolvers<ContextType>;
  TestUser?: TestUserResolvers<ContextType>;
  TimeTemplate?: TimeTemplateResolvers<ContextType>;
  TransferProcessHistoryXmlResponse?: TransferProcessHistoryXmlResponseResolvers<ContextType>;
  TransferProductDetails?: TransferProductDetailsResolvers<ContextType>;
  TransferReferenceError?: TransferReferenceErrorResolvers<ContextType>;
  TransferReferenceResponse?: TransferReferenceResponseResolvers<ContextType>;
  TransferRequestDetails?: TransferRequestDetailsResolvers<ContextType>;
  TransferRequestHistoryRecord?: TransferRequestHistoryRecordResolvers<ContextType>;
  Translation?: TranslationResolvers<ContextType>;
  TransportMovementCodeTemplate?: TransportMovementCodeTemplateResolvers<ContextType>;
  TreatmentTemplate?: TreatmentTemplateResolvers<ContextType>;
  UpdateApprovedTransferTransportResponse?: UpdateApprovedTransferTransportResponseResolvers<ContextType>;
  UpdatePrintReasonResponse?: UpdatePrintReasonResponseResolvers<ContextType>;
  UpdateSupportingDocumentResult?: UpdateSupportingDocumentResultResolvers<ContextType>;
  UploadReferenceDataResponse?: UploadReferenceDataResponseResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserDetailsById?: UserDetailsByIdResolvers<ContextType>;
  UserInfo?: UserInfoResolvers<ContextType>;
  UserPermission?: UserPermissionResolvers<ContextType>;
  UserProfile?: UserProfileResolvers<ContextType>;
  Validation?: ValidationResolvers<ContextType>;
  VolumeAdjustmentResponse?: VolumeAdjustmentResponseResolvers<ContextType>;
  VolumeMeasureTemplate?: VolumeMeasureTemplateResolvers<ContextType>;
  WineAnalytesTolerancesResponse?: WineAnalytesTolerancesResponseResolvers<ContextType>;
  WineAnalytesTolerancesType?: WineAnalytesTolerancesTypeResolvers<ContextType>;
  WineChemistryTemplate?: WineChemistryTemplateResolvers<ContextType>;
  WineConsignment?: WineConsignmentResolvers<ContextType>;
  WineConsignmentTemplate?: WineConsignmentTemplateResolvers<ContextType>;
  WineFieldsTemplate?: WineFieldsTemplateResolvers<ContextType>;
  WineProductFieldType?: WineProductFieldTypeResolvers<ContextType>;
  Winemaking?: WinemakingResolvers<ContextType>;
  WinemakingConfirmation?: WinemakingConfirmationResolvers<ContextType>;
  XMLSettings?: XmlSettingsResolvers<ContextType>;
  awsS3PostUploadUrl?: AwsS3PostUploadUrlResolvers<ContextType>;
  getDeclarationInputsResponse?: GetDeclarationInputsResponseResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  aws_cognito_user_pools?: Aws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam?: Aws_IamDirectiveResolver<any, any, ContextType>;
  aws_lambda?: Aws_LambdaDirectiveResolver<any, any, ContextType>;
  aws_subscribe?: Aws_SubscribeDirectiveResolver<any, any, ContextType>;
};
